(function () {
    'use strict';

    angular
        .module('vox-leonis.core', [
            'ngAnimate', 'ngTouch', 'ngSanitize', 'ui.router', 'ui.bootstrap',
            'SignalR', 'angular-ladda', 'ngScrollbars', 'angular-progress-arc', 'ApplicationInsightsModule',
            'blocks.exception', 'blocks.logger', 'blocks.router', 'smart-table', 'ngCookies', 'angular-cache', 'ui.select']);
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.core')
        .filter('unique', function () {
            // we will return a function which will take in a collection
            // and a keyname
            return function (collection, keyname) {
                // we define our output and keys array;
                var output = [],
                    keys = [];

                // we utilize angular's foreach function
                // this takes in our original collection and an iterator function
                angular.forEach(collection, function (item) {
                    // we check to see whether our object exists
                    var key = item[keyname];
                    // if it's not already part of our keys array
                    if (keys.indexOf(key) === -1) {
                        // add it to our keys array
                        keys.push(key);
                        // push this item to our final output array
                        output.push(item);
                    }
                });
                // return our array which should be devoid of
                // any duplicates
                return output;
            };
        });
})();

(function ()
{
    'use strict';

    angular
        .module('vox-leonis.core')
        .filter('map', function () {
            return function (input, map) {
                return map[input];
            };
        });
})();
        
(function () {
    'use strict';

    angular
        .module('vox-leonis.core')
        .filter('camelcaseSpace', function () {
            return function (input) {
                if (input !== undefined && isNaN(input)) {
                    input = input.replace(/([a-z])([A-Z])/g, '$1 $2');
                    return input;
                }
                else {
                    return input;
                }
            };
        });
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.core')
        .filter('elapsedTime', ['utilities', function (utilities) {

            function elapsedTime(startDateTime, endDateTime) {
                startDateTime = startDateTime ? new Date(startDateTime) : new Date();
                endDateTime = endDateTime ? new Date(endDateTime) : new Date();
                return getTimeDisplay(startDateTime.getTime(), endDateTime.getTime());
            }

            return elapsedTime;

            function getTimeDisplay(startDateTime, endDateTime) {

                if (startDateTime >= endDateTime) {
                    return '0';
                }

                var diffSeconds = (endDateTime - startDateTime) / 1000;

                return utilities.convertSecondsToDisplayString(diffSeconds);
            }

        }]);
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.core')
        .factory('userservice', userservice);

    userservice.$inject = ['$http', '$q', 'exception', 'logger', 'enums', 'usermessageservice', 'stringResources', 'utilities', 'accountservice'];
    /* @ngInject */
    function userservice($http, $q, exception, logger, enums, usermessageservice, stringResources, utilities, accountservice) {
        var baseUrl = '/api/User';

        var service = {
            acceptAlert: acceptAlert,
            rejectAlert: rejectAlert,
            getCurrentAlert: getCurrentAlert,
            showChangeStatusReason: showChangeStatusReason,
            addCallEvent: addCallEvent,
            updateContactMethod: updateContactMethod,
            setMetadata: setMetadata,
            setSipdata: setSipdata,
            getUserSetting: getUserSetting,
            getUserFullSetting: getUserFullSetting,
            setUserSetting: setUserSetting,
            endConference: endConference,
            disconnectCall: disconnectCall,
            interpreterDispositionMenu: interpreterDispositionMenu,
            testCall: testCall
        };

        return service;

        /* */

        function acceptAlert(resourceAlertId, resourceRequestId, isTestCall, callId, isScheduleCall) {
            accountservice.logMessage('AcceptAlert is triggered|ResourceRequestId = ' + resourceRequestId + '|ResourceAlertId = ' + resourceAlertId, enums.LogLevel.Debug);
            return $http.put(baseUrl + '/AcceptAlert', {},
                { params: { resourceAlertId: resourceAlertId, resourceRequestId: resourceRequestId, isTestCall: isTestCall, callId: callId, isScheduleCall: isScheduleCall } })
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for acceptAlert')(e);
            }
        }

        function rejectAlert(resourceAlertId, resourceRequestId, isTestCall, callId, isScheduleCall) {
            return $http.put(baseUrl + '/RejectAlert?resourceAlertId=' + resourceAlertId + '&resourceRequestId=' + resourceRequestId + '&isTestCall=' + isTestCall + '&callId=' + callId +
                '&isScheduleCall=' + isScheduleCall)
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for rejectAlert')(e);
            }
        }

        function getCurrentAlert() {
            return $http.get(baseUrl + '/Alert')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for getCurrentAlert')(e);
            }
        }

        function showChangeStatusReason(statusName, time, reason) {
            // Don't show lost connectivity reasons to the user
            if (!time || !reason || reason === 21) {
                usermessageservice.notify(enums.Events.ShowInstructionMessage, { message: '' });
                return;
            }

            var reasonToDisplay = enums.PersonStatusMessage[reason];

            // Don't show reason dialog if there is no associated message text
            if (!reasonToDisplay || reasonToDisplay === '') {
                usermessageservice.notify(enums.Events.ShowInstructionMessage, { message: '' });
                return;
            }

            var timeToDisplay = utilities.getLocalDate(time);
            var message;

            if (statusName === enums.PersonStatusNames.Available) {
                message = utilities.stringFormat('{0}. {1}', reasonToDisplay, timeToDisplay);
            } else {
                message = utilities.stringFormat(
                    stringResources.personStatusMessageFormat, statusName, reasonToDisplay, timeToDisplay);
            }

            usermessageservice.notify(enums.Events.ShowInstructionMessage, { message: message });
        }

        function addCallEvent(eventName, callId, metadata) {
            var body = { metadata: null };
            if (metadata !== undefined && metadata !== null && metadata !== '') {
                body = { metadata: metadata };
            }

            return $http.put(baseUrl + '/Call/' + callId + '/CallEvent/' + eventName, body)
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for addCallEvent')(e);
            }

        }

        function getUserSetting(userSetting, defaultValue) {
            return $http.get('/api/User/Settings/' + userSetting + '?defaultValue=' + defaultValue)
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for getUserSetting')(e);
            }
        }

        function getUserFullSetting(userSetting, defaultValue) {
            return $http.get('/api/User/FullSettings/' + userSetting)
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for getUserFullSetting')(e);
            }
        }

        function setUserSetting(userSetting, value) {
            return $http.put(baseUrl + '/Settings/' + userSetting,  value)
                .then(success)
                .catch(fail);
            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for set user setting')(e);
            }
        }

        function updateContactMethod(contactMethod) {
            return $http.put('/api/User/ContactMethod', contactMethod)
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for updateContactMethod')(e);
            }
        }

        /* */
        function setMetadata(callId, metaData) {
            return $http.put(baseUrl + '/MetaData/' + callId, metaData)
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for set meta data')(e);
            }
        }

        function setSipdata(callId, sipData) {
            return $http.put(baseUrl + '/SipData/' + callId, sipData)
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for set sip data')(e);
            }
        }

        /* */
        function endConference(callId) {
            return $http.put(baseUrl + '/EndConference/' + callId)
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed to end conference')(e);
            }
        }

        /* */
        function disconnectCall(callId) {
            return $http.put(baseUrl + '/Call/' + callId + '/Disconnect')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for userservice.disconnectCall')(e);
            }
        }

        /* */
        function interpreterDispositionMenu() {
            return $http.get(baseUrl + '/Disposition/Interpreter')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for userservice.interpreterDispositionMenu')(e);
            }
        }

        /* */
        function testCall() {
            return $http.put(baseUrl + '/TestCall')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed our userservice.testcall')(e);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.core')
        .factory('usermessageservice', usermessageservice);

    usermessageservice.$inject = ['$rootScope'];
    /* @ngInject */
    function usermessageservice($rootScope) {
        var service = {
            subscribe: subscribe,
            notify: notify
        };

        return service;

        /* */
        function subscribe(scope, event, callback) {
            var handler = $rootScope.$on(event, callback);
            scope.$on('$destroy', handler);
        }

        function notify(event, args) {
            $rootScope.$emit(event, args);
        }
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('vox-leonis.core')
        .factory('twiliowebrtcservice', twiliowebrtcservice);

    twiliowebrtcservice.$inject = ['$rootScope', 'accountservice', 'enums', 'twilio', '$cookies', 'callEvents', 'userservice',
        'appsettingsservice', 'preferences', 'constants', 'usermessageservice'];

    function twiliowebrtcservice($rootScope, accountservice, enums, twilio, $cookies, callEvents, userservice,
        appsettingsservice, preferences, constants, usermessageservice) {
        var devices = [];
        var lastConnection;
        var preflightTest;
        var service = {
            enable: enable,
            disable: disable,
            hangUp: hangUp,
            setup: setup,
            isInCall: isInCall,
            isWebRTCSupported: isWebRTCSupported,
            mute: mute,
            unmute: unmute,
            sendDigits: sendDigits,
            disconnect: disconnect,
            clearDevice: clearDeviceAndCreateNew,
            setPortalRefresh: setPortalRefresh
        };

        var showNetworkQualityIndicatorDefault = 'false';
        var preFlightEnabled = false;
        var currentRole = $cookies.get(constants.userRole);
        var twilioErrorLimitToLog = 1000;
        var tokenRefreshMilliseconds = 60000;
        var settingUpPeriodicTokenUpdation = false;
        var pageRefresh = true;
        var hangupNeedsRefreshToken = false;
        // SDK 2.1.1
        var refreshTokenInProgress = false;
        var runningPreflight = false;
        var showWebRTCReconnectionStatus = false;
        // SDK 2.1.1
        var twilioSDKLogLevel = 5; //silent
        var createTokenOnError = false;
        var tokenAgeMinutes = 60;
        var tokenAgeMilliseconds = tokenAgeMinutes * 60000;
        var interval = false;
        var defaultEdgeLocations = ['roaming'];
        var codecPreferences = ['opus'];
        var disableTokenGenerationLocalHost = false;
        var logTwilioErrorsOnConsole = false;
        var registerDeviceWhenOffline = false;

        initializePreferences();

        return service;

        function initializePreferences() {
            appsettingsservice.getAppSetting(preferences.TwilioErrorLimitToLog, twilioErrorLimitToLog).then(function (data) {
                twilioErrorLimitToLog = +data;
            });

            userservice.getUserSetting('Portal_EnableTwilioClientDebugging', twilioSDKLogLevel).then(function (data) {
                if (data) {
                    twilioSDKLogLevel = +data;
                }
            });

            appsettingsservice.getAppSetting(preferences.TokenRefreshMilliseconds, tokenRefreshMilliseconds).then(function (data) {
                tokenRefreshMilliseconds = +data;
            });

            if (currentRole !== undefined) {
                appsettingsservice.getAppSetting(preferences.ShowNetworkQualityIndicator, showNetworkQualityIndicatorDefault).then(function (data) {
                    showNetworkQualityIndicatorDefault = data;
                });
            }

            appsettingsservice.getAppSetting(preferences.DisableTokenGenerationLocalHost, disableTokenGenerationLocalHost).then(function (data) {
                disableTokenGenerationLocalHost = (data === 'true');
            });

            appsettingsservice.getAppSetting(preferences.WebRTCTokenAgeMinutes, tokenAgeMinutes).then(function (data) {
                tokenAgeMinutes = +data;
                tokenAgeMilliseconds = tokenAgeMinutes * 60000;
            });

            userservice.getUserSetting(preferences.preFlight, preFlightEnabled).then(function (data) {
                preFlightEnabled = (data === 'true');
            });

            appsettingsservice.getAppSetting(preferences.WebRTCEdgeLocations, defaultEdgeLocations).then(function (data) {
                defaultEdgeLocations = data ? data.toString().split(',') : defaultEdgeLocations;
            });

            appsettingsservice.getAppSetting(preferences.CodecPreferences, codecPreferences).then(function (data) {
                codecPreferences = data ? data.toString().split(',') : codecPreferences;
            });

            appsettingsservice.getAppSetting(preferences.CreateTokenOnError, createTokenOnError).then(function (data) {
                createTokenOnError = (data === 'true');
            });

            userservice.getUserSetting(preferences.LogTwilioErrorsOnConsole, logTwilioErrorsOnConsole).then(function (data) {
                logTwilioErrorsOnConsole = (data === 'true');
            });

            appsettingsservice.getAppSetting(preferences.ShowWebRTCReconnectionStatus, showWebRTCReconnectionStatus).then(function (data) {
                showWebRTCReconnectionStatus = (data === 'true');
            });

            appsettingsservice.getAppSetting(preferences.RegisterDeviceWhenOffline, registerDeviceWhenOffline).then(function (data) {
                registerDeviceWhenOffline = (data === 'true');
            });
        }
        function enable() {
            var regereratingTokenDueToError = false;
            setup(regereratingTokenDueToError, 0);
        }

        function disable(userId) {
            if (devices.length > 0) {
                devices.forEach(function (device) {
                    device.removeListener(enums.DeviceStatus.Error, deviceEventHandlerError);
                    device.removeListener(enums.DeviceStatus.Incoming, deviceEventHandlerIncoming);
                    device.removeListener(enums.DeviceStatus.Unregistered, deviceEventHandlerUnregistered);
                    device.removeListener(enums.DeviceStatus.Registered, deviceEventHandlerRegistered);
                    device.removeListener(enums.DeviceStatus.Destroyed, deviceEventHandlerDestroyed);
                    device.removeListener(enums.DeviceStatus.Registering, deviceEventHandlerRegistering);
                    device.removeListener(enums.DeviceStatus.TokenWillExpire, deviceEventHandlerTokenWillExpire);
                    device.destroy();
                });

                // start over
                devices = [];
                //Use deleteDeviceUpdationJob in sdk 2.0.0
                //deleteDeviceUpdationJob();
                accountservice.logMessage('twiliowebrtcservice.disable|WebRTC disabled for User: ' + userId, enums.LogLevel.Debug);
            }
        }

        function deviceEventHandlerDestroyed() {
            console.log('Device Destroyed');
            //Use deleteDeviceUpdationJob in sdk 2.0.0
            //deleteDeviceUpdationJob();
        }

        function deleteDeviceUpdationJob() {
            if (interval) {
                clearInterval(interval);
                interval = undefined;
            }
        }
        function deviceEventHandlerRegistered() {
            devices.every(function (device) {

                console.log('registered... Device Status: ' + device.state);
            });
            //Call setUpTokenUpdation in sdk version 2.0.0
            //setUpTokenUpdation();

            if (runningPreflight) {
                console.log('Preflight Run in progress');
                return;
            }
            runningPreflight = true;

            if (preFlightEnabled) {
                var curStatus = $cookies.get('currentStatus');
                if (curStatus === 'Available' || curStatus === 'Away') {
                    runPreflightTests();
                }
            }
            setTimeout(function () { runningPreflight = false; }, 2000);
        }

        function runPreflightTests() {
            if (preFlightEnabled) {
                accountservice.getPreflightAccessToken().then(function (data) {
                    if (!!data) {
                        var setupOptions = {
                            // for testing:
                            logLevel: twilioSDKLogLevel,
                            //warnings: true,
                            edge: defaultEdgeLocations,
                            appName: 'Voice Portal Preflight',
                            closeProtection: true,
                            codecPreferences: ['opus', 'pcmu'],
                        };

                        preflightTest = twilio.Device.runPreflight(data, setupOptions);
                        preflightTest.on('completed', preflightSuccess);
                        preflightTest.on('failed', preflightError);
                    }
                });
            }
        }

        function preflightSuccess(report) {
            console.log(report);
            if (!!report) {
                accountservice.logMessage('twiliowebrtcservice.preflightSuccess|CallSid: ' + report.callSid +
                    ', userId: ' + getUserId() + ', result: ' + report.callQuality + ', edge: ' + report.edge +
                    ', selectedEdge: ' + report.selectedEdge, enums.LogLevel.Info);
            }
        }

        function preflightError(error) {
            accountservice.logMessage('twiliowebrtcservice.preflightError|Code: ' + error.code + ', Message: ' + error.message +
                ' Causes: ' + error.TwilioError.causes + ', userId: ' + getUserId(), enums.LogLevel.Warn);
        }

        // due to old long-aged bug try to find userId by any suitable way
        function getUserId() {
            var cachedUserId = $cookies.get('userId');
            if (!!cachedUserId) {
                return cachedUserId;
            }

            var cachedCurrentUserId = $cookies.get('currentUserid');
            if (!!cachedCurrentUserId) {
                return cachedCurrentUserId;
            }

            return accountservice.getCurrentUserId();
        }

        //used in twilio sdk 2.1.1
        function deviceEventHandlerTokenWillExpire() {
            if (refreshTokenInProgress) {
                console.log('RefreshToken is in progress');
                return;
            }
            refreshTokenInProgress = true;
            console.log('Token expiration time nearing...updating new token');

            updateToken();
            setTimeout(function () { refreshTokenInProgress = false; }, 2000);
        }

        function setUpTokenUpdation() {
            //used in twilio sdk 2.0.0
            if (!settingUpPeriodicTokenUpdation && !interval && devices.length > 0) {
                settingUpPeriodicTokenUpdation = true;

                const REFRESH_TIMER = tokenAgeMilliseconds - tokenRefreshMilliseconds; // We update our token 30 seconds before expiration;
                interval = setInterval(updateToken, REFRESH_TIMER);
                console.log('Token will be renewed every ' + REFRESH_TIMER / 1000 + ' seconds.');
                setTimeout(function () {
                    settingUpPeriodicTokenUpdation = false;
                }, 2000);

            }
        }

        function updateToken() {
            var callId = $cookies.get('callId');
            var userId = $cookies.get('userId');
            accountservice.getWebRTCAccessTokens().then(function (data) {
                if (data) {
                    var index = 0;
                    var timeStamp = new Date();
                    console.log('received new token on ' + timeStamp);
                    devices.forEach(function (device) {
                        device.updateToken(data[index]);
                        index++;
                        accountservice.logMessage('twiliowebrtcservice.UpdateToken| Message: Token Updated  , CallId: ' + callId + ', UserId: ' + userId +
                            ' Next token will be renewed  ' + tokenRefreshMilliseconds + ' ms before expiry (' + tokenAgeMilliseconds + ')', enums.LogLevel.Debug);
                    });
                }
            });
        }

        function deviceEventHandlerRegistering() {
            devices.every(function (device) {
                console.log('registering... Device Status: ' + device.state);
            });
        }
        function deviceEventHandlerUnregistered() {
            var callId = $cookies.get('callId');
            var userId = $cookies.get('userId');
            console.log('Device Offline');
            accountservice.logMessage('twiliowebrtcservice.offline|: Received offline event from Twilio. CallId: ' + callId + ', UserId: ' +
                userId, enums.LogLevel.Debug);
            // start over
            if (registerDeviceWhenOffline) {
                devices = [];
                setup(false, 0);
            }
        }

        function connectionEventHandlerWarning(warning) {
            var isError = true;
            var callId = $cookies.get('callId');
            if (warning === 'low-mos') {
                $rootScope.$broadcast(enums.Events.WebRtcConnectionQualityChanged, isError);
                userservice.addCallEvent(callEvents.LowMosWebRTCError, callId);
            }
            if (warning === 'high-rtt') {
                $rootScope.$broadcast(enums.Events.WebRtcConnectionQualityChanged, isError);
                userservice.addCallEvent(callEvents.HighRttWebRTCError, callId);
            }
            if (warning === 'high-jitter') {
                $rootScope.$broadcast(enums.Events.WebRtcConnectionQualityChanged, isError);
                userservice.addCallEvent(callEvents.HighJitterWebRTCError, callId);
            }
            if (warning === 'high-packet-loss') {
                $rootScope.$broadcast(enums.Events.WebRtcConnectionQualityChanged, isError);
                userservice.addCallEvent(callEvents.HighPacketLossWebRTCError, callId);
            }
            if (warning === 'device-change') {
                $rootScope.$broadcast(enums.Events.WebRtcConnectionQualityChanged, isError);
                userservice.addCallEvent(callEvents.AudioDeviceChanged, callId);
            }
            if (warning === 'high-packets-lost-fraction') {
                $rootScope.$broadcast(enums.Events.WebRtcConnectionQualityChanged, isError);
                userservice.addCallEvent(callEvents.HighPacketsLossFractionWebRTCError, callId);
            }
        }

        function connectionEventHandlerWarningCleared(warning) {
            var isError = false;
            var callId = $cookies.get('callId');
            if (warning === 'low-mos') {
                $rootScope.$broadcast(enums.Events.WebRtcConnectionQualityChanged, isError);
                userservice.addCallEvent(callEvents.WebRTCErrorCleared, callId);
            }
            if (warning === 'high-rtt') {
                $rootScope.$broadcast(enums.Events.WebRtcConnectionQualityChanged, isError);
                userservice.addCallEvent(callEvents.WebRTCErrorCleared, callId);
            }
            if (warning === 'high-jitter') {
                $rootScope.$broadcast(enums.Events.WebRtcConnectionQualityChanged, isError);
                userservice.addCallEvent(callEvents.WebRTCErrorCleared, callId);
            }
            if (warning === 'high-packet-loss') {
                $rootScope.$broadcast(enums.Events.WebRtcConnectionQualityChanged, isError);
                userservice.addCallEvent(callEvents.WebRTCErrorCleared, callId);
            }
        }

        function deviceEventHandlerError(error) {
            var callId = $cookies.get('callId');
            var userId = $cookies.get('userId');
            if (logTwilioErrorsOnConsole) {
                console.log('Twilio Error: ' + error);
            }
            switch (error.code) {
                case 31205:
                case 31202:
                case 31204:
                    accountservice.logMessage('twiliowebrtcservice.deviceEventHandlerError|Code: ' + error.code + ', Message: ' + error.message +
                        ' Causes: ' + error.TwilioError.causes + ', Refreshing the token again. CallId: ' + callId + ', userId: ' + userId, enums.LogLevel.Warn);
                    if (createTokenOnError) { setup(true, error.code); }
                    break;
                default:
                    handleWebRTCErrors(error.code, userId, error.message, error.TwilioError, callId);
            }
        }

        function deviceEventHandlerIncoming(connection) {
            lastConnection = connection;

            if (showNetworkQualityIndicatorDefault === 'true') {
                lastConnection.on('warning', connectionEventHandlerWarning);
                lastConnection.on('warning-cleared', connectionEventHandlerWarningCleared);
            }

            //used in sdk version 2.1.1
            if (showWebRTCReconnectionStatus === true) {
                lastConnection.on('reconnected', connectionEventHandlerReconnected);
                lastConnection.on('reconnecting', connectionEventHandlerReconnecting);
            }

            lastConnection.on('ringing', connectionEventHandlerRinging);
            connection.accept();
        }

        function connectionEventHandlerReconnected() {
            console.log('The call has regained connectivity.');
            usermessageservice.notify('notify', { message: true, eventName: 'WebRTCReconnected' });
        }

        function connectionEventHandlerRinging() {
            console.log('Device Ringing');
        }

        function connectionEventHandlerReconnecting(twilioError) {
            usermessageservice.notify('notify', { message: true, eventName: 'WebRTCReconnecting' });
            console.log('Connectivity error: ', twilioError);
        }

        // returns true if all of the devices on the page are 'Ready'; otherwise false
        function isReady() {
            var isReady = devices.every(function (device) {
                return device.state === enums.DeviceStatus.Registered;
            });
            return isReady;
        }

        // returns true if at least one of the devices on the page is 'Busy'; otherwise false
        function isInCall() {
            var inCall = devices.some(function (device) {
                return device.isBusy;
            });
            return inCall;
        }

        function hangUp() {
            var callId = $cookies.get('callId');
            var userId = $cookies.get('userId');
            devices.forEach(function (device) {
                if (device.isBusy) {
                    device.disconnectAll();
                }
            });
        }

        function setPortalRefresh(enable, emptyDevice) {
            console.log('setPortalRefresh called');
            pageRefresh = enable;
            if (emptyDevice) {
                devices = [];
            }
            else {
                var userId = $cookies.get('userId');
                disable(userId);
            }

        }

        function clearDeviceAndCreateNew(force) {
            console.log('clearDeviceAndCreateNew called');
            hangupNeedsRefreshToken = force ? true : hangupNeedsRefreshToken;
            if (hangupNeedsRefreshToken) {
                hangupNeedsRefreshToken = false;
                devices.forEach(function (device) {
                    device.removeListener(enums.DeviceStatus.Error, deviceEventHandlerError);
                    device.removeListener(enums.DeviceStatus.Incoming, deviceEventHandlerIncoming);
                    device.removeListener(enums.DeviceStatus.Unregistered, deviceEventHandlerUnregistered);
                    device.removeListener(enums.DeviceStatus.Registered, deviceEventHandlerRegistered);
                    device.removeListener(enums.DeviceStatus.Destroyed, deviceEventHandlerDestroyed);
                    device.removeListener(enums.DeviceStatus.Registering, deviceEventHandlerRegistering);
                    device.removeListener(enums.DeviceStatus.TokenWillExpire, deviceEventHandlerTokenWillExpire);
                    device.destroy();
                });
                devices = [];
                setup(false, 0);
            }
        }

        // If the window object has any of the following properties, WebRTC connections are possible
        function isWebRTCSupported() {
            return ['RTCPeerConnection', 'webkitRTCPeerConnection', 'mozRTCPeerConnection', 'RTCIceGatherer'].some(function (item) {
                if (item in window) {
                    accountservice.logMessage('twiliowebrtcservice.isWebRTCSupported|Property: ' + item, enums.LogLevel.Debug);
                    console.log('WebRTC Supported: true');
                    return true;
                }
                accountservice.logMessage('twiliowebrtcservice.isWebRTCSupported false', enums.LogLevel.Debug);
                console.log('WebRTC Supported: false');
                return false;
            });
        }

        function mute() {
            if (lastConnection != null) {
                lastConnection.mute(true);
            }

            logConnectionStatus(lastConnection, 'mute');
        }

        function unmute() {
            if (lastConnection != null) {
                lastConnection.mute(false);
            }

            logConnectionStatus(lastConnection, 'unmute');
        }

        function sendDigits(digit) {
            if (lastConnection != null) {
                lastConnection.sendDigits(digit);
            }

            logConnectionStatus(lastConnection, 'sendDigits');
        }

        function logConnectionStatus(conn, methodName) {
            var callId = $cookies.get('callId');
            var userId = $cookies.get('userId');

            if (conn) {
                accountservice.logMessage('twiliowebrtcservice.' + methodName + ' | Message:  CallId: ' + callId + ', UserId: ' + userId + ' Status: ' + conn.status(), enums.LogLevel.Debug);
            }
            else {
                accountservice.logMessage('twiliowebrtcservice.' + methodName + ' Connection is null | Message:  CallId: ' + callId + ', UserId: ' + userId, enums.LogLevel.Warn);
            }
        }

        function disconnect() {
            var callId = $cookies.get('callId');
            var userId = $cookies.get('userId');

            if (lastConnection != null) {
                lastConnection.disconnect();
                userservice.addCallEvent(callEvents.UserHangup, callId);
                accountservice.logMessage('twiliowebrtcservice.disconnect| Message: Disconnect Called, CallId: ' + callId + ', UserId: ' + userId, enums.LogLevel.Debug);
            }
            else {
                accountservice.logMessage('twiliowebrtcservice.disconnect| Message: No Active Connection, CallId: ' + callId + ', UserId: ' + userId, enums.LogLevel.Warn);
            }
        }

        function setup(regererateTokenDueToError, code) {
            if (pageRefresh) {
                hangupNeedsRefreshToken = true;
                pageRefresh = false;
            }
            if (devices.length > 0) {
                if (isReady) {
                    console.log('Devices Registered Already');
                    return;
                }
                else {
                    devices = [];
                }
            }

            if (disableTokenGenerationLocalHost && (location.hostname === 'localhost' || location.hostname === '127.0.0.1')) {
                return;
            }

            accountservice.getWebRTCAccessTokens().then(function (data) {
                if (data) {
                    var setupOptions = {
                        // for testing:
                        logLevel: twilioSDKLogLevel,
                        //warnings: true,
                        edge: defaultEdgeLocations,
                        appName: 'Voice Portal',
                        closeProtection: true,
                        codecPreferences: ['opus', 'pcmu'],
                        tokenRefreshMs: tokenRefreshMilliseconds
                    };
                    var webRTCToken = null;
                    data.forEach(function (token) {
                        webRTCToken = token;
                        // The Device constructor calls device.setup(token, setupOptions)
                        var twilioDevice = new twilio.Device(token, setupOptions);
                        devices.push(twilioDevice);
                    });

                    // Register a series of callback functions on each device...
                    // See: https://www.twilio.com/docs/voice/client/javascript/device#twilio-device for more information.
                    devices.forEach(function (device) {
                        device.on(enums.DeviceStatus.Error, deviceEventHandlerError);
                        device.on(enums.DeviceStatus.Incoming, deviceEventHandlerIncoming);
                        device.on(enums.DeviceStatus.Unregistered, deviceEventHandlerUnregistered);
                        device.on(enums.DeviceStatus.Registered, deviceEventHandlerRegistered);
                        device.on(enums.DeviceStatus.Destroyed, deviceEventHandlerDestroyed);
                        device.on(enums.DeviceStatus.Registering, deviceEventHandlerRegistering);
                        device.on(enums.DeviceStatus.TokenWillExpire, deviceEventHandlerTokenWillExpire);
                        device.register();
                    });

                    //devices.forEach(function (device) {
                    //    if (preFlightEnabled) {
                    //        preflightTest = twilio.Device.runPreflight(webRTCToken, setupOptions);

                    //    }
                    //});
                    //if (preFlightEnabled) {
                    //    preflightTest.on('completed', testPreflight);
                    //    preflightTest.on('failed', testPreflight);
                    //}
                }

                var numTokens = devices.length;
                var logLevel = numTokens === 0 ? enums.LogLevel.Error : enums.LogLevel.Trace;
                var generateTokenDueToErrorMessage = regererateTokenDueToError === true ? ', TokenGenerated due to error, ErrorCode: ' + code : '';
                accountservice.logMessage('twiliowebrtcservice.setup ' + numTokens + ' token' + (numTokens === 1 ? '' : 's') + ' returned ' + generateTokenDueToErrorMessage, logLevel);
            });

        }

        function handleWebRTCErrors(ErorCode, userId, message, twilioError, callId) {
            if (twilioErrorLimitToLog > 0) {
                var twilioErrorCookie = $cookies.get(ErorCode);
                var error = {};
                if (twilioErrorCookie !== undefined) {
                    error = JSON.parse(twilioErrorCookie);
                    error.Code = ErorCode;
                    error.UserId = userId !== undefined ? userId : error.UserId;
                    error.Count = +error.Count + 1;
                    $cookies.put(ErorCode, JSON.stringify(error));
                }
                else {
                    error.Code = ErorCode;
                    error.UserId = userId;
                    error.Count = 1;
                    var today = new Date();
                    var tomorrow = new Date(today);
                    tomorrow.setDate(today.getDate() + 1);
                    var expires = new Date(tomorrow);
                    $cookies.put(ErorCode, JSON.stringify(error), { 'expires': expires });
                    accountservice.logMessage('twiliowebrtcservice.deviceEventHandlerError|Code: ' + error.Code + ', Message: ' + message + ', Causes: ' +
                        twilioError.causes + ', Solution: ' + twilioError.solutions + ', CallId: ' +
                        callId + ', userId: ' + error.UserId + ' ErrorCount: ' + error.Count, enums.LogLevel.Warn);
                }
                //Log Message to graylog if the count reaches the twilioErrorLimitToLog or on ever twilioErrorLimitToLog th interval
                if (+error.Count === twilioErrorLimitToLog || (+error.Count % twilioErrorLimitToLog === 0)) {
                    usermessageservice.notify('notify', { message: true, eventName: 'TwilioErrors' });
                    accountservice.logMessage('twiliowebrtcservice.deviceEventHandlerError|Code: ' + error.Code + ', Message: ' + message + ', Causes: ' +
                        twilioError.causes + ', Solution: ' + twilioError.solutions + ', CallId: ' +
                        callId + ', userId: ' + error.UserId + ' ErrorCount: ' + error.Count, enums.LogLevel.Warn);
                }
            }
        }
    }
})(angular);

/*jshint esversion: 6 */
(function () {
    'use strict';

    angular
        .module('vox-leonis.core')
        .factory('telemetryservice', telemetryservice);

    telemetryservice.$inject = ['$injector', '$q', 'applicationInsightsService', 'preferences'];

    //this service should be used by all custom telemetry services instead of direct using applicationInsightsService
    function telemetryservice($injector, $q, applicationInsightsService, preferences) {
        var service = {
            logEvent: logEvent
        };

        var settings;

        //we need that to do not cause generation of multiple requests to retrieve settings till we not received response
        var loadingSettings = false;

        var defaultEnabled = false;

        resetSettings();

        return service;

        function resetSettings() {
            settings = {
                userId: null,
                enabled: defaultEnabled
            };
        }

        //request telemetry settings from server
        function telemetryEnabled() {
            var defer = $q.defer();

            var userId = $injector.get('accountservice').getCurrentUserId();

            // use default setting when user not logged
            if (!userId) {
                resetSettings();
                defer.reject();
            }
            else {
                //if the same logged user just use cached settings
                if (settings.userId === userId) {
                    if (settings.enabled) {
                        defer.resolve(settings);
                    } else {
                        defer.reject();
                    }
                }
                //if logged user changed reload settings from server for new user.
                else {
                    resetSettings();

                    var appSettingsService = $injector.get('appsettingsservice');

                    if (!loadingSettings) {
                        loadingSettings = true;

                        appSettingsService.getAppSetting(preferences.SendCustomUITelemetry, defaultEnabled, userId)
                            .then(function (data) {
                                //update cached settings
                                settings.enabled = $injector.get('utilities').isTrue(data);
                                settings.userId = userId;
                                loadingSettings = false;
                                if (settings.enabled) {
                                    defer.resolve(settings);
                                }
                                else {
                                    defer.reject();
                                }
                            })
                            .catch(function (e) {
                                //if can not receive from server than set to default
                                resetSettings();
                                loadingSettings = false;
                                defer.reject();
                            });
                    }
                    else {
                        //disable telemetry while waiting for all telemetry settings from server
                        defer.reject();
                    }
                }
            }

            return defer.promise;
        }

        //Such format is required by angular-applicationinsights library. It should be object with string or numeric values.
        function normalizeEvent(o) {
            Object.keys(o).forEach(function (k) {
                //Date serializing to ISOString, example: 2018-09-12T10:43:03.123Z
                if (o[k] instanceof Date) {
                    o[k] = o[k].toISOString();
                    return;
                }
                //Any object values serializing to JSON string
                if (typeof o[k] === 'object') {
                    o[k] = JSON.stringify(o[k]);
                }
                //any number and string keep as is
            });
            return o;
        }

        function logEvent(eventName, properties, measurements) {
            telemetryEnabled().then(
                function (settings) {
                    if (measurements) {
                        applicationInsightsService.trackEvent(eventName, normalizeEvent(properties), normalizeEvent(measurements));
                    }
                    else {
                        applicationInsightsService.trackEvent(eventName, normalizeEvent(properties));
                    }
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.core')
        .factory('signalservice', signalservice);

    signalservice.$inject = ['interpretersignalreceiver', 'operatorsignalreceiver', 'monitorsignalreceiver', 'session', 'signalreceiversmonitorservice'];
    /* @ngInject */
    function signalservice(interpretersignalreceiver, operatorsignalreceiver, monitorsignalreceiver, session, signalreceiversmonitorservice) {

        var service = {
            connect: connect,
            disconnect: disconnect
        };

        return service;

        // Connect SignalR when logging in or refreshing the page
        function connect() {
            if (session.roles.indexOf('Interpreter') >= 0) {
                interpretersignalreceiver.connect().done(function() {
                    signalreceiversmonitorservice.track(interpretersignalreceiver);
                });
            }

            if (session.roles.indexOf('Operator') >= 0 || session.roles.indexOf('Admin') >= 0 || session.roles.indexOf('SuperUser') >= 0) {
                operatorsignalreceiver.connect().done(function() {
                    signalreceiversmonitorservice.track(operatorsignalreceiver);
                });
            }

            if (session.roles.indexOf('Monitor') >= 0) {
                monitorsignalreceiver.connect().done(function() {
                    signalreceiversmonitorservice.track(monitorsignalreceiver);
                });
            }
        }

        // Disconnect SignalR when logging out
        // Avoids 'The user identity cannot change during an active SignalR connection' error if a different user subsequently logs in
        function disconnect() {
            if (session.roles.indexOf('Interpreter') >= 0) {
                interpretersignalreceiver.disconnect();
                signalreceiversmonitorservice.unTrack(interpretersignalreceiver.key);
            }

            if (session.roles.indexOf('Operator') >= 0 || session.roles.indexOf('Admin') >= 0 || session.roles.indexOf('SuperUser') >= 0) {
                operatorsignalreceiver.disconnect();
                signalreceiversmonitorservice.unTrack(operatorsignalreceiver.key);
            }

            if (session.roles.indexOf('Monitor') >= 0) {
                monitorsignalreceiver.disconnect();
                signalreceiversmonitorservice.unTrack(monitorsignalreceiver.key);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vox-leonis.core')
        .factory('signalreceiversmonitorservice', signalreceiversmonitorservice);

    signalreceiversmonitorservice.$inject = ['$cookies', '$interval', '$window', 'accountservice', 'appsettingsservice', 'constants', 'enums', 'utilities'];

    /* @ngInject */
    function signalreceiversmonitorservice($cookies, $interval, $window, accountservice, appsettingsservice, constants, enums, utilities) {
        var intervals = {};
        var settingsPromise;
        var refreshBrowserOnSignalRDisconnectPromise;
        var minimumMsSinceLastDisconnectBrowserRefreshPromise;

        activate();

        return {
            track: track,
            unTrack: unTrack,
            logSignalRTimeout: logSignalRTimeout
        };

        function activate() {
            var currentRole = $cookies.get(constants.userRole);
            if (currentRole !== undefined) {
                settingsPromise = appsettingsservice.getAppSetting('Portal_SignalRCheckConnectionIntervalSeconds', 30);
                refreshBrowserOnSignalRDisconnectPromise = appsettingsservice.getAppSetting('Portal_RefreshBrowserOnSignalRDisconnect', true);
                minimumMsSinceLastDisconnectBrowserRefreshPromise = appsettingsservice.getAppSetting('Portal_MinimumSecondsSinceLastDisconnectBrowserRefresh', 30);
            }
        }

        function track(signalReceiver) {
            var currentRole = $cookies.get(constants.userRole);
            if (currentRole !== undefined) {
                if (settingsPromise === undefined) {
                    activate();
                }
                settingsPromise.then(function (seconds) {
                    refreshBrowserOnSignalRDisconnectPromise.then(function (refreshBrowserOnSignalRDisconnect) {
                        minimumMsSinceLastDisconnectBrowserRefreshPromise.then(function (minimumMsSinceLastDisconnectBrowserRefresh) {
                            minimumMsSinceLastDisconnectBrowserRefresh = minimumMsSinceLastDisconnectBrowserRefresh * 1000;

                            var interval = $interval(function () {

                                if (!signalReceiver.getIsConnected()) {
                                    return;
                                }

                                signalReceiver.checkConnection().done(function (response) {
                                    if (!response) {
                                        if (!refreshBrowserOnSignalRDisconnect) {
                                            signalReceiver.disconnect();
                                            signalReceiver.connect().done(function () {
                                                track(signalReceiver);
                                            });
                                        } else if (isBrowserRefreshAllowed(minimumMsSinceLastDisconnectBrowserRefresh)) {
                                            $window.location.reload();
                                        }
                                    }
                                }).fail(function () {
                                    if (!refreshBrowserOnSignalRDisconnect) {
                                        signalReceiver.disconnect();
                                        signalReceiver.connect().done(function () {
                                            track(signalReceiver);
                                        });
                                    } else if (isBrowserRefreshAllowed(minimumMsSinceLastDisconnectBrowserRefresh)) {
                                        $window.location.reload();
                                    }
                                });
                            }, utilities.convertSecondsToMilliseconds(seconds));

                            intervals[signalReceiver.key] = interval;

                            return minimumMsSinceLastDisconnectBrowserRefresh;
                        });

                        return refreshBrowserOnSignalRDisconnect;
                    });

                    return seconds;
                });
            }
        }

        function unTrack(key) {
            if (!intervals[key]) {
                return;
            }

            $interval.cancel(intervals[key]);
            delete intervals[key];
        }

        function logSignalRTimeout(opeartionResult, hub, methodName) {
            if (!opeartionResult || !hub) {
                return;
            }
            var resolved = false;
            var timeout = 60000;
            var timer = setTimeout(function() {
                if (!resolved) {
                    accountservice.logMessage(methodName + '|ConnectionId: ' + hub.proxy.connection.id + ', SignalR Timeout: ' + timeout +
                        ', User Agent: ' + navigator.userAgent + ', Vendor: ' + navigator.vendor, enums.LogLevel.Info);
                }
            }, timeout);
            opeartionResult.promise().then(function() {
                resolved = true;
                clearTimeout(timer);
            });
        }

        function isBrowserRefreshAllowed(minimumMsSinceLastDisconnectBrowserRefresh) {
            var lastRefreshTime = $cookies.get(constants.lastRefreshTime);
            var currentTime = Date.now();

            return (currentTime - parseInt(lastRefreshTime)) >= minimumMsSinceLastDisconnectBrowserRefresh;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.core')
        .factory('reducecallfrequencyservice', reducecallfrequencyservice);

    reducecallfrequencyservice.$inject = ['$timeout'];
    /* @ngInject */
    function reducecallfrequencyservice($timeout) {
        var callsDictionary = [];
        var service = {
            call: callFunction
        };

        return service;

        function callFunction(key, method, delay) {
            if (callsDictionary[key] === undefined) {
                callsDictionary[key] = { delay: delay, method: method, needToCall: true, timer: false };
            }
            var instance = callsDictionary[key];
            instance.method = method;
            instance.delay = delay;

            if (instance.timer === true) {
                instance.needToCall = true;
            } else {
                instance.method();
                instance.needToCall = false;
                runTimer(instance);
            }
        }

        function runTimer(instance) {
            instance.timer = true;
            $timeout(function (instance) {
                if (instance.needToCall === true) {
                    instance.method();
                    instance.needToCall = false;
                    runTimer(instance);
                } else {
                    instance.timer = false;
                }
            }, instance.delay, true, instance);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.core')
        .factory('phonenumberservice', phonenumberservice);

    phonenumberservice.$inject = ['$http', 'exception','$cookies', 'constants'];
    /* @ngInject */
    function phonenumberservice($http, exception, $cookies, constants) {
        var baseUrl = '/api/Twilio';
        var service = {
            validatePhoneNumber: validatePhoneNumber,
            callablePhoneNumber: callablePhoneNumber,
            phoneNumberInfo: phoneNumberInfo
        };

        return service;

        /* Determines if a phone number if valid */
        function validatePhoneNumber(phoneNumber) {
            return $http.put(baseUrl + '/ValidatePhoneNumber', '"' + phoneNumber + '"')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for validate Phone Number')(e);
            }
        }

        // Determines if a phone number is callable. A callable number must also be valid.
        function callablePhoneNumber(phoneNumber) {
            return $http.put(baseUrl + '/CallablePhoneNumber', '"' + phoneNumber + '"')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for callable Phone Number')(e);
            }
        }

        // Gets the extended information about a phone number.
        function phoneNumberInfo(phoneNumber) {
            return $http.put(baseUrl + '/PhoneNumberInfo', '"' + phoneNumber + '"')
                .then(success)
                .catch(fail);

            function success(response) {
                $cookies.put(constants.phoneNumberInfo, JSON.stringify(response.data));
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for phone Number Info')(e);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.core')
        .factory('operatorservice', operatorservice);

    operatorservice.$inject = ['$http', '$q', 'exception', 'logger', 'accountservice', 'enums'];
    /* @ngInject */
    function operatorservice($http, $q, exception, logger, accountservice, enums) {
        var baseUrl = '/api/Operator';
        var service = {
            acceptCall: acceptCall,
            rejectCall: rejectCall,
            get: get,
            addParticipant: addParticipant,
            deleteParticipant: deleteParticipant,
            getAll: getAll,
            getInterpreters: getInterpreters,
            setPhoneNumber: setPhoneNumber,
            setStatus: setStatus,
            setKeepAlive: setKeepAlive,
            getInCallInterpreters: getInCallInterpreters,
            getLoggedInInterpreters: getLoggedInInterpreters,
            findInterpreter: findInterpreter,
            findInterpreterwithGender: findInterpreterwithGender,
            callInterpreter: callInterpreter,
            connectInterpreter: connectInterpreter,
            getCurrentCall: getCurrentCall,
            callLanguageService: callLanguageService,
            conferenceJoin: conferenceJoin,
            setLoginStatus: setLoginStatus,
            getLanguageServiceUsers: getLanguageServiceUsers,
            getLanguageServiceUsersByGroup: getLanguageServiceUsersByGroup,
            checkLanguageServiceTimeout: checkLanguageServiceTimeout,
            updateInterpreterHoldStatus: updateInterpreterHoldStatus,
            updateCustomerHoldStatus: updateCustomerHoldStatus,
            hangupCall: hangupCall,
            disconnectCall: disconnectCall,
            addCallEvent: addCallEvent,
            findLanguageServiceInterpreter: findLanguageServiceInterpreter,
            findLanguageServiceInterpreterByGroup: findLanguageServiceInterpreterByGroup,
            joinInterpretersWithCustomer: joinInterpretersWithCustomer,
            workingResourceRequestExists: workingResourceRequestExists,
            getInterpreterStatistics: getInterpreterStatistics
        };

        return service;

        /* */
        function findInterpreter(languageId, callId) {
            return $http.put(baseUrl + '/Interpreter/' + languageId, { 'callId': callId })
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.findInterpreter')(e);
            }
        }

        function findInterpreterwithGender(languageId, callId, genderId) {
            return $http.put(baseUrl + '/Interpreter/' + languageId, { 'callId': callId, 'genderId': genderId })
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.findInterpreter')(e);
            }
        }

        function updateInterpreterHoldStatus(interpreterId, onHold, callId) {
            return $http.put(baseUrl + '/Interpreter/' + interpreterId + '/Hold/' + onHold, {},
                { params: { callId: callId } })
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.updateInterpreterHoldStatus')(e);
            }
        }

        function updateCustomerHoldStatus(callId, onHold) {
            return $http.put(baseUrl + '/Customer/' + callId + '/Hold/' + onHold, {}, {})
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.updateCustomerHoldStatus')(e);
            }
        }

        function getLanguageServiceUsers(languageId, customerId) {
            return $http.get(baseUrl + '/LanguageService/' + languageId + '/Users/' + customerId)
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.getLanguageServiceUsers')(e);
            }
        }

        function getLanguageServiceUsersByGroup(languageId, customerId, groupId) {
            return $http.get(baseUrl + '/LanguageService/' + languageId + '/Users/' + customerId + '/' + groupId)
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.getLanguageServiceUsersByGroup')(e);
            }
        }

        function checkLanguageServiceTimeout(callId) {
            return $http.get(baseUrl + '/LanguageService/Timeout/' + callId)
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.checkLanguageServiceTimeout')(e);
            }
        }

        function callInterpreter(callId, interpreterId, holdCustomer) {
            return $http.put(baseUrl + '/Interpreter/' + interpreterId + '/Call/' + callId, {},
                { params: { holdCustomer: holdCustomer } })
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.callInterpreter')(e);
            }
        }

        function connectInterpreter(callId, interpreterId) {
            return $http.put(baseUrl + '/Interpreter/' + interpreterId + '/Connect/' + callId, {})
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.connectInterpreter')(e);
            }
        }

        function callLanguageService(callId, languageServiceId, languageId) {
            return $http.put(baseUrl + '/LanguageService/' + languageServiceId + '/Call/' + callId + '/LanguageId/' + languageId)
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.callLanguageService')(e);
            }
        }

        function conferenceJoin(callId) {
            return $http.put(baseUrl + '/Conference/Join/' + callId)
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.conferenceJoin')(e);
            }
        }

        function getCurrentCall() {
            return $http.get(baseUrl + '/CurrentCall/')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.getCurrentCall')(e);
            }
        }

        function acceptCall(callId, phoneNumber) {
            return $http.put(baseUrl + '/Call/' + callId + '/Accept', { 'phoneNumber': phoneNumber })
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.acceptCall')(e);
            }
        }

        function rejectCall(callId, fromPhoneNumber, customerId) {
            return $http.put(baseUrl + '/Call/' + callId + '/Reject', { 'fromPhoneNumber': fromPhoneNumber, 'customerId': customerId })
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.rejectCall')(e);
            }
        }

        function hangupCall(callId, sayMessage) {
            return $http.put(baseUrl + '/Call/' + callId + '/Hangup', {}, { params: { 'sayMessage': sayMessage } })
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.hangupCall')(e);
            }
        }

        function disconnectCall(callId) {
            return $http.put(baseUrl + '/Call/' + callId + '/Disconnect')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.disconnectCall')(e);
            }
        }

        function addCallEvent(eventName, callId) {
            return $http.put(baseUrl + '/Call/' + callId + '/CallEvent/' + eventName)
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.addCallEvent')(e);
            }
        }
        function addParticipant(callId, phoneNumber) {
            return $http.post(baseUrl + '/Call/' + callId + '/Participant', '"' + phoneNumber + '"')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.addParticipant')(e);
            }
        }

        function deleteParticipant(participantCallSid, callId) {
            return $http.delete(baseUrl + '/Call/' + callId + '/Participant/' + participantCallSid)
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.deleteParticipant')(e);
            }
        }

        /* */
        function get() {
            return $http.get(baseUrl)
                .then(success)
                .catch(fail);

            function success(response) {
                var user = {
                    userId: response.data.Id,
                    username: response.data.Username,
                    role: 'Operator'
                };
                accountservice.setUser(user);
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.get')(e);
            }
        }

        /* */
        function getAll() {
            return $http.get(baseUrl + '/Operators')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.getAll')(e);
            }
        }

        /* */
        function getInterpreters() {
            return $http.get(baseUrl + '/Interpreters')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.getInterpreters')(e);
            }
        }

        /* */
        function setStatus(status, reason) {
            return $http.post(baseUrl + '/Status', '"' + status + '"', { params: { reason: reason } })
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.setStatus')(e);
            }
        }

        /* */
        function setKeepAlive() {
            return $http.put(baseUrl + '/KeepAlive')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.setKeepAlive')(e);
            }
        }

        /* */
        function setLoginStatus(interpreterId, status, reason) {
            return $http.post(baseUrl + '/Status/Interpreter/' + interpreterId, '"' + status + '"', { params: { reason: reason } })
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.setLoginStatus')(e);
            }
        }

        /* */
        function setPhoneNumber(phoneNumber) {
            return $http.put(baseUrl + '/TempPhoneNumber', '"' + phoneNumber + '"')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.setPhoneNumber')(e);
            }
        }

        /* */
        function getInCallInterpreters() {
            return $http.get(baseUrl + '/InCallInterpreters')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.getInCallInterpreters')(e);
            }
        }

        /* */
        function getLoggedInInterpreters() {
            return $http.get(baseUrl + '/Interpreters/LoggedIn')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.getLoggedInInterpreters')(e);
            }
        }

        /* backward compatibility this function need to remove next release */
        function findLanguageServiceInterpreter(languageId, customerId, callId) {
            return getLanguageServiceUsers(languageId, customerId)
                .then(onGetLanguageServiceUsers)
                .then(function (languageServiceId) { return callLanguageService(callId, languageServiceId, languageId); })
                .then(function (data) { return data === false ? $q.reject() : $q.resolve(); })
                .catch(onError);

            function onGetLanguageServiceUsers(data) {
                if (data !== '' && data.length > 0 && data[0]) {
                    return data[0];
                } else {
                    return $q.reject();
                }
            }

            function onError() {
                accountservice.logMessage('operatorservice.findLanguageServiceInterpreter Action Failed|LanguageId:' +
                    languageId + ', CallId:' + callId + ', CustomerId:' + customerId, enums.LogLevel.Warn);
            }
        }

        /**/
        function findLanguageServiceInterpreterByGroup(languageId, customerId, callId, lsGroupId) {
            return getLanguageServiceUsersByGroup(languageId, customerId, lsGroupId)
                .then(onGetLanguageServiceUsers)
                .then(function (languageServiceId) { return callLanguageService(callId, languageServiceId, languageId); })
                .then(function (data) { return data === false ? $q.reject() : $q.resolve(); })
                .catch(onError);

            function onGetLanguageServiceUsers(data) {
                if (data !== '' && data.length > 0 && data[0]) {
                    return data[0];
                } else {
                    return $q.reject();
                }
            }

            function onError() {
                accountservice.logMessage('operatorservice.findLanguageServiceInterpreterByGroup Action Failed|LanguageId:' +
                    languageId + ', CallId:' + callId + ', CustomerId:' + customerId, enums.LogLevel.Warn);
            }
        }

        function workingResourceRequestExists(callId) {
            return $http.get(baseUrl + '/Call/' + callId + '/WorkingResourceRequestExists')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.workingResourceRequestExists')(e);
            }
        }

        function joinInterpretersWithCustomer(callId, interpreterId, relayInterpreterId) {
            if (!relayInterpreterId || !interpreterId) {
                return $q.reject();
            }

            return connectInterpreter(callId, interpreterId)
                .then(onConnectInterpreter)
                .then(function () { return connectInterpreter(callId, relayInterpreterId); })
                .then(onConnectInterpreter)
                .then(onSuccess)
                .catch(onError);

            function onConnectInterpreter(data) {
                return data === false ? $q.reject() : data;
            }

            function onSuccess(data) {
                hangupCall(callId, 'Thank you for connecting the interpreters.');
            }

            function onError() {
                accountservice.logMessage('operatorservice.joinInterpretersWithCustomer Action Failed|CallId:' +
                    callId, enums.LogLevel.Warn);
                return $q.reject();
            }
        }

        function getInterpreterStatistics(languageId, interpreterPoolId, secondaryInterpreterPoolId, thirdInterpreterPoolId, fourthInterpreterPoolId) {
            var url = baseUrl + '/Interpreters/Statistic' + '/Language/' + languageId + '/Pool/' + interpreterPoolId;

            if (secondaryInterpreterPoolId) {
                url += '?secondaryPoolId=' + secondaryInterpreterPoolId;
                if (thirdInterpreterPoolId) {
                    url += '&thirdPoolId=' + thirdInterpreterPoolId;
                    if (fourthInterpreterPoolId) {
                        url += '&fourthPoolId=' + fourthInterpreterPoolId;
                    }
                }
            }

            return $http.get(url)
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR failed for operatorservice.getInterpreterStatistics')(e);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.core')
        .factory('monitorservice', monitorservice);

    monitorservice.$inject = ['$http', 'exception'];
    /* @ngInject */
    function monitorservice($http, exception) {
        var baseUrl = '/api/Monitor';
        var service = {
            get: get,
            setStatus: setStatus,
            setPhoneNumber: setPhoneNumber,
            listen: listen
        };

        return service;

        /* */
        function get() {
            return $http.get(baseUrl)
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for get monitor')(e);
            }
        }

        /* */
        function setStatus(status, reason) {
            return $http.post(baseUrl + '/Status', '"' + status + '"', { params: { reason: reason } })
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for set status')(e);
            }
        }

        /* */
        function setPhoneNumber(phoneNumber) {
            return $http.put(baseUrl + '/TempPhoneNumber', '"' + phoneNumber + '"')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for set phone number')(e);
            }
        }

        /* */
        function listen(callId) {
            return $http.put(baseUrl + '/Listen/' + callId)
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for listen')(e);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.core')
        .factory('latencyservice', latencyservice)
        .run(['latencyservice', function (latencyservice) {
            latencyservice.init();
        }]);

    latencyservice.$inject = ['$q', '$injector', '$http', 'preferences', 'telemetryservice'];

    //Uses '/api/Diagnostics/Ping API to measure request latency It means time of sending request from client to server + time of sending response from server to client. Server processing time will not be included.
    //This API is very fast, server processing time is less that 1 ms, so we can ignore it (assume it is 0 ms.)
    function latencyservice($q, $injector, $http, preferences, telemetryService) {
        //disable latency calculation by default
        var defaultMeasuringInterval = 0;

        var settings;

        function init() {
            resetSettings();

            //User initializes later that this code, so we need wait some time till user loggs in, then we will have userId needed to retrieve settings
            setTimeout(measureLatency, 3000);
        }

        return {
            init: init
        };

        function measureLatency() {
            serviceEnabled().then(
                function (settings) {
                    var sentTime = new Date();

                    $http.get('/api/Diagnostics/Ping')
                        .then(function (data) {
                            var receivedTime = new Date();
                            var latencyMs = receivedTime.getTime() - sentTime.getTime();
                            var event =
                                {
                                    userId: settings.userId,
                                    userName: settings.userName,
                                    userRole: settings.userRole
                                };
                            var eventMetrics =
                                {
                                    latencyMs: latencyMs
                                };

                            telemetryService.logEvent('Requests Latency', event, eventMetrics);
                        });

                    setTimeout(measureLatency, settings.measuringInterval * 60000);
                })
                .catch(function (e) {
                    //even if latency calculation is not enabled for current user it could be enabled for other user that will login, so we keep executing this function (idle) with default interval
                    setTimeout(measureLatency, defaultMeasuringInterval * 60000);
                });
        }

        function resetSettings() {
            settings = {
                userId: null,
                userName: null,
                userRole: null,
                measuringInterval: defaultMeasuringInterval
            };
        }

        //requests latency settings from server (LatencyMeasuringInterval)
        function serviceEnabled() {
            var defer = $q.defer();

            var loggedUserInfo = $injector.get('accountservice').getCurrentUser();

            // just using default latency setting when user not logged
            if (!loggedUserInfo || !loggedUserInfo.id || !loggedUserInfo.name || !loggedUserInfo.role) {
                resetSettings();
                defer.reject();
            }
            else {
                //if the same logged user just use cached settings
                if (settings.userId === loggedUserInfo.id) {
                    if (settings.measuringInterval === 0) {
                        defer.reject();
                    }
                    else {
                        defer.resolve(settings);
                    }
                }
                //if logged user changed reload settings from server for new user.
                else {
                    resetSettings();

                    var appSettingsService = $injector.get('appsettingsservice');

                    appSettingsService.getAppSetting(preferences.LatencyMeasuringInterval, defaultMeasuringInterval, loggedUserInfo.id)
                        .then(function (data) {
                            //update cached settings if received from server
                            settings.measuringInterval = parseInt(data, 10);
                            settings.userId = loggedUserInfo.id;
                            settings.userName = loggedUserInfo.name;
                            settings.userRole = loggedUserInfo.role;
                            //0 - means that it will be disabled
                            //TODO: check if measuringInterval from server could be '0' (string). JSHint requires ===
                            if (settings.measuringInterval === 0) {
                                defer.reject();
                            }
                            else {
                                defer.resolve(settings);
                            }
                        })
                        .catch(function (e) {
                            //if can not receive from server than set setting to default
                            resetSettings();
                            defer.reject();
                        });
                }
            }

            return defer.promise;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.core')
        .factory('interpreterservice', interpreterservice);

    interpreterservice.$inject = ['$http', '$q', 'exception', 'logger', 'accountservice'];
    /* @ngInject */
    function interpreterservice($http, $q, exception, logger, accountservice) {
        var baseUrl = '/api/Interpreter';
        var service = {
            acceptCall: acceptCall,
            rejectCall: rejectCall,
            get: get,
            addParticipant: addParticipant,
            deleteParticipant: deleteParticipant,
            setStatus: setStatus,
            setKeepAlive: setKeepAlive,
            setStatusAtomic: setStatusAtomic,
            setPhoneNumber: setPhoneNumber,
            getCurrentCall: getCurrentCall,
            reconnectCall: reconnectCall
        };

        return service;

        /* */

        function getCurrentCall() {
            return $http.get(baseUrl + '/CurrentCall/')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for get current call')(e);
            }
        }

        function acceptCall(callSid, phoneNumber, languageId, customerId, fromPhoneNumber) {
            console.log('callid from accept service' + callSid);
            return $http.put(baseUrl + '/Call/' + callSid + '/Accept',
                {
                    'phoneNumber': phoneNumber,
                    'languageId': languageId,
                    'customerId': customerId,
                    'fromPhoneNumber': fromPhoneNumber
                })
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for accept call')(e);
            }
        }

        /* */
        function rejectCall(callSid, languageId, customerId, fromPhoneNumber) {
            console.log('callid from reject service' + callSid);
            return $http.put(baseUrl + '/Call/' + callSid + '/Reject', { 'languageId': languageId, 'customerId': customerId, 'fromPhoneNumber': fromPhoneNumber })
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for reject call')(e);
            }
        }

        function addParticipant(callId, phoneNumber) {
            return $http.post(baseUrl + '/Call/' + callId + '/Participant', '"' + phoneNumber + '"')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for add participant')(e);
            }
        }

        function deleteParticipant(participantCallSid, callId) {
            return $http.delete(baseUrl + '/Call/' + callId + '/Participant/' + participantCallSid)
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for delete participant')(e);
            }
        }

        function get() {
            return $http.get(baseUrl)
                .then(success)
                .catch(fail);

            function success(response) {
                var user = {
                    userId: response.data.Id,
                    username: response.data.Username,
                    role: 'Interpreter'
                };
                accountservice.setUser(user);
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for get interpreter')(e);
            }
        }

        /* */
        function setStatus(status, reason) {
            return $http.post(baseUrl + '/Status', '"' + status + '"', { params: { reason: reason } })
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for set status')(e);
            }
        }

        /* */
        function setKeepAlive() {
            return $http.put(baseUrl + '/KeepAlive')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for set keep alive')(e);
            }
        }

        /* */
        function setStatusAtomic(originalStatus, expectedStatus, reason) {
            return $http.put('/api/Interpreter/Status',
                { 'status': expectedStatus, 'originalStatus': originalStatus }, {
                    params: { reason: reason }
                })
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for set status atomic')(e);
            }
        }

        /* */
        function setPhoneNumber(phoneNumber) {
            return $http.put(baseUrl + '/TempPhoneNumber', '"' + phoneNumber + '"')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for set phone number')(e);
            }
        }

        /* */
        function reconnectCall(callId) {
            return $http.put(baseUrl + '/Reconnect', '"' + callId + '"')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for reconnect call process')(e);
            }
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('vox-leonis.core')
        .factory('internetConnectionChecker', internetConnectionChecker);

    internetConnectionChecker.$inject = ['$injector', '$rootScope', 'enums', '$q'];

    function internetConnectionChecker($injector, $rootScope, enums, $q) {
        var checkConnectionDeferred;
        var connectionState = true;
        var checkConnectionUrl = '/favicon.ico';

        return {
            checkConnection: checkConnection,
            setInternetConnectionState: setInternetConnectionState,
            getInternetConnectionState: getInternetConnectionState,
            isInternetConnectionResponse: isInternetConnectionResponse
        };

        function setInternetConnectionState(state) {
            if (connectionState === state) {
                return;
            }
            
            connectionState = state;
            $rootScope.$broadcast(enums.Events.InternetConnectionStateChanged, state);
        }

        function getInternetConnectionState() {
            return connectionState;
        }

        function checkConnection() {
            //if we have active request for icon we're returning this requests promise
            if (checkConnectionDeferred && !checkConnectionDeferred.promise.$$state.status) {
                return checkConnectionDeferred.promise;
            }

            checkConnectionDeferred = $q.defer();

            var $http = $injector.get('$http');

            //we are checking if site icon is accesable if it's does - the request have failed because of another reason
            //but if icon is not accessable it's mean that internet connection is down (there is no trustworthy built-in ability to check internet connection without doing a request)
            //also to disable browser cache we are adding random number to questy string
            $http.head(checkConnectionUrl + '?v=' + Math.random())
                .then(function () {
                    setInternetConnectionState(true);
                }, function () {
                    setInternetConnectionState(false);
                }).finally(function () {
                    checkConnectionDeferred.resolve();
                });

            return checkConnectionDeferred.promise;
        }

        function isInternetConnectionResponse(response) {
            return response.config.url.indexOf(checkConnectionUrl) >= 0;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.core')
        .factory('httpInterceptor', httpInterceptor);

    httpInterceptor.$inject = ['$injector', '$q', 'preferences', 'telemetryservice'];

    //Intercepts each http request made by Angular.
    //For more information please look https://docs.angularjs.org/api/ng/service/$http#interceptors
    function httpInterceptor($injector, $q, preferences, telemetryService) {

        var requests = {};

        //later it can be moved to preferences, milliseconds
        var requestTimeout = 10000;

        var settings;

        //we need that to do not cause generation of multiple requests to retrieve settings till we not received response
        var loadingSettings = false;

        var defaultEnabled = false;
        //if can not receive it from server
        var defaultRequestMinDuration = 1000;

        resetSettings();

        setInterval(cleanupRequests, 1000);

        function buildEvent(requestInfo) {
            var result = {
                url: requestInfo.url,
                sentTime: requestInfo.sentTime,
                method: requestInfo.method,
                userId: requestInfo.userId,
                userName: requestInfo.userName,
                userRole: requestInfo.userRole
            };
            if (requestInfo.headers) {
                result.headers = requestInfo.headers;
            }

            return result;
        }

        //removes from the dictionary requests for which timeout is passed.
        function cleanupRequests() {
           
            Object.keys(requests).forEach(function (key) {
                var requestInfo = requests[key];
                var utcNow = new Date();
                var requestDuration = utcNow.getTime() - requestInfo.sentTime.getTime();

                if (requestDuration > requestTimeout) {
                    requestInfo.userId = settings.userId;
                    requestInfo.userName = settings.userName;
                    requestInfo.userRole = settings.userRole;

                    var event = buildEvent(requestInfo);

                    event.waitingTimeMs = requestDuration;

                    // Add custom event for ui requests that did not received answers from server during 'requestTimeout'
                    telemetryService.logEvent('Timeout request', event);

                    //will anyway need to delete outdated item regarding of interceptor ON or OFF, because request can be from previously logged user, for which interceptor was ON, even if for current user interceptor OFF
                    delete requests[key];
                }
            });
        }

        function resetSettings() {
            settings = {
                userId: null,
                userName: null,
                userRole: null,
                enabled: defaultEnabled,
                minRequestDuration: defaultRequestMinDuration
            };
        }

        //request interceptor settings from server
        function serviceEnabled() {
            var defer = $q.defer();

            var loggedUserInfo = $injector.get('accountservice').getCurrentUser();

            // use default setting when user not logged
            if (!loggedUserInfo || !loggedUserInfo.id || !loggedUserInfo.name || !loggedUserInfo.role) {
                resetSettings();
                defer.reject();
            }
            else {
                //if the same logged user just use cached settings
                if (settings.userId === loggedUserInfo.id) {
                    if (settings.enabled) {
                        defer.resolve(settings);
                    }
                    else {
                        defer.reject();
                    }
                }
                //if logged user changed reload settings from server for new user.
                else {
                    var appSettingsService = $injector.get('appsettingsservice');

                    if (!loadingSettings) {
                        loadingSettings = true;

                        appSettingsService.getAppSetting(preferences.UIRequestMinDuration, defaultRequestMinDuration, loggedUserInfo.id)
                            .then(function (data) {
                                //update cached value if received from server
                                settings.minRequestDuration = parseInt(data, 10);
                                //if 0 - turn off interceptor
                                settings.enabled = settings.minRequestDuration > 0;
                                settings.userId = loggedUserInfo.id;
                                settings.userName = loggedUserInfo.name;
                                settings.userRole = loggedUserInfo.role;
                                loadingSettings = false;
                                if (settings.enabled) {
                                    defer.resolve(settings);
                                }
                                else {
                                    defer.reject();
                                }
                            })
                            .catch(function (e) {
                                //if can not receive from server than set to default
                                resetSettings();
                                loadingSettings = false;
                                defer.reject();
                            });
                    }
                    else {
                        //disable interceptor while waiting for settings from server
                        defer.reject();
                    }
                }
            }

            return defer.promise;
        }

        return {

            request: function (rawRequest) {

                serviceEnabled().then(
                    function (settings) {
                        rawRequest.guid = $injector.get('utilities').createGuid();

                        //builds request object for storing in dictionary till receiving response.
                        var requestInfo = {
                            url: rawRequest.url,
                            method: rawRequest.method,
                            headers: rawRequest.headers ? rawRequest.headers : '',
                            sentTime: new Date()
                        };

                        if (rawRequest.headers) {
                            requestInfo.headers = rawRequest.headers;
                        }

                        //store requestInfo in dictionary
                        requests[rawRequest.guid] = requestInfo;
                    });

                return rawRequest;
            },

            response: function (rawResponse) {

                serviceEnabled().then(
                    function (settings) {
                        var requestInfo = requests[rawResponse.config.guid];
                        //Request can be already removed by cleanupRequests() if the response came too late (after waiting timeout)
                        if (requestInfo) {
                            var utcNow = new Date();
                            requestInfo.requestDuration = utcNow.getTime() - requestInfo.sentTime.getTime();

                            //Ignore the request if it's duration less than specified. Only long requests are interesting.
                            if (requestInfo.requestDuration >= settings.minRequestDuration) {

                                requestInfo.userId = settings.userId;
                                requestInfo.userName = settings.userName;
                                requestInfo.userRole = settings.userRole;

                                var event = buildEvent(requestInfo);

                                if (rawResponse.status) {
                                    event.status = rawResponse.status.toString();
                                }
                                if (rawResponse.statusText) {
                                    event.statusCode = rawResponse.statusText.toString();
                                }

                                var eventMetrics = { 'durationMs': requestInfo.requestDuration };

                                // Primary custom event. Writes duration of each request to each url (url, user, request params, response status code and additional params will be logged).
                                telemetryService.logEvent('Request duration', event, eventMetrics);
                            }
                        }
                    });

                return rawResponse;
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.core')
        .factory('dataservice', dataservice);

    dataservice.$inject = ['$http', '$q', 'exception', 'logger'];
    /* @ngInject */
    function dataservice($http, $q, exception, logger) {
        var service = {
            getLanguages: getLanguages,
            getPools: getPools,
            getCaseDisplay: getCaseDisplay
        };

        return service;

        /* */
        function getLanguages() {
            return $http.get('/api/Languages', {cache: true}) // cached because we don't expect this to change during a session
                .then(success)
                .catch(fail);

            function success(response) {
                // Convert from array to dictionary
                return response.data.reduce(function(map, language) {
                    map[language.Id] = language.Name;
                    return map;
                }, {});
            }

            function fail(e)
            {
                return exception.catcher('XHR Failed for get languages')(e);
            }
        }

        /* */
        function getPools() {
            return $q.when([{ Id: 0, Name: 'Default' }, { Id: 1, Name: 'Another Pool' }, { Id: 5, Name: 'Luke\'s Pool' }]
                .reduce(function (map, pool) {
                    map[pool.Id] = pool.Name;
                    return map;
                }, {}));
        }

        // Return Case display data for a call
        function getCaseDisplay(callId) {
            return $http.get('/api/Case/Call/' + callId + '/Display')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for get case display')(e);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.core')
        .factory('callservice', callservice);

    callservice.$inject = [];
    
    /* @ngInject */
    function callservice() {
        var service = {
            interpreterDropped: interpreterDropped,
            getInterpreterDroppedInfo: getInterpreterDroppedInfo,
            findLastEventIndex: findLastEventIndex
        };

        return service;

        function interpreterDropped(callEvents) {
            return findLastEventIndex(callEvents, 'InterpreterDisconnected') >= 0;
        }

        function getInterpreterDroppedInfo(callEvents, languageId, interpreters) {

            if (interpreters === undefined) {
                return null;
            }

            var eventIndex = findLastEventIndex(callEvents, 'InterpreterDisconnected', languageId);

            if (eventIndex < 0) {
                return null;
            }

            var event = callEvents[eventIndex];

            var reason = null;
            var userId = null;

            if (callEvents[eventIndex - 1] !== undefined && callEvents[eventIndex - 1].StatusEvent === 'RouteToOperator') {
                reason = 'Customer Pressed * to Operator.';
            }

            for (var j = 0; j < interpreters.length; j++) {
                if (interpreters[j].Id === event.UserId) {
                    for (var k = 0; k < interpreters[j].LanguagePayrates.length; k++) {
                        if (interpreters[j].LanguagePayrates[k].LanguageID === languageId) {
                            reason = 'Interpreter ' + event.UserFirstName + ' ' + event.UserLastName + ' disconnected from the call.';
                            userId = event.UserId;
                        }
                    }
                }
            }

            return {
                interpreterId: userId,
                reason: reason
            };
        }

        function findLastEventIndex(callEvents, eventName) {
            if (!callEvents) {
                return -1;
            }

            for (var i = callEvents.length - 1; i >= 0; i--) {
                var event = callEvents[i];

                if (event.StatusEvent === eventName) {
                    return i;
                }
            }

            return -1;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.core')
        .factory('cacheservice', cacheservice);

    cacheservice.$inject = ['CacheFactory', 'constants', 'preferences', 'appsettingsservice'];
    /* @ngInject */
    function cacheservice(CacheFactory, constants, preferences, appsettingsservice) {
        var expirationTime = 1000;
        if (!CacheFactory.get(constants.dataCache)) {
            var dataCache = new CacheFactory(constants.dataCache, {
                maxAge: expirationTime, // Items added to this cache expire after 1 second
                cacheFlushInterval: 60 * 60 * 1000, // This cache will clear itself every hour
                deleteOnExpire: 'aggressive' // Items will be deleted from this cache when they expire
            });
        }
        appsettingsservice.getAppSetting(preferences.DataCacheExpirationTimeMilliseconds, expirationTime).then(function (data) {
            var dataCache = CacheFactory.get(constants.dataCache);
            dataCache.$$maxAge = data;
        });

        var service = {
            dataCache: CacheFactory.get(constants.dataCache)
        };

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.core')
        .factory('appsettingsservice', appsettingsservice);

    appsettingsservice.$inject = ['$http', 'exception'];
    /* @ngInject */
    function appsettingsservice($http, exception) {
        var service = {
            getAppSetting: getAppSetting,
            getIVPFrontEndUrl: getIVPFrontEndUrl,
            getOVPFrontEndUrl: getOVPFrontEndUrl,
            getAppVersion: getAppVersion
        };

        return service;

        /* */
        function getAppSetting(appSetting, defaultValue, userId) {
            return $http.get('/api/AppSettings/' + appSetting + '?defaultValue=' + defaultValue + '&userId=' + userId)
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for get app setting')(e);
            }
        }

        function getIVPFrontEndUrl() {
            return $http.get('/api/AppSettings/GetIVPFrontEndUrl')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for get iVP FrontEnd Url')(e);
            }
        }

        function getOVPFrontEndUrl() {
            return $http.get('/api/AppSettings/GetOVPFrontEndUrl')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('XHR Failed for get oVP FrontEnd Url')(e);
            }
        }

        function getAppVersion() {
            return $http.get('/api/AppVersion')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return 'unknown';
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.core')
        .factory('adminservice', adminservice);

    adminservice.$inject = ['$http', '$q', 'exception', 'logger'];
    /* @ngInject */
    function adminservice($http, $q, exception, logger) {
        var service = {
            getCalls: getCalls
        };

        return service;

        /* */
        function getCalls(recentCallHours, forceGet) {
            return $http.get('/api/Admin/Calls/' + recentCallHours + '/ForceGet/' + forceGet)
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e)
            {
                return exception.catcher('XHR failed for adminservice.getCalls')(e);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.core')
        .factory('accountservice', accountservice);

    accountservice.$inject = ['$http', '$q', 'exception', 'logger'];
    /* @ngInject */
    function accountservice($http, $q, exception, logger)
    {
        var service = {
            login: login,
            loginADB2C: loginADB2C,
            loginADB2CAzureOnly: loginADB2CAzureOnly,
            voicePortalLoginMode: voicePortalLoginMode,
            logout: logout,
            getCurrentUser: getCurrentUser,
            getCurrentUserId: getCurrentUserId,
            setUser: setUser,
            getRoles: getRoles,
            logMessage: logMessage,

            getWebRTCAccessTokens: getWebRTCAccessTokens,
            getPreflightAccessToken: getPreflightAccessToken
        };

        var userInfo = null;

        return service;

        function login(username, password) {
            return $http.post('/api/Account/Login',
                {'Username': username, 'Password': password, 'RememberMe': false})
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('Login')(e);
            }
        }

        function loginADB2C() {
            return $http.get('/api/Account/ADB2CLogin')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                if (e.status === 401) {
                    return { Failure: null, Roles: null};
                }

                return exception.catcher('loginADB2C')(e);
            }
        }

        function loginADB2CAzureOnly() {
            return $http.get('/api/Account/ADB2CLogin')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                if (e.status === 401) {
                    location.replace('/ADB2C/Login');
                    return { Failure: null, Roles: null };
                }
                return logout().finally(function () {
                    location.replace('/ADB2C/Logout');
                    return exception.catcher('loginADB2CAzureOnly')(e);
                });
            }
        }

        function logout() {
            return $http.post('/api/Account/Logoff')
                .then(success)
                .catch(fail);

            function success(response) {
                userInfo = null;
                return response.data;
            }

            function fail(e) {
                return exception.catcher('Logout')(e);
            }
        }

        function voicePortalLoginMode() {
            return $http.get('/api/Account/VoicePortalLoginMode')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {

                return exception.catcher('voicePortalLoginMode')(e);
            }
        }

        function getCurrentUser() {
            return userInfo;
        }

        function getCurrentUserId() {
            return userInfo ? userInfo.id : '';
        }

        function setUser(user) {
            userInfo = {
                id: user.userId,
                name: user.username,
                role: user.role
            };
        }

        function getRoles(suppressError) {
            return $http.get('/api/Account/Roles')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('Roles', suppressError)(e);
            }
        }

        function logMessage(message, logLevel) {
            return $http.post('/api/Account/LogMessage/' + logLevel, '"' + message + '"')
                .catch(fail);

            function fail(e) {
                return exception.catcher('Log Message failed')(e);
            }
        }

        function getWebRTCAccessTokens() {
            return $http.get('/api/Account/WebRtcAccessTokens')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('AccessTokens')(e);
            }
        }

        function getPreflightAccessToken() {
            return $http.get('/api/Account/PreflightWebRtcAccessToken')
                .then(success)
                .catch(fail);

            function success(response) {
                return response.data;
            }

            function fail(e) {
                return exception.catcher('PreflightWebRtcAccessToken')(e);
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('blocks.router', [
        'ui.router',
        'blocks.logger'
    ]);
})();

/* Help configure the state-base ui.router */
(function() {
    'use strict';

    angular
        .module('blocks.router')
        .provider('routerHelper', routerHelperProvider);

    routerHelperProvider.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider'];
    /* @ngInject */
    function routerHelperProvider($locationProvider, $stateProvider, $urlRouterProvider) {
        /* jshint validthis:true */
        var config = {
            docTitle: undefined,
            resolveAlways: {}
        };

        $locationProvider.html5Mode(true);

        this.configure = function(cfg) {
            angular.extend(config, cfg);
        };

        this.$get = RouterHelper;
        RouterHelper.$inject = ['$location', '$rootScope', '$state', 'logger', '$uibModalStack'];
        /* @ngInject */
        function RouterHelper($location, $rootScope, $state, logger, $uibModalStack) {
            var handlingStateChangeError = false;
            var hasOtherwise = false;
            var stateCounts = {
                errors: 0,
                changes: 0
            };

            var service = {
                configureStates: configureStates,
                getStates: getStates,
                stateCounts: stateCounts
            };

            init();

            return service;

            ///////////////

            function configureStates(states, otherwisePath) {
                states.forEach(function(state) {
                    state.config.resolve =
                        angular.extend(state.config.resolve || {}, config.resolveAlways);
                    $stateProvider.state(state.state, state.config);
                });
                if (otherwisePath && !hasOtherwise) {
                    hasOtherwise = true;
                    $urlRouterProvider.otherwise(otherwisePath);
                }
            }

            function handleRoutingErrors() {
                // Route cancellation:
                // On routing error, go to the dashboard.
                // Provide an exit clause if it tries to do it twice.
                $rootScope.$on('$stateChangeError',
                    function(event, toState, toParams, fromState, fromParams, error) {
                        if (handlingStateChangeError) {
                            return;
                        }
                        stateCounts.errors++;
                        handlingStateChangeError = true;
                        var destination = (toState &&
                            (toState.title || toState.name || toState.loadedTemplateUrl)) ||
                            'unknown target';
                        var msg = 'Error routing to ' + destination + '. ' +
                            (error.data || '') + '. <br/>' + (error.statusText || '') +
                            ': ' + (error.status || '');
                        logger.warning(msg, [toState]);
                        $location.path('/');
                    }
                );
            }

            function init() {
                handleRoutingErrors();
                stateChangeStart();
                updateDocTitle();
            }

            function getStates() { return $state.get(); }

            function stateChangeStart() {
                $rootScope.$on('$stateChangeStart',
                    function (event, toState, toParams, fromState, fromParams, options) {
                        // get rid of any existing modals since we are switching to a new state
                        $uibModalStack.dismissAll('');
                    }
                );
            }

            function updateDocTitle() {
                $rootScope.$on('$stateChangeSuccess',
                    function(event, toState, toParams, fromState, fromParams) {
                        stateCounts.changes++;
                        handlingStateChangeError = false;
                        var title = config.docTitle;
                        $rootScope.title = title; // data bind to <title>
                    }
                );
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('blocks.logger', []);
})();

(function() {
    'use strict';

    angular
        .module('blocks.logger')
        .factory('logger', logger);

    logger.$inject = ['$log', 'toastr'];

    /* @ngInject */
    function logger($log, toastr) {
        var service = {
            showToasts: true,

            error   : error,
            info    : info,
            success : success,
            warning : warning,
            debug   : debug,

            // straight to console; bypass toastr
            log     : $log.log
        };

        return service;
        /////////////////////

        function error(message, data, title) {
            toastr.error(message, title);
            data = (data === undefined) ? '' : data;
            $log.error('Error: ' + message, data);
        }

        function info(message, data, title) {
            //toastr.info(message, title);
            data = (data === undefined) ? '' : data;
            $log.info('Info: ' + message, data);
        }

        function success(message, data, title) {
            //toastr.success(message, title);
            data = (data === undefined) ? '' : data;
            $log.info('Success: ' + message, data);
        }

        function warning(message, data, title) {
            //toastr.warning(message, title);
            data = (data === undefined) ? '' : data;
            $log.warn('Warning: ' + message, data);
        }

        function debug(message, data, title) {
            toastr.error(message, title);
            data = (data === undefined) ? '' : data;
            $log.debug('Debug: ' + message, data);
        }
    }
}());

(function() {
    'use strict';

    angular.module('blocks.exception', ['blocks.logger']);
})();

(function () {
    'use strict';

    angular
        .module('blocks.exception')
        .factory('exception', exception);

    /* @ngInject */
    function exception($q, logger) {
        var service = {
            catcher: catcher
        };
        return service;

        function catcher(message, suppressError) {
            return function (e) {
                var thrownDescription;
                var newMessage = message;
                if (e.data && e.data.description) {
                    thrownDescription = '\n' + e.data.description;
                    newMessage = newMessage + thrownDescription;
                    e.data.description = newMessage;
                }
                else if (e.status && e.statusText) {
                    thrownDescription = '\n' + e.status + ':' + e.statusText;
                    newMessage = newMessage + thrownDescription;
                    if (e.data && typeof e.data === 'object') {
                        e.data.description = newMessage;
                    }
                }

                if (!suppressError) {
                    logger.error(newMessage);
                }

                return $q.reject(e);
            };
        }
    }
})();

// Include in index.html so that app level exceptions are handled.
// Exclude from testRunner.html which should run exactly what it wants to run
(function() {
    'use strict';

    angular
        .module('blocks.exception')
        .provider('exceptionHandler', exceptionHandlerProvider)
        .config(config);

    /**
     * Must configure the exception handling
     */
    function exceptionHandlerProvider() {
        /* jshint validthis:true */
        this.config = {
            appErrorPrefix: undefined
        };

        this.configure = function (appErrorPrefix) {
            this.config.appErrorPrefix = appErrorPrefix;
        };

        this.$get = function() {
            return {config: this.config};
        };
    }

    config.$inject = ['$provide'];

    /**
     * Configure by setting an optional string value for appErrorPrefix.
     * Accessible via config.appErrorPrefix (via config value).
     * @param  {Object} $provide
     */
    /* @ngInject */
    function config($provide) {
        $provide.decorator('$exceptionHandler', extendExceptionHandler);
    }

    extendExceptionHandler.$inject = ['$delegate', 'exceptionHandler', 'logger'];

    /**
     * Extend the $exceptionHandler service to also display a toast.
     * @param  {Object} $delegate
     * @param  {Object} exceptionHandler
     * @param  {Object} logger
     * @return {Function} the decorated $exceptionHandler service
     */
    function extendExceptionHandler($delegate, exceptionHandler, logger) {
        return function(exception, cause) {
            var appErrorPrefix = exceptionHandler.config.appErrorPrefix || '';
            var errorData = {exception: exception, cause: cause};
            exception.message = appErrorPrefix + exception.message;
            $delegate(exception, cause);
            /**
             * Could add the error to a service's collection,
             * add errors to $rootScope, log errors to remote web server,
             * or log locally. Or throw hard. It is entirely up to you.
             * throw exception;
             *
             * @example
             *     throw { message: 'error message we added' };
             */
            logger.error(exception.message, errorData);
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('vox-leonis.widgets', [
            'vox-leonis.core'
        ]);
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.widgets')
        .directive('voxWebRtcConnectionQuality', voxWebRtcConnectionQuality);

    /* @ngInject */
    function voxWebRtcConnectionQuality() {
        var directive = {
            bindToController: true,
            controller: WebRtcConnectionQualityController,
            controllerAs: 'vm',
            restrict: 'E',
            replace: true,
            scope: {
            },
            templateUrl: 'app/widgets/vox-web-rtc-connection-quality.html'
        };

        return directive;
    }

    WebRtcConnectionQualityController.$inject = ['$scope', 'enums'];

    /* @ngInject */
    function WebRtcConnectionQualityController($scope, enums) {
        var vm = this;
        var defaultStatusTitle = 'All systems Go!';

        vm.statusClass = 'fad fa-signal';
        vm.statusTitle = defaultStatusTitle;
        vm.errorLevel = 0;

        $scope.$on(enums.Events.WebRtcConnectionQualityChanged, function (event, isError) {
            showWarning(isError);
        });

        function showWarning(isError) {
            if (isError) {
                vm.statusTitle = 'Poor network connection!';
                vm.statusClass = 'fas fa-signal-alt-3 blinkFast alertColor';
            }
            else {
                vm.statusTitle = 'All systems Go!';
                vm.statusClass = 'fad fa-signal';
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.widgets')
        .directive('voxTestCallButton', voxTestCallButton);

    function voxTestCallButton() {
        var directive = {
            bindToController: true,
            controller: TestCallButtonController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'person': '=',
            },
            templateUrl: 'app/widgets/vox-test-call-button.html'
        };
        return directive;
    }

    TestCallButtonController.$inject = ['$scope', 'accountservice', 'preferences', 'appsettingsservice', 'userservice', 'enums', 'usermessageservice'];

    /* @ngInject */
    function TestCallButtonController($scope, accountservice, preferences, appsettingsservice, userservice, enums, usermessageservice) {

        var vm = this;

        setupVarsAndMethods();

        function setupVarsAndMethods() {
            vm.enableTestButton = false;
            vm.testButtonDisabledFactory = true;
            vm.forceButtonToDisable = false;
            vm.logLevel = enums.LogLevel;
            vm.test = test;
            vm.waiting = false;
            vm.isDisabledByPoorLatency = false;
            vm.EnableDisableTestButon = EnableDisableTestButon;
            appsettingsservice.getAppSetting(preferences.DisableStatusChange, vm.IsDisabledStatusChange).then(function (data) {
                vm.isDisabledByPoorLatency = data;
            });
            appsettingsservice.getAppSetting(preferences.TestButtonDisabled, vm.testButtonDisabledDefault).then(function (data) {
                vm.testButtonDisabledFactory = (data === 'true');
                //call this method after getting the preference
                vm.EnableDisableTestButon();
            });
        }
        usermessageservice.subscribe($scope, 'callStatus', function (event, data) {

            vm.person.Status = data.StatusName;
            //Status change should again check the status of test button
            vm.EnableDisableTestButon();
        });

        function EnableDisableTestButon() {
            var statusShouldEnableButton = false;
            switch (vm.person.Status) {

                case enums.PersonStatusNames.Available:
                case enums.PersonStatusNames.Unavailable:
                case enums.PersonStatusNames.NotAvailable:
                case enums.PersonStatusNames.Away:
                case enums.PersonStatusNames.Monitoring:
                    if (vm.isDisabledByPoorLatency && vm.person.UserStatusReason === enums.PersonStatusReason.PoorLatency) {
                        statusShouldEnableButton = false;
                    } else {
                        statusShouldEnableButton = true;
                    }
            }

            if (!vm.testButtonDisabledFactory && statusShouldEnableButton) {
                vm.enableTestButton = true;
                vm.forceButtonToDisable = false;
            }
            else {
                vm.enableTestButton = false;
            }

        }

        function test() {
            //set force to disable as clicking on test call takes some time for status to change from available to alerting, hence disable the button immediately
            vm.waiting = true;
            userservice.testCall().then(function (result) {
                if (result) {
                    accountservice.logMessage('Message: testCall result:' + result, vm.logLevel.Info);
                }
            })
                .catch(function (result) {
                    var msg = JSON.stringify(result);
                    //graylog truncates double quotes before and after curly brackets
                    msg = msg.replaceAll('"', '');

                    if (result.status === -1) {
                        accountservice.logMessage('Message: testCallMethod failed, poor network connectivity. Message:' + msg + ' UserId:' + vm.person.Id, vm.logLevel.Warn);
                    } else {
                        accountservice.logMessage('Message: testCallMethod failed, Message:' + msg + ' UserId:' + vm.person.Id, vm.logLevel.Error);
                    }
                })
                .finally(function () {
                    vm.waiting = false;
                });
        }
    }
})(angular);

(function () {
    'use strict';

    angular
        .module('vox-leonis.widgets')
        .directive('voxSipData', voxSipData);

    /* @ngInject */
    function voxSipData() {
        var directive = {
            bindToController: true,
            controller: SipDataController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'userId': '='
            },
            templateUrl: 'app/widgets/vox-sip-data.html'
        };
        return directive;
    }

    SipDataController.$inject = ['$scope', 'accountservice', 'callEvents', 'enums', 'session', 'usermessageservice', 'userservice', '$interval', 'preferences', 'appsettingsservice'];
    /* @ngInject */
    function SipDataController($scope, accountservice, callEvents, enums, session, usermessageservice, userservice, $interval, preferences, appsettingsservice) {
        var vm = this;

        vm.callId = undefined;
        vm.logLevel = enums.LogLevel;
        vm.sipdata = undefined;
        vm.sipdataCopy = undefined;
        vm.interpreter = undefined;
        vm.operator = undefined;
        vm.roles = session.roles;
        vm.save = save;
        vm.reset = reset;
        vm.sipdataChanged = sipdataChanged;
        vm.showSipdata = showSipdata;
        vm.showSipdataItem = showSipdataItem;
        vm.editSipdataItem = editSipdataItem;
        vm.showOrEditSipdata = showOrEditSipdata;
        vm.showUpdateMessage = false;
        vm.showSaveMessage = false;
        vm.validateSipdata = false;
        vm.handlePattern = handlePattern;

        appsettingsservice.getAppSetting(preferences.ValidateSipdata, 'false').then(function (data) {
            vm.validateSipdata = (data === 'true');
        });

        usermessageservice.subscribe($scope, 'notify', function (event, data) {
            if (data.eventName === 'sipCallDataDetails') {
                vm.callId = data.callId;
                vm.sipdata = [];
                if (!data.sipCallData) {
                    return;
                }
                for (var i = 0; i < data.sipCallData.length; i++) {
                    var item = data.sipCallData[i];
                    if (showSipdataItem(item)) {
                        vm.sipdata.push(item);
                    }
                }
                vm.sipdataCopy = angular.copy(vm.sipdata);
            }
        });

        vm.interpreter = vm.roles.indexOf('Interpreter') >= 0;
        vm.operator = vm.roles.indexOf('Operator') >= 0;

        // Only show the Sipdata Details UI if the user is allowed to view at least 1 Sipdata item
        function showSipdata() {

            if (vm.sipdata) {
                for (var i = 0; i < vm.sipdata.length; i++) {
                    if (showSipdataItem(vm.sipdata[i])) {
                        return true;
                    }
                }
            }

            return false;
        }
        function showSipdataItem(sipdataItem) {
            if (sipdataItem) {
                return showOrEditSipdata(sipdataItem.Visible);
            }

            return false;
        }

        // Only show the Sipdata Items the user is allowed to view
        function editSipdataItem(sipdataItem) {
            if (sipdataItem) {
                return showOrEditSipdata(sipdataItem.Editable);
            }

            return false;
        }

        function reset(index) {
            vm.showUpdateMessage = false;
            if (!vm.sipdata || !vm.sipdata[index]) {
                return;
            }
            vm.sipdata[index].ValueText = vm.sipdataCopy[index].ValueText;
        }

        function save(index) {
            vm.showUpdateMessage = false;
            var updatedSipdata = [vm.sipdata[index]];
            userservice.setSipdata(vm.callId, updatedSipdata).then(function (result) {
                if (result === false) {
                    accountservice.logMessage('sipDataChanged Action Failed|CallId: ' + vm.callId, vm.logLevel.Warn);
                } else {
                    vm.showSaveMessage = true;
                }
                vm.oldValue = vm.sipdataCopy[index].ValueText;
                userservice.addCallEvent(callEvents.SipCallHeaderChanged, vm.callId, vm.oldValue);
                vm.sipdataCopy = angular.copy(vm.sipdata);

                $interval(function () {
                    vm.showSaveMessage = false;
                }, 2000);
            });
        }

        //This filter is for to show the Sipdata Items the user is allowed to view
        $scope.visible = function (sipdataItem) {
            return showSipdataItem(sipdataItem);
        };

        function sipdataChanged(index) {
            if (!vm.sipdata || !vm.sipdata[index]) {
                return;
            }

            if (vm.sipdata[index].ValueText === vm.sipdataCopy[index].ValueText) {
                vm.showUpdateMessage = false;
            } else {
                vm.showUpdateMessage = true;
            }
        }

        function handlePattern(index) {
            var nameRegex = '';

            if (!vm.validateSipdata) {
                return;
            }

            if (!vm.sipdata || !vm.sipdata[index]) {
                return;
            }

            if (vm.sipdata) {

                nameRegex = vm.sipdata[index].MatchPattern;
                return nameRegex;

            } else {
                return;
            }
        }

        function showOrEditSipdata(value) {
            var result = false;

            switch (value) {
                case 1:
                    if (vm.operator) {
                        result = true;
                    }
                    break;
                case 2:
                    if (vm.interpreter) {
                        result = true;
                    }
                    break;
                case 3:
                    result = true;
                    break;
            }

            return result;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.widgets')
        .directive('voxSignalRStatus', voxSignalRStatus);

    /* @ngInject */
    function voxSignalRStatus() {
        var directive = {
            bindToController: true,
            controller: SignalRStatusController,
            controllerAs: 'vm',
            restrict: 'E',
            replace: true,
            scope: {
            },
            templateUrl: 'app/widgets/vox-signal-r-status.html'
        };

        return directive;
    }

    SignalRStatusController.$inject = ['$rootScope', '$scope', '$timeout', 'enums', 'internetConnectionChecker', 'appsettingsservice', 'preferences'];
    /* @ngInject */
    function SignalRStatusController($rootScope, $scope, $timeout, enums, internetConnectionChecker, appsettingsservice, preferences) {
        var vm = this;
        vm.showWarning = false;

        vm.signalRStateNames = { 0: 'connecting', 1: 'connected', 2: 'reconnecting', 4: 'disconnected' };
        vm.signalRStates = { connecting: 0, connected: 1, reconnecting: 2, disconnected: 4 };
        vm.signalRData = {
            connecting: {
                classes: 'blinkSlow warnColor',
                title: 'Connecting...'
            },
            reconnecting: {
                classes: 'blinkSlow warnColor',
                title: 'Reconnecting...'
            },
            disconnected: {
                classes: 'blinkFast alertColor',
                title: 'Connection lost. Refresh the page!'
            }
        };

        $scope.$on(enums.Events.InternetConnectionStateChanged, function (event, state) {
            if (!state) {
                showWarning(vm.signalRStates.disconnected);
            }
            else {
                vm.showWarning = false;
            }
        });

        $scope.$on(enums.Events.SignalRStateChanged, function (event, state) {
            $timeout(function () {
                if (!internetConnectionChecker.getInternetConnectionState()) {
                    showWarning(vm.signalRStates.disconnected);
                }
                else {
                    // when the status is connecting, reconnecting, or disconnected, no alerts will be received by the client
                    switch (state) {
                        case 0:
                        case 2:
                        case 4:
                            showWarning(state);
                            break;
                        default:
                            vm.showWarning = false;
                    }
                }
            });
        });

        function showWarning(state) {
            var signalRStateName = vm.signalRStateNames[state];
            var signalRObject = vm.signalRData[signalRStateName];
            vm.statusClass = 'fa fa-warning ' + signalRObject.classes;
            vm.statusTitle = signalRObject.title;
            vm.showWarning = true;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.widgets')
        .directive('voxPhoneNumber', voxPhoneNumber, ['phonenumberservice']);

    /* @ngInject */
    function voxPhoneNumber(phonenumberservice) {
        var directive = {
            bindToController: true,
            controller: PhoneNumberController,
            controllerAs: 'vm',
            restrict: 'E',
            scope: {
                'phoneNumber': '=',
                'userCountryName': '=',
                'phoneErrorMessage': '=',
                'allowBlankNumbers': '=',
                'allowMobileNumbers': '=',
                'validating': '=?',
                'setUserStatus': '=',
                'personStatus': '=',
                'defaultNumber': '=?',
                'userId': '=?',
                'thirdParty': '=',
            },
            templateUrl: 'app/widgets/vox-phone-number.html',
            link: function postLink(scope, element, attrs, vm) {

                var watch = scope.$watch('vm.phoneNumber', function (newVal) {
                    vm.parse(newVal);
                    if (newVal !== null && vm.validatePhoneCheck === false && (!vm.allowBlankNumbers || (vm.number !== undefined)))
                    {
                        var response = vm.phoneNumberCookie;
                        if (response === null || response === undefined || (response !== undefined && (response.TwilioNumber === null || response.TwilioNumber.PhoneNumber !== newVal)))
                        {
                            return phonenumberservice.phoneNumberInfo(newVal).then(function (data) {
                                if (data)
                                {
                                    setupPhoneResponse(data, vm);
                                }
                                else
                                {
                                    setPhoneMessage(vm, vm.getInvalidErrorMessage(vm.phoneCountryName, vm.phoneNumber), true);
                                }
                            });
                        }
                        else
                        {
                            setupPhoneResponse(response, vm);
                        }
                    }
                    scope.$on('$destroy', function () {
                        watch();
                    });
                });
            }
        };
        return directive;
    }

    function setupPhoneResponse(response, vm) {
        if (!response.Valid)
        {
            setPhoneMessage(vm, vm.getInvalidErrorMessage(vm.phoneCountryName, vm.phoneNumber), true);
        }
        else if (!response.Callable)
        {
            setPhoneMessage(vm, vm.getNotAllowedErrorMessage(vm.phoneCountryName, vm.phoneNumber), true);
        }
        else if (!response.AllowMobilePhone && !vm.allowMobileNumbers)
        {
            setPhoneMessage(vm, vm.getDenyMobileUseErrorMessage(), true);
        }
        else
        {
            setPhoneMessage(vm, undefined, false);
        }
    }

    function setPhoneMessage(vm, message, isError) {
        vm.validating = false;
        vm.phoneErrorMessage = message;

        if (isError)
        {
            vm.color = { color: 'red' };
            vm.phoneErrorMessageChanged(message, vm.setUserStatus);
        } else
        {
            vm.color = {};
        }
    }

    PhoneNumberController.$inject = ['$scope', '$timeout', '$cookies', 'session', 'phonenumberservice', 'appsettingsservice', 'accountservice',
        'constants', 'enums', 'interpreterservice', 'operatorservice', 'monitorservice', '$rootScope', 'preferences'];
    /* @ngInject */
    function PhoneNumberController($scope, $timeout, $cookies, session, phonenumberservice, appsettingsservice, accountservice, constants,
        enums, interpreterservice, operatorservice, monitorservice, $rootScope, preferences) {
        var vm = this;

        // Variables
        var usRequireLengthErrorMessage = 'US numbers require exactly 10 digits.';
        vm.country = undefined;
        vm.number = undefined;
        vm.phoneCountryName = undefined;
        vm.roles = session.roles;
        vm.validatePhoneCheck = false;
        vm.validating = false;
        vm.logLevel = enums.LogLevel;
        vm.phoneNumberCookie = $cookies.get(constants.phoneNumberInfo) !== (null || undefined) ? JSON.parse($cookies.get(constants.phoneNumberInfo)) : undefined;
        vm.premiumRatePhoneNumberPrefixes = [];

        // Functions
        vm.countryDisabled = countryDisabled;
        vm.getDenyMobileUseErrorMessage = getDenyMobileUseErrorMessage;
        vm.getInvalidErrorMessage = getInvalidErrorMessage;
        vm.getNotAllowedErrorMessage = getNotAllowedErrorMessage;
        vm.isPuertoRico = isPuertoRico;
        vm.parse = parse;
        vm.phoneChanged = phoneChanged;
        vm.phoneErrorMessageChanged = phoneErrorMessageChanged;
        vm.resetClicked = resetClicked;
        vm.save = save;

        activate();

        function activate() {
            initValidationTimeoutDuration();

            $scope.$on(enums.Events.ContactMethodChanged, function () {
                return phoneChanged('vox-phone-number_contact_method_changed_event');
            });

            $rootScope.$broadcast(enums.Events.SetTempPhoneNumber);
            if (!vm.thirdParty)
            {
                vm.isTemporaryPhonenumber = vm.defaultNumber !== vm.phoneNumber;
            }
            else
            {
                vm.isTemporaryPhonenumber = false;
            }

            appsettingsservice.getAppSetting(preferences.PremiumRatePhoneNumberPrefix, '', null).then(function (data) {
                try {
                    vm.premiumRatePhoneNumberPrefixes = data.split(';').filter(function (value) { return value !== '';});
                }
                catch (e) {
                }
            });
        }

        function phoneChanged(callerName) {
            if (vm.number !== undefined)
            {
                vm.number = vm.number.replace(/[^\d]/g, '');

                if ((vm.number === '') && vm.allowBlankNumbers)
                {
                    setPhoneMessage(vm, undefined, false);
                    return true;
                }

                if ((vm.country === '1') && (vm.number.length !== 10))
                {
                    setPhoneMessage(vm, usRequireLengthErrorMessage, true);
                    return false;
                }

                if ((vm.phoneErrorMessage !== usRequireLengthErrorMessage) && (vm.phoneNumber === '+' + vm.country + vm.number))
                {
                    return false;
                }

                setPhoneMessage(vm, undefined, false);
                vm.validating = true;

                vm.phoneNumber = '+' + vm.country + vm.number;
                vm.validatePhoneCheck = true;

                accountservice.logMessage('vox-phone-number.phoneNumberChanged, Called by: ' + (callerName ? callerName : 'Unknown') + ', PhoneNumber: ' + vm.phoneNumber, vm.logLevel.Info);

                if (isPremiumRatePhoneNumber(vm.phoneNumber)) {
                    setPhoneMessage(vm, getPremiumRateNumbersNotEnabledMessage(), true);
                    return Promise.resolve();
                }

                return phonenumberservice.phoneNumberInfo(vm.phoneNumber).then(function (response) {
                    if (response)
                    {
                        if (!response.Valid)
                        {
                            setPhoneMessage(vm, vm.getInvalidErrorMessage(vm.phoneCountryName, vm.phoneNumber), true);
                        }
                        else if (!response.Callable)
                        {
                            setPhoneMessage(vm, vm.getNotAllowedErrorMessage(vm.phoneCountryName, vm.phoneNumber), true);
                        }
                        else if (!response.AllowMobilePhone && !vm.allowMobileNumbers)
                        {
                            setPhoneMessage(vm, vm.getDenyMobileUseErrorMessage(), true);
                        }
                        else
                        {
                            setPhoneMessage(vm, undefined, false);
                        }
                        if (!vm.thirdParty && vm.userId)
                        {
                            $timeout(function () { vm.save(callerName); });
                        }
                    }
                    else
                    {
                        setPhoneMessage(vm, vm.getInvalidErrorMessage(vm.phoneCountryName, vm.phoneNumber), true);
                    }
                    if (!vm.thirdParty)
                    {
                        vm.isTemporaryPhonenumber = vm.defaultNumber !== vm.phoneNumber;
                    }
                    else
                    {
                        vm.isTemporaryPhonenumber = false;
                    }
                });
            }

            if (!vm.thirdParty && vm.userId)
            {
                $timeout(function () { vm.save(callerName); });
            }
        }
        function save(caller) {
            accountservice.logMessage('Message: vox-phone-number.Save, Called by: ' + (caller ? caller : '') + ', UserId: ' + vm.userId, vm.logLevel.Info);
            vm.currentRole = $cookies.get(constants.userRole);
            if (vm.currentRole === constants.Operator)
            {
                return operatorservice.setPhoneNumber(vm.phoneNumber).then(function (result) {
                    if (result === false)
                    {
                        accountservice.logMessage('Message:  vox-phone-number.Save action failed, UserId: ' + vm.userId + ', Role: Operator', vm.logLevel.Warn);
                    }
                });
            }
            else if (vm.currentRole === constants.Interpreter)
            {
                return interpreterservice.setPhoneNumber(vm.phoneNumber).then(function (result) {
                    if (result === false)
                    {
                        accountservice.logMessage('Message: vox-phone-number.Save action failed, UserId: ' + vm.userId + ', Role: Interpreter', vm.logLevel.Warn);
                    }
                });
            }
            else if (vm.currentRole === constants.Monitor)
            {
                return monitorservice.setPhoneNumber(vm.phoneNumber).then(function (result) {
                    if (result === false)
                    {
                        accountservice.logMessage('Message: phoneChanged action failed, UserId: ' + vm.userId + ', Role: Monitor', vm.logLevel.Warn);
                    }
                });
            }
            else
            {
                accountservice.logMessage('Message: vox-phone-number.Save, Unable to fetch roles action failed, UserId: ' + vm.userId + ', Role: None', vm.logLevel.Warn);
            }
        }

        function resetClicked() {
            if (vm.personStatus === enums.PersonStatusNames.InCall || vm.personStatus === enums.PersonStatusNames.Reconnect)
            {
                return;
            }
            vm.currentRole = $cookies.get(constants.userRole);
            vm.phoneNumber = vm.defaultNumber;
            if (vm.currentRole === constants.Operator)
            {
                operatorservice.setPhoneNumber(vm.phoneNumber).then(function (data) {
                    if (data === false)
                    {
                        accountservice.logMessage('Message: resetClicked action failed, UserId:' + vm.person.Id, vm.logLevel.Warn);
                    }
                });
            }
            else if (vm.currentRole === constants.Interpreter)
            {
                interpreterservice.setPhoneNumber(vm.phoneNumber);
            }
            else if (vm.currentRole === constants.Monitor)
            {
                monitorservice.setPhoneNumber(vm.phoneNumber);
            }
            vm.isTemporaryPhonenumber = false;
        }

        function initValidationTimeoutDuration() {
            vm.validationTimeoutDuration = 1200;
            appsettingsservice.getAppSetting('Portal_PhoneValidationDelayMilliseconds', vm.validationTimeoutDuration).then(function (data) {
                vm.validationTimeoutDuration = data;
            });
        }

        function getInvalidErrorMessage(countryName, phoneNumber) {
            var errorMessage = 'This phone number is not valid';
            if (countryName === 'USA')
            {
                countryName = isPuertoRico(phoneNumber) ? 'Puerto Rico' : 'the USA';
            }
            errorMessage += (countryName ? (' in ' + countryName) : '.');

            return errorMessage;
        }

        function getPremiumRateNumbersNotEnabledMessage() {
            return 'Premium rate phone numbers are not callable';
        }

        function getNotAllowedErrorMessage(countryName, phoneNumber) {
            var errorMessage = 'Phone numbers in x are not allowed.';
            var replaceText = countryName ? countryName : 'this country';
            replaceText = (countryName === 'USA' && isPuertoRico(phoneNumber)) ? 'Puerto Rico' : replaceText;
            errorMessage = errorMessage.replace('x', replaceText);
            accountservice.logMessage('vox - phone - number.getNotAllowedErrorMessage NotAllowedErrorMessage: ' + errorMessage, ' PhoneNumber: ' + phoneNumber, vm.logLevel.Info);
            return errorMessage;
        }

        function isPuertoRico(phoneNumber) {
            if (phoneNumber !== undefined)
            {
                return phoneNumber.startsWith('+1787') || phoneNumber.startsWith('+1939');
            }
        }

        function getDenyMobileUseErrorMessage() {
            return 'Mobile devices are not allowed. Please set the phone number to a valid landline.';
        }

        function countryDisabled() {

            // SuperUsers have no restrictions
            if (vm.roles && (vm.roles.indexOf('SuperUser') >= 0))
            {
                return false;
            }

            if (vm.userCountryName && (vm.userCountryName !== 'USA'))
            {
                return false;
            }

            return true;
        }

        function parse() {
            if ((vm.phoneNumber !== undefined) && (vm.phoneNumber.length > 0))
            {
                var phoneNumberNoPlus = vm.phoneNumber.replace('+', '');

                var firstFour = phoneNumberNoPlus.substr(0, 4);

                if (countryCodes[firstFour] !== undefined)
                {
                    vm.country = firstFour;
                    vm.number = phoneNumberNoPlus.substr(4);
                    vm.phoneCountryName = countryCodes[firstFour];
                    return;
                }

                var firstThree = phoneNumberNoPlus.substr(0, 3);

                if (countryCodes[firstThree] !== undefined)
                {
                    vm.country = firstThree;
                    vm.number = phoneNumberNoPlus.substr(3);
                    vm.phoneCountryName = countryCodes[firstThree];
                    return;
                }

                var firstTwo = phoneNumberNoPlus.substr(0, 2);

                if (countryCodes[firstTwo] !== undefined)
                {
                    vm.country = firstTwo;
                    vm.number = phoneNumberNoPlus.substr(2);
                    vm.phoneCountryName = countryCodes[firstTwo];
                    return;
                }

                var firstOne = phoneNumberNoPlus.substr(0, 1);

                if (countryCodes[firstOne] !== undefined)
                {
                    vm.country = firstOne;
                    vm.number = phoneNumberNoPlus.substr(1);
                    vm.phoneCountryName = countryCodes[firstOne];
                }
            } else
            {
                vm.country = '1';
                vm.number = undefined;
                vm.phoneCountryName = countryCodes[1];
            }
        }

        function phoneErrorMessageChanged(message, setUserStatus) {
            $rootScope.$broadcast(enums.Events.PhoneErrorMessageChanged, { message: message, setUserStatus: setUserStatus });
        }

        function isPremiumRatePhoneNumber(phoneNumber) {
            return vm.premiumRatePhoneNumberPrefixes
                .map(function (prefix) { return phoneNumber.startsWith(prefix); })
                .some(function (res) { return res; });
        }

        var countryCodes = {
            '1': 'USA',
            '213': 'Algeria',
            '376': 'Andorra',
            '244': 'Angola',
            '1264': 'Anguilla',
            '1268': 'Antigua & Barbuda',
            '54': 'Argentina',
            '374': 'Armenia',
            '297': 'Aruba',
            '61': 'Australia',
            '43': 'Austria',
            '994': 'Azerbaijan',
            '1242': 'Bahamas',
            '973': 'Bahrain',
            '880': 'Bangladesh',
            '1246': 'Barbados',
            '375': 'Belarus',
            '32': 'Belgium',
            '501': 'Belize',
            '229': 'Benin',
            '1441': 'Bermuda',
            '975': 'Bhutan',
            '591': 'Bolivia',
            '387': 'Bosnia Herzegovina',
            '267': 'Botswana',
            '55': 'Brazil',
            '673': 'Brunei',
            '359': 'Bulgaria',
            '226': 'Burkina Faso',
            '257': 'Burundi',
            '855': 'Cambodia',
            '237': 'Cameroon',
            '238': 'Cape Verde Islands',
            '1345': 'Cayman Islands',
            '236': 'Central African Republic',
            '56': 'Chile',
            '86': 'China',
            '57': 'Colombia',
            '269': 'Comoros',
            '242': 'Congo',
            '682': 'Cook Islands',
            '506': 'Costa Rica',
            '385': 'Croatia',
            '53': 'Cuba',
            '90392': 'Cyprus North',
            '357': 'Cyprus South',
            '42': 'Czech Republic',
            '45': 'Denmark',
            '253': 'Djibouti',
            '1809': 'Dominican Republic',
            '593': 'Ecuador',
            '20': 'Egypt',
            '503': 'El Salvador',
            '240': 'Equatorial Guinea',
            '291': 'Eritrea',
            '372': 'Estonia',
            '251': 'Ethiopia',
            '500': 'Falkland Islands',
            '298': 'Faroe Islands',
            '679': 'Fiji',
            '358': 'Finland',
            '33': 'France',
            '594': 'French Guiana',
            '689': 'French Polynesia',
            '241': 'Gabon',
            '220': 'Gambia',
            '7880': 'Georgia',
            '49': 'Germany',
            '233': 'Ghana',
            '350': 'Gibraltar',
            '30': 'Greece',
            '299': 'Greenland',
            '1473': 'Grenada',
            '590': 'Guadeloupe',
            '671': 'Guam',
            '502': 'Guatemala',
            '224': 'Guinea',
            '245': 'Guinea - Bissau',
            '592': 'Guyana',
            '509': 'Haiti',
            '504': 'Honduras',
            '852': 'Hong Kong',
            '36': 'Hungary',
            '354': 'Iceland',
            '91': 'India',
            '62': 'Indonesia',
            '98': 'Iran',
            '964': 'Iraq',
            '353': 'Ireland',
            '972': 'Israel',
            '39': 'Italy',
            '1876': 'Jamaica',
            '81': 'Japan',
            '962': 'Jordan',
            '7': 'Kazakhstan',
            '254': 'Kenya',
            '686': 'Kiribati',
            '850': 'Korea North',
            '82': 'Korea South',
            '965': 'Kuwait',
            '996': 'Kyrgyzstan',
            '856': 'Laos',
            '371': 'Latvia',
            '961': 'Lebanon',
            '266': 'Lesotho',
            '231': 'Liberia',
            '218': 'Libya',
            '417': 'Liechtenstein',
            '370': 'Lithuania',
            '352': 'Luxembourg',
            '853': 'Macao',
            '389': 'Macedonia',
            '261': 'Madagascar',
            '265': 'Malawi',
            '60': 'Malaysia',
            '960': 'Maldives',
            '223': 'Mali',
            '356': 'Malta',
            '692': 'Marshall Islands',
            '596': 'Martinique',
            '222': 'Mauritania',
            '52': 'Mexico',
            '691': 'Micronesia',
            '373': 'Moldova',
            '377': 'Monaco',
            '976': 'Mongolia',
            '1664': 'Montserrat',
            '212': 'Morocco',
            '258': 'Mozambique',
            '95': 'Myanmar',
            '264': 'Namibia',
            '674': 'Nauru',
            '977': 'Nepal',
            '31': 'Netherlands',
            '687': 'New Caledonia',
            '64': 'New Zealand',
            '505': 'Nicaragua',
            '227': 'Niger',
            '234': 'Nigeria',
            '683': 'Niue',
            '672': 'Norfolk Islands',
            '670': 'Northern Marianas',
            '47': 'Norway',
            '968': 'Oman',
            '680': 'Palau',
            '507': 'Panama',
            '675': 'Papua New Guinea',
            '595': 'Paraguay',
            '51': 'Peru',
            '63': 'Philippines',
            '48': 'Poland',
            '351': 'Portugal',
            //'1787': 'Puerto Rico',
            '974': 'Qatar',
            '262': 'Reunion',
            '40': 'Romania',
            '250': 'Rwanda',
            '378': 'San Marino',
            '239': 'Sao Tome & Principe',
            '966': 'Saudi Arabia',
            '221': 'Senegal',
            '381': 'Serbia',
            '248': 'Seychelles',
            '232': 'Sierra Leone',
            '65': 'Singapore',
            '421': 'Slovak Republic',
            '386': 'Slovenia',
            '677': 'Solomon Islands',
            '252': 'Somalia',
            '27': 'South Africa',
            '34': 'Spain',
            '94': 'Sri Lanka',
            '290': 'St. Helena',
            '1869': 'St. Kitts',
            '1758': 'St. Lucia',
            '249': 'Sudan',
            '597': 'Suriname',
            '268': 'Swaziland',
            '46': 'Sweden',
            '41': 'Switzerland',
            '963': 'Syria',
            '886': 'Taiwan',
            '66': 'Thailand',
            '228': 'Togo',
            '676': 'Tonga',
            '1868': 'Trinidad & Tobago',
            '216': 'Tunisia',
            '90': 'Turkey',
            '993': 'Turkmenistan',
            '1649': 'Turks & Caicos Islands',
            '688': 'Tuvalu',
            '256': 'Uganda',
            '44': 'UK',
            '380': 'Ukraine',
            '971': 'United Arab Emirates',
            '598': 'Uruguay',
            '678': 'Vanuatu',
            '379': 'Vatican City',
            '58': 'Venezuela',
            '84': 'Vietnam',
            '1284': 'Virgin Islands - British',
            '1340': 'Virgin Islands - US',
            '681': 'Wallis & Futuna',
            '969': 'Yemen',
            '967': 'Yemen',
            '260': 'Zambia',
            '263': 'Zimbabwe'
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.widgets')
        .directive('voxParticipants', voxParticipants);

    function voxParticipants() {
        var directive = {
            bindToController: true,
            controller: ParticipantsController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'currentCall': '=',
                'interpreter': '=',
                'operator': '=',
                'customer': '='
            },
            link: function postLink(scope, element, args, vm) {
                var participantWatch = scope.$watch('vm.participants', function (newVal, oldVal) {
                    if (newVal !== undefined) {
                        scope.vm.buildParticipants();
                    }
                });

                scope.$on('$destroy', function () {
                    participantWatch();
                });
            },
            templateUrl: 'app/widgets/vox-participants.html'
        };

        return directive;
    }

    ParticipantsController.$inject = ['$scope', 'interpreterservice', 'logger', 'session', 'interpretersignalreceiver', 'operatorservice', 'operatorsignalreceiver', 'accountservice', 'enums',
        'stringResources'];
    /* @ngInject */
    function ParticipantsController($scope, interpreterservice, logger, session, interpretersignalreceiver, operatorservice, operatorsignalreceiver, accountservice, enums,
        stringResources) {
        var vm = this;
        vm.phoneErrorMessage = undefined;
        vm.phoneIsValidating = false;
        vm.participants = angular.copy(vm.currentCall.Participants);
        vm.logLevel = enums.LogLevel;
        vm.thirdPartyMessage = false;
        vm.callCenterMessage = false;
        vm.isAddParticipantClick = false;
        vm.buildParticipants = buildParticipants;

        vm.newParticipantPhoneNumber = '';
        vm.addParticipant = addParticipant;
        vm.removeParticipant = removeParticipant;
        vm.roles = session.roles;
        vm.isDisabled = isDisabled;

        $scope.$on(interpretersignalreceiver.thirdPartyStatusEvent, thirdPartyStatusEvent);
        $scope.$on(operatorsignalreceiver.thirdPartyStatusEvent, thirdPartyStatusEvent);

        $scope.$on(interpretersignalreceiver.callCenterStatusEvent, callCenterStatusEvent);
        $scope.$on(operatorsignalreceiver.callCenterStatusEvent, callCenterStatusEvent);

        function addParticipant() {
            vm.isAddParticipantClick = true;
            vm.thirdPartyMessage = false;
            var phoneNumber = vm.newParticipantPhoneNumber;
            var callId = vm.currentCall.CallId;

            //Check phone number is present in ParticipantList
            if (isPhoneNumberAlreadyPresent(phoneNumber) === true) {
                vm.isAddParticipantClick = false;
                return;
            }
            
            if (vm.interpreter !== undefined) {
                interpreterservice.addParticipant(callId, phoneNumber).then(function (participantId) {
                    if (participantId !== '') {
                        vm.participants.push({
                            ParticipantId: participantId,
                            PhoneNumber: phoneNumber,
                            Status: 'ThirdPartyRinging',
                            Name: undefined
                        });
                        logger.info('Participant added to conference');
                        vm.newParticipantPhoneNumber = '';
                        vm.isAddParticipantClick = false;
                    }
                    else {
                        accountservice.logMessage('add Participant Action Failed. CallId: ' + callId, vm.logLevel.Warn);
                    }
                });
            }
            else {
                operatorservice.addParticipant(callId, phoneNumber).then(function (participantId) {
                    if (participantId !== '') {
                        vm.participants.push({
                            ParticipantId: participantId,
                            PhoneNumber: phoneNumber,
                            Status: 'ThirdPartyRinging',
                            Name: undefined
                        });
                        logger.info('Participant added to conference');
                        vm.newParticipantPhoneNumber = '';
                        vm.isAddParticipantClick = false;
                    }
                    else {
                        accountservice.logMessage('vox-participants.addParticipant Action Failed|CallId:' + callId, vm.logLevel.Warn);
                    }
                });
            }
        }
        function removeParticipant(participant) {
            var idx = vm.participants.indexOf(participant);
            if (vm.interpreter !== undefined) {
                interpreterservice.deleteParticipant(participant.ParticipantId, vm.currentCall.CallId).then(function (result) {
                    if (result === true) {
                        vm.participants.splice(idx, 1);
                        logger.warning('Participant removed from conference');
                    }
                    else {
                        accountservice.logMessage('vox-participants.removeParticipant delete Participant Action Failed by Interpreter|ParticipantId:' + participant.ParticipantId, vm.logLevel.Warn);
                    }
                });
            }
            else {
                operatorservice.deleteParticipant(participant.ParticipantId, vm.currentCall.CallId).then(function (result) {
                    if (result === true) {
                        vm.participants.splice(idx, 1);
                        logger.warning('Participant removed from conference');
                    }
                    else {
                        accountservice.logMessage('delete Participant Action Failed by Operator. ParticipantId: ' + participant.ParticipantId, vm.logLevel.Warn);
                    }
                });
            }
        }

        function thirdPartyStatusEvent(event, data) {
            if (vm.interpreter !== undefined) {
                $scope.$apply(function () {
                    interpreterservice.getCurrentCall().then(function (data) {
                        if (data !== '') {
                            vm.currentCall = data.Call;
                            vm.participants = angular.copy(vm.currentCall.Participants);
                        }
                        else {
                            accountservice.logMessage('vox-participants.thirdPartyStatusEvent interpreterservice.getCurrentCall() Action Failed.', vm.logLevel.Warn);
                        }
                    });
                    for (var i in vm.participants) {
                        if (vm.participants[i].ParticipantId === data.participantId) {
                            vm.participants[i].Status = data.statusName;

                            showThirdPartyMessage(data.statusName);

                            break;
                        }
                    }
                });
            }
            else {
                $scope.$apply(function () {
                    operatorservice.getCurrentCall().then(function (data) {
                        if (data !== '') {
                            vm.currentCall = data.Call;
                            vm.participants = angular.copy(vm.currentCall.Participants);
                        }
                        else {
                            accountservice.logMessage('vox-participants.thirdPartyStatusEven operatorservice.getCurrentCall Action Failed.', vm.logLevel.Warn);
                        }
                    });
                    for (var i in vm.participants) {
                        if (vm.participants[i].ParticipantId === data.participantId) {
                            vm.participants[i].Status = data.statusName;

                            showThirdPartyMessage(data.statusName);

                            break;
                        }
                    }
                });
            }
        }

        function callCenterStatusEvent(event, data) {
            if (vm.interpreter !== undefined) {
                $scope.$apply(function () {
                    interpreterservice.getCurrentCall().then(function (data) {
                        if (data !== '') {
                            vm.currentCall = data.Call;
                            vm.participants = angular.copy(vm.currentCall.Participants);
                        }
                        else {
                            accountservice.logMessage('vox-participants.callCenterStatusEvent interpreterservice.getCurrentCall Action Failed.', vm.logLevel.Warn);
                        }
                    });
                    for (var i in vm.participants) {
                        if (vm.participants[i].ParticipantId === data.participantId) {
                            vm.participants[i].Status = data.statusName;

                            showCallCenterMessage(data.statusName);

                            break;
                        }
                    }
                });
            }
            else {
                $scope.$apply(function () {
                    operatorservice.getCurrentCall().then(function (data) {
                        if (data !== '') {
                            vm.currentCall = data.Call;
                            vm.participants = angular.copy(vm.currentCall.Participants);
                        }
                        else {
                            accountservice.logMessage('vox-participants.callCenterStatusEvent operatorservice.getCurrentCall Action Failed.', vm.logLevel.Warn);
                        }
                    });
                    for (var i in vm.participants) {
                        if (vm.participants[i].ParticipantId === data.participantId) {
                            vm.participants[i].Status = data.statusName;

                            showCallCenterMessage(data.statusName);

                            break;
                        }
                    }
                });
            }
        }

        function isDisabled() {
            if (vm.newParticipantPhoneNumber === '' || vm.phoneErrorMessage !== undefined || vm.phoneIsValidating || vm.isAddParticipantClick) {
                return true;
            }
            return false;
        }

        function showThirdPartyMessage(thirdPartyStatus) {
            console.log(thirdPartyStatus);

            switch (thirdPartyStatus) {
                case 'ThirdPartyBusy':
                    vm.thirdPartyMessage = stringResources.ThirdPartyEventMessages.ThirdPartyBusy;
                    break;
                case 'ThirdPartyNoAnswer':
                    vm.thirdPartyMessage = stringResources.ThirdPartyEventMessages.ThirdPartyNoAnswer;
                    break;
                case 'ThirdPartyCanceled':
                    vm.thirdPartyMessage = stringResources.ThirdPartyEventMessages.ThirdPartyCanceled;
                    break;
                case 'ThirdPartyFailed':
                    vm.thirdPartyMessage = stringResources.ThirdPartyEventMessages.ThirdPartyFailed;
                    break;
                case 'AnsweringMachineDetected':
                    vm.thirdPartyMessage = stringResources.ThirdPartyEventMessages.AnsweringMachineDetected;
                    break;
                case 'PhoneNumberAlreadyAdded':
                    vm.thirdPartyMessage = 'The phone number you have entered is already added before. Please try adding different number OR Remove existing number from the list.';
                    break;
                default:
                    vm.thirdPartyMessage = false;
                    break;
            }
        }

        function showCallCenterMessage(callCenterStatus) {
            console.log(callCenterStatus);

            switch (callCenterStatus) {
                case 'CallCenterBusy':
                    vm.callCenterMessage = stringResources.callCenterEventMessages.CallCenterBusy;
                    break;
                case 'CallCenterNoAnswer':
                    vm.callCenterMessage = stringResources.callCenterEventMessages.CallCenterNoAnswer;
                    break;
                case 'CallCenterCanceled':
                    vm.callCenterMessage = stringResources.callCenterEventMessages.CallCenterCanceled;
                    break;
                case 'CallCenterFailed':
                    vm.callCenterMessage = stringResources.callCenterEventMessages.CallCenterFailed;
                    break;
                default:
                    vm.callCenterMessage = false;
                    break;
            }
        }

        function buildParticipants() {
            for (var i = vm.participants.length - 1; i >= 0; i--) {
                var participant = vm.participants[i];
                if (participant.InterpreterId && vm.interpreter && participant.InterpreterId === vm.interpreter.Id) {
                    participant.Status = 'InterpreterConnected';
                    participant.Name = vm.interpreter !== undefined ? vm.interpreter.Name : participant.phoneNumber;
                    $scope.$emit('showThirdParty');
                } else if (participant.InterpreterId) {
                    participant.Status = 'InterpreterConnected';
                    participant.Name = participant.phoneNumber;
                    $scope.$emit('showThirdParty');
                }
                else if (participant.OperatorId || participant.MonitorId) {
                    // Remove user from participants beacuse We don't show operators or monitors in the participant list
                    vm.participants.splice(i, 1);
                }
                else if (participant.CustomerId && vm.customer && participant.CustomerId === vm.customer.Id) {
                    participant.Status = 'CustomerConnected';
                    participant.Name = vm.customer.Name;
                    $scope.$emit('showThirdParty');
                }
                //User is LEP (ClickToCall and hostedIVR flow)
                else if (participant.CustomerId === null && participant.ParticipantId === vm.currentCall.CallId) {
                    participant.Status = 'LEPConnected';
                    participant.Name = vm.customer.Name;
                    $scope.$emit('showThirdParty');
                }
                else if (participant.IsCallCenter) {
                    participant.Status = 'CallCenterConnected';
                    participant.Name = vm.customer.Name;
                    $scope.$emit('showThirdParty');
                }
                else {
                    // Assigning ThirdPartyConnected status If we refresh the page the Status shows blank for ThirdParty participant.
                    participant.Status = 'ThirdPartyConnected';
                    $scope.$emit('showThirdParty');
                }
            }
        }

        function isPhoneNumberAlreadyPresent(phoneNumber) {
            for (var i = vm.participants.length - 1; i >= 0; i--) {
                var participant = vm.participants[i];
                if (participant.PhoneNumber === phoneNumber) {
                    showThirdPartyMessage('PhoneNumberAlreadyAdded');
                    return true;
                }
            }
            return false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.widgets')
        .directive('voxNotalkActionMenu', voxNotalkActionMenu);

    function voxNotalkActionMenu() {
        var directive = {
            bindToController: true,
            controller: NotalkActionMenuController,
            controllerAs: 'vm',
            restrict: 'E',
            scope: { 'person': '=' },
            templateUrl: 'app/widgets/vox-notalk-action-menu.html'
        };

        return directive;
    }

    NotalkActionMenuController.$inject = ['$cookies', 'constants', 'userservice', 'enums', 'callEvents', 'accountservice', 'preferences',
        'appsettingsservice', 'usermessageservice'];
    function NotalkActionMenuController($cookies, constants, userservice, enums, callEvents, accountservice, preferences,
        appsettingsservice, usermessageservice) {
        var vm = this;
        vm.submitNotalkAction = submitNotalkAction;
        vm.getNoTalkActionMenu = getNoTalkActionMenu;
        vm.notalkActionOptions = undefined;
        vm.displaymessage = displaymessage;
        vm.notalkActionSelected = undefined;
        vm.submitted = false;
        vm.message = '';
        vm.notalkMessage = '';
        vm.callId = $cookies.get(constants.callId);
        vm.currentRole = $cookies.get(constants.userRole);

        getNoTalkActionMenu();

        appsettingsservice.getAppSetting(preferences.NoTalkActionMessage1, vm.message).then(function (data) {
            if (data) {
                vm.notalkMessage = data;
                appsettingsservice.getAppSetting(preferences.NoTalkActionMessage2, vm.message).then(function (data2) {
                    if (data2) {
                        vm.notalkMessage += data2;
                    }
                });
            }
        });

        function getNoTalkActionMenu() {
            if (vm.currentRole === constants.Interpreter) {
                vm.notalkOptions = [
                    { key: 1, value: 'Customer agent has put the call on hold' },
                    { key: 2, value: 'LEP has put the call on hold/delayed the call flow' },
                    { key: 3, value: 'Customer agent or LEP has not joined the call at all' },
                    { key: 4, value: 'Active interpretation is ongoing, there is no silence' },
                    { key: 5, value: 'I am having an audio or technical issue' },
                    { key: 6, value: 'The LEP speaks English and I have been instructed to listen and help if needed/I am a quality monitor for this call.' }
                ];
            }
            accountservice.logMessage('vox-notalk-action-menu.getNoTalkActionMenu|CallId: ' + vm.callId + ', CurrentRole:' + vm.currentRole + ', status:' + vm.person.Status +
                'UserId: ' + vm.person.Id, enums.LogLevel.Debug);
        }

        function submitNotalkAction() {
            vm.currentRole = $cookies.get(constants.userRole);
            vm.callId = $cookies.get(constants.callId);
            vm.personCurrentStatus = $cookies.get('currentStatus');
            if (vm.personCurrentStatus === enums.PersonStatusNames.InCall) {
                if (vm.currentRole === constants.Interpreter) {

                    switch (vm.notalkActionSelected) {
                        case 1:
                            addCallEvent(callEvents.CustomerPutCallOnHold);
                            break;
                        case 2:
                            addCallEvent(callEvents.LEPPutCallOnHoldOrDelayedCall);
                            break;
                        case 3:
                            addCallEvent(callEvents.CustomerOrLEPNotJoinedCall);
                            break;
                        case 4:
                            addCallEvent(callEvents.ActiveInterpretationGoingOn);
                            break;
                        case 5:
                            addCallEvent(callEvents.AudioOrTechnicalIssue);
                            break;
                        case 6:
                            addCallEvent(callEvents.QualityMonitorOnCall);
                            break;
                    }
                }
            }
        }

        function displaymessage() {
            switch (vm.notalkActionSelected) {
                case 1:
                case 2:
                case 3:
                case 6:
                    vm.message = vm.notalkMessage;
                    break;
                default:
                    vm.message = '';
                    break;
            }
        }
        function addCallEvent(callEvent) {
            usermessageservice.notify('notalksubmitted', { message: true, eventName: 'notalksubmitted' });
            userservice.addCallEvent(callEvent, vm.callId);
            accountservice.logMessage('vox-notalk-action-menu.submit|CallId: ' + vm.callId + ', No-Talk action selected option: ' +
                callEvent, enums.LogLevel.Debug);
            vm.notalkActionSelected = undefined;
            vm.notalkActionOptions = undefined;
            vm.message = '';
            vm.submitted = true;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.widgets')
        .directive('voxMetaData', voxMetaData);

    /* @ngInject */
    function voxMetaData() {
        var directive = {
            bindToController: true,
            controller: MetaDataController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'userId': '='
            },
            templateUrl: 'app/widgets/vox-meta-data.html'
        };
        return directive;
    }

    MetaDataController.$inject = ['$scope', 'accountservice', 'callEvents', 'enums', 'session', 'usermessageservice', 'userservice', '$interval', 'preferences', 'appsettingsservice'];
    /* @ngInject */
    function MetaDataController($scope, accountservice, callEvents, enums, session, usermessageservice, userservice, $interval, preferences, appsettingsservice) {
        var vm = this;

        vm.callId = undefined;
        vm.logLevel = enums.LogLevel;
        vm.metaData = undefined;
        vm.metadataCopy = undefined;
        vm.interpreter = undefined;
        vm.operator = undefined;
        vm.roles = session.roles;

        vm.metadataChanged = metadataChanged;
        vm.showMetadata = showMetadata;
        vm.showMetadataItem = showMetadataItem;
        vm.editMetadataItem = editMetadataItem;
        vm.showOrEditMetadata = showOrEditMetadata;
        vm.showUpdateMessage = false;
        vm.showSaveMessage = false;
        vm.save = save;
        vm.reset = reset;
        vm.handlePattern = handlePattern;
        vm.validateMetadata = 'false';

        appsettingsservice.getAppSetting(preferences.ValidateMetadata, 'false').then(function (data) {
            vm.validateMetadata = data;
        });

        usermessageservice.subscribe($scope, 'notify', function (event, data) {
            if (data.eventName === 'metadataDetails') {
                vm.callId = data.callId;
                vm.metadata = [];
                if (!data.metadata) {
                    return;
                }
                for (var i = 0; i < data.metadata.length; i++) {
                    var item = data.metadata[i];
                    if (showMetadataItem(item)) {
                        vm.metadata.push(item);
                    }
                }
                vm.metadataCopy = angular.copy(vm.metadata);
            }
        });

        vm.interpreter = vm.roles.indexOf('Interpreter') >= 0;
        vm.operator = vm.roles.indexOf('Operator') >= 0;

        function handlePattern(index) {
            var nameRegex = '';

            if (vm.validateMetadata !== 'true') {
                return;
            }

            if (!vm.metadata || !vm.metadata[index]) {
                return;
            }

            if (vm.metadata[index].Label === 'Reference Number' || vm.metadata[index].Label === 'Numeric Number') {
                
                if (vm.metadata[index].AllowedCharacters) {
                    nameRegex = vm.metadata[index].AllowedCharacters;
                }
                else if (vm.metadata[index].Length) {
                    nameRegex = '^[a-zA-Z0-9\_\-]{' + vm.metadata[index].Length + '}$';
                }

                return nameRegex;

            } else {
                return;
            }
        }

        // Only show the Metadata Details UI if the user is allowed to view at least 1 metadata item
        function showMetadata() {

            if (vm.metadata) {
                for (var i = 0; i < vm.metadata.length; i++) {
                    if (showMetadataItem(vm.metadata[i])) {
                        return true;
                    }
                }
            }

            return false;
        }

        // Only show the Metadata Items the user is allowed to view
        function showMetadataItem(metadataItem) {
            if (metadataItem) {
                return showOrEditMetadata(metadataItem.Visible);
            }

            return false;
        }

        function editMetadataItem(metadataItem) {
            if (metadataItem) {
                return showOrEditMetadata(metadataItem.Editable);
            }

            return false;
        }

        function save(index) {
            vm.showUpdateMessage = false;
            var updatedMetadata = [vm.metadata[index]];
            userservice.setMetadata(vm.callId, updatedMetadata).then(function (result) {
                if (result === false) {
                    accountservice.logMessage('metadataChanged Action Failed|CallId: ' + vm.callId, vm.logLevel.Warn);
                } else {
                    vm.showSaveMessage = true;
                }
                vm.oldValue = vm.metadataCopy[index].AnswerText;
                userservice.addCallEvent(callEvents.MetadataAnswerChanged, vm.callId, vm.oldValue);
                vm.metadataCopy = angular.copy(vm.metadata);

                $interval(function() {
                    vm.showSaveMessage = false;
                }, 2000);
            });
        }

        function reset(index) {
            vm.showUpdateMessage = false;
            if (!vm.metadata || !vm.metadata[index]) {
                return;
            }
            vm.metadata[index].AnswerText = vm.metadataCopy[index].AnswerText;
        }

        function metadataChanged(index) {
            if (!vm.metadata || !vm.metadata[index]) {
                return;
            }

            if (vm.metadata[index].AnswerText === vm.metadataCopy[index].AnswerText) {
                vm.showUpdateMessage = false;
            } else {
                vm.showUpdateMessage = true;
            }
        }

        //This filter is for to show the Metadata Items the user is allowed to view
        $scope.visible = function (metadataItem) {
            return showMetadataItem(metadataItem);
        };

        function showOrEditMetadata(value) {
            var result = false;

            switch (value) {
                case 1:
                    if (vm.operator) {
                        result = true;
                    }
                    break;
                case 2:
                    if (vm.interpreter) {
                        result = true;
                    }
                    break;
                case 3:
                    result = true;
                    break;
            }

            return result;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.widgets')
        .directive('voxDispositionMenu', voxDispositionMenu);

    function voxDispositionMenu() {
        var directive = {
            bindToController: true,
            controller: DispositionMenuController,
            controllerAs: 'vm',
            restrict: 'E',
            scope: { 'person': '=' },
            templateUrl: 'app/widgets/vox-disposition-menu.html'
        };

        return directive;
    }

    DispositionMenuController.$inject = ['$cookies', 'constants', 'userservice', 'preferences', 'appsettingsservice', '$interval', 'interpreterservice', 'enums', 'callEvents',
        'usermessageservice', 'accountservice', 'operatorservice'];
    function DispositionMenuController($cookies, constants, userservice, preferences, appsettingsservice, $interval, interpreterservice, enums, callEvents,
        usermessageservice, accountservice, operatorservice) {
        var vm = this;
        vm.showDisposition = showDisposition;
        vm.submitDisposition = submitDisposition;
        vm.getDispositionMenu = getDispositionMenu;
        vm.startTimer = startTimer;
        vm.stopTimer = stopTimer;
        vm.dispositionOptions = undefined;
        vm.countDown = 10;
        var submitTimer = 0;
        vm.dispositionSelected = undefined;
        vm.comment = undefined;
        vm.callId = $cookies.get(constants.callId);
        vm.currentRole = $cookies.get(constants.userRole);
        var commentMaxLength = '500';
        var callDispositionTimeout = 10;

        //this function run when page first time loads so clear so clear timer if
        if (submitTimer !== 0)
        {
            $interval.cancel(submitTimer);
            submitTimer = 0;
        }
        getDispositionMenu();

        showDisposition();

        appsettingsservice.getAppSetting(preferences.GetCallDispositionMenuTimeOutSeconds, callDispositionTimeout).then(function (data) {
            callDispositionTimeout = data;
            vm.countDown = callDispositionTimeout;
        });
        appsettingsservice.getAppSetting(preferences.DispositionMaxAllowedChars, commentMaxLength).then(function (data) {
            commentMaxLength = data;
            vm.maxLength = commentMaxLength;
        });

        function getDispositionMenu() {
            if (vm.currentRole === constants.Interpreter)
            {
                vm.dispositionOptions = [
                    { key: 1, value: 'Successful Call' },
                    { key: 2, value: 'Audio Loss / Can’t Hear' },
                    { key: 3, value: 'No Customer / Only LEP' },
                    { key: 4, value: 'Wrong language selected' },
                    { key: 5, value: 'Other' }
                ];
            }
            else if (vm.currentRole === constants.Operator) {
                vm.dispositionOptions = [
                    { key: 1, value: 'No Interpreter Available' },
                    { key: 2, value: 'Cancelled Call' }
                ];
            }
            accountservice.logMessage('vox-disposition-menu.getDispositionMenu|CallId: ' + vm.callId + ', CurrentRole:' + vm.currentRole + ', status:' + vm.person.Status , enums.LogLevel.Debug);
        }

        function showDisposition() {
            if (submitTimer === 0) {
                vm.countDown = callDispositionTimeout;
                startTimer();
                accountservice.logMessage('vox-disposition-menu.StartTimer|CallId: ' + vm.callId + ', CountdownTime:' + vm.countDown + ', submitTimer:' + submitTimer, enums.LogLevel.Debug);
            }
        }

        function startTimer() {
            submitTimer = $interval(function () {
                vm.countDown--;
                if (vm.countDown <= 0) {
                    submitDisposition();
                }
            }, 1000);
        }

        function stopTimer() {
            if (submitTimer) {
                $interval.cancel(submitTimer);
            }
        }

        function submitDisposition() {
            $interval.cancel(submitTimer);
            submitTimer = 0;
            vm.currentRole = $cookies.get(constants.userRole);
            vm.callId = $cookies.get(constants.callId);
            vm.personCurrentStatus = $cookies.get('currentStatus');
            usermessageservice.notify('notify', { eventName: 'disableHangupButton', message: false });
            if (vm.personCurrentStatus === enums.PersonStatusNames.AfterCallWork) {
                if (vm.currentRole === constants.Interpreter) {
                    interpreterservice.setStatus(enums.PersonStatusNames.Available, '0').then(function (data) {
                        //update cookie
                        $cookies.put('currentStatus', enums.PersonStatusNames.Available);
                        usermessageservice.notify('notify', { eventName: 'currentStatus', statusName: enums.PersonStatusNames.Available });
                        //while submit the disposition make sure we stop playing disposition menu on phone kill interpreters call.
                        userservice.disconnectCall(vm.callId).then(function (data) {
                            accountservice.logMessage('vox-disposition-menu.submitDisposition|CallId: ' + vm.callId + ', Hangup Interpreters call' + data, enums.LogLevel.Debug);
                        });
                        switch (vm.dispositionSelected) {
                            case 1:
                                addCallEvent(callEvents.DispositionMenuCallWasSuccessfull);
                                break;
                            case 2:
                                addCallEvent(callEvents.DispositionMenuAudioLossAndOrCantHear);
                                break;
                            case 3:
                                addCallEvent(callEvents.DispositionMenuNoCustomerAndOrOnlyLEP);
                                break;
                            case 4:
                                addCallEvent(callEvents.DispositionMenuWrongLanguageSelected);
                                break;
                            case 5:
                                addCallEvent(callEvents.DispositionMenuOther);
                                break;
                            default:
                                addCallEvent(callEvents.NoDispositionOptionSelected);
                                break;
                        }
                    });
                }
                else if (vm.currentRole === constants.Operator) {
                    operatorservice.setStatus(enums.PersonStatusNames.Available, '0').then(function (data) {
                        switch (vm.dispositionSelected) {
                            case 1:
                                addCallEvent(callEvents.NoInterpreter);
                                break;
                            case 2:
                                addCallEvent(callEvents.CancelledCall);
                                break;
                            default:
                                addCallEvent(callEvents.NoDispositionOptionSelected);
                                break;
                        }
                    });
                }
            }
        }

        function addCallEvent(callEvent) {
            userservice.addCallEvent(callEvent, vm.callId, vm.comment);
            accountservice.logMessage('vox-disposition-menu.submitDisposition|CallId: ' + vm.callId + ', Disposition selected option: ' +
                callEvent, enums.LogLevel.Debug);

            vm.dispositionSelected = undefined;
            $cookies.put(constants.callId, undefined);
            $cookies.put(constants.customerName, undefined);
            vm.comment = undefined;
            vm.dispositionOptions = undefined;
            //Fail Safe
            vm.person.Status = enums.PersonStatusNames.Available;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.widgets')
        .directive('voxCountup', voxCountup);

    /* @ngInject */
    function voxCountup() {
        var directive = {
            bindToController: true,
            controller: CountupController,
            controllerAs: 'vm',
            restrict: 'E',
            scope: {
                'startDateTime': '=',
                'alternateDateTime': '=',
                'hideDays': '=',
                'thresholds': '<',
                'callId': '=',
                'interpreterId': '='
            },
            templateUrl: 'app/widgets/vox-countup.html',
            link: function link(scope, element, attrs, vm) {
                scope.$on('$destroy', function () {
                    vm.toggle(false);
                });
            }
        };

        return directive;
    }

    CountupController.$inject = ['$interval', '$scope', 'accountservice', 'appsettingsservice', 'enums', 'utilities'];
    /* @ngInject */
    function CountupController($interval, $scope, accountservice, appsettingsservice, enums, utilities) {
        var vm = this;

        vm.toggle = toggle;
        vm.timeDisplay = getTimeDisplay();

        var interval;
        toggle(true);

        function toggle(run) {
            if (run && interval === undefined) {
                interval = $interval(function () {
                    // digest just this directive
                    vm.timeDisplay = getTimeDisplay();
                    $scope.$digest();
                }, 1000, 0, false);
            }
            else if (!run && interval !== undefined) {
                $interval.cancel(interval);
                interval = undefined;
            }
        }

        // For Interpreter Waiting time:
        //  vm.startDateTime = Last Login Time
        //  vm.alternateDateTime = Last Call Ended
        // For Call Duration:
        //  vm.startDateTime = Call participant start time (null until joined the conference)
        //  vm.aleternateDateTime = undefined

        // return hh:mm:ss string representing amount of time passed
        function getTimeDisplay() {
            var startDate = (new Date(vm.startDateTime)).getTime() || 0;
            var alternateDate = (new Date(vm.alternateDateTime)).getTime() || 0;
            // get the later of the 2 dates
            var dateTimeMs = Math.max(startDate, alternateDate);
            if (dateTimeMs <= 0) {
                return '';
            }

            var diffSeconds = (Date.now() - dateTimeMs) / 1000;

            checkThresholds(diffSeconds);

            return utilities.convertSecondsToDisplayString(diffSeconds, vm.hideDays);
        }

        function checkThresholds(diffSeconds) {
            if (!vm.thresholds) {
                return;
            }

            for (var i = vm.thresholds.length - 1; i >= 0; i--) {
                var threshold = vm.thresholds[i];

                if (threshold.limitInSeconds <= diffSeconds) {
                    threshold.raise();

                    accountservice.logMessage('vox-countup.checkThresholds|Message: ' + threshold.description +
                        ', InterpreterId: ' + vm.interpreterId +
                        ', CallDuration: ' + diffSeconds + ' seconds' +
                        ', LimitInSeconds: ' + threshold.limitInSeconds +
                        ', StartDateTime: ' + vm.startDateTime +
                        ', AlternateDateTime: ' + vm.alternateDateTime +
                        ', TimeDisplay: ' + vm.timeDisplay +
                        ', CallId: ' + vm.callId, enums.LogLevel.Warn);

                    vm.thresholds.splice(i, 1);
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.widgets')
        .directive('voxCountdown', voxCountdown);

    /* @ngInject */
    function voxCountdown() {
        var directive = {
            bindToController: true,
            controller: CountdownController,
            controllerAs: 'vm',
            restrict: 'E',
            scope: {
                'seconds': '=',
                'started': '='
            },
            templateUrl: 'app/widgets/vox-countdown.html',
            link: function postLink(scope, element, attrs, vm) {
                var watch = scope.$watch('vm.started', function (newVal) {
                    vm.toggle(newVal);
                });

                scope.$on('$destroy', function () {
                    watch();
                    vm.toggle(false);
                });
            }
        };

        return directive;
    }

    CountdownController.$inject = ['$scope', '$interval'];
    /* @ngInject */
    function CountdownController($scope, $interval) {
        var vm = this;

        vm.progress = 0;
        vm.toggle = toggle;

        var stop;

        activate();

        function activate() {
            if (vm.started === true) {
                toggle(true);
            }
        }

        function toggle(run) {
            if (run && stop === undefined) {
                vm.progress = 1;
                stop = $interval(function () {
                    vm.progress = vm.progress - (1.0 / (vm.seconds * 50.0));
                    if (vm.progress < 0) {
                        $scope.$emit('elapsed', { message: true });
                        endInterval();
                    }
                }, 20);
            }
            else if (!run && stop !== undefined) {
                endInterval();
            }
        }

        function endInterval() {
            $interval.cancel(stop);
            vm.progress = 0;
            stop = undefined;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('vox-leonis.console', [
            'vox-leonis.core'
        ]);
})();


(function (angular) {
    'use strict';

    angular
        .module('vox-leonis.console')
        .directive('voxConsoleWebrtcDialpad', voxConsoleWebrtcDialpad);

    /* @ngInject */
    function voxConsoleWebrtcDialpad() {
        var directive = {
            bindToController: true,
            controller: ConsoleWebRtcDialpadController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {

            },
            templateUrl: 'app/widgets/vox-console-webrtc-dialpad.html'
        };
        return directive;
    }

    ConsoleWebRtcDialpadController.$inject = ['$scope',  'twiliowebrtcservice', 'usermessageservice'];

    /* @ngInject */
    function ConsoleWebRtcDialpadController($scope,  twiliowebrtcservice, usermessageservice) {

        var vm = this;
        setupMethods();
        vm.enteredDigits = '';

        function setupMethods() {
            vm.mute = mute;
            vm.unMute = unMute;
            vm.sendDigit = sendDigit;
            vm.minimize = minimize;
            vm.muteUnmute = muteUnmute;
            vm.hangUp = hangUp;
        }
        vm.muted = false;
        usermessageservice.subscribe($scope, 'dialpadMaximize', function (event, data) {
            vm.muted = data.dialpadMuteStatus;
        });

        usermessageservice.subscribe($scope, 'resetDialpad', function (event) {
            vm.muted = false;
            vm.enteredDigits = '';
        });

        function muteUnmute(muteTheMic) {
            if (muteTheMic) {
                mute();
            }
            else {
                unMute();
            }
        }
        function mute() {
            twiliowebrtcservice.mute();
        }
        function unMute() {
            twiliowebrtcservice.unmute();
        }
        function sendDigit(digit) {
            vm.enteredDigits = vm.enteredDigits + digit;
            twiliowebrtcservice.sendDigits(digit);
        }
        function minimize() {
            usermessageservice.notify('dialpadMaximize', { message: false, dialpadMuteStatus: vm.muted, digits: vm.enteredDigits });
        }
        function hangUp() {
            usermessageservice.notify('notify', { eventName: 'hangUp' });
            vm.muted = false;
            vm.enteredDigits = '';
        }
    }
})(angular);

(function (angular) {
    'use strict';

    angular
        .module('vox-leonis.console')
        .directive('voxConsoleWebrtcDialpadMin', voxConsoleWebrtcDialpadMin);

    /* @ngInject */
    function voxConsoleWebrtcDialpadMin() {
        var directive = {
            bindToController: true,
            controller: ConsoleWebRtcDialpadMinController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {

            },
            templateUrl: 'app/widgets/vox-console-webrtc-dialpad-min.html'
        };
        return directive;
    }

    ConsoleWebRtcDialpadMinController.$inject = ['$scope', '$cookies', 'enums', 'twiliowebrtcservice', 'usermessageservice', 'constants',
        'interpreterservice', 'accountservice', 'appsettingsservice', 'preferences', 'operatorservice'];

    /* @ngInject */
    function ConsoleWebRtcDialpadMinController($scope, $cookies, enums, twiliowebrtcservice, usermessageservice, constants, interpreterservice,
        accountservice, appsettingsservice, preferences, operatorservice) {

        var vm = this;
        setupMethods();
        
        usermessageservice.subscribe($scope, 'dialpadMaximize', function (event, data) {
            vm.muted = data.dialpadMuteStatus;
            vm.enteredDigits = data.digits;
        });

        usermessageservice.subscribe($scope, 'resetDialpad', function (event) {
            vm.muted = false;
            vm.enteredDigits = '';
        });

        function setupMethods() {
            vm.maximize = maximize;
            vm.hangUp = hangUp;
            vm.muteUnmute = muteUnmute;
        }

        function muteUnmute(muteTheMic) {
            if (muteTheMic) {
                mute();
            }
            else {
                unMute();
            }
        }
        function maximize() {
            usermessageservice.notify('dialpadMaximize', { message: true, dialpadMuteStatus: vm.muted });
        }
        function mute() {
            twiliowebrtcservice.mute();
        }
        function unMute() {
            twiliowebrtcservice.unmute();
        }
        function hangUp() {
            usermessageservice.notify('notify', { eventName: 'hangUp' });
            usermessageservice.notify('resetDialpad');
        }
       
    }
})(angular);

(function () {
    'use strict';

    angular
        .module('vox-leonis.widgets')
        .directive('voxConsoleContactMethods', voxConsoleContactMethods);

    function voxConsoleContactMethods() {
        var directive = {
            bindToController: true,
            controller: ConsoleContactMethodsController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'person': '=',
            },
            templateUrl: 'app/widgets/vox-console-contact-methods.html'
        };
        return directive;
    }

    ConsoleContactMethodsController.$inject = ['$cookies', '$timeout', '$q', 'accountservice', 'userservice', 'enums', 'usermessageservice', 'twiliowebrtcservice',
        'preferences', 'appsettingsservice'];

    /* @ngInject */
    function ConsoleContactMethodsController($cookies, $timeout, $q, accountservice, userservice, enums, usermessageservice, twiliowebrtcservice,
        preferences, appsettingsservice) {

        var vm = this;
        setupVars();
        setupMethods();

        function setupVars() {
            vm.browserSupportsWebRTC = undefined;
            vm.contactMethods = [];
            vm.selectedContactMethod = undefined;
            vm.logLevel = enums.LogLevel;
            vm.isDisabledByPoorLatency = false;
            vm.contactMethodsCookie = $cookies.get('UserContactMethods');

            appsettingsservice.getAppSetting(preferences.DisableStatusChange, vm.IsDisabledStatusChange).then(function (data) {
                vm.isDisabledByPoorLatency = data;
            });
        }

        function setupMethods() {
            userservice.getUserSetting('IVR_ContactMethods', '').then(function (contactMethods) {
                if (vm.contactMethodsCookie !== contactMethods) {
                    vm.contactMethodsCookie = contactMethods;
                    $cookies.put('UserContactMethods', vm.contactMethodsCookie);
                }
                console.log(vm.contactMethodsCookie);
                if (vm.contactMethodsCookie) {
                    buildContactMethodsArray(vm.contactMethodsCookie);
                }
                else {
                    buildContactMethodsArray(contactMethods);
                }
            });

            vm.setStatusIntoCookie = setStatusIntoCookie;
            vm.contactMethodChanged = contactMethodChanged;
            vm.contactMethodSelectDisabled = contactMethodSelectDisabled;
            vm.enums = enums;
            vm.updateContactMethod = updateContactMethod;
            vm.browserSupportsWebRTC = twiliowebrtcservice.isWebRTCSupported();
        }

        function buildContactMethodsArray(contactMethods) {
            var promise = contactMethods.split(',').map(function (contactMethod) {
                createContactMethodObject(+contactMethod);
            });
            $q.all(promise).then(function (values) {
                setInitialContactMethod();
            }).catch(function (e) {
                if (e.status === 401) {
                    console.log('Error Fetching ContactMethods');
                }
            });
        }

        function createContactMethodObject(contactMethod) {
            var name;
            var faClass;
            switch (contactMethod) {
                case 1:
                    name = enums.ContactMethodDesc.ReceiveViaPhone;
                    faClass = 'fa-mobile';
                    break;
                case 2:
                    if (!vm.browserSupportsWebRTC) {
                        return;
                    }
                    name = enums.ContactMethodDesc.ReceiveViaComputer;
                    faClass = 'fa-desktop';
                    break;
                default:
                    return;
            }
            var contactMethodObj = { id: contactMethod, name: name, faClass: faClass };
            vm.contactMethods.push(contactMethodObj);
            return vm.contactMethods;
        }

        function setInitialContactMethod() {
            if (vm.contactMethods.length === 1) {
                vm.selectedContactMethod = vm.contactMethods[0];
                notifyContactMethodChange();
            }
            else {
                vm.contactMethods.some(function (contactMethod) {
                    if (contactMethod.id === +vm.person.ContactMethod) {
                        vm.selectedContactMethod = contactMethod;
                        notifyContactMethodChange();
                        return true;
                    }
                    return false;
                });
            }

            if (vm.selectedContactMethod === undefined && vm.contactMethods.length > 0) {
                vm.selectedContactMethod = vm.contactMethods[0];
                notifyContactMethodChange();
            }

            if (vm.selectedContactMethod) {
                if (vm.selectedContactMethod.id !== +vm.person.ContactMethod) {
                    vm.person.ContactMethod = vm.selectedContactMethod.id;
                    updateContactMethod(vm.person.ContactMethod);
                }
                else if (vm.selectedContactMethod.id === enums.ContactMethod.WebRTC) {
                    notifyContactMethodChange();
                    twiliowebrtcservice.enable();
                }
            }
        }

        function contactMethodChanged() {
            if (vm.selectedContactMethod) {
                vm.person.ContactMethod = vm.selectedContactMethod.id;
                updateContactMethod(vm.person.ContactMethod);
                notifyContactMethodChange();
            }
        }

        function updateContactMethod(contactMethodId) {
            userservice.updateContactMethod(contactMethodId).then(success).catch(fail);

            function success() {
                if (+vm.person.ContactMethod === enums.ContactMethod.WebRTC) {
                    vm.TempPhoneNumber = vm.person.TempPhoneNumber;
                    //vm.person.TempPhoneNumber = undefined;
                    twiliowebrtcservice.enable();
                    vm.person.Status = enums.PersonStatusNames.Available;
                    vm.setStatusIntoCookie(vm.person.Status);
                    vm.phoneErrorMessage = undefined;
                    notifyConsoleStatus();
                } else {
                    twiliowebrtcservice.disable(vm.person.Id);
                }
            }

            function fail(e) {
                accountservice.logMessage('voxConsoleContactMethods|Message: contactMethodChanged failed, UserId:' + vm.person.Id, vm.logLevel.Error);
            }
        }

        function setStatusIntoCookie(statusName) {
            $cookies.put('currentStatus', statusName);
            usermessageservice.notify('notify', { eventName: 'currentStatus', statusName: statusName });
        }

        function contactMethodSelectDisabled() {

            if (vm.isDisabledByPoorLatency && vm.person.UserStatusReason === enums.PersonStatusReason.PoorLatency) {
                return true;
            }

            if (vm.contactMethods.length < 2) {
                return true;
            }

            switch (vm.person.Status) {
                case enums.PersonStatusNames.Alerting:
                case enums.PersonStatusNames.InCall:
                case enums.PersonStatusNames.Ringing:
                case enums.PersonStatusNames.Reconnect:
                case enums.PersonStatusNames.Quarantine:
                    return true;
                default:
                    return false;
            }
        }

        function notifyContactMethodChange() {
            $cookies.put('UserlatestContactMethod', vm.selectedContactMethod.id);
            usermessageservice.notify('notify', { eventName: 'contactMethod', message: vm.selectedContactMethod });
        }

        function notifyConsoleStatus() {
            usermessageservice.notify('notify', { eventName: 'contactMethodChange' });
        }

    }
})(angular);

(function () {
    'use strict';

    angular
        .module('vox-leonis.widgets')
        .directive('voxConnectInterpreter', voxConnectInterpreter);

    /* @ngInject */
    function voxConnectInterpreter() {
        var directive = {
            bindToController: true,
            controller: ConnectInterpreterController,
            controllerAs: 'vm',
            restrict: 'E',
            scope: {
                'callId': '=',
                'languageId': '=',
                'languageService': '=',
                'customerId': '=',
                'callParticipants': '=',
                'callLanguage': '=',
                'currentLanguages': '=',
                'disableAllLanguageSelect': '=?',
                'interpreterPoolId': '=',
                'secondaryInterpreterPoolId': '=',
                'thirdInterpreterPoolId': '=',
                'fourthInterpreterPoolId': '=',
                'case': '=',
                'disableIfNotSelected': '=',
                'filterOverflow': '='
            },
            link: function postLink(scope, element, args, vm) {
                var languageSelectWatch = scope.$watch('vm.disableAllLanguageSelect', function (newVal, oldVal) {
                    if (newVal !== undefined) {
                        if (vm.disableAllLanguageSelect !== undefined) {
                            vm.disableLanguageSelect = vm.disableAllLanguageSelect;
                            vm.disableAllConnect = vm.disableAllLanguageSelect;
                        }
                    }
                });
                scope.$on('$destroy', function () {
                    languageSelectWatch();
                });
            },
            templateUrl: 'app/widgets/vox-connect-interpreter.html',
        };

        return directive;
    }

    ConnectInterpreterController.$inject = ['$scope', '$timeout', '$filter', 'operatorservice', 'operatorsignalreceiver',
        'accountservice', 'enums', 'userservice', 'callEvents', 'utilities', 'preferences', 'appsettingsservice', '$cookies'];
    /* @ngInject */
    function ConnectInterpreterController($scope, $timeout, $filter, operatorservice, operatorsignalreceiver,
        accountservice, enums, userservice, callEvents, utilities, preferences, appsettingsservice, $cookies) {
        var vm = this;

        setupFunctions();
        setupVariables();
        activate();

        function setupFunctions() {
            vm.callLanguageSelect = callLanguageSelect;
            vm.close = close;
            vm.connectInterpreter = connectInterpreter;
            vm.connectMe = connectMe;
            vm.findInterpreter = findInterpreter;
            vm.loadStatistics = loadStatistics;
            vm.showInterpreterStatistics = showInterpreterStatistics;
            vm.logButtonShowEvent = logButtonShowEvent;
            vm.changeLanguageServiceSelection = changeLanguageServiceSelection;
            vm.changeGenderInterpreterSelection = changeGenderInterpreterSelection;
            vm.genderOptions = [{ 'Id': 0, 'Name': 'Connect' }, { 'Id': 1, 'Name': 'Connect to Male' }, { 'Id': 2, 'Name': 'Connect to Female' }];
        }

        function setupVariables() {
            vm.callingLanguageSelect = false;
            vm.connectingInterpreter = false;
            vm.connectingMe = false;
            vm.connectInterpreterDisabled = true;
            vm.disableAllLanguageSelect = false;
            vm.findingInterpreter = false;
            vm.findInterpreterSelect = undefined;
            vm.hasInterpreters = true;
            vm.inCall = false;
            vm.interpreterStatisticsShown = false;
            vm.statisticsLoading = false;
            vm.languageServiceList = vm.filterOverflow ? getLanguageServiceList() : vm.languageService;
            vm.languageServiceId = undefined;
            vm.logLevel = enums.LogLevel;
            vm.showErrorMessage = false;
            vm.errorMessage = undefined;
            vm.languageServiceIds = buildLanguageServiceIds(vm.languageService);
            vm.showLanguageSelectForScheduled = vm.case ? vm.languageServiceIds && vm.languageServiceIds.length > 0 : true;
            vm.showNoInterpsFoundError = false;
            vm.statistics = undefined;
            vm.LanguageSelect = getSelectedLanguageService();
            vm.LanguageSelectGroupId = 2;
            vm.genderSelect = getSelectedGenderInterpreter();
            
        }

        function activate() {
            vm.showLanguageSelect = true;
            setInCall();
            vm.hasOfflineInterpreters = true;
            $scope.$on(operatorsignalreceiver.callAnsweredEvent, callAnswered);
            $scope.$on(operatorsignalreceiver.callNotAnsweredEvent, callNotAnsweredEvent);
            $scope.$on(operatorsignalreceiver.languageServiceCallEndedEvent, languageServiceCallEnded);
        }

        function getLanguageServiceList()
        {
            var defaultList = vm.languageService;
            var lsDirect = $filter('filter')(vm.languageService, { LanguageId: vm.languageId });
            var allOther = $filter('filter')(vm.languageService, { LanguageId: null });
            defaultList = lsDirect.concat(allOther);
            return defaultList;
        }

        // determine whether the operator is talking to a language service for this language's buttons
        function setInCall() {
            if (vm.currentLanguages) {
                for (var i = 0; i < vm.currentLanguages.length; i++) {
                    var lang = vm.currentLanguages[i];
                    // don't enable this row's connect buttons because a connect button is already enabled on a different row
                    if (lang.Id === vm.callLanguage) {
                        return;
                    }
                }
            }
            else if (vm.languageId !== vm.callLanguage) {
                // this row's language is not equal to the language on the call so don't enable the connect buttons for this row
                return;
            }

            if (!vm.callParticipants || !vm.callParticipants.length) {
                return;
            }

            for (var j = 0; j < vm.callParticipants.length; j++) {
                var callParticipant = vm.callParticipants[j];
                if (callParticipant.InterpreterId) {
                    vm.interpreterId = callParticipant.InterpreterId;

                    var isLanguageServiceAvailable = vm.languageServiceIds && vm.languageServiceIds.length;
                    var indexPosition = isLanguageServiceAvailable ? vm.languageServiceIds.indexOf(callParticipant.InterpreterId) : -1;
                    var interpreterIsInCall = callParticipant.Status === enums.PersonStatusNames.InCall;
                    var customerIsOnHold = !!vm.callParticipants.filter(function (participant) {
                        return participant.CustomerId && participant.Status === 'OnHold';
                    }).length;

                    if (indexPosition >= 0) {
                        vm.languageServiceId = vm.languageServiceIds[indexPosition];
                        vm.inCall = true;
                        vm.connectInterpreterDisabled = false;
                        vm.showLanguageSelect = false;
                        vm.disableAllLanguageSelect = true;
                        accountservice.logMessage('vox-connect-interpreter.setInCall|Message: Showing Connect Me, CallId:' + vm.callId +
                            ', Interpreter Status: ' + callParticipant.Status + ', UserId: ' + callParticipant.InterpreterId, vm.logLevel.Debug);
                        return;
                    } else if (interpreterIsInCall && customerIsOnHold) {
                        vm.connectInterpreterDisabled = false;
                        vm.showLanguageSelect = false;
                        vm.inCall = true;
                        vm.disableAllLanguageSelect = true;
                    }
                }
                else if ((callParticipant.CustomerId) && callParticipant.Status === 'OnHold') {
                    vm.inCall = true;
                    accountservice.logMessage('vox-connect-interpreter.setInCall|Message: Showing Connect Me, CallId: ' + vm.callId +
                        ', Customer Status:' + callParticipant.Status + ', CustomerId: ' + callParticipant.CustomerId, vm.logLevel.Debug);
                }
            }
        }

        // Show a language service button if the language service timeout has expired for the call
        function checkLanguageServiceTimeout() {
            if (vm.callId && !vm.languageServiceId && !vm.showLanguageSelect) {
                operatorservice.checkLanguageServiceTimeout(vm.callId).then(function (data) {
                    var logLevel = vm.logLevel.Info;

                    if (data === true) {
                        // The language service timeout has exipred for this call; show a language service button
                        vm.showLanguageSelect = true;
                        logLevel = vm.logLevel.Debug;
                    }

                    var logMessage = 'vox-connect-interpreter.checkLanguageServiceTimeout|Expired: ' + (data === true) + ', CallId: ' + vm.callId;
                    accountservice.logMessage(logMessage, logLevel);
                });
            }
        }

        function buildLanguageServiceIds(languageService) {
            if (languageService) {
                return languageService.map(function (ids) { return ids.Id; });
            }
            return [];
        }

        function callAnswered(event, data) {
            var messagePart1 = 'vox-connect-interpreter.callAnswered|Message: Showing Connect Me/Connect Interpreter, LanguageId: ' + vm.languageId;
            var messagePart2 = ', CallLanguage: ' + vm.callLanguage + ', CallId: ' + vm.callId;
            var messagePart3 = ', LaguageServiceId: ' + data.interpreterId;

            if (vm.languageServiceIds && vm.languageServiceIds.indexOf(data.interpreterId) >= 0) {
                // the interpreter has answered the operator's call, make sure the operator can connect the interpreter to the customer
                vm.connectInterpreterDisabled = false;
                // disable connect and language service button when operator is connected LS interpreter
                vm.disableAllLanguageSelect = true;
                accountservice.logMessage(messagePart1 + messagePart2 + messagePart3, vm.logLevel.Debug);
            } else if (vm.languageId !== undefined && vm.callLanguage !== undefined && vm.languageId.toString() === vm.callLanguage.toString()) {
                vm.interpreterId = data.interpreterId;
                vm.inCall = true;
                vm.connectInterpreterDisabled = false;
                vm.showLanguageSelect = false;
                accountservice.logMessage(messagePart1 + messagePart2, vm.logLevel.Debug);
            }
            vm.findingInterpreter = false;
        }

        function callNotAnsweredEvent(event, data) {
            if (vm.languageId !== undefined && vm.callLanguage !== undefined && vm.languageId.toString() === vm.callLanguage.toString())
            {
                vm.disableAllLanguageSelect = false;
                vm.connectInterpreterDisabled = true;
                vm.inCall = true;
                //Connect the operator back to customer as the Interpreter didn't answer

                accountservice.logMessage('vox-connect-interpreter.callNotAnsweredEvent() |Message: log for bug 241330, before  "connectMe();", CallId: ' + vm.callId, vm.logLevel.Trace);

                connectMe();

                accountservice.logMessage('vox-connect-interpreter.callNotAnsweredEvent() |Message: log for bug 241330, after  "connectMe();", CallId: ' + vm.callId, vm.logLevel.Trace);

                vm.findingInterpreter = false;
                vm.errorMessage = 'Interpreter didn\'t answer';
                if (data.callStatus === 'no-answer')
                {
                    vm.errorMessage = 'Interpreter didn\'t answer';
                }
                else if (data.callStatus === 'busy')
                {
                    vm.errorMessage = 'Interpreter rejected the call';
                }
                else
                {
                    vm.errorMessage = 'Interpreter dropped due to acceptance code verification timeout';
                }
                vm.showErrorMessage = true;
                accountservice.logMessage('vox-connect-interpreter.callNotAnsweredEvent|Message: Connecting back to Customer, LanguageId: ' + vm.languageId +
                    ', CallLanguage: ' + vm.callLanguage + ', Reason: ' + data.callStatus + ', CallId: ' + vm.callId, vm.logLevel.Debug);
                $timeout(function () {
                    vm.showErrorMessage = false;
                }, 5000);
            }
        }

        function languageServiceCallEnded(event, data) {
            if (!vm.connectInterpreterDisabled)
            {
                accountservice.logMessage('vox-connect-interpreter.languageServiceCallEnded() |Message: log for bug 241330, before  "connectMe();", CallId: ' + vm.callId, vm.logLevel.Trace);

                connectMe();

                accountservice.logMessage('vox-connect-interpreter.languageServiceCallEnded() |Message: log for bug 241330, after  "connectMe();", CallId: ' + vm.callId, vm.logLevel.Trace);

                vm.connectInterpreterDisabled = true;
                vm.disableAllLanguageSelect = false;
            }
        }
        // Find an interpreter
        function findInterpreter(genderSelect) {

            vm.connectInterpreterDisabled = true;
            vm.disableAllLanguageSelect = true;
            vm.findingInterpreter = true;
            vm.inCall = false;
            vm.showLanguageSelect = true;
            vm.showNoInterpsFoundError = false;
            vm.callLanguage = vm.languageId;
            accountservice.logMessage('vox-connect-interpreter.findInterpreter|Message: Enter, hasInterpreters: ' + vm.hasInterpreters +
                ', hasOfflineInterpreters: ' + vm.hasOfflineInterpreters + ', CallId: ' + vm.callId + ', GenderId: ' + genderSelect.Id, vm.logLevel.Info);

            checkWorkingResourceRequest();
            // log event connect button click
            userservice.addCallEvent(callEvents.ConnectButtonClicked, vm.callId);
            // log event when gender specific option is slected
            addGenderSpecificEvent(genderSelect, vm.callId);

            operatorservice.findInterpreterwithGender(vm.languageId, vm.callId, genderSelect.Id).then(function (data) {
                if (data === false) {
                    accountservice.logMessage('vox-connect-interpreter.findInterpreter|Message: No interpreters found, CallId: ' + vm.callId, vm.logLevel.Debug);

                    // log event connect button click failed
                    userservice.addCallEvent(callEvents.ConnectClickFailedNoInterpreters, vm.callId);

                    showInterpreterStatistics();

                    // Update the UI based on the failure to find an interpreter
                    vm.showLanguageSelect = vm.languageServiceIds && vm.languageServiceIds.length > 0;
                    vm.showNoInterpsFoundError = true;
                    vm.disableAllLanguageSelect = false;
                    // Make the error disappear after 5 seconds
                    $timeout(function() {
                        vm.showNoInterpsFoundError = false;
                    }, 5000);
                    vm.findingInterpreter = false;
                } else {
                    setInCall();
                }
            }).finally(function (e) {
                accountservice.logMessage('vox-connect-interpreter.findInterpreter|Message: Exit, CallId: ' + vm.callId, vm.logLevel.Info);
            });
        }

        // call the Language Select operator
        function callLanguageSelect(languageSelect) {
            vm.LanguageSelect = { GroupId: languageSelect.GroupId, Name: languageSelect.Name };
            vm.callingLanguageSelect = true;
            // log event Language select click button
            userservice.addCallEvent(callEvents.LSButtonClicked, vm.callId);

            accountservice.logMessage('vox-connect-interpreter.callLanguageSelect|Message: LS button clicked, CallId:' + vm.callId +
                ', LanguageId:' + vm.languageId + ', CustomerId:' + vm.customerId +
                ', LanguageServiceSelect:' + vm.LanguageSelect.GroupId, vm.logLevel.Trace);

            //Disable Rest of the LanguageSelect and Connect buttons
            vm.disableAllLanguageSelect = true;
            operatorservice.getLanguageServiceUsersByGroup(vm.languageId, vm.customerId, vm.LanguageSelect.GroupId).then(function (data) {
                if (data !== '' && data.length > 0) {
                    vm.languageServiceId = data[0];
                    if (vm.languageServiceId) {
                        vm.showNoInterpsFoundError = false;
                        operatorservice.callLanguageService(vm.callId, vm.languageServiceId, vm.languageId).then(function (data) {
                            accountservice.logMessage('vox-connect-interpreter.callLanguageSelect|Message: Entered Method, CallId:' + vm.callId +
                                ', LanguageId:' + vm.languageId + ', CustomerId:' + vm.customerId +
                                ', LanguageServiceId:' + vm.languageServiceId, vm.logLevel.Trace);

                            vm.callLanguage = vm.languageId;

                            if (data === true) {
                                vm.showLanguageSelect = false;
                                vm.inCall = true;
                                $scope.$emit('showThirdParty');
                                accountservice.logMessage('vox-connect-interpreter.callLanguageSelect|Message: Success, CallId: ' + vm.callId +
                                    ', LanguageId:' + vm.languageId + ', CustomerId:' + vm.customerId +
                                    ', LanguageServiceId:' + vm.languageServiceId + ', InCall:' + vm.inCall, vm.logLevel.Trace);
                            }
                            else {
                                // log event Language select click button failed
                                userservice.addCallEvent(callEvents.LSClickedFailed, vm.callId);

                                accountservice.logMessage('vox-connect-interpreter.callLanguageSelect|Message: Failed, CallId: ' + vm.callId +
                                    ', InCall: ' + vm.inCall, vm.logLevel.Warn);
                                vm.showLanguageSelect = true;
                                vm.inCall = true;
                                vm.connectInterpreterDisabled = true;
                                vm.errorMessage = 'Call Failed! Please try again';
                                vm.showErrorMessage = true;
                                $timeout(function () {
                                    vm.showErrorMessage = false;
                                }, 5000);
                                //Enable back the LanguageSelect and Connect Buttons
                                vm.disableAllLanguageSelect = false;
                            }
                        }).catch(function (e) {
                            vm.showLanguageSelect = false;
                            vm.inCall = false;
                            vm.connectInterpreterDisabled = true;
                            vm.disableAllLanguageSelect = false;
                        });
                    }
                } else {
                    accountservice.logMessage('vox-connect-interpreter.getLanguageServiceUsersByGroup Action Failed|LanguageId: ' + vm.languageId +
                        ', CustomerId: ' + vm.customerId, vm.logLevel.Warn);
                }
            }).finally(function (e) {
                vm.callingLanguageSelect = false;
            });
        }

        function changeLanguageServiceSelection(languageService) {
            vm.LanguageSelect = { GroupId: languageService.GroupId, Name: languageService.Name };

            $cookies.put('SelectedLanguageServiceGroup_' + vm.languageId, languageService.GroupId);
        }

        function changeGenderInterpreterSelection(genderOption) {
            vm.genderSelect = { Id: genderOption.Id, Name: genderOption.Name };

            $cookies.put('SelectedGenderSpecificInterpreter_' + vm.languageId, genderOption.Id);
        }

        // add the Language Select interpreter to the customer conference
        function connectInterpreter() {
            var interpreterId = vm.languageServiceId || vm.interpreterId;
            accountservice.logMessage('vox-connect-interpreter.connectInterpreter|Message: Enter, InterpreterId: ' + vm.interpreterId +
                ', CallId: ' + vm.callId, vm.logLevel.Info);
            if (interpreterId) {
                ///Log event for connectInterpreter click button
                userservice.addCallEvent(callEvents.ConnectInterpreterButtonClicked, vm.callId);

                vm.connectingInterpreter = true;
                operatorservice.connectInterpreter(vm.callId, interpreterId).then(function (data) {
                    if (data === true) {
                        vm.inCall = false;
                        vm.disableAllLanguageSelect = true;
                    }
                    else {
                        // log event connectInterpreter click button failed
                        userservice.addCallEvent(callEvents.ConnectInterpreterClickedFailed, vm.callId);
                        accountservice.logMessage('vox-connect-interpreter.connectInterpreter|Message: Select interpreter connect Action Failed, CallId: ' +
                            vm.callId, vm.logLevel.Warn);
                    }
                }).finally(function (e) {
                    vm.connectingInterpreter = false;
                    vm.connectInterpreterDisabled = true;
                });
            }
        }

        // Move our operator to the customer conference
        function connectMe() {
            vm.connectingMe = true;

            accountservice.logMessage('vox-connect-interpreter.connectMe|Message: before userservice.addCallEvent, CallId: ' +
                vm.callId, vm.logLevel.Trace);

            //Log event for connectMe click button
            userservice.addCallEvent(callEvents.ConnectMeButtonClicked, vm.callId);

            accountservice.logMessage('vox-connect-interpreter.connectMe|Message: after userservice.addCallEvent, CallId: ' +
                vm.callId, vm.logLevel.Trace);
            operatorservice.conferenceJoin(vm.callId).then(function (data) {
                if (data === true) {
                    $scope.$emit('hideThirdParty');
                    vm.disableAllLanguageSelect = false;
                    vm.showLanguageSelect = true;

                    accountservice.logMessage('vox-connect-interpreter.connectMe|Message: after ' + vm.showLanguageSelect + ' , CallId: ' + vm.callId, vm.logLevel.Trace);
                }
                else {
                    // log event connectMe click button failed
                    userservice.addCallEvent(callEvents.ConnectMeClickedFailed, vm.callId);
                    accountservice.logMessage('vox-connect-interpreter.connectMe|Message: Failed, CallId: ' + vm.callId, vm.logLevel.Warn);
                }
            }).finally(function (e) {
                vm.connectingMe = false;
                vm.inCall = false;
            });
        }

        function checkWorkingResourceRequest() {

            vm.showErrorMessage = false;

            operatorservice.workingResourceRequestExists(vm.callId).then(function (data) {
                if (data === true) {
                    accountservice.logMessage('vox-connect-interpreter.checkWorkingResourceRequest|Message: working resource request found, CallId: ' +
                        vm.callId, vm.logLevel.Debug);
                    vm.errorMessage = 'Connecting interpreter';
                    vm.showErrorMessage = true;
                    vm.showLanguageSelect = true;
                    $timeout(function () {
                        vm.showErrorMessage = false;
                    }, 5000);
                    return;
                }
            }).finally(function (e) {
            });
        }

        function close() {
            vm.showNoInterpsFoundError = false;
        }

        function showInterpreterStatistics() {
            if (!vm.interpreterStatisticsShown) {
                vm.interpreterStatisticsShown = true;
                loadStatistics();
            }
        }

        /* When connectMe, Language select and connect interpreter button display on UI this method triggers*/
        function logButtonShowEvent(eventName) {
            if (eventName === 'ConnectMeButtonVisible' || eventName === 'ConnectInterpreterButtonVisible')
            {
                utilities.logButtonShowEvent(eventName, vm.callId);
                return true;
            }
            if (vm.languageServiceIds.length) {
                utilities.logButtonShowEvent(eventName, vm.callId);
                return true;
            }

            return false;
        }

        function loadStatistics() {
            vm.statisticsLoading = true;
            close();

            operatorservice
                .getInterpreterStatistics(vm.languageId, vm.interpreterPoolId, vm.secondaryInterpreterPoolId, vm.thirdInterpreterPoolId, vm.fourthInterpreterPoolId)
                .then(onStatisticsReceived)
                .finally(function () {
                    vm.statisticsLoading = false;
                });
        }

        function onStatisticsReceived(statistics) {
            vm.statistics = statistics;
            vm.hasInterpreters = vm.statistics.AvailablePortal > 0 || vm.statistics.AvailablePhone > 0;
            vm.hasOfflineInterpreters = vm.statistics.Offline > 0;
            if (vm.hasInterpreters === false) {
                //if any LS user available for that call then display LS button
                operatorservice.getLanguageServiceUsersByGroup(vm.languageId, vm.customerId, 0).then(function (data) {
                    if (data !== '' && data.length > 0) {
                        vm.showLanguageSelect = true;

                    } else {
                        accountservice.logMessage('vox-connect-interpreter.getLanguageServiceUsersByGroup Action Failed|LanguageId: ' + vm.languageId +
                            ', CustomerId: ' + vm.customerId, vm.logLevel.Warn);
                    }
                });

            }
            accountservice.logMessage('vox-connect-interpreter.onStatisticReceived|has Available or AvailablePhone Interpreters: ' + vm.hasInterpreters +
                ', hasOfflineInterpreters: ' + vm.hasOfflineInterpreters + ', CallId: ' + vm.callId, vm.logLevel.Debug);
            vm.showNoInterpsFoundError = !vm.hasInterpreters && !vm.hasOfflineInterpreters;
        }

        function getSelectedLanguageService() {
            if (vm.languageServiceIds.length <= 0) {
                return undefined;
            }

            var preSelectedGroupId = $cookies.get('SelectedLanguageServiceGroup_' + vm.languageId);

            if (preSelectedGroupId !== undefined && preSelectedGroupId > 0) {
                for (var i = 0; i < vm.languageService.length; i++) {
                    if (vm.languageService[i].GroupId === preSelectedGroupId) {
                        return { GroupId: vm.languageService[i].GroupId, Name: vm.languageService[i].Name };
                    }
                }
            }

            return { GroupId: 0, Name: 'Language Service' };
        }

        function getSelectedGenderInterpreter() {
            var preSelectedGenderOption = $cookies.get('SelectedGenderSpecificInterpreter_' + vm.languageId);

            if (preSelectedGenderOption !== undefined) {
                for (var i = 0; i < vm.genderOptions.length; i++) {
                    if (vm.genderOptions[i].Id === preSelectedGenderOption) {
                        return { Id: vm.genderOptions[i].Id, Name: vm.genderOptions[i].Name };
                    }
                }
            }

            return { Id: 0, Name: 'Connect' };
        }

        function addGenderSpecificEvent(genderSelect, callId) {
            switch (genderSelect.Id) {
                case 1:
                    userservice.addCallEvent(callEvents.ConnectToMale, callId);
                    break;
                case 2:
                    userservice.addCallEvent(callEvents.ConnectToFemale, callId);
                    break;
                default:
                    accountservice.logMessage('vox-connect-interpreter.AddGenderSpecificEvent|No gender specific option is selected, CallId: ' + callId, vm.logLevel.Debug);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.widgets')
        .directive('voxCase', voxCase);

    function voxCase() {
        var directive = {
            bindToController: true,
            controller: CaseController,
            controllerAs: 'vm',
            restrict: 'E',
            scope: {
                'currentCall': '=',
                'currentCase': '=',
                'operator': '=',
                'callParticipants': '=',
                'customer': '=',
                'interpreters': '=',
                'languageService': '='
            },
            templateUrl: 'app/widgets/vox-case.html',
        };

        return directive;
    }

    CaseController.$inject = ['dataservice'];

    function CaseController(dataservice) {
        var vm = this;

        activate();

        function activate() {
            getCaseDisplay();
        }

        function getCaseDisplay() {
            dataservice.getCaseDisplay(vm.currentCall.CallId).then(function (data) {
                vm.caseDisplay = data;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.widgets')
        .directive('voxAlert', voxAlert);

    function voxAlert($document) {
        var directive = {
            bindToController: true,
            controller: AlertController,
            controllerAs: 'vm',
            restrict: 'E',
            scope: {
                alert: '=',
                contactMethod: '=',
                reCreateTokens: '='
            },
            link: function (scope) {
                $document.bind('keydown', function (e) {
                    if (scope.vm.alert) {
                        if (e.which === 13) {
                            scope.vm.alertResponse('Accept', true);
                        }
                        else if (e.which === 27) {
                            scope.vm.alertResponse('Reject', true);
                        }
                    }
                });
            },
            templateUrl: 'app/widgets/vox-alert.html'
        };

        return directive;
    }

    AlertController.$inject = ['$document', '$interval', '$scope', 'accountservice', 'callEvents', 'enums', 'logger', 'usermessageservice', 'userservice', 'twiliowebrtcservice'];
    function AlertController($document, $interval, $scope, accountservice, callEvents, enums, logger, usermessageservice, userservice, twiliowebrtcservice) {
        var vm = this;
        var defaultAudioFilePath = '/assets/audio/PagerBeeps.mp3';

        // Functions
        vm.alertResponse = alertResponse;

        vm.alertType = 'alert alert-success';
        vm.alertMessage = undefined;
        vm.alertPromise = undefined;
        vm.hideAlertPromise = undefined;
        vm.beepSound = undefined;
        vm.waitingForAcceptResponse = false;
        vm.waitingForRejectResponse = false;
        vm.triggeredBy = '';
        vm.actionedAlert = undefined;
        activate();

        function activate() {
        }

        // No if/then/else test on 'newValue' is needed here because 'newValue' will always be the alert data.
        // If vm.alert ever was 'undefined', this directive and it's scope would be destroyed before this code
        // could run. Instead, I use $scope.$on($destroy'...) to stop the alarm sound.
        $scope.$watch('vm.alert', function (newValue, oldValue) {
            updateAlert('alert alert-success', undefined); //reset the alert - shouldn't be needed

            if (newValue !== undefined) {
                userservice.addCallEvent(callEvents.AlertButtonVisible, newValue.CallId, newValue.ResourceAlertId);
            }
            soundTheAlarm();

            if (newValue !== undefined) {
                userservice.addCallEvent(callEvents.AlertSoundPlaying, newValue.CallId);
            }

            // Play the alarm every 10 seconds (play for 5, wait for 5)...
            // but repeat only once so if the client loses connectivity for some reason, the sound won't play for ever.
            vm.alertPromise = $interval(soundTheAlarm, 10000, 1);
        });

        // Just before the controller scope is destroyed, stop the alarm (in case it's sounding).
        $scope.$on('$destroy', function () {
            $document.unbind('keydown');
            stopTheAlarm();
        });

        function alertResponse(action, keypress) {
            $document.unbind('keydown');
            stopTheAlarm();

            if (!vm.alert) {
                return;
            }
            vm.actionedAlert = vm.alert;

            vm.triggeredBy = keypress === true ? 'KeyPress' : 'MouseClick';
            accountservice.logMessage('vox-alert.directive|Message: AlertResponse triggered by ' + vm.triggeredBy +
                ', ResourceAlertId: ' + vm.actionedAlert.ResourceAlertId + ', ResourceRequestId: ' + vm.actionedAlert.ResourceRequestId, enums.LogLevel.Info);
            try {
                switch (action) {
                    case 'Accept':
                        vm.waitingForAcceptResponse = true;
                        refreshWebRTCToken();
                        userservice.acceptAlert(vm.actionedAlert.ResourceAlertId, vm.actionedAlert.ResourceRequestId, vm.actionedAlert.IsTestCall, vm.actionedAlert.CallId,
                            vm.actionedAlert.IsScheduleCall).then(function (result) {
                            if (result === true) {
                                usermessageservice.notify('notify', { eventName: 'Accept' });
                                logger.info('Call Accepted');
                            }
                            else {
                                usermessageservice.notify('notify', { eventName: 'AlreadyAccept' });
                                logger.info('Couldn\'t Accept Call');
                            }

                            var requestId = vm.actionedAlert ? vm.actionedAlert.ResourceRequestId : undefined;
                            vm.hideAlertPromise = $interval(hideAlert, 0, 1, true, requestId);

                        }).finally(function () {
                            vm.waitingForAcceptResponse = false;
                        });
                        break;
                    case 'Reject':
                        vm.waitingForRejectResponse = true;
                        userservice.rejectAlert(vm.actionedAlert.ResourceAlertId, vm.actionedAlert.ResourceRequestId, vm.actionedAlert.IsTestCall, vm.actionedAlert.CallId,
                            vm.actionedAlert.IsScheduleCall).then(function (result) {
                            usermessageservice.notify('notify', { eventName: 'Reject' });

                            var requestId = vm.actionedAlert ? vm.actionedAlert.ResourceRequestId : undefined;
                            vm.hideAlertPromise = $interval(hideAlert, 0, 1, true, requestId);

                        }).finally(function () {
                            vm.waitingForRejectResponse = false;
                        });
                        break;
                    default:
                        logger.error('Unexpected action: \'' + action + '\'');
                        break;
                }
            }
            catch (e) {
                vm.waitingForAcceptResponse = false;
                vm.waitingForRejectResponse = false;
            }
        }

        function refreshWebRTCToken()
        {
            if (+vm.contactMethod === enums.ContactMethod.WebRTC && vm.reCreateTokens)
            {
                twiliowebrtcservice.enable();
            }
        }

        //Change the alert level and message
        function updateAlert(changedAlertStyle, alertMessage) {
            vm.alertType = changedAlertStyle;
            vm.alertMessage = alertMessage;
        }

        // Start the alarm sound
        function soundTheAlarm() {
            var path = defaultAudioFilePath;
            if (vm.alert && vm.alert.AudioFilePath) {
                path = vm.alert.AudioFilePath;
            }
            vm.beepSound = new Audio(path);
            vm.beepSound.autoplay = true;
        }

        // Stop the alarm sound
        function stopTheAlarm() {
            if (vm.beepSound) {
                vm.beepSound.pause();
            }

            if (vm.alertPromise) {
                $interval.cancel(vm.alertPromise);
            }

            if (vm.hideAlertPromise) {
                $interval.cancel(vm.hideAlertPromise);
            }
        }

        // Hide the alert if the active alert hasn't changed since the user was alerted.
        // We're trying to guard against the rare possibility that the user receives a new
        // alert between the time they respond to the first one and the time the system
        // processes the response.
        function hideAlert(resourceRequestId) {
            if (vm.alert && (resourceRequestId !== undefined) && (vm.alert.ResourceRequestId === resourceRequestId)) {
                vm.alert = undefined;
            }

            vm.hideAlertPromise = undefined;
        }
    }
})();

'use strict';

angular
    .module('smart-table')
    .directive('stReset', stReset);

/* @ngInject */
function stReset() {
    var directive = {
        require: '^stTable',
        restrict: 'EA',
        scope: { stReset: '=stReset' },
        link: function postLink(scope, element, attrs, ctrl) {
            return element.bind('click', function () {
                return scope.$apply(function () {
                    var tableState;
                    tableState = ctrl.tableState();
                    tableState.search.predicateObject = {};
                    return ctrl.pipe();
                });
            });
        }
    };
    return directive;
}

(function () {
    'use strict';

    angular
        .module('vox-leonis.widgets')
        .controller('NewInterpreterPortalController', NewInterpreterPortalController);

    NewInterpreterPortalController.$inject = [
        '$timeout', '$uibModalInstance', '$window', '$scope',
        'userservice', 'preferences', 'usermessageservice', 'enums',
        'interpreterVoicePortalFrontEndUrl'
    ];

    /* @ngInject */
    function NewInterpreterPortalController(
        $timeout, $uibModalInstance, $window, $scope,
        userservice, preferences, usermessageservice, enums,
        interpreterVoicePortalFrontEndUrl
    ) {
        var vm = this;
        vm.interpreterVoicePortalFrontEndUrl = interpreterVoicePortalFrontEndUrl;
        vm.stayInOldVoicePortal = stayInOldVoicePortal;
        vm.hasRequiredStatusToStayInOldVoicePortal = false;

        var switchToInterpreterTimeout = 6000;
        var isSwitchAborted = false;

        $timeout(function () {
            if (!isSwitchAborted) {
                redirectToInterpreterVoicePortal();
            }
        }, switchToInterpreterTimeout);

        usermessageservice.subscribe($scope, 'notify', function (event, data) {
            if (data.eventName === 'currentStatus') {
                var acceptableStatuses = [
                    enums.PersonStatusNames.NotAvailable,
                    enums.PersonStatusNames.Available,
                    enums.PersonStatusNames.Unavailable,
                    enums.PersonStatusNames.Offline,
                    enums.PersonStatusNames.Away,
                ];
                vm.hasRequiredStatusToStayInOldVoicePortal = acceptableStatuses.some(function (status) { return status === data.statusName; });
            }
        });

        function stayInOldVoicePortal() {
            isSwitchAborted = true;
            userservice.setUserSetting(preferences.IvrNewVoicePortalUsedByInterpreter, false)
                .then(function (data) {
                    $uibModalInstance.close();
                });
        }

        function redirectToInterpreterVoicePortal() {
            $window.location.href = vm.interpreterVoicePortalFrontEndUrl;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.widgets')
        .controller('NewCallOperatorsPortalController', NewCallOperatorsPortalController);

    NewCallOperatorsPortalController.$inject = [
        '$timeout', '$uibModalInstance', '$window',
        'userservice', 'preferences',
        'callOperatorsVoicePortalFrontEndUrl'
    ];

    /* @ngInject */
    function NewCallOperatorsPortalController(
        $timeout, $uibModalInstance, $window,
        userservice, preferences,
        callOperatorsVoicePortalFrontEndUrl
    ) {
        var vm = this;
        vm.callOperatorsVoicePortalFrontEndUrl = callOperatorsVoicePortalFrontEndUrl;
        vm.stayInOldVoicePortal = stayInOldVoicePortal;

        var switchToCallOperatorsTimeout = 6000;
        var isSwitchAborted = false;

        $timeout(function () {
            if (!isSwitchAborted) {
                redirectToCallOperatorsVoicePortal();
            }
        }, switchToCallOperatorsTimeout);

        function stayInOldVoicePortal() {
            isSwitchAborted = true;
            userservice.setUserSetting(preferences.IvrNewVoicePortalUsedByOperator, false)
                .then(function (data) {
                    $uibModalInstance.close();
                });
        }

        function redirectToCallOperatorsVoicePortal() {
            $window.location.href = vm.callOperatorsVoicePortalFrontEndUrl;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.widgets')
        .controller('ModalFeedbackController', ModalFeedbackController);

    ModalFeedbackController.$inject = ['$scope', 'utilities', 'user', 'roles', '$uibModalInstance', 'appsettingsservice', 'accountservice', 'enums', '$cookies', 'constants'];
    /* @ngInject */
    function ModalFeedbackController($scope, utilities, user, roles, $uibModalInstance, appsettingsservice, accountservice, enums, $cookies, constants) {
        var vm = this;

        vm.submitFeedback = submitFeedback;
        vm.cancel = cancel;
        vm.title = 'Lionbridge Voice Portal';
        vm.feedbackDescription = '';
        vm.logLevel = enums.LogLevel;
        vm.user = user;
        vm.roles = roles;
        vm.buildFeedbackTypesList = buildFeedbackTypesList;
        vm.submitting = false;

        // This method is called when the modal is created (even if the tab on which the modal will be displayed is inactive)
        $uibModalInstance.opened.then(function () {
            vm.referenceId = $cookies.get(constants.referenceId);
            vm.profileName = $cookies.get(constants.profileName);

            if (vm.referenceId === undefined) {
                if (roles.includes(constants.Operator)) {
                    vm.role = constants.Operator;
                } else {
                    vm.role = constants.Interpreter;
                }
                vm.referenceId = 'undefined';
            } else {
                vm.role = $cookies.get(constants.userRole);
            }
            
            appsettingsservice.getAppSetting('Portal_' + vm.role + 'IssueTypes', 'Call Quality:0').then(function (data) {
                vm.feedbackTypes = buildFeedbackTypesList(data);
            });
        });

        function buildFeedbackTypesList(list) {

            return list.split('|').map(function (attribute) {
                var dividedAttribute = attribute.split(':');
                return {
                    id: dividedAttribute[1],
                    name: dividedAttribute[0]
                };
            });
        }

        function submitFeedback() {
            vm.submitting = true;
            var description = vm.feedbackDescription.replace(/(\r\n|\n|\r)/gm, ' ');
            description = description.replace(/"/g, '\x27');
            var message = 'VoicePortalFeedback|UserId: ' + user.Id + '|FirstName: ' + user.FirstName + '|LastName: ' + user.LastName + '|Email: ' + user.Email + ' ' +
                '|UserRole: ' + vm.role + '|ReferenceId: ' + vm.referenceId + '|Organization: ' + vm.profileName + '|IssueTypeId: ' + vm.feedbackType.id + '|IssueType: ' +
                vm.feedbackType.name + '|IssueDescription: ' + description + '|Browser: ' + getBrowserInfo();
            accountservice.logMessage(message, vm.logLevel.Info);
            cancel();
        }

        function cancel() {
            $uibModalInstance.close();
            utilities.setRootScopeTitle(vm.title);
        }

        function getBrowserInfo() {
            var userAgent = navigator.userAgent, tem,
            matchArray = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if (/trident/i.test(matchArray[1])) {
                tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
                return 'IE ' + (tem[1] || '');
            }
            if (matchArray[1] === 'Chrome') {
                tem = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
                if (tem != null) {
                    return tem.slice(1).join(' ').replace('OPR', 'Opera');
                }
            }
            matchArray = matchArray[2] ? [matchArray[1], matchArray[2]] : [navigator.appName, navigator.appVersion, '-?'];
            if ((tem = userAgent.match(/version\/(\d+)/i)) != null) {
                matchArray.splice(1, 1, tem[1]);
            }
            return matchArray.join(',');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.widgets')
        .controller('ModalCallController', ModalCallController);

    ModalCallController.$inject = ['$scope', 'utilities', '$uibModalInstance', 'data', 'session', 'interpreterservice', 'operatorservice', 'logger', 'accountservice', 'enums'];
    /* @ngInject */
    function ModalCallController($scope, utilities, $uibModalInstance, data, session, interpreterservice, operatorservice, logger, accountservice, enums) {
        var vm = this;

        vm.accept = accept;
        vm.from = data.FromPhoneNumber;
        vm.profileName = data.ProfileName;
        vm.reject = reject;
        vm.timerStarted = false;
        vm.language = data.Language;
        vm.interpreterid = data.InterpreterId;
        vm.operatorid = data.OperatorId;
        vm.roles = session.roles;
        vm.responseTimeout = data.ResponseTimeout;
        vm.organizationName = data.OrganizationName;
        vm.scheduledCase = data.ScheduledCase;
        vm.callRejectedMessage = '';
        vm.close = close;
        vm.waitingForResponse = false;
        vm.beepSound = undefined;
        vm.title = 'Lionbridge Voice Portal';
        vm.missedCallTitle = 'You missed a call';
        vm.modalOpened = undefined;
        vm.logLevel = enums.LogLevel;
        vm.callid = data.CallId;

        activate();

        $scope.$on('elapsed', function (event, args) {
            if (args.message) {
                reject('OutOfTime');
                utilities.setRootScopeTitle(vm.missedCallTitle);
            }
        });

        function activate() {
            vm.beepSound = new Audio('assets/audio/PagerBeeps.mp3');
            vm.beepSound.autoplay = true;
        }

        function accept() {
            vm.beepSound.pause();
            vm.waitingForResponse = true;
            vm.timerStarted = false;
            if (vm.interpreterid !== undefined) {
                interpreterservice.acceptCall(data.CallId, data.PhoneNumber, data.LanguageId, data.CustomerId, data.FromPhoneNumber).then(function (result) {
                    console.log('from modal accept' + data.CallId);
                    if (result !== true) {
                        vm.callRejectedMessage = getCallRejectedMessage('Accept');
                        utilities.setRootScopeTitle(vm.missedCallTitle);
                        logger.error('Couldn\'t Accept Call');
                    }
                    else {
                        logger.info('Call Accepted');
                        $uibModalInstance.close();
                        utilities.setRootScopeTitle(vm.title);
                    }
                })
                .catch(function (result) {
                    vm.callRejectedMessage = getCallRejectedMessage('Accept');
                    utilities.setRootScopeTitle(vm.missedCallTitle);
                })
                .finally(function () {
                    vm.waitingForResponse = false;
                });
            }
            else if (vm.operatorid !== undefined) {
                operatorservice.acceptCall(data.CallId, data.PhoneNumber).then(function (result) {
                    if (result === false) {
                        vm.callRejectedMessage = getCallRejectedMessage('Accept');
                        utilities.setRootScopeTitle(vm.missedCallTitle);
                        logger.error('Couldn\'t Accept Call');
                    }
                    else {
                        logger.info('Call Accepted');
                        $uibModalInstance.close();
                        utilities.setRootScopeTitle(vm.title);
                    }
                })
                .catch(function (result) {
                    vm.callRejectedMessage = getCallRejectedMessage('Accept');
                    utilities.setRootScopeTitle(vm.missedCallTitle);
                })
                .finally(function () {
                    vm.waitingForResponse = false;
                });
            }
        }

        function reject(actionAttempted) {
            vm.beepSound.pause();
            vm.waitingForResponse = true;
            vm.timerStarted = false;
            console.log('callid' + vm.callid);
            utilities.setRootScopeTitle(vm.title);
            if (vm.interpreterid !== undefined) {
                interpreterservice.rejectCall(data.CallId, data.LanguageId, data.CustomerId, data.FromPhoneNumber).then(function (result) {
                    console.log('from modal' + data.CallId);
                    if (result === false) {
                        accountservice.logMessage('modal-callController.reject Call Action Failed|CallId:' + data.CallId, vm.logLevel.Warn);
                    }
                })
                 .finally(function () {
                     callRejected(actionAttempted);
                 });
            }
            else if (vm.operatorid !== undefined) {
                operatorservice.rejectCall(data.CallId, data.FromPhoneNumber, data.CustomerId).then(function (result) {
                    if (result === false) {
                        accountservice.logMessage('modal-callController.reject Call Action Failed|CallId:' + data.CallId, vm.logLevel.Warn);
                    }
                })
                .finally(function () {
                    callRejected(actionAttempted);
                });
            }
        }

        function callRejected(actionAttempted) {
            vm.callRejectedMessage = getCallRejectedMessage(actionAttempted);
            vm.waitingForResponse = false;
        }

        // This method is called when the modal is actually rendered (not until the tab on which it is displayed becomes active)
        $uibModalInstance.rendered.then(function () {

            var renderDelay = Math.floor((Date.now() - vm.modalOpened) / 1000);
            vm.responseTimeout -= renderDelay;

            if (vm.responseTimeout <= 0) {
                reject('OutOfTime');
                utilities.setRootScopeTitle(vm.missedCallTitle);
            }
            else {
                vm.timerStarted = true;
            }
        });

        // This method is called when the modal is created (even if the tab on which the modal will be displayed is inactive)
        $uibModalInstance.opened.then(function () {
            vm.modalOpened = Date.now();
        });

        function close() {
            $uibModalInstance.close();
            utilities.setRootScopeTitle(vm.title);
        }

        function getCallRejectedMessage(actionAttempted) {
            var message;
            if (actionAttempted === 'Accept') {
                setInterpreterStatus();
                message = 'You clicked Accept too late.';
            }
            else if (actionAttempted === 'Reject') {
                message = 'You clicked Reject. Your status has been changed to Unavailable.';
            }
            else {
                setInterpreterStatus();
                message = 'You missed a call.';
            }
            return message;
        }

        function setInterpreterStatus()
        {
            if (vm.interpreterid !== undefined) {
                interpreterservice.setStatusAtomic(enums.PersonStatusNames.Unavailable, enums.PersonStatusNames.Available);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.widgets')
        .directive('ngDraggable', drag);

    function drag($document) {
        var directive = {
            restrict: 'EA',
            scope: {
                dragOptions: '=ngDraggable'
            },
            controller: DraggableController,
            controllerAs: 'vm',
            link: function (scope, elem, attr) {
                var startX, startY, x = 0, y = 0,
                    start, stop, drag, container;

                var width = elem[0].offsetWidth,
                    height = elem[0].offsetHeight;

                // Obtain drag options
                if (scope.dragOptions) {
                    start = scope.dragOptions.start;
                    drag = scope.dragOptions.drag;
                    stop = scope.dragOptions.stop;
                    var id = scope.dragOptions.container;
                }

                // Bind mousedown event
                elem.on('mousedown', function (e) {
                    e.preventDefault();
                    startX = e.clientX - elem[0].offsetLeft;
                    startY = e.clientY - elem[0].offsetTop;
                    $document.on('mousemove', mousemove);
                    $document.on('mouseup', mouseup);
                    if (start) { start(e); }
                });

                // Handle drag event
                function mousemove(e) {
                    y = e.clientY - startY;
                    x = e.clientX - startX;
                    setPosition();
                    if (drag) { drag(e); }
                }

                // Unbind drag events
                function mouseup(e) {
                    $document.unbind('mousemove', mousemove);
                    $document.unbind('mouseup', mouseup);
                    if (stop) { stop(e); }
                }

                // Move element, within container if provided
                function setPosition() {
                    if (container) {
                        if (x < container.left) {
                            x = container.left;
                        } else if (x > container.right - width) {
                            x = container.right - width;
                        }
                        if (y < container.top) {
                            y = container.top;
                        } else if (y > container.bottom - height) {
                            y = container.bottom - height;
                        }
                    }

                    elem.css({
                        top: y + 'px',
                        left: x + 'px'
                    });
                }
            }
        };
        return directive;
    }
    DraggableController.$inject = ['$scope'];
    function DraggableController($scope) {
        $scope.dragOptions = {
            start: function (e) {
                console.log('STARTING');
            },
            drag: function (e) {
                console.log('DRAGGING');
            },
            stop: function (e) {
                console.log('STOPPING');
            },
            container: 'container'
        };
    }
})();


(function ()
{
    'use strict';

    angular
        .module('vox-leonis.operator', [
            'vox-leonis.core'
        ]);
})();


(function () {
    'use strict';

    angular
        .module('vox-leonis.operator')
        .directive('voxScheduledRelayInterpretation', voxScheduledRelayInterpretation);
    /* @ngInject */
    function voxScheduledRelayInterpretation() {
        var directive = {
            bindToController: true,
            controller: ScheduledRelayInterpretationController,
            controllerAs: 'vm',
            restrict: 'E',
            scope: {
                'currentCall': '=',
                'currentCase': '=',
                'caseDisplay': '=',
                'operator': '=',
                'customer': '=',
                'interpreters': '=',
                'languageService': '='
            },
            templateUrl: 'app/operator/vox-scheduled-relay-interpretation.html'
        };

        return directive;
    }

    ScheduledRelayInterpretationController.$inject = ['$scope', '$rootScope', 'accountservice', 'enums', 'operatorservice', '$q',
        'operatorsignalreceiver', 'usermessageservice', 'callservice', 'utilities', 'userservice', 'callEvents', '$cookies'];
    /* @ngInject */
    function ScheduledRelayInterpretationController($scope, $rootScope, accountservice, enums, operatorservice, $q,
        operatorsignalreceiver, usermessageservice, callservice, utilities, userservice, callEvents, $cookies) {
        var vm = this;

        vm.areControlsDisabled = areControlsDisabled;
        vm.isConnectRelayInterpreterButtonDisabled = isConnectRelayInterpreterButtonDisabled;
        vm.changeLanguageServiceSelection = changeLanguageServiceSelection;

        vm.connectRareLanguageInterpreter = connectRareLanguageInterpreter;
        vm.connectRelayInterpreter = connectRelayInterpreter;
        vm.callLanguageService = callLanguageService;
        vm.conferenceAllParties = conferenceAllParties;
        vm.switchParticipant = switchParticipant;
        vm.getRareInterpreterPhone = getRareInterpreterPhone;
        vm.logButtonShowEvent = logButtonShowEvent;
        vm.languageServiceIds = buildLanguageServiceIds(vm.languageService);
        vm.LanguageSelect = getSelectedLanguageService();
        var relayInterpreterId = null;

        initialize();
        activate();

        function initialize() {
            vm.isRareLanguageInterpreterConnected = false;
            vm.isRelayInterpreterConnected = false;
            vm.relayInterpreterConnectFailed = false;
            vm.arePartiesConnected = false;

            vm.isCustomerOnHold = false;
            vm.isRareLanguageInterpreterOnHold = false;
            vm.isRelayInterpreterOnHold = false;

            vm.connectingRareLanguageInterpreter = false;
            vm.connectingRelayInterpreter = false;
            vm.callingLanguageService = false;
            vm.connectingParties = false;
            vm.switchingParticipant = false;

            vm.logLevel = enums.LogLevel;
        }

        function activate() {
            onCurrentCallChanged();
            $scope.$watch('vm.currentCall', onCurrentCallChanged);
            $scope.$on(operatorsignalreceiver.callNotAnsweredEvent, interpreterMissedTheCall);
            $scope.$on(operatorsignalreceiver.callAnsweredEvent, interpreterAnsweredTheCall);
            $scope.$on(operatorsignalreceiver.interpreterLeftTheCallEvent, interpreterLeftTheCall);
            $scope.$on(operatorsignalreceiver.findInterpreterTimeoutEvent, findRelayInterpreterTiemout);

            $scope.$on('$destroy', function () {
                showInstructionMessage('');
            });
        }

        function buildLanguageServiceIds(languageService) {
            if (languageService) {
                return languageService.map(function (ids) {
                    return ids.Id;
                });
            }
            return [];
        }

        function findRelayInterpreterTiemout() {
            vm.callingLanguageService = false;
            vm.connectingRelayInterpreter = false;
            vm.connectRelayInterpreterDisabled = false;
            vm.callLanguageServiceDisabled = false;
            vm.relayInterpreterConnectFailed = true;
            showInstructionMessage('Failed to connect Relay Interpreter. Click on Connect Language Service or ' +
                'Connect Relay Interpreter button to connect Relay Interpreter.');
        }

        function interpreterMissedTheCall(event, data) {
            if (vm.currentCase.InterpreterId === data.interpreterId) {
                vm.connectingRareLanguageInterpreter = false;
            } else if (!!data.interpreterId) {
                findRelayInterpreterTiemout();
            }
        }

        function interpreterAnsweredTheCall(event, data) {
            if (vm.currentCase.InterpreterId === data.interpreterId) {
                vm.connectingRareLanguageInterpreter = false;
                vm.isRareLanguageInterpreterConnected = true;
            } else if (!!data.interpreterId) {
                vm.callingLanguageService = false;
                vm.connectingRelayInterpreter = false;
                vm.isRelayInterpreterConnected = true;
                relayInterpreterId = data.interpreterId;
            }
            updateInstructionMessage();
        }

        function interpreterLeftTheCall(event, data) {
            if (vm.currentCase.InterpreterId === data.interpreterId) {
                vm.isRareLanguageInterpreterConnected = false;
                vm.isRareLanguageInterpreterOnHold = false;
            } else if (!!data.interpreterId) {
                vm.isRelayInterpreterConnected = false;
                vm.connectingRelayInterpreter = false;
                vm.isRelayInterpreterOnHold = false;
                relayInterpreterId = null;
                vm.relayInterpreterPhoneNumber = null;
            }

            updateInstructionMessage();
        }

        function onCurrentCallChanged() {
            checkParticipantsOnCall();
            updateInstructionMessage();
        }

        function checkParticipantsOnCall() {
            vm.isRareLanguageInterpreterConnected = false;
            vm.isRelayInterpreterConnected = false;
            relayInterpreterId = null;
            vm.relayInterpreterPhoneNumber = null;

            if (vm.currentCall && vm.currentCall.Participants && vm.currentCall.Participants.length) {
                for (var k = 0; k < vm.currentCall.Participants.length; k++) {
                    var callParticipant = vm.currentCall.Participants[k];
                    if (callParticipant.CustomerId === vm.customer.Id) {
                        vm.isCustomerOnHold = callParticipant.Status === 'OnHold';
                    } else if (callParticipant.InterpreterId === vm.currentCase.InterpreterId) {
                        vm.isRareLanguageInterpreterConnected = true;
                        vm.isRareLanguageInterpreterOnHold = callParticipant.Status === 'OnHold';
                    } else if (!!callParticipant.InterpreterId) {
                        vm.isRelayInterpreterConnected = true;
                        relayInterpreterId = callParticipant.InterpreterId;
                        vm.relayInterpreterPhoneNumber = callParticipant.PhoneNumber;
                        vm.isRelayInterpreterOnHold = callParticipant.Status === 'OnHold';
                    }
                }
            }
        }

        function updateInstructionMessage() {
            var rareDropped = false;
            var ralayDropped = false;

            if (!vm.currentCall) {
                return;
            }

            var interpreterDroppedInfo = callservice.getInterpreterDroppedInfo(vm.currentCall.Events);
            if (interpreterDroppedInfo) {
                rareDropped = interpreterDroppedInfo.interpreterId === vm.currentCase.InterpreterId;
                ralayDropped = !rareDropped;
            }

            if (!vm.isRareLanguageInterpreterConnected) {
                if (rareDropped) {
                    showInstructionMessage('Rare Interpreter was abruptly dropped from conference call with this customer');
                } else {
                    showInstructionMessage('Scheduled Relay Interpretation Conference Call. Please Click Connect Rare Language ' +
                        'Interpreter button to connect interpreter.');
                }
            } else if (!vm.isRelayInterpreterConnected) {
                if (ralayDropped) {
                    showInstructionMessage('Relay Interpreter was abruptly dropped from conference call with this customer');
                } else {
                    showInstructionMessage('Successfully connected Rare Language Interpreter. Click on Connect Relay ' +
                        'Interpreter button to connect Relay Interpreter.');
                }
            } else {
                showInstructionMessage('Successfully connected Rare Language Interpreter and Relay Interpreter. ' +
                    'Click on the Conference button to connect Customer, Rare Language Interpreter and Relay Interpreter.');
            }
        }

        function switchParticipant(muteCustomer, muteRareInterpreter, muteRelayInterpreter) {
            vm.switchingParticipant = true;
            var promises = [];

            if (vm.isCustomerOnHold !== muteCustomer) {
                promises.push(updateCustomerHoldStatus(muteCustomer));
            }

            if (vm.isRareLanguageInterpreterConnected && (vm.isRareLanguageInterpreterOnHold !== muteRareInterpreter || muteRareInterpreter === true)) {
                promises.push(updateInterpreterHoldStatus(vm.currentCase.InterpreterId, muteRareInterpreter));
            }

            if (vm.isRelayInterpreterConnected && (vm.isRelayInterpreterOnHold !== muteRelayInterpreter || muteRelayInterpreter === true)) {
                promises.push(updateInterpreterHoldStatus(relayInterpreterId, muteRelayInterpreter));
            }

            return $q
                .all(promises)
                .finally(function () { vm.switchingParticipant = false; });
        }

        function areControlsDisabled() {
            return vm.connectingRareLanguageInterpreter ||
                vm.connectingRelayInterpreter ||
                vm.callingLanguageService ||
                vm.connectingParties ||
                vm.switchingParticipant;
        }

        function isConnectRelayInterpreterButtonDisabled() {
            return vm.relayInterpreterConnectFailed;
        }

        function connectRareLanguageInterpreter() {

            vm.connectingRareLanguageInterpreter = true;

            switchParticipant(true, true, true)
                .then(callHoldSuccess)
                .catch(callError);

            function callHoldSuccess() {
                return operatorservice
                    .callInterpreter(vm.currentCall.CallId, vm.currentCase.InterpreterId, false)
                    .then(callSuccess)
                    .catch(callError);
            }

            function callSuccess(data) {
                if (data === false) {
                    accountservice.logMessage('vox-scheduled-relay-interpretation.connectRareLanguageInterpreter Action Failed. CallId: ' +
                        vm.currentCall.CallId, vm.logLevel.Warn);
                    callError();
                } else {
                    if (relayInterpreterId !== null) {
                        accountservice.logMessage('vox-scheduled-relay-interpretation.connectRareLanguageInterpreter Put relay interpreter onHold. RelayInterpreterId: ' +
                        relayInterpreterId + ' CallId: ' + vm.currentCall.CallId, vm.logLevel.Warn);
                        updateInterpreterHoldStatus(relayInterpreterId, true);
                    }
                    vm.isCustomerOnHold = true;
                }
            }

            function callError() {
                vm.connectingRareLanguageInterpreter = false;
                showInstructionMessage('Failed to connect Rare Language Interpreter.');
            }
        }

        function connectRelayInterpreter() {
            vm.connectingRelayInterpreter = true;

            switchParticipant(true, true, true)
                .then(callHoldSuccess)
                .catch(callError);

            function callHoldSuccess() {
                return operatorservice
                    .findInterpreter(vm.currentCase.RelayLanguageId, vm.currentCall.CallId)
                    .then(callSuccess)
                    .catch(callError);
            }

            function callSuccess(data) {
                if (data === false) {

                    operatorservice
                        .checkLanguageServiceTimeout(vm.currentCall.CallId)
                        .then(function (languageServiceIsTimeouted) {
                            vm.languageServiceIsTimeouted = languageServiceIsTimeouted;
                        })
                        .finally(function() {
                            accountservice.logMessage('vox-scheduled-relay-interpretation.connectRelayInterpreter Action Failed|CallId:' +
                                vm.currentCall.CallId, vm.logLevel.Warn);
                            callError();
                        });
                } else {
                    accountservice.logMessage('vox-scheduled-relay-interpretation.connectRelayInterpreter. Put rare Interpreter on hold. RareInterpreterId: ' +
                        vm.currentCase.InterpreterId + ' CallId: ' + vm.currentCall.CallId, vm.logLevel.Warn);
                    updateInterpreterHoldStatus(vm.currentCase.InterpreterId, true);
                    vm.relayInterpreterConnectFailed = false;
                }
            }

            function callError() {
                vm.connectingRelayInterpreter = false;
                vm.relayInterpreterConnectFailed = true;
                showInstructionMessage('Failed to connect Relay Interpreter. Click on Connect Language Service button to connect Language Service.');
            }
        }

        function callLanguageService(languageSelect) {
            vm.LanguageSelect = { GroupId: languageSelect.GroupId, Name: languageSelect.Name };
            vm.callingLanguageService = true;
            // log event Language select click button
            userservice.addCallEvent(callEvents.LSButtonClicked, vm.currentCall.CallId);

            switchParticipant(true, true, true)
                .then(callHoldSuccess)
                .catch(onError);

            function callHoldSuccess() {
                return operatorservice
                    .findLanguageServiceInterpreterByGroup(vm.currentCase.RelayLanguageId, vm.currentCase.CustomerId, vm.currentCall.CallId, vm.LanguageSelect.GroupId)
                    .catch(onError);
            }

            function onError() {
                vm.relayInterpreterConnectFailed = true;
                vm.callingLanguageService = false;
                showInstructionMessage('Failed to connect Relay Interpreter. Click on Connect Language Service or ' +
                    'Connect Relay Interpreter button to connect Relay Interpreter.');
            }
        }

        function conferenceAllParties() {
            vm.connectingParties = true;

            operatorservice
                .joinInterpretersWithCustomer(vm.currentCall.CallId, vm.currentCase.InterpreterId, relayInterpreterId)
                .then(connectSuccess)
                .catch(connectError)
                .finally(connectFinally);

            function connectSuccess() {
                vm.arePartiesConnected = true;
                showInstructionMessage('');
            }

            function connectError() {
                showInstructionMessage('Failed to conference all parties.');
            }

            function connectFinally() {
                vm.connectingParties = false;
            }
        }

        function updateInterpreterHoldStatus(interpreterId, isOnHold) {
            if (!interpreterId) {
                return $q.resolve();
            }

            return operatorservice
                .updateInterpreterHoldStatus(interpreterId, isOnHold, vm.currentCall.CallId)
                .then(function (data) {
                    if (data === false) {
                        accountservice.logMessage('vox-scheduled-relay-interpretation.holdCurrentCall Action Failed|CallId:' +
                            vm.currentCall.CallId, vm.logLevel.Warn);
                        return $q.reject();
                    }

                    if (interpreterId === relayInterpreterId) {
                        vm.isRelayInterpreterOnHold = isOnHold;
                    }

                    if (interpreterId === vm.currentCase.InterpreterId) {
                        vm.isRareLanguageInterpreterOnHold = isOnHold;
                    }

                    return $q.resolve();
                });
        }

        function updateCustomerHoldStatus(isOnHold) {
            return operatorservice.updateCustomerHoldStatus(vm.currentCall.CallId, isOnHold).then(function (data) {
                if (data === false) {
                    accountservice.logMessage('vox-scheduled-relay-interpretation.updateCustomerHoldStatus Action Failed. CallId: ' +
                        vm.currentCall.CallId, vm.logLevel.Warn);
                    return $q.reject();
                }

                vm.isCustomerOnHold = isOnHold;
                return $q.resolve();
            });
        }

        function showInstructionMessage(message) {
            usermessageservice.notify(enums.Events.ShowInstructionMessage, { message: message });
        }

        function getRareInterpreterPhone() {
            if (vm.caseDisplay && vm.caseDisplay.InterpreterPhone) {
                return vm.caseDisplay.InterpreterPhone;
            }

            if (!vm.interpreters || !vm.currentCase) {
                return null;
            }

            var rareInterpreter = null;
            for (var i = 0; i < vm.interpreters.length; i++) {
                if (vm.interpreters[i].Id === vm.currentCase.InterpreterId) {
                    rareInterpreter = vm.interpreters[i];
                    break;
                }
            }

            if (!rareInterpreter) {
                return null;
            }

            return rareInterpreter.PhoneNumber;
        }

        /* This method is called when the connectMe, Language Select or Connect interpreter buttons are shown */
        function logButtonShowEvent(eventName) {
            if (vm.languageServiceIds && vm.languageServiceIds.length > 0) {
                return utilities.logButtonShowEvent(eventName, vm.currentCall.CallId);
            }

            return false;
        }

        function changeLanguageServiceSelection(languageService) {
            vm.LanguageSelect = { GroupId: languageService.GroupId, Name: languageService.Name };

            $cookies.put('SelectedLanguageServiceGroup_' + vm.languageId, languageService.GroupId);
        }

        function getSelectedLanguageService() {
            if (!vm.languageServiceIds || vm.languageServiceIds.length <= 0) {
                return undefined;
            }

            var preSelectedGroupId = $cookies.get('SelectedLanguageServiceGroup_' + vm.languageId);

            if (preSelectedGroupId !== undefined && preSelectedGroupId > 0 && vm.languageService) {
                for (var i = 0; i < vm.languageService.length; i++) {
                    if (vm.languageService[i].GroupId === preSelectedGroupId) {
                        return { GroupId: vm.languageService[i].GroupId, Name: vm.languageService[i].Name };
                    }
                }
            }

            return { GroupId: 0, Name: 'Language Service' };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.operator')
        .directive('voxReconnectSpecificInterpreter', voxReconnectSpecificInterpreter);

    /* @ngInject */
    function voxReconnectSpecificInterpreter() {
        var directive = {
            bindToController: true,
            controller: ReconnectSpecificInterpreterController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'callId': '=',
                'callParticipants': '=',
                'interpreterName': '=',
                'interpreterId': '='
            },
            templateUrl: 'app/operator/vox-reconnect-specific-interpreter.html'
        };
        return directive;
    }

    ReconnectSpecificInterpreterController.$inject = ['$scope', '$timeout', 'accountservice', 'enums', 'operatorservice', 'operatorsignalreceiver', 'usermessageservice'];
    /* @ngInject */
    function ReconnectSpecificInterpreterController($scope, $timeout, accountservice, enums, operatorservice, operatorsignalreceiver, usermessageservice) {
        var vm = this;

        // functions called from the HTML
        vm.callInterpreter = callInterpreter;
        vm.connectInterpreter = connectInterpreter;

        // constants
        vm.callTitle = 'Put the customer on hold and call the interpreter';
        vm.connectTitle = 'Connect the interpreter with the customer';

        vm.callDisabled = false;
        vm.connectDisabled = true;
        vm.interpreterUnavailable = false;
        vm.logLevel = enums.LogLevel;

        activate();

        function activate() {
            $scope.$on(operatorsignalreceiver.callAnsweredEvent, callAnswered);
            $scope.$on(operatorsignalreceiver.callNotAnsweredEvent, interpreterMissedTheCall);
            checkIfInterpreterOnCall();
        }

        function interpreterMissedTheCall(event, data) {
            usermessageservice.notify(enums.Events.ShowInstructionMessage, {
                message: 'Failed to connect Scheduled Language Interpreter. Call status: ' + (data.callStatus.replace('-', ' ') || 'unknown') + '.'
            });
        }

        // If the interpreter is already on THIS call, don't enable the Call button (the Connect button is disabled by default)
        function checkIfInterpreterOnCall() {
            if (vm.callParticipants && vm.callParticipants.length) {
                for (var k = 0; k < vm.callParticipants.length; k++) {
                    var callParticipant = vm.callParticipants[k];
                    if (callParticipant.InterpreterId === vm.interpreterId) {
                        vm.callDisabled = true;
                        vm.connectDisabled = false;
                    }
                }
            }
        }

        // Call the interpreter
        function callInterpreter() {
            vm.callDisabled = true;
            vm.connectDisabled = true;

            vm.callingInterpreter = true;
            vm.interpreterUnavailable = false;
            usermessageservice.notify('disableAllButtons', { message: true });
            var result = operatorservice.callInterpreter(vm.callId, vm.interpreterId, true);
            result.then(callSuccess, callShowError);

            // The service call succeeded!
            function callSuccess(data) {
                stopLadda();

                if (data === false) {
                    accountservice.logMessage('vox-reconnect-specific-interpreter callInterpreter Action Failed. CallId: ' + vm.callId, vm.logLevel.Warn);
                    callShowError();
                }
                else
                {
                    usermessageservice.notify('disableAllButtons', { message: true });
                }
            }

            // If the service call fails or if it succeeds but we don't actually make a call...
            function callShowError() {
                stopLadda();
                vm.callDisabled = false;
                vm.interpreterUnavailable = true;
                usermessageservice.notify('disableAllButtons', { message: false });
                $timeout(callHideError, 5000);
            }

            // Hide the error
            function callHideError() {
                vm.interpreterUnavailable = false;
            }
        }

        // the interpreter has answered the operator's call, make sure the operator can connect the interpreter to the customer
        function callAnswered(event, data) {
            if (vm.interpreterId && (vm.interpreterId === data.interpreterId)) {
                vm.connectDisabled = false;
                usermessageservice.notify('disableAllButtons', { message: true });
            }
        }

        // (re)connect the interpreter with the customer
        function connectInterpreter() {
            vm.connectingInterpreter = true;
            vm.connectDisabled = true;

            operatorservice.connectInterpreter(vm.callId, vm.interpreterId).then(connectSuccess).finally(stopLadda);

            function connectSuccess(data) {

                accountservice.logMessage('vox-reconnect-specific-interpreter.connectInterpreter|Result: {(data === true ? "Success" : "Fail")}, CallId: ' + vm.callId, vm.logLevel.Trace);

                if (data === false) {
                    // If we can't connect the interpreter with the customer, the intepreter probably hung up. Letting the Opertor click 'Connect'
                    // again isn't likely to have any effect. Reset the UI so the Operator can try to call the interpreter again.
                    vm.callDisabled = false;
                    vm.connectDisabled = true;
                    vm.cantConnectInterpreter = true;
                    usermessageservice.notify('disableAllButtons', { message: false });
                    $timeout(connectHideError, 5000);
                }
            }

            // Hide the error
            function connectHideError() {
                vm.cantConnectInterpreter = false;
            }
        }

        // stop the ladda animation
        function stopLadda() {
            vm.callingInterpreter = false;
            vm.connectingInterpreter = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.operator')
        .directive('voxReconnectInterpreter', voxReconnectInterpreter);

    voxReconnectInterpreter.$inject = ['callservice'];

    /* @ngInject */
    function voxReconnectInterpreter(callservice) {
        var directive = {
            bindToController: true,
            controller: ReconnectInterpreterController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'callId': '=',
                'callEvents': '=',
                'interpreters': '=',
                'callParticipants': '=',
                'languageId': '='
            },
            link: function postLink(scope) {
                var callEventsWatch = scope.$watch('vm.callEvents', function (callEvents) {
                    if (callEvents) {

                        var eventInfo = callservice.getInterpreterDroppedInfo(callEvents, scope.vm.languageId, scope.vm.interpreters);
                        if (!eventInfo) {
                            scope.vm.interpreterId = null;
                            scope.vm.disconnectMessage = null;
                            return;
                        }

                        scope.vm.interpreterId = eventInfo.interpreterId;
                        scope.vm.disconnectMessage = eventInfo.reason;

                        for (var j = 0; j < scope.vm.interpreters.length; j++) {
                            if (scope.vm.interpreters[j].Id === scope.vm.interpreterId && scope.vm.interpreters[j].Status === 'InCall') {
                                scope.vm.isReconnectInterpreterDisabled = false;
                                break;
                            }
                        }

                        checkIfInterpreterOnCall();
                    }
                });

                function checkIfInterpreterOnCall() {
                    // check if the interpreter is already on the call
                    if (scope.vm.interpreterId && scope.vm.callParticipants && scope.vm.callParticipants.length) {
                        for (var k = 0; k < scope.vm.callParticipants.length; k++) {
                            var callParticipant = scope.vm.callParticipants[k];
                            if (callParticipant.InterpreterId === scope.vm.interpreterId) {
                                scope.vm.isReconnectInterpreterDisabled = false;
                                scope.vm.callInterpreterDisabled = true;
                            }
                        }
                    }
                }

                scope.$on('$destroy', function () {
                    callEventsWatch();
                });
            },
            templateUrl: 'app/operator/vox-reconnect-interpreter.html'
        };
        return directive;
    }

    ReconnectInterpreterController.$inject = ['operatorservice', '$timeout', 'operatorsignalreceiver', '$scope', 'accountservice', 'enums'];
    /* @ngInject */
    function ReconnectInterpreterController(operatorservice, $timeout, operatorsignalreceiver, $scope, accountservice, enums) {
        var vm = this;
        vm.interpreterId = undefined;
        vm.callInterpreter = callInterpreter;
        vm.connectInterpreter = connectInterpreter;
        vm.disconnectMessage = undefined;
        vm.isReconnectInterpreterDisabled = true;
        vm.isInterpreterUnavailable = false;
        vm.callInterpreterDisabled = false;
        vm.logLevel = enums.LogLevel;

        activate();

        function activate() {
            $scope.$on(operatorsignalreceiver.callAnsweredEvent, callAnswered);
        }

        function callAnswered(event, data) {
            if (vm.interpreterId && vm.interpreterId === data.interpreterId) {
                // the interpreter has answered the operator's call, make sure the operator can connect the interpreter to the customer
                vm.isReconnectInterpreterDisabled = false;
            }
        }

        function callInterpreter() {
            vm.connectingInterpreter = true;
            var result = operatorservice.callInterpreter(vm.callId, vm.interpreterId, true);
            result.then(function (data) {
                if (data === true) {
                    vm.isInterpreterUnavailable = false;
                    vm.connectingInterpreter = false;
                    vm.callInterpreterDisabled = true;
                }
                else {
                    accountservice.logMessage('vox-reconnect-interpreterdirective.callInterpreter Action Failed|CallId:' + vm.callId, vm.logLevel.Warn);
                    vm.isInterpreterUnavailable = true;
                    vm.isReconnectInterpreterDisabled = true;
                    vm.connectingInterpreter = false;
                    vm.callInterpreterDisabled = false;

                    // Make the error disappear after 5 seconds
                    $timeout(function () {
                        vm.isInterpreterUnavailable = false;
                    }, 5000);
                }
            });
        }

        function connectInterpreter() {
            vm.connectingInterpreter = true;
            vm.isReconnectInterpreterDisabled = true;
            operatorservice
                .connectInterpreter(vm.callId, vm.interpreterId)
                .then(function (result) {
                    if (result === false) {
                        accountservice.logMessage('x-reconnect-interpreterdirective.connectInterpreter Action Failed|CallId:' + vm.callId, vm.logLevel.Warn);
                    }
                })
                .finally(function () {
                    vm.connectingInterpreter = false;
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.operator')
        .directive('voxOperatorsTable', voxOperatorsTable);

    /* @ngInject */
    function voxOperatorsTable() {
        var directive = {
            bindToController: true,
            controller: OperatorsTableController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'operators': '=',
                'operatorCount': '='
            },
            link: function postLink(scope, element, attrs, vm) {
                scope.$watch('vm.displayedCollection', function (val) {
                    if (val) {
                        vm.operatorCount = val.length;
                    }
                });
            },
            templateUrl: 'app/operator/vox-operators-table.html'
        };
        return directive;
    }

    /* @ngInject */
    function OperatorsTableController() {
        var vm = this;
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.operator')
        .directive('voxOperator', voxOperator);

    /* @ngInject */
    function voxOperator() {
        var directive = {
            bindToController: true,
            controller: OperatorController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'operator': '=',
                'roles': '=',
                'callType': '='
            },
            templateUrl: 'app/operator/vox-operator.html'
        };
        return directive;
    }

    OperatorController.$inject = ['$cookies', '$q', '$scope', '$filter', '$state', '$timeout', '$uibModal', '$uibModalStack',
        'accountservice', 'appsettingsservice', 'callEvents', 'callservice', 'constants', 'dataservice', 'enums',
        'operatorservice', 'operatorsignalreceiver', 'preferences', 'reducecallfrequencyservice', 'usermessageservice', 'utilities'];
    /* @ngInject */
    function OperatorController($cookies, $q, $scope, $filter, $state, $timeout, $uibModal, $uibModalStack,
        accountservice, appsettingsservice, callEvents, callservice, constants, dataservice, enums,
        operatorservice, operatorsignalreceiver, preferences, reducecallfrequencyservice, usermessageservice, utilities) {

        var vm = this;

        var lodash = window._;
        var callDispositionTimeout = 10000;
        appsettingsservice.getAppSetting(preferences.GetCallDispositionTimeoutMilliseconds, callDispositionTimeout).then(function (data) {
            callDispositionTimeout = data;
        });

        var enableCallDisposition = 'true';
        appsettingsservice.getAppSetting(preferences.GetCallDispositionFlag, enableCallDisposition).then(function (data) {
            enableCallDisposition = data;
        });

        vm.showNonIVRLanguagesDropdown = false;
        appsettingsservice.getAppSetting(preferences.ShowNonIVRLanguagesDropdown, vm.showNonIVRLanguagesDropdown).then(function (data) {
            vm.showNonIVRLanguagesDropdown = (data === 'true');
        });

        vm.filterOverflowVendorsBasedOnLanguage = false;
        appsettingsservice.getAppSetting(preferences.FilterOverflowVendorsBasedOnLanguage, vm.filterOverflowVendorsBasedOnLanguage).then(function (data) {
            vm.filterOverflowVendorsBasedOnLanguage = (data === 'true');
        });

        vm.getLoggedInInterpretersDelay = 1000;
        vm.getOperatorDelay = 1000;

        vm.logButtonShowEvent = logButtonShowEvent;

        activate();

        $scope.$on('showThirdParty', function () {
            vm.showThirdParty = true;
        });
        $scope.$on('hideThirdParty', function () {
            vm.showThirdParty = false;
        });
        usermessageservice.subscribe($scope, 'disableAllButtons', function (event, data) {
            if (data.message) {
                vm.disableAllLanguageSelect = true;
            }
            else {
                vm.disableAllLanguageSelect = false;
            }
        });
        var submitTimer = 0;
        function activate() {
            initialize();
            listeners();

            var promises = {
                languages: getLanguages(),
                pools: getPools(),
                operators: getAllOperators(),
                interpreters: getAllInterpreters()
            };
            if (vm.roles.indexOf('Operator') >= 0) {
                promises.operator = getOperator();
            }
            getLoggedInInterpretersCall();

            return $q.all(promises).then(function (values) {
                vm.languages = utilities.buildLanguages(values.languages);
                if (vm.showNonIVRLanguagesDropdown) { $cookies.put(constants.Languages, JSON.stringify(vm.languages)); }
                vm.pools = values.pools;
                vm.operators = buildOperators(values.operators);
                vm.interpreters = utilities.buildInterpreters(values.interpreters, values.languages);
                getCurrentCall();
            }).catch(function (e) {
                if (e.status === 401) {
                    $state.go('login');
                }
            });
        }

        // initialize variables
        function initialize() {
            // moved initialize code into separate function due to jshint error "the function had too many statements"
            vm.currentCall = undefined;
            vm.currentCustomer = undefined;
            vm.currentLanguages = undefined;
            vm.currentMetaData = undefined;
            vm.operators = undefined;
            vm.pools = undefined;
            vm.interpreters = undefined;
            vm.languages = undefined;
            vm.languageList = undefined;
            vm.inCallInterpreters = undefined;
            vm.loggedInInterpreters = undefined;
            vm.selectedLanguage = undefined;
            vm.currentCase = undefined;
            vm.activeTable = 'loggedInInterpreters';
            vm.interpreterCount = undefined;
            vm.loggedInInterpreterCount = undefined;
            vm.operatorCount = undefined;
            vm.showCallDetails = undefined;
            vm.disconnectButtonDisabled = undefined;
            vm.callId = $cookies.get(constants.callId);
            vm.callEventType = 'NoInterpreter';
            vm.customerName = $cookies.get(constants.customerName);
            vm.changeActiveTable = changeActiveTable;
            vm.showThirdParty = false;
            vm.allOperatorsTableNeedsRefresh = false;
            vm.logLevel = enums.LogLevel;
            vm.disableAllLanguageSelect = true;
            vm.configureAppSettings = configureAppSettings;
        }

        function listeners() {
            $scope.$on(operatorsignalreceiver.alertStartEvent, alertStart);
            $scope.$on(operatorsignalreceiver.alertStopEvent, alertStop);
            $scope.$on(operatorsignalreceiver.callConnectedEvent, callConnected);
            $scope.$on(operatorsignalreceiver.testCallConnectedEvent, testCallConnected);
            $scope.$on(operatorsignalreceiver.callEndedEvent, callEnded);
            $scope.$on(operatorsignalreceiver.missedCallEvent, missedCall);
            $scope.$on(operatorsignalreceiver.refreshDataEvent, refreshData);
            $scope.$on(operatorsignalreceiver.youHaveACallEvent, youHaveACall);

            $scope.$on(operatorsignalreceiver.callAnsweredEvent, getCurrentCall);
            $scope.$on(operatorsignalreceiver.interpreterLeftTheCallEvent, getCurrentCall);
        }

        function setAllInterpretersTable() {
            getAllInterpreters().then(function (interpreters) {
                vm.interpreters = utilities.buildInterpreters(interpreters, vm.languages);
            });
        }

        function setAllOperatorsTable() {
            vm.allOperatorsTableNeedsRefresh = false;

            if (vm.operators) {
                //update the current users status to the list of all operators locally
                var operatorToSingleUpdate = vm.operators.find(
                    function (list) {
                        var rowToUpdate = list.Id === vm.operator.Id;
                        return rowToUpdate;
                    });
                if (operatorToSingleUpdate) {
                    operatorToSingleUpdate.Status = vm.operator.Status;
                }
            }

            reducecallfrequencyservice.call(constants.operatorGetAllOperators, function () {
                getAllOperators().then(function (operators) {
                    vm.operators = buildOperators(operators);
                });
            }, vm.getOperatorDelay);
        }

        function configureAppSettings(userId) {
            appsettingsservice.getAppSetting(preferences.GetLoggedInInterpretersDelayMilliseconds, vm.getLoggedInInterpretersDelay, userId).then(function (data) {
                vm.getLoggedInInterpretersDelay = data;
            });

            appsettingsservice.getAppSetting(preferences.GetOperatorDelayMilliseconds, vm.getOperatorDelay, userId).then(function (data) {
                vm.getOperatorDelay = data;
            });
        }

        function changeActiveTable(tableName) {
            vm.activeTable = tableName;
            if (tableName === 'allOperators' && vm.allOperatorsTableNeedsRefresh) {
                setAllOperatorsTable();
            }
        }

        function showCallDetails() {
            if (!vm.currentCall) {
                vm.showCallDetails = false;
                vm.callType = 'Operator';
            }
            else {
                for (var i = 0; i < vm.currentCall.Participants.length; i++) {
                    if (vm.currentCall.Participants[i].OperatorId === vm.operator.Id) {
                        vm.showCallDetails = true;
                        vm.callType = 'Operator';
                        break;
                    }
                    else {
                        vm.callType = 'Interpreter';
                    }
                }
                // show the 3rd-party list when the number of participants is > 1
                // (i.e.an operator is in call with a 3rd-party or a language service_.
                vm.showThirdParty = (vm.currentCall.Participants.length >= 2);
            }
        }

        // Data retrieval
        function getCurrentCall() {
            var status = vm.operator ? vm.operator.Status : '';
            if (status === enums.PersonStatusNames.InCall) {
                operatorservice.getCurrentCall().then(function (data) {
                    if (data !== '') {
                        vm.currentCall = data.Call;
                        vm.currentCustomer = data.Customer;
                        vm.currentLanguages = data.Languages;
                        vm.currentMetaData = data.Metadata;
                        vm.currentSipCallData = data.SipCallData;
                        vm.currentCase = data.Case;
                        vm.currentCallLanguage = getCallLanguage(data.Call);
                        vm.languageList = vm.showNonIVRLanguagesDropdown ? getNonIVRLanguages() : vm.languages;

                        showCallDetails();

                        if (enableCallDisposition === 'false') {
                            vm.disconnectButtonDisabled = true;
                        }

                        usermessageservice.notify('notify', { eventName: 'operatorDetails', operatordata: vm.operator });
                        // show metadata details
                        usermessageservice.notify('notify', { eventName: 'metadataDetails', callId: vm.currentCall.CallId, metadata: vm.currentMetaData });

                        if (vm.currentSipCallData) {
                            usermessageservice.notify('notify', { eventName: 'sipCallDataDetails', callId: vm.currentCall.CallId, sipCallData: vm.currentSipCallData });
                        }
                        // show Customer details
                        usermessageservice.notify('notify', { eventName: 'customerDetails', callId: vm.currentCall.CallId, customerdata: vm.currentCustomer });
                    }
                    else {
                        accountservice.logMessage('vox-operatordirective.getCurrentCall Action Failed', vm.logLevel.Warn);
                    }
                });
            }
        }

        function getOperator() {
            return operatorservice.get().then(function (operator) {
                if (operator !== '') {
                    vm.operator = operator;
                    vm.configureAppSettings(vm.operator.Id);
                    return vm.operator;
                }
                else {
                    accountservice.logMessage('vox-operatordirective.getOperator Action Failed', vm.logLevel.Warn);
                }
            });
        }

        function getCallLanguage(call) {
            var events = call.Events || [];

            for (var i = events.length - 1; i >= 0; i--) {
                var event = events[i];

                if (event.LanguageId && event.StatusEvent === enums.CallStatusNames.LanguageSelected) {
                    return event.LanguageId;
                }
            }

            return call.LanguageId;
        }

        function getNonIVRLanguages() {
            var languagesCache = JSON.parse($cookies.get(constants.Languages));
            vm.languages = languagesCache ? languagesCache : utilities.buildLanguages(getLanguages());
            var filteredLanguages = vm.languages;

            for (var i = filteredLanguages.length - 1; i >= 0; i--) {

                for (var j = 0; j < vm.currentLanguages.length; j++) {

                    if (filteredLanguages[i] && (filteredLanguages[i].value === vm.currentLanguages[j].Name)) {
                        filteredLanguages.splice(i, 1);
                    }
                }
            }
            return filteredLanguages;
        }

        function getAllOperators() {
            return operatorservice.getAll().then(function (operators) {
                return operators;
            });
        }

        function getAllInterpreters() {
            return operatorservice.getInterpreters().then(function (interpreters) {
                return interpreters;
            });
        }

        function getLoggedInInterpreters() {
            return operatorservice.getLoggedInInterpreters().then(function (loggedInInterpreters) {
                return loggedInInterpreters;
            });
        }

        function getLanguages() {
            return dataservice.getLanguages().then(function (languages) {
                return languages;
            });
        }

        function getPools() {
            return dataservice.getPools().then(function (pools) {
                return pools;
            });
        }

        function buildOperators(operators) {
            if (operators) {
                return operators.map(function (operator) {
                    return {
                        Id: operator.Id, FirstName: operator.FirstName, LastName: operator.LastName, Status: operator.Status,
                        PhoneNumber: operator.TempPhoneNumber || operator.PhoneNumber, Pools: utilities.buildPoolsList(operator.Pools)
                    };
                });
            }
            return [];
        }

        // Event Listeners

        function alertStart(event, data) {
            getCurrentCall();
            $scope.$apply(function () {
                vm.alert = data;
            });
        }

        function alertStop(event, desiredStatus) {
            $scope.$apply(function () {
                vm.alert = undefined;
            });
        }

        function callConnected(event, data) {
            $scope.$apply(function () {
                vm.currentCall = data.call;
                vm.currentCustomer = data.customer;
                vm.currentLanguages = data.languages;
                vm.currentMetaData = data.metadata;
                vm.currentCase = data.caseData;
                vm.disconnectButtonDisabled = false;
                vm.callId = data.call.CallId;
                vm.customerName = data.customer.Name;
                vm.currentSipCallData = data.SipCallData;
                vm.languageList = vm.showNonIVRLanguagesDropdown ? getNonIVRLanguages() : vm.languages;
                usermessageservice.notify('notify', { eventName: 'operatorDetails', operatordata: vm.operator });
                // show Customer details
                usermessageservice.notify('notify', { eventName: 'customerDetails', callId: vm.currentCall.CallId, customerdata: vm.currentCustomer });
                // show metadata details
                usermessageservice.notify('notify', { eventName: 'metadataDetails', callId: vm.currentCall.CallId, metadata: vm.currentMetaData });

                if (vm.currentSipCallData) {
                    usermessageservice.notify('notify', { eventName: 'sipCallDataDetails', callId: vm.currentCall.CallId, sipCallData: vm.currentSipCallData });
                }
                $cookies.put(constants.referenceId, data.call.ReferenceId);
                $cookies.put(constants.userRole, constants.Operator);
                $cookies.put(constants.callId, data.call.CallId);
                $cookies.put(constants.customerName, data.customer.Name);
                $cookies.put(constants.profileName, data.customer.ProfileName);
                if (enableCallDisposition === 'false') {
                    vm.disconnectButtonDisabled = true;
                }
                if (callservice.interpreterDropped(vm.currentCall.Events)) {
                    var message = 'Interpreter was abruptly dropped from conference call with this customer. Please click the feedback button and collect details from customer.';
                    usermessageservice.notify(enums.Events.ShowInstructionMessage, { message: message });
                }
            });
            showCallDetails();
        }

        function testCallConnected(event, data) {
            $scope.$apply(function () {
                $cookies.put(constants.callId, data.callId);
            });
        }

        function callEnded(event, data) {
            $scope.$apply(function () {
                if (vm.currentLanguages) {
                    for (var i = 0; i < vm.currentLanguages.length; i++) {
                        $cookies.put('SelectedLanguageServiceGroup_' + vm.currentLanguages[i].Id, undefined);
                    }
                }

                vm.currentCall = undefined;
                vm.currentCustomer = undefined;
                vm.currentLanguages = undefined;
                vm.currentMetaData = undefined;
                vm.showThirdParty = false;
                vm.currentCase = undefined;

                // show metadata details
                usermessageservice.notify('notify', { eventName: 'metadataDetails', callId: undefined, metadata: undefined });
                usermessageservice.notify('notify', { eventName: 'sipCallDataDetails', callId: undefined, sipCallData: undefined });

                $cookies.put(callEvents.LSButtonVisible, undefined);
                $cookies.put(callEvents.ConnectInterpreterButtonVisible, undefined);
                $cookies.put(callEvents.ConnectMeButtonVisible, undefined);
                $cookies.put(callEvents.HangupButtonVisible, undefined);

                usermessageservice.notify(enums.Events.ShowInstructionMessage, { message: '' });
            });
            showCallDetails();
        }

        function missedCall(event, data) {
            $scope.$apply(function () {
                utilities.setRootScopeTitle('You missed a call');
                vm.currentCall = undefined;
                vm.currentCustomer = undefined;
                vm.currentLanguages = undefined;
                vm.currentMetaData = undefined;
                vm.currentCase = undefined;
            });
            showCallDetails();
        }

        function getLoggedInInterpretersCall() {
            reducecallfrequencyservice.call(constants.operatorGetLoggedInInterpreters, function () {
                getLoggedInInterpreters().then(function (loggedInInterpreters) {
                    vm.loggedInInterpreters = utilities.buildLoggedInInterpreters(loggedInInterpreters);
                });
            }, vm.getLoggedInInterpretersDelay);
        }

        function refreshData(event, data) {
            $scope.$apply(function () {
                switch (data.property) {
                    case 'InterpreterStatus':
                        if (!data.interpreterEnvelope || !data.interpreterEnvelope.Interpreter) {
                            getLoggedInInterpretersCall();
                        } else {
                            changeLoggedInInterpreterState(data.interpreterEnvelope);
                        }
                        break;
                    case 'OperatorStatus':
                        if (vm.activeTable === 'allOperators') {
                            setAllOperatorsTable();
                        } else {
                            // since we are not actively looking at this table, mark it as needing a refresh
                            vm.allOperatorsTableNeedsRefresh = true;
                        }
                        break;
                    case 'RefreshData':
                        getOperator();
                        break;
                }
            });
        }

        function changeLoggedInInterpreterState(interpreterEnvelope) {
            switch (interpreterEnvelope.Action) {
                case 1:
                    updateInterpreters(interpreterEnvelope.Interpreter);
                    break;
                case 2:
                    removeInterpreter(interpreterEnvelope.Interpreter.Id);
                    break;
            }

            updateInterpreterStatusInfoInAllInterpretersTab(interpreterEnvelope.Interpreter);
        }

        function updateInterpreterStatusInfoInAllInterpretersTab(interpreter) {
            var indexInListOfAll = lodash.findIndex(vm.interpreters, function (i) {
                return i.Id === interpreter.Id;
            });
            if (vm.interpreters[indexInListOfAll]) {
                vm.interpreters[indexInListOfAll].Status = interpreter.Status;
                vm.interpreters[indexInListOfAll].LastLogin = interpreter.LastLogin;
                vm.interpreters[indexInListOfAll].LastLoginDisplay = $filter('date')(interpreter.LastLogin, 'medium');
                vm.interpreters[indexInListOfAll].IsLanguageService = utilities.getInterpreterLoginLogoutButtonState(interpreter);
            }
        }

        function updateInterpreters(interpreter) {
            if (!vm.loggedInInterpreters) {
                vm.loggedInInterpreters = utilities.buildLoggedInInterpreters([interpreter]);
                return;
            }

            var index = lodash.findIndex(vm.loggedInInterpreters, function (i) {
                return i.Id === interpreter.Id;
            });
            var loggedInInterpreter = utilities.buildLoggedInInterpreter(interpreter);
            if (index === -1) {
                vm.loggedInInterpreters.push(loggedInInterpreter);
                vm.loggedInInterpreters = lodash.orderBy(vm.loggedInInterpreters, ['LastName', 'FirstName']);
            } else {
                vm.loggedInInterpreters[index] = loggedInInterpreter;
            }
        }

        function removeInterpreter(id) {
            vm.loggedInInterpreters = lodash.filter(vm.loggedInInterpreters, function (i) {
                return i.Id !== id;
            });
        }

        function youHaveACall(event, data) {
            utilities.setRootScopeTitle('You have a call');
            // close any existing modals before opening a new one
            $uibModalStack.dismissAll('');
            vm.modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                bindToController: true,
                templateUrl: 'app/widgets/modal-call.html',
                controller: 'ModalCallController',
                controllerAs: 'vm',
                resolve: {
                    data: function () {
                        return data;
                    }
                }
            });
        }

        /* When Connect button displays on UI this method triggers*/
        function logButtonShowEvent(eventName) {
            if (eventName === 'ConnectButtonVisible') {
                utilities.logButtonShowEvent(eventName, vm.callId);
                return true;
            }

            return false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.operator')
        .directive('voxLoggedinInterpretersTable', voxLoggedinInterpretersTable);

    /* @ngInject */
    function voxLoggedinInterpretersTable() {
        var directive = {
            bindToController: true,
            controller: LoggedinInterpretersTableController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'loggedInInterpreters': '=',
                'loggedInInterpreterCount': '=?'
            },
            link: function postLink(scope, element, attrs, vm) {
                scope.$watch('vm.displayedCollection', function (val) {
                    if (val) {
                        vm.loggedInInterpreterCount = val.length;
                    }
                });
            },
            templateUrl: 'app/operator/vox-loggedin-interpreters-table.html'
        };
        return directive;
    }

    LoggedinInterpretersTableController.$inject = ['$scope', 'enums', 'operatorservice', 'accountservice'];

    /* @ngInject */
    function LoggedinInterpretersTableController($scope, enums, operatorservice, accountservice) {
        var vm = this;

        vm.roles = $scope.$parent.vm.roles;
        vm.interpreterLoginStatusChange = interpreterLoginStatusChange;
        vm.statuses = enums.PersonStatus;
        vm.logLevel = enums.LogLevel;

        function interpreterLoginStatusChange(interpreterId, loginStatus) {
            var status = (loginStatus === 'Login') ? 6 : 5; //6 = AvailablePhone //5 = Offline
            var reason = status === 6 ? enums.PersonStatusReason.Login : enums.PersonStatusReason.Logout;
            return operatorservice.setLoginStatus(interpreterId, vm.statuses[status].name, reason).then(function (result) {
                if (result === false) {
                    accountservice.logMessage('Interpreter login status change Action Failed|UserId: ' + interpreterId, vm.logLevel.Warn);
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.operator')
        .directive('voxInterpretersTable', voxInterpretersTable);

    /* @ngInject */
    function voxInterpretersTable() {
        var directive = {
            bindToController: true,
            controller: InterpretersTableController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'interpreters': '=',
                'interpreterCount': '='
            },
            link: function postLink(scope, element, attrs, vm) {
                scope.$watch('vm.displayedCollection', function (val) {
                    if (val) {
                        vm.interpreterCount = val.length;
                    }
                });
            },
            templateUrl: 'app/operator/vox-interpreters-table.html'
        };
        return directive;
    }
    InterpretersTableController.$inject = ['$scope', 'enums', 'operatorservice', 'accountservice'];

    /* @ngInject */
    function InterpretersTableController($scope, enums, operatorservice, accountservice) {
        var vm = this;

        vm.roles = $scope.$parent.vm.roles;
        vm.interpreterLoginStatusChange = interpreterLoginStatusChange;
        vm.statuses = enums.PersonStatus;
        vm.logLevel = enums.LogLevel;

        function interpreterLoginStatusChange(interpreterId, loginStatus) {
            var status = (loginStatus === 'Login') ? 6 : 5; //6 = AvailablePhone //5 = Offline
            var reason = status === 6 ? enums.PersonStatusReason.Login : enums.PersonStatusReason.Logout;
            return operatorservice.setLoginStatus(interpreterId, vm.statuses[status].name, reason).then(function (result) {
                if (result === false) {
                    accountservice.logMessage('Interpreter login status change Action Failed|UserId: ' + interpreterId, vm.logLevel.Warn);
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.operator')
        .factory('operatorsignalreceiver', operatorsignalreceiver);

    operatorsignalreceiver.$inject = ['$http', '$rootScope', '$window', 'accountservice', 'enums', 'Hub', 'logger', 'operatorservice', 'signalreceiversmonitorservice'];
    /* @ngInject */
    function operatorsignalreceiver($http, $rootScope, $window, accountservice, enums, Hub, logger, operatorservice, signalreceiversmonitorservice) {

        var urlsToCheck = {
            'InterpreterStatus': '/api/Operator/Interpreters/LoggedIn',
            'OperatorStatus': '/api/Operator/Interpreters',
            'RefreshData': '/api/Operator/Operators',
            'RecentCalls': '/api/Admin/Calls/'
        };

        var service = {
            key: 'vox.operator',
            alertStartEvent: 'vox.operator.alertStartEvent',
            alertStopEvent: 'vox.operator.alertStopEvent',
            callAnsweredEvent: 'vox.operator.callAnswered',
            callNotAnsweredEvent: 'vox.operator.callNotAnswered',
            callConnectedEvent: 'vox.operator.callConnected',
            testCallConnectedEvent: 'vox.operator.testCallConnected',
            callEndedEvent: 'vox.operator.callEnded',
            missedCallEvent: 'vox.operator.missedCall',
            operatorStatusEvent: 'vox.operator.operatorStatus',
            refreshDataEvent: 'vox.operator.refreshData',
            thirdPartyStatusEvent: 'vox.operator.thirdPartyStatus',
            callCenterStatusEvent: 'vox.operator.callCenterStatus',
            languageServiceCallEndedEvent: 'vox.operator.languageServiceCallEnded',
            youHaveACallEvent: 'vox.operator.youHaveACall',
            redirectToLoginEvent: 'vox.operator.redirectToLoginEvent',
            logOutUserEvent: 'vox.interpreter.logOutUser',
            interpreterLeftTheCallEvent: 'vox.interpreter.interpreterLeftTheCallEvent',
            findInterpreterTimeoutEvent: 'vox.operator.findInterpreterTimeout',
            disconnect: disconnect,
            connect: connect,
            checkConnection: checkConnection,
            getIsConnected: getIsConnected
        };

        //declaring the hub connection
        var hub = new Hub('operatorHub', {

            useSharedConnection: true,

            //client side methods
            listeners: {
                'alertStart': alertStart,
                'alertStop': alertStop,
                'callAnswered': callAnswered,
                'callNotAnswered': callNotAnswered,
                'callConnected': callConnected,
                'testCallConnected': testCallConnected,
                'callEnded': callEnded,
                'missedCall': missedCall,
                'operatorStatus': operatorStatus,
                'refreshData': refreshData,
                'youHaveACall': youHaveACall,
                'thirdPartyStatus': thirdPartyStatus,
                'callCenterStatus': callCenterStatus,
                'languageServiceCallEnded': languageServiceCallEnded,
                'redirectToLogin': redirectToLogin,
                'logOutUser': logOutUser,
                'interpreterLeftTheCall': interpreterLeftTheCall,
                'findInterpreterTimeout': findInterpreterTimeout,
                'refreshBrowser': refreshBrowser,
                'operatorPostServerMessage': operatorPostServerMessage
            },

            //server side methods
            methods: ['checkConnection'],
            
            logging: true,

            autoConnect: false,

            transport: ['webSockets', 'serverSentEvents', 'longPolling'],

            //query params sent on initial connection
            queryParams: {
                //'token': 'exampletoken'
            },

            //handle connection error
            errorHandler: function (error) {
                logger.info(error);
            },

            // This method is called whenever the SignalR state changes
            stateChanged: function (state) {
                // When SignalR reconnects we refersh client side data
                // 2. reconnecting  1.  connected
                if (state.oldState === 2 && state.newState === 1) {
                    operatorservice.get().then(function (operator) {
                        if (operator !== '') {
                            accountservice.logMessage('operatorsignalreceiver.stateChanged Reconnected|UserId: ' + operator.Id, enums.LogLevel.Debug);
                        } else {
                            accountservice.logMessage('operatorsignalreceiver.stateChanged getOperator Action Failed', enums.LogLevel.Warn);
                        }
                    });

                    operatorRefreshAll();
                }

                if (state.newState === 4) {
                    signalreceiversmonitorservice.unTrack(service.key);
                }

                logger.log('Operator: SignalR state changed from ' + state.oldState + ' to ' + state.newState);
                $rootScope.$broadcast(enums.Events.SignalRStateChanged, state.newState);
            }
        });

        return service;

        ////////////////

        function alertStart(operatorId, data) {
            $rootScope.$broadcast(service.alertStartEvent, data);

            if (data.DesiredStatus && data.DesiredStatus !== null) {
                $rootScope.$broadcast(service.operatorStatusEvent, { statusName: data.DesiredStatus });
            }
            
            var message = 'operatorsignalreceiver.alertStart|UserId: ' + operatorId + ', ResourceAlertId: ' + data.ResourceAlertId +
                ', ResourceRequestId: ' + data.ResourceRequestId + ', CallId: ' + data.CallId + ', DesiredStatus: ' + data.DesiredStatus;
            accountservice.logMessage(message, enums.LogLevel.Trace);
        }

        function alertStop(operatorId, desiredStatus) {
            $rootScope.$broadcast(service.alertStopEvent);

            if (desiredStatus && desiredStatus !== null) {
                $rootScope.$broadcast(service.operatorStatusEvent, { statusName: desiredStatus });
            }
            
            accountservice.logMessage('operatorsignalreceiver.alertStop|UserId: ' + operatorId + 'DesiredStatus: ' + desiredStatus, enums.LogLevel.Trace);
        }

        function callAnswered(operatorId, interpreterId) {
            $rootScope.$broadcast(service.callAnsweredEvent, { interpreterId: interpreterId });
            accountservice.logMessage('operatorsignalreceiver.callAnswered|UserId: ' + operatorId + ', InterpreterId: ' + interpreterId, enums.LogLevel.Trace);
        }

        function callNotAnswered(operatorId, interpreterId, callStatus) {
            $rootScope.$broadcast(service.callNotAnsweredEvent, { interpreterId: interpreterId, callStatus: callStatus });
            accountservice.logMessage('operatorsignalreceiver.callNotAnswered|UserId: ' + operatorId + ', InterpreterId: ' + interpreterId + ', CallStatus: ' + callStatus, enums.LogLevel.Warn);
        }

        function callConnected(call, customer, languages, metadata, caseData, isLanguageServiceTimeoutExpired, sipcalldata) {
            $rootScope.$broadcast(service.callConnectedEvent, {
                call: call,
                customer: customer,
                languages: languages,
                metadata: metadata,
                caseData: caseData,
                isLanguageServiceTimeoutExpired: isLanguageServiceTimeoutExpired,
                SipCallData: sipcalldata
            });
            accountservice.logMessage('operatorsignalreceiver.callConnected|CallId: ' + call.CallId, enums.LogLevel.Trace);
        }

        function testCallConnected(callId) {
            $rootScope.$broadcast(service.testCallConnectedEvent, { callId: callId });
            accountservice.logMessage('operatorsignalreceiver.testCallConnected|CallId: ' + callId, enums.LogLevel.Trace);
        }

        function callEnded(operatorId) {
            $rootScope.$broadcast(service.callEndedEvent);
            accountservice.logMessage('operatorsignalreceiver.callEnded|UserId: ' + operatorId, enums.LogLevel.Trace);
        }

        function missedCall(callSid, operatorId) {
            $rootScope.$broadcast(service.missedCallEvent, { callSid: callSid });
            accountservice.logMessage('operatorsignalreceiver.missedCall|UserId: ' + operatorId + ', CallSid: ' + callSid, enums.LogLevel.Warn);
        }

        function operatorStatus(statusName, operatorId, reason, time) {
            $rootScope.$broadcast(service.operatorStatusEvent, { statusName: statusName, reason: reason, time: time });
            accountservice.logMessage('operatorsignalreceiver.operatorStatus|UserId: ' + operatorId + ', Status: ' + statusName + ', Reason: ' + reason + ', Time: ' + time, enums.LogLevel.Trace);
        }

        function operatorPostServerMessage(operatorId, message) {
            var timeStarted = new Date().toISOString();
            $rootScope.$broadcast(service.operatorPostServerMessageEvent, { message: message });
            var logMessage = 'operatorsignalreceiver.PostServerMessage|UserId: ' + operatorId + ', Message: ' + message + ', Received: ' + timeStarted;
            accountservice.logMessage(logMessage, enums.LogLevel.Trace);
        }

        function refreshData(property, interpreterEnvelope) {
            var isPreReqPending = false;
            var httpPendingReqList = $http.pendingRequests;
            for (var req = 0; req < httpPendingReqList.length; req++) {
                if (httpPendingReqList[req].url.indexOf(urlsToCheck[property]) > -1) {
                    isPreReqPending = true;
                    break;
                }
            }

            if (!isPreReqPending) {
                $rootScope.$broadcast(service.refreshDataEvent, { property: property, interpreterEnvelope: interpreterEnvelope });
            }
        }

        function thirdPartyStatus(participantId, statusName) {
            $rootScope.$broadcast(service.thirdPartyStatusEvent, { participantId: participantId, statusName: statusName });
            accountservice.logMessage('operatorsignalreceiver.thirdPartyStatus|ParticipantId: ' + participantId + ', Status: ' + statusName, enums.LogLevel.Trace);
        }

        function callCenterStatus(participantId, statusName) {
            $rootScope.$broadcast(service.callCenterStatusEvent, { participantId: participantId, statusName: statusName });
            accountservice.logMessage('operatorsignalreceiver.callCenterStatus|ParticipantId: ' + participantId + ', Status: ' + statusName, enums.LogLevel.Trace);
        }

        function languageServiceCallEnded(operatorId, interpreterId) {
            $rootScope.$broadcast(service.languageServiceCallEndedEvent, { interpreterId: interpreterId, operatorId: operatorId });
            accountservice.logMessage('operatorsignalreceiver.languageServiceCallEnded|languageServiceStatusId: ' + interpreterId + ', OperatorId: ' + operatorId, enums.LogLevel.Trace);
        }

        function youHaveACall(data) {
            $rootScope.$broadcast(service.youHaveACallEvent, data);
            accountservice.logMessage('operatorsignalreceiver.youHaveACall|UserId: ' + data.OperatorId + ', CallId: ' + data.CallId, enums.LogLevel.Trace);
        }

        function redirectToLogin(operatorId) {
            $rootScope.$broadcast(service.redirectToLoginEvent);
            accountservice.logMessage('operatorsignalreceiver.redirectToLogin|UserId: ' + operatorId, enums.LogLevel.Debug);
        }

        function logOutUser(operatorId) {
            $rootScope.$broadcast(service.logOutUserEvent);
            accountservice.logMessage('operatorsignalreceiver.logOutUser|UserId: ' + operatorId, enums.LogLevel.Debug);
        }

        function interpreterLeftTheCall(operatorId, interpreterId) {
            $rootScope.$broadcast(service.interpreterLeftTheCallEvent, { interpreterId: interpreterId });
            accountservice.logMessage('operatorsignalreceiver.interpreterLeftTheCall|UserId: ' + operatorId + ', InterpreterId: ' + interpreterId, enums.LogLevel.Trace);
        }

        function findInterpreterTimeout(operatorId, interpreterId) {
            $rootScope.$broadcast(service.findInterpreterTimeoutEvent);
            accountservice.logMessage('operatorsignalreceiver.findInterpreterTimeout|UserId: ' + operatorId, enums.LogLevel.Debug);
        }

        function operatorRefreshAll() {
            refreshData('RefreshData'); // Get operator
            refreshData('OperatorStatus'); // Get All operators
            refreshData('InterpreterStatus'); // Get All Interpreters and Get Logged in interpreters
        }

        function refreshBrowser() {
            $window.location.reload(true);
        }

        // Disconnect SignalR
        function disconnect() {
            var result = hub.disconnect();
            signalreceiversmonitorservice.logSignalRTimeout(result, hub, 'operatorsignalreceiver.disconnect');
            return result;
        }

        // Connect SignalR
        function connect() {
            var result = hub.connect();
            signalreceiversmonitorservice.logSignalRTimeout(result, hub, '.operatorsignalreceiverconnect');
            return result;
        }
        
        function checkConnection() {
            var result = hub.checkConnection();
            signalreceiversmonitorservice.logSignalRTimeout(result, hub, 'operatorsignalreceiver.checkConnection');
            return result;
        }

        function getIsConnected() {
            return hub.connection.state === 1;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.monitor', [
            'vox-leonis.core'
        ]);
})();


(function () {
    'use strict';

    angular
        .module('vox-leonis.monitor')
        .directive('voxMonitor', voxMonitor);

    /* @ngInject */
    function voxMonitor() {
        var directive = {
            bindToController: true,
            controller: MonitorController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'monitor': '='
            }
        };
        return directive;
    }

    MonitorController.$inject = ['$scope', '$cookies', 'monitorservice', 'monitorsignalreceiver', 'constants'];
    /* @ngInject */
    function MonitorController($scope, $cookies, monitorservice, monitorsignalreceiver, constants) {
        var vm = this;

        activate();

        function activate() {
            monitorservice.get().then(function (monitor) {
                if (monitor !== '') {
                    vm.monitor = monitor;
                    
                }
            });

            $scope.$on(monitorsignalreceiver.monitorCurrentCallIdEvent, monitorCurrentCallId);
        }

        function monitorCurrentCallId(event, data) {
            vm.monitor.CurrentCallId = data.currentCallId;
            $cookies.put(constants.callId, data.currentCallId);
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('vox-leonis.monitor')
        .factory('monitorsignalreceiver', monitorsignalreceiver);

    monitorsignalreceiver.$inject = ['$rootScope', '$window', 'accountservice', 'enums', 'Hub', 'logger', 'monitorservice', 'signalreceiversmonitorservice'];
    /* @ngInject */
    function monitorsignalreceiver($rootScope, $window, accountservice, enums, Hub, logger, monitorservice, signalreceiversmonitorservice) {

        var service = {
            key: 'vox.monitor',
            monitorStatusEvent: 'vox.monitor.monitorStatus',
            monitorCurrentCallIdEvent: 'vox.monitor.monitorCurrentCallId',
            refreshDataEvent: 'vox.monitor.refreshData',
            redirectToLoginEvent: 'vox.monitor.redirectToLoginEvent',
            logOutUserEvent: 'vox.interpreter.logOutUser',
            disconnect: disconnect,
            connect: connect,
            checkConnection: checkConnection,
            getIsConnected: getIsConnected
        };

        //declaring the hub connection
        var hub = new Hub('monitorHub', {

            useSharedConnection: true,

            //client side methods
            listeners: {
                'monitorStatus': monitorStatus,
                'monitorCurrentCallId': monitorCurrentCallId,
                'refreshData': refreshData,
                'redirectToLogin': redirectToLogin,
                'logOutUser': logOutUser,
                'refreshBrowser': refreshBrowser
            },

            //server side methods
            methods: ['checkConnection'],
            
            logging: true,

            autoConnect: false,

            transport: ['webSockets', 'serverSentEvents', 'longPolling'],

            //query params sent on initial connection
            queryParams: {
                //'token': 'exampletoken'
            },

            //handle connection error
            errorHandler: function (error) {
                logger.info(error);
            },

            // This method is called whenever the SignalR state changes
            stateChanged: function (state) {
                // When SignalR reconnects we refersh client side data
                // 2. reconnecting  1.  connected
                if (state.oldState === 2 && state.newState === 1) {
                    monitorservice.get().then(function (monitor) {
                        if (monitor !== '') {
                            accountservice.logMessage('monitorsignalreceiver.stateChanged Reconnected|UserId: ' + monitor.Id, enums.LogLevel.Trace);
                        } else {
                            accountservice.logMessage('monitorsignalreceiver.stateChanged getMonitor Action Failed', enums.LogLevel.Warn);
                        }
                    });
                    monitorRefreshAll();
                }

                if (state.newState === 4) {
                    signalreceiversmonitorservice.unTrack(service.key);
                }

                logger.log('Monitor: SignalR state changed from ' + state.oldState + ' to ' + state.newState);
                $rootScope.$broadcast(enums.Events.SignalRStateChanged, state.newState);
            }
        });

        return service;

        ////////////////
        function monitorStatus(statusName, monitorId, reason, time) {
            $rootScope.$broadcast(service.monitorStatusEvent, { statusName: statusName, reason: reason, time: time });
            accountservice.logMessage('monitorsignalreceiver.monitorStatus|UserId:' + monitorId + '|Status: ' + statusName + '|Reason:' + reason + '|Time:' + time, enums.LogLevel.Trace);
        }

        function monitorCurrentCallId(currentCallId, monitorId) {
            $rootScope.$broadcast(service.monitorCurrentCallIdEvent, { currentCallId: currentCallId });
            accountservice.logMessage('monitorsignalreceiver.monitorCurrentCallId. UserId: ' + monitorId + ' CurrentCallId: ' + currentCallId, enums.LogLevel.Trace);
        }

        function refreshData(property) {
            $rootScope.$broadcast(service.refreshDataEvent, { property: property });
        }

        function monitorRefreshAll() {
            refreshData('RecentCalls');
        }

        function redirectToLogin(monitorId) {
            $rootScope.$broadcast(service.redirectToLoginEvent);
            accountservice.logMessage('monitorsignalreceiver.redirectToLogin|UserId:' + monitorId, enums.LogLevel.Debug);
        }

        function logOutUser(monitorId) {
            $rootScope.$broadcast(service.logOutUserEvent);
            accountservice.logMessage('monitorsignalreceiver.logOutUser|UserId:' + monitorId, enums.LogLevel.Debug);
        }

        function refreshBrowser() {
            $window.location.reload(true);
        }

        // Disconnect SignalR
        function disconnect() {
            return hub.disconnect();
        }

        // Connect SignalR
        function connect() {
            return hub.connect();
        }
                
        function checkConnection() {
            return hub.checkConnection();
        }

        function getIsConnected() {
            return hub.connection.state === 1;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('vox-leonis.login', [
            'vox-leonis.core'
        ]);
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.login')
        .run(appRun);

    appRun.$inject = ['routerHelper'];
    /* @ngInject */
    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'login',
                config: {
                    url: '/',
                    templateUrl: 'app/login/login.html',
                    controller: 'LoginController',
                    controllerAs: 'vm',
                    title: 'Login',
                    resolve: {
                        getRoles: getRoles
                    }
                }
            }
        ];
    }

    getRoles.$inject = ['$cookies', 'accountservice', 'session', 'constants'];
    /* @ngInject */
    function getRoles($cookies, accountservice, session, constants) {
        var currentRole = $cookies.get(constants.userRole);
        session.roles = undefined;

        if (currentRole !== undefined) {
            return accountservice.getRoles(true).then(function (data) {
                session.roles = data.Roles;
                return session.roles;
            }).catch(function () {
                return session.roles;
            });
        }
        else {
            return session.roles;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.login')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$cookies', '$q', '$state', 'accountservice', 'appsettingsservice', 'constants', 'enums', 'logger', 'session'];
    /* @ngInject */
    function LoginController($cookies, $q, $state, accountservice, appsettingsservice, constants, enums, logger, session) {
        var vm = this;

        vm.activated = false;
        vm.loginError = undefined;
        vm.loginWaiting = false;
        vm.username = '';
        vm.password = '';
        vm.roles = session.roles;
        vm.login = login;
        vm.loginADB2C = loginADB2C;
        vm.redirectToADB2C = redirectToADB2C;
        vm.version = undefined;
        vm.voicePortalLoginMode = 'AzureDisabled';
        vm.oldLoginVisible = false;
        vm.setOldLoginVisible = setOldLoginVisible;

        activate();

        function activate() {
            redirect();
            vm.activated = true;
        }

        function login() {
            vm.loginError = undefined;
            vm.loginWaiting = true;
            vm.voicePortalLoginMode = 'AzureEnabled';
            accountservice.voicePortalLoginMode().then(function (data) {
                vm.voicePortalLoginMode = data;
                if (data === 'AzureEnabled') {
                    location.replace('/ADB2C/Login');
                    return;
                }
                return accountservice.login(vm.username, vm.password).then(function (data) {
                    if (data.Failure !== null) {
                        vm.loginError = data.Failure;
                        logger.error(data.Failure);
                    }
                    else if (data.Roles !== null) {
                        vm.roles = data.Roles;
                        accountservice.logMessage('Successful login ' + vm.username, enums.LogLevel.Info);
                        redirect();
                    }
                }).catch(function (e) {
                    if (e.status === 400) {
                        vm.loginError = e.status;
                    }
                }).finally(function () {
                    vm.loginWaiting = false;
                });
            }).catch(function (e) {
                if (e.status === 400) {
                    vm.loginError = e.status;
                }
            }).finally(function () {
                vm.loginWaiting = false;
            });
        }
        function setOldLoginVisible() {
            vm.oldLoginVisible = !vm.oldLoginVisible;
        }
        
        function redirectToADB2C() {
            location.replace('/ADB2C/Login');
        }
        function loginADB2C() {
            vm.loginError = undefined;
            vm.loginWaiting = true;
            vm.voicePortalLoginMode = 'AzureEnabled';
            accountservice.voicePortalLoginMode().then(function (data) {
                vm.voicePortalLoginMode = data;
                if (data !== 'AzureDisabled') {
                    if (data === 'AzureEnabled') {
                        return accountservice.loginADB2CAzureOnly().then(function (data) {
                            if (data.Failure !== null) {
                                vm.loginError = data.Failure;
                                logger.error(data.Failure);
                            }
                            else if (data.Roles !== null) {
                                vm.roles = data.Roles;
                                accountservice.logMessage('Successful login ' + vm.username, enums.LogLevel.Info);
                                redirect();
                            }
                        }).catch(function (e) {
                            if (e.status === 400) {
                                vm.loginError = e.status;
                            }
                        }).finally(function () {
                            vm.loginWaiting = false;
                        });
                    } else {
                        return accountservice.loginADB2C().then(function (data) {
                            if (data.Failure !== null) {
                                vm.loginError = data.Failure;
                                logger.error(data.Failure);
                            }
                            else if (data.Roles !== null) {
                                vm.roles = data.Roles;
                                accountservice.logMessage('Successful login ' + vm.username, enums.LogLevel.Info);
                                redirect();
                            }
                        }).catch(function (e) {
                            if (e.status === 400) {
                                vm.loginError = e.status;
                            }
                        }).finally(function () {
                            vm.loginWaiting = false;
                        });
                    }
                }
            }).catch(function (e) {
                if (e.status === 400) {
                    vm.loginError = e.status;
                }
            }).finally(function () {
                vm.loginWaiting = false;
            });
        }

        function redirect() {
            appsettingsservice.getAppVersion().then(function (data) {
                vm.version = data;
            });

            if (vm.roles !== undefined && vm.roles !== null) {
                if (vm.roles.indexOf('Interpreter') >= 0) {
                    $cookies.put(constants.userRole, constants.Interpreter);
                }
                if (vm.roles.indexOf('Operator') >= 0) {
                    $cookies.put(constants.userRole, constants.Operator);
                }
                if (vm.roles.indexOf('Admin') >= 0 && vm.roles.indexOf('Interpreter') === -1 && vm.roles.indexOf('Operator') === -1) {
                    $state.go('admin');
                }
                else {
                    $state.go('console');
                }
            } else {
                loginADB2C();
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('vox-leonis.layout', [
            'vox-leonis.core'
        ]);
})();

(function () {
    'use strict';

    /*jshint -W072 */

    angular
        .module('vox-leonis.layout')
        .directive('voxTopNav', voxTopNav);

    /* @ngInject */
    function voxTopNav() {
        var directive = {
            bindToController: true,
            controller: TopNavController,
            controllerAs: 'vm',
            restrict: 'EA',
            scope: {
                'user': '=',
                'version': '='
            },
            templateUrl: 'app/layout/vox-top-nav.html'
        };

        return directive;
    }

    TopNavController.$inject = ['$cookies', '$scope', '$state', '$uibModal', '$timeout', '$uibModalStack', '$window',
        'twiliowebrtcservice', 'accountservice', 'constants', 'enums', 'interpretersignalreceiver', 'monitorsignalreceiver', 'operatorsignalreceiver',
        'session', 'signalservice', 'usermessageservice', 'appsettingsservice', 'preferences', 'userservice', 'utilities',
        'interpreterservice'
    ];

    /* @ngInject */
    function TopNavController($cookies, $scope, $state, $uibModal, $timeout, $uibModalStack, $window,
                              twiliowebrtcservice, accountservice, constants, enums, interpretersignalreceiver, monitorsignalreceiver, operatorsignalreceiver,
                              session, signalservice, usermessageservice, appsettingsservice, preferences, userservice, utilities,
                              interpreterservice
    ) {
        var vm = this;

        vm.roles = session.roles;
        vm.reload = reload;
        vm.signOut = signOut;
        vm.logOut = logOut;
        vm.feedback = feedback;

        vm.hasRequiredStatusToSwitchNewVoicePortal = false;

        vm.hasAccessToNewInterpreterVoicePortal = false;
        vm.switchToInterpreterVoicePortal = switchToInterpreterVoicePortal;

        var refreshing = false;
        var contactMethod = $cookies.get('UserlatestContactMethod');
        var refreshRetainsCall = false;

        var switchingPortalDelay = 0;
        var switchingPortalMaxAge = 3600;

        var isInterpreter = session.roles.indexOf('Interpreter') >= 0;
        var ivrNewVoicePortalUsedByInterpreter = null;
        var ivrNewVoicePortalUsedByInterpreterMaxAge = 0;
        var interpreterVoicePortalFrontEndUrl = null;
        var isOtherThanInterpreter = !isInterpreter && session.roles.length > 0;
        
        var callOperatorsVoicePortalFrontEndUrl = null;

        appsettingsservice.getAppSetting(preferences.RefreshRetainsCall, refreshRetainsCall).then(function (data) {
            refreshRetainsCall = (data === true);
        });

        initSwitching();
        initInterpreterSwitching();
        initOperatorMonitorSwitching();

        $scope.$on(interpretersignalreceiver.logOutUserEvent, logOut);
        $scope.$on(operatorsignalreceiver.logOutUserEvent, logOut);
        $scope.$on(monitorsignalreceiver.logOutUserEvent, logOut);
        $scope.$on(interpretersignalreceiver.redirectToLoginEvent, redirectToLogin);
        $scope.$on(operatorsignalreceiver.redirectToLoginEvent, redirectToLogin);
        $scope.$on(monitorsignalreceiver.redirectToLoginEvent, redirectToLogin);

        $cookies.put(constants.lastRefreshTime, Date.now());

        function initSwitching() {
            if (!isInterpreter && !isOtherThanInterpreter) {
                return;
            }

            appsettingsservice.getAppSetting(preferences.PortalSwitchingPortalsDelay, switchingPortalDelay).then(function (data) {
                switchingPortalDelay = data;
            });

            usermessageservice.subscribe($scope, 'notify', function (event, data) {
                if (data.eventName === 'currentStatus') {
                    var acceptableStatuses = [
                        enums.PersonStatusNames.NotAvailable,
                        enums.PersonStatusNames.Available,
                        enums.PersonStatusNames.Unavailable,
                        enums.PersonStatusNames.Offline,
                        enums.PersonStatusNames.Away,
                    ];
                    vm.hasRequiredStatusToSwitchNewVoicePortal = acceptableStatuses.some(function (status) { return status === data.statusName; });
                }
            });
        }

        function initInterpreterSwitching() {
            if (!isInterpreter) {
                return;
            }
            userservice.getUserFullSetting(preferences.IvrNewVoicePortalUsedByInterpreter, ivrNewVoicePortalUsedByInterpreter).then(function (data) {
                if (data != null && data !== '') {
                    ivrNewVoicePortalUsedByInterpreter = data['Value'];
                    ivrNewVoicePortalUsedByInterpreterMaxAge = timespanToTotalSeconds(data['MaxAge'] !== undefined ? data['MaxAge'] : '00:00:00');
                }
                updateInterpreterVoicePortalAccess();
            });

            appsettingsservice.getIVPFrontEndUrl().then(function (data) {
                interpreterVoicePortalFrontEndUrl = data;
                updateInterpreterVoicePortalAccess();
            });
        }

        function initOperatorMonitorSwitching() {
            console.log('step 1');

            if (!isOtherThanInterpreter) {
                return;
            }
            console.log('step 1.2');
            appsettingsservice.getOVPFrontEndUrl().then(function (data) {
                callOperatorsVoicePortalFrontEndUrl = data;
                updateOperatorVoicePortalAccess();
            });
        }

        function updateInterpreterVoicePortalAccess() {
            if (ivrNewVoicePortalUsedByInterpreter != null && interpreterVoicePortalFrontEndUrl != null) {
                if (utilities.isTrue(ivrNewVoicePortalUsedByInterpreter)) {
                    if (ivrNewVoicePortalUsedByInterpreterMaxAge >= switchingPortalMaxAge) {
                        redirectToInterpreterVoicePortal();
                        return;
                    } else {
                        showModalSwitchingToNewInterpreterPortal();
                    }
                }
                vm.hasAccessToNewInterpreterVoicePortal = true;
            }
        }

        function updateOperatorVoicePortalAccess() {
            console.log('step 2');
            if (callOperatorsVoicePortalFrontEndUrl != null) {
                redirectToCallOperatorsVoicePortal();
            }
        }

        function switchToInterpreterVoicePortal() {
            userservice.setUserSetting(preferences.IvrNewVoicePortalUsedByInterpreter, true).then(function () {
                setTimeout(function () {
                    redirectToInterpreterVoicePortal();
                }, switchingPortalDelay);
            });
        }

        function redirectToInterpreterVoicePortal() {
            interpreterservice.setStatus(enums.PersonStatusNames.Unavailable, '0').then(function () {
                $window.location.href = interpreterVoicePortalFrontEndUrl;
            });
        }

        function redirectToCallOperatorsVoicePortal() {
            console.log('step 3');
            console.log('callOperatorsVoicePortalFrontEndUrl: ', callOperatorsVoicePortalFrontEndUrl);
            $window.location.href = callOperatorsVoicePortalFrontEndUrl;
        }

        function timespanToTotalSeconds(timespan) {
            return ((parseInt((timespan.slice(0,2))) * 3600) +
                (parseInt((timespan.slice(3,5))) * 60) +
                (parseInt((timespan.slice(6,8)))));
        }
        function reload() {
            var shouldReload = true;
            var warnStatus = isWarnStatus();
            if (warnStatus && contactMethod === '2') {
                if (!refreshRetainsCall) {
                    shouldReload = $window.confirm('Your status is ' + vm.user.Status + '. Reloading might end the current call. Do you wish to continue?');
                }
            }

            if (shouldReload && !refreshing) {
                refreshing = true;
                $timeout(function () {
                    refreshing = false;
                    if (contactMethod === '2' && !refreshRetainsCall) {
                        twiliowebrtcservice.disable(vm.user.Id);
                    } else if (contactMethod === '2' && refreshRetainsCall) {
                        if (warnStatus) {
                            twiliowebrtcservice.setPortalRefresh(true, true);
                        } else {
                            twiliowebrtcservice.setPortalRefresh(true, false);
                        }
                    }

                    $state.reload();
                    signalservice.disconnect();
                    signalservice.connect();
                }, 1000);
            }
        }

        function signOut() {
            var signOut = true;
            if (isWarnStatus()) {
                signOut = $window.confirm('Your status is ' + vm.user.Status + '. Are you sure you want to log out?');
            }

            if (signOut) {
                return vm.logOut();
            }
        }

        function logOut() {
            signalservice.disconnect();
            $cookies.remove('currentStatus', {path: '/'});
            usermessageservice.notify('notify', { eventName: 'currentStatus', statusName: null });
            $cookies.remove(constants.userRole, {path: '/'});
            //the logout event is also fired from signalR, that puts a user into offline state, disabling webRTC should also work here
            usermessageservice.notify('disableWebRTC', {message: vm.user.Id});
            return accountservice.logout().finally(function () {
                redirectToLogin();
                accountservice.voicePortalLoginMode().then(function (data) {
                    vm.voicePortalLoginMode = data;
                    if (data !== 'AzureDisabled') {
                        location.replace('/ADB2C/Logout');
                    }
                });
            });
        }

        function showModalSwitchingToNewInterpreterPortal() {
            // close any existing modals before opening a new one
            $uibModalStack.dismissAll('');
            vm.modalInstance = $uibModal.open({
                animation: true,
                backdrop: false,
                keyboard: false,
                bindToController: true,
                templateUrl: 'app/widgets/modal-new-interpreter-portal.html',
                controller: 'NewInterpreterPortalController',
                controllerAs: 'vm',
                resolve: {
                    interpreterVoicePortalFrontEndUrl: function () {
                        return interpreterVoicePortalFrontEndUrl;
                    }
                }
            });
        }

        function showModalSwitchingToNewCallOperatorsPortal() {
            // close any existing modals before opening a new one
            $uibModalStack.dismissAll('');
            vm.modalInstance = $uibModal.open({
                animation: true,
                backdrop: false,
                keyboard: false,
                bindToController: true,
                templateUrl: 'app/widgets/modal-new-call-operators-portal.html',
                controller: 'NewCallOperatorsPortalController',
                controllerAs: 'vm',
                resolve: {
                    callOperatorsVoicePortalFrontEndUrl: function () {
                        return callOperatorsVoicePortalFrontEndUrl;
                    }
                }
            });
        }

        function feedback() {
            // close any existing modals before opening a new one
            $uibModalStack.dismissAll('');
            vm.modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                bindToController: true,
                templateUrl: 'app/widgets/modal-feedback.html',
                controller: 'ModalFeedbackController',
                controllerAs: 'vm',
                resolve: {
                    user: function () {
                        return vm.user;
                    },
                    roles: function () {
                        return vm.roles;
                    }
                }
            });
        }

        function redirectToLogin() {
            $state.go('login');
        }

        // Returns true if the user's status warrants a warning when logging out or navigating away; returns false otherwise.
        function isWarnStatus() {
            if (vm.user) {
                switch (vm.user.Status) {
                    case enums.PersonStatusNames.InCall:
                    case enums.PersonStatusNames.Alerting:
                    case enums.PersonStatusNames.Ringing:
                    case enums.PersonStatusNames.Reconnect:
                        return true;
                }
            }
            return false;
        }

        // Warn the user if it's unwise to close the browser/tab and/or navigate away
        $window.onbeforeunload = function (e) {
            if (isWarnStatus()) {
                // Most browsers show a standard message for this event that does not include the returned text but
                // you never know so we return something meaningful.
                return 'Your status is ' + vm.user.Status + '. Are you sure you want to leave the page?';
            }

            // safe to leave
            return undefined;
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.console')
        .directive('voxUserInformation', voxUserInformation);

    function voxUserInformation() {
        var directive = {
            bindToController: true,
            controller: VoxUserInformationController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'operatorPools': '=',
                'interpreterLanguagePayrates': '=',
                'isCustomerMonitor': '='
            },
            templateUrl: 'app/console/vox-user-information.html'
        };

        return directive;

    }

    /* @ngInject */
    function VoxUserInformationController() {

        var vm = this;

    }
})(angular);

(function () {
    'use strict';

    angular
        .module('vox-leonis.console')
        .directive('voxConsoleStatus', voxConsoleStatus);

    voxConsoleStatus.$inject = ['enums', 'userservice', '$timeout'];

    /* @ngInject */
    function voxConsoleStatus(enums, userservice, $timeout) {
        var directive = {
            bindToController: true,
            controller: ConsoleStatusController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'operator': '=',
                'interpreter': '=',
                'monitor': '='
            },
            link: function postLink(scope, element, args, vm) {
                var operatorWatch = scope.$watch('vm.operator', function (newVal, oldVal) {
                    if (newVal !== undefined) {
                        // only try getting the alert when the page initially loads (vm.person is undefined)

                        vm.person = newVal;
                        scope.vm.notify(vm.person);
                        scope.vm.setStatusIntoCookie(vm.person.Status);

                        if (!vm.person.TempPhoneNumber) {
                            vm.person.TempPhoneNumber = vm.person.PhoneNumber;
                        }
                        handlePersonStatus();
                        vm.logClientJavaScriptVersion(vm.person.Id);
                    }
                });

                var interpreterWatch = scope.$watch('vm.interpreter', function (newVal, oldVal) {
                    if (newVal !== undefined && vm.operator === undefined) {
                        // only try getting the alert when the page initially loads (vm.person is undefined)

                        vm.person = newVal;
                        scope.vm.notify(vm.person);
                        scope.vm.setStatusIntoCookie(vm.person.Status);

                        if (!vm.person.TempPhoneNumber) {
                            vm.person.TempPhoneNumber = vm.person.PhoneNumber;
                        }
                        handlePersonStatus();
                        vm.logClientJavaScriptVersion(vm.person.Id);
                    }
                });

                var monitorWatch = scope.$watch('vm.monitor', function (newVal, oldVal) {
                    if (newVal !== undefined && vm.operator === undefined && vm.interpreter === undefined) {
                        vm.person = newVal;

                        if (!vm.person.TempPhoneNumber) {
                            vm.person.TempPhoneNumber = vm.person.PhoneNumber;
                        }
                        handlePersonStatus();
                        vm.logClientJavaScriptVersion(vm.person.Id);
                        scope.vm.setStatusIntoCookie(vm.person.Status);
                    }
                });

                function handlePersonStatus() {
                    if (vm.person && isVisibleStatusReasonChangedMessage(vm.person.UserStatusReason)) {
                        if (vm.person.Status === enums.PersonStatusNames.Unavailable) {
                            //Adding a second delay to handle subscriber initialization delay on page refresh
                            $timeout(showStatusChangeReason, 60000);
                        }
                        else {
                            showStatusChangeReason();
                        }
                    }
                }

                function showStatusChangeReason() {
                    userservice.showChangeStatusReason(vm.person.Status, vm.person.LastStatusChange, vm.person.UserStatusReason);
                }

                function isVisibleStatusReasonChangedMessage(userStatusReason) {
                    var statusReasonsToHideInitially = [enums.PersonStatusReason.MissedAlert];

                    return statusReasonsToHideInitially.indexOf(userStatusReason) < 0;
                }

                // change the user's status to Unavailable and back again based on the phone number validation
                var errorMessageWatch = scope.$watch('vm.phoneErrorMessage', function (newVal) {
                    vm.phoneErrorMessageChanged(enums.Events.PhoneErrorMessageChanged, { message: newVal, setUserStatus: true });
                });

                scope.$on('$destroy', function () {
                    operatorWatch();
                    interpreterWatch();
                    monitorWatch();
                    errorMessageWatch();
                });
            },
            templateUrl: 'app/console/vox-console-status.html'
        };
        return directive;
    }

    ConsoleStatusController.$inject = ['$scope', '$cookies', '$uibModalStack', '$timeout', 'enums', 'interpreterservice', 'operatorservice', 'monitorservice',
        'interpretersignalreceiver', 'operatorsignalreceiver', 'monitorsignalreceiver', 'session', 'accountservice', 'userservice', 'usermessageservice', 'twiliowebrtcservice', 'utilities',
        'preferences', 'appsettingsservice', 'constants'];
    /* @ngInject */
    function ConsoleStatusController($scope, $cookies, $uibModalStack, $timeout, enums, interpreterservice, operatorservice, monitorservice,
        interpretersignalreceiver, operatorsignalreceiver, monitorsignalreceiver, session, accountservice, userservice, usermessageservice,
        twiliowebrtcservice, utilities, preferences, appsettingsservice, constants) {

        var vm = this;
        setupVars();
        setupMethods();
        activate();
        displayStatus();

        function setupVars() {
            vm.browserSupportsWebRTC = undefined;
            vm.invalidPhoneOriginalStatus = undefined;
            vm.statuses = enums.PersonStatus;
            vm.logLevel = enums.LogLevel;
            vm.person = undefined;
            vm.showContactMethods = false;
            vm.phoneErrorMessage = undefined;
            vm.roles = session.roles;
            vm.contactMethods = [];
            vm.interpreterData = undefined;
            vm.customerData = undefined;
            vm.language = undefined;
            vm.interpreterName = undefined;
            vm.customerDetails = undefined;
            vm.testButtonDisabledDefault = true;
            vm.currentRole = $cookies.get(constants.userRole);
            vm.showDefaultReminderText = undefined;
            vm.showDefaultOpertorReminderText = undefined;
            vm.panelClass = 'col-sm-5';
            vm.showWebRtcDialpad = 'false';
            vm.submitTimer = 0;
            vm.showWebRtcDialpad = 'false';
            vm.enableStateMachine = 'false';
            vm.stateMachineStatusForAlerting = '[Ringing, InCall, Available, Unavailable]';
            vm.stateMachineStatusForInCall = '[Reconnect, AfterCallWork, Available, Unavailable, Monitoring]';
            vm.stateMachineStatusForRinging = '[InCall, AfterCallWork, Available, Unavailable]';
            vm.isCustomerMonitor = true;
            vm.IsDisabledStatusChange = 'false';
            appsettingsservice.getAppSetting(preferences.IsShowDefaultReminder, vm.showDefaultReminderText).then(function (data) {
                if (vm.currentRole === constants.Interpreter) {
                    vm.showDefaultReminderText = data;
                }
            });
            appsettingsservice.getAppSetting(preferences.IsShowDefaultOperatorReminder, vm.showDefaultOpertorReminderText).then(function (data) {
                if (vm.currentRole === constants.Operator) {
                    vm.showDefaultOpertorReminderText = data;
                }
            });
            appsettingsservice.getAppSetting(preferences.ShowWebRtcDialpad, 'false').then(function (data) {
                vm.showWebRtcDialpad = data;
            });
            appsettingsservice.getAppSetting(preferences.EnableStateMachine, 'false').then(function (data) {
                vm.enableStateMachine = data;
            });
            appsettingsservice.getAppSetting(preferences.StateMachineStatusForAlerting, vm.stateMachineStatusForAlerting).then(function (data) {
                vm.stateMachineStatusForAlerting = data;
            });
            appsettingsservice.getAppSetting(preferences.StateMachineStatusForInCall, vm.stateMachineStatusForInCall).then(function (data) {
                vm.stateMachineStatusForInCall = data;
            });
            appsettingsservice.getAppSetting(preferences.StateMachineStatusForRinging, vm.stateMachineStatusForRinging).then(function (data) {
                vm.stateMachineStatusForRinging = data;
            });
            appsettingsservice.getAppSetting(preferences.DisableStatusChange, vm.IsDisabledStatusChange).then(function (data) {
                vm.IsDisabledStatusChange = data;
            });
            userservice.getUserSetting('Portal_CustomerMonitor', '').then(function (data) {
                vm.isCustomerMonitor = data !== undefined && data !== '';
            });
        }

        function setupMethods() {
            vm.enums = enums;
            vm.logClientJavaScriptVersion = logClientJavaScriptVersion;
            vm.phoneErrorMessageChanged = phoneErrorMessageChanged;
            vm.statusChanged = statusChanged;
            vm.statusDisabled = statusDisabled;
            vm.statusOptionHidden = statusOptionHidden;
            vm.setTempPhoneNumber = setTempPhoneNumber;
            vm.setStatusIntoCookie = setStatusIntoCookie;
            vm.notify = notify;
        }

        usermessageservice.subscribe($scope, 'notify', function (event, data) {

            if (data.eventName === 'interpreterDetails') {
                vm.interpreterDetails = data.interpreterdata;
            }
            if (data.eventName === 'operatorDetails') {
                vm.operatorDetails = data.operatordata;
            }
            if (data.eventName === 'customerDetails') {
                vm.customerDetails = data;
            }

            if (data.eventName === 'contactMethodChange') {
                vm.statusChanged();
            }
        });
        usermessageservice.subscribe($scope, 'disableWebRTC', function (event, data) {
            twiliowebrtcservice.disable(data.message);
        });
        function notify(person) {
            usermessageservice.notify('person', { data: person });
        }

        function displayStatus() {
            var status = enums.PersonStatus;
            var index = -1;

            if (vm.roles.indexOf('Monitor') === -1) {
                for (var i = 0; i < status.length; i++) {
                    if (status[i].name === enums.PersonStatusNames.Monitoring) {
                        index = i;
                        break;
                    }
                }
                if (index > -1) {
                    status.splice(index, 1);
                }

            }
            vm.statuses = status;
        }

        function activate() {
            listeners();
            vm.browserSupportsWebRTC = twiliowebrtcservice.isWebRTCSupported();

            userservice.getUserSetting('IVR_ContactMethods', '').then(function (contactMethods) {
                vm.contactMethods = contactMethods.split(',');
                contactMethodSelectShown(vm.contactMethods);
            });
            //we will need this preference to check defaults while force notifying test directive when a call ends
            appsettingsservice.getAppSetting(preferences.TestButtonDisabled, vm.testButtonDisabledDefault).then(function (data) {
                vm.testButtonDisabledDefault = (data === 'true');
            });
        }

        function listeners() {
            $scope.$on(interpretersignalreceiver.interpreterStatusEvent, interpreterStatus);
            $scope.$on(operatorsignalreceiver.operatorStatusEvent, operatorStatus);
            $scope.$on(monitorsignalreceiver.monitorStatusEvent, monitorStatus);
            $scope.$on(enums.Events.SetTempPhoneNumber, setTempPhoneNumber);
            $scope.$on(enums.Events.PhoneErrorMessageChanged, phoneErrorMessageChanged);
        }

        function statusChanged(reason) {
            var statusChangeTime = new Date().toISOString();
            userservice.showChangeStatusReason(vm.person.Status, statusChangeTime, reason);
            setStatusIntoCookie(vm.person.Status);
            if (!vm.testButtonDisabledDefault) {
                notifyTestButtonDirective(vm.person.Status);
            }
            if (vm.person === vm.operator) {
                return operatorservice.setStatus(vm.person.Status, reason).then(function (result) {
                    if (result === false) {
                        accountservice.logMessage('Message: statusChanged - Operator setStatus action failed, UserId: ' + vm.person.Id, vm.logLevel.Warn);
                    } else {
                        if (vm.monitor) {
                            vm.monitor.Status = vm.person.Status;
                        }
                    }
                });
            }
            else if (vm.person === vm.interpreter) {
                return interpreterservice.setStatus(vm.person.Status, reason).then(function (result) {
                    if (result === false) {
                        accountservice.logMessage('Message: statusChanged - Interpreter setStatus action failed, UserId: ' + vm.person.Id +
                            ', Status: ' + vm.person.Status + ', Reason: ' + reason, vm.logLevel.Warn);
                    } else {
                        if (vm.monitor) {
                            vm.monitor.Status = vm.person.Status;
                        }
                    }
                });
            }
            else if (vm.person === vm.monitor) {
                return monitorservice.setStatus(vm.person.Status, reason).then(function (result) {
                    if (result === false) {
                        accountservice.logMessage('Message: statusChanged - Monitor setStatus action failed, UserId: ' + vm.person.Id, vm.logLevel.Warn);
                    }
                });
            }
        }

        // Event Handlers

        function interpreterStatus(event, data) {
            $scope.$apply(function () {
                if (checkAllowedStatusChanges(vm.interpreter.Status, data.statusName, vm.interpreter.Id)) {
                    if (data.statusName !== undefined) {
                        removeModal(data.statusName);
                        vm.interpreter.Status = data.statusName;
                        if (vm.showWebRtcDialpad === 'true' && vm.interpreter.ContactMethod === enums.ContactMethod.WebRTC && data.statusName === enums.PersonStatusNames.Available) {
                            resetDialpad();
                        }
                        setStatusIntoCookie(vm.interpreter.Status);
                        //If user has interpreter and operator role and user accept the call as interpreter then
                        // vm.person not updated with updated status
                        vm.person.Status = data.statusName;
                        vm.person.UserStatusReason = data.reason;

                        if (vm.monitor) {
                            vm.monitor.Status = data.statusName;
                        }

                        if (vm.currentRole === constants.Interpreter && (data.statusName === enums.PersonStatusNames.InCall || data.statusName === enums.PersonStatusNames.Reconnect)) {
                            appsettingsservice.getAppSetting(preferences.IsShowDefaultReminder, vm.showDefaultReminderText).then(function (data) {
                                if (vm.currentRole === constants.Interpreter) {
                                    vm.showDefaultReminderText = data;
                                }
                            });
                        }
                        else {
                            vm.showDefaultReminderText = 'false';
                        }
                        //If the reconnect time out elapses and customer dissconnect the call then hide the reconnect error message
                        //Or if the interpreter clicked on reconnect button then do not hide the message.
                        if (vm.person.Status !== enums.PersonStatusNames.Reconnect) {
                            usermessageservice.notify(enums.Events.ShowInstructionMessage, { message: false });
                        }
                        if (!vm.testButtonDisabledDefault && (vm.person.Status === enums.PersonStatusNames.Available || vm.person.Status === enums.PersonStatusNames.Unavailable)) {
                            //ending call should notify child directive
                            notifyTestButtonDirective(vm.person.Status);
                        }
                        if (data.statusName === enums.PersonStatusNames.AfterCallWork) {
                            usermessageservice.notify('notify', { eventName: 'disableHangupButton', message: true });
                        }
                        if (data.reason === enums.PersonStatusReason.PoorLatency) {
                            userservice.showChangeStatusReason(data.statusName, data.time, data.reason);
                        }

                        userservice.showChangeStatusReason(data.statusName, data.time, data.reason);
                    }
                }
                else {
                    accountservice.logMessage('vox-console-status.interpreterStatus| Check allowed status failed' + vm.interpreter.Status + ' desired status: ' + data.statusName +
                        ' userId:' + vm.interpreter.Id, vm.logLevel.Warn);
                }
            });
        }

        function monitorStatus(event, data) {
            $scope.$apply(function () {
                if (checkAllowedStatusChanges(vm.monitor.Status, data.statusName, vm.monitor.Id)) {
                    removeModal(data.statusName);
                    if (vm.showWebRtcDialpad === 'true' && vm.monitor.ContactMethod === enums.ContactMethod.WebRTC && data.statusName === enums.PersonStatusNames.Available) {
                        resetDialpad();
                    }
                    vm.monitor.Status = data.statusName;
                    vm.person.Status = data.statusName;
                    setStatusIntoCookie(vm.person.Status);
                    userservice.showChangeStatusReason(data.statusName, data.time, data.reason);
                }
                else {
                    accountservice.logMessage('vox-console-status.monitorStatus| Check allowed status failed ' + vm.monitor.Status + ' desired status: ' + data.statusName +
                        ' userId:' + vm.monitor.Id, vm.logLevel.Warn);
                }
            });
        }

        function operatorStatus(event, data) {
            $scope.$apply(function () {
                if (checkAllowedStatusChanges(vm.operator.Status, data.statusName, vm.operator.Id)) {
                    removeModal(data.statusName);
                    vm.operator.Status = data.statusName;
                    if (vm.showWebRtcDialpad === 'true' && vm.operator.ContactMethod === enums.ContactMethod.WebRTC && data.statusName === enums.PersonStatusNames.Available) {
                        resetDialpad();
                    }
                    setStatusIntoCookie(vm.operator.Status);

                    if (vm.currentRole === constants.Operator && data.statusName === enums.PersonStatusNames.InCall) {
                        appsettingsservice.getAppSetting(preferences.IsShowDefaultOperatorReminder, vm.showDefaultOpertorReminderText).then(function (data) {
                            if (vm.currentRole === constants.Operator) {
                                vm.showDefaultOpertorReminderText = data;
                            }
                        });
                    }
                    else {
                        vm.showDefaultOpertorReminderText = 'false';
                    }

                    if (vm.monitor) {
                        vm.monitor.Status = data.statusName;
                    }

                    if (data.statusName === enums.PersonStatusNames.AfterCallWork) {
                        usermessageservice.notify('notify', { eventName: 'disableHangupButton', message: true });
                    }
                    if (!vm.testButtonDisabledDefault && (vm.person.Status === enums.PersonStatusNames.Available || vm.person.Status === enums.PersonStatusNames.Unavailable)) {
                        //ending call should notify child directive
                        notifyTestButtonDirective(vm.person.Status);
                    }

                    userservice.showChangeStatusReason(data.statusName, data.time, data.reason);
                }
                else {
                    accountservice.logMessage('vox-console-status.operatorStatus| Check allowed status failed ' + vm.operator.Status + ' desired status: ' + data.statusName +
                        ' userId: ' + vm.operator.Id, vm.logLevel.Warn);
                }
            });
        }

        //Check status wether it is allowed to be change
        function checkAllowedStatusChanges(currentStatus, desiredStatus, userId) {
            accountservice.logMessage('vox-console-status.checkAllowedStatusChanges Entered| current status:' + currentStatus + ' desired status: ' + desiredStatus +
                ' userId:' + userId, vm.logLevel.Info);

            var result = false;
            if (vm.enableStateMachine !== 'true') {
                accountservice.logMessage('vox-console-status.checkAllowedStatusChanges State Machine is disabled', vm.logLevel.Info);
                return true;
            }

            switch (currentStatus) {
                case enums.PersonStatusNames.Alerting:
                    if (validateAllowedStatus(desiredStatus, vm.stateMachineStatusForAlerting)) {
                        result = true;
                    }
                    break;
                case enums.PersonStatusNames.InCall:
                    if (validateAllowedStatus(desiredStatus, vm.stateMachineStatusForInCall)) {
                        result = true;
                    }
                    break;
                case enums.PersonStatusNames.Ringing:
                    if (validateAllowedStatus(desiredStatus, vm.stateMachineStatusForRinging)) {
                        result = true;
                    }
                    break;
                default:
                    result = true;
                    break;
            }

            return result;
        }

        function validateAllowedStatus(desiredStatus, allowedStatus) {
            if (allowedStatus.indexOf(desiredStatus) !== -1) {
                return true;
            }
            else {
                return false;
            }
        }

        // when a user misses a call, their status is changed to Unavailable and the modal is left open
        // their status has since changed, so close the modal if it is still open
        function removeModal(statusName) {
            if (statusName === enums.PersonStatusNames.Available || statusName === enums.PersonStatusNames.AvailablePhone || statusName === enums.PersonStatusNames.Monitoring) {
                $uibModalStack.dismissAll('');
                vm.showDefaultReminderText = 'false';
                vm.showDefaultOpertorReminderText = 'false';
            }
        }

        function getStatus() {
            var status = '';
            if (!vm.person) {
                return status;
            }

            if (vm.person === vm.operator) {
                status = vm.operator.Status;
            }
            else if (vm.person === vm.interpreter) {
                status = vm.interpreter.Status;
            }
            else if (vm.person === vm.monitor) {
                status = vm.monitor.Status;
            }
            return status;
        }

        // Don't let interpreters / operators manually change their status when they've been assigned a 'system' status
        function statusDisabled() {
            vm.testButtonDisabled = false;
            // SuperUsers have no restrictions
            if (vm.roles.indexOf('SuperUser') >= 0) {
                return false;
            }

            if (!vm.person) {
                return false;
            }

            if (vm.person.Status === enums.PersonStatusNames.Unavailable && vm.phoneErrorMessage) {
                return true;
            }

            if (vm.person.UserStatusReason === enums.PersonStatusReason.DropThresholdExceeded) {
                return true;
            }

            if (vm.IsDisabledStatusChange === 'true') {

                if (vm.person.UserStatusReason === enums.PersonStatusReason.PoorLatency) {
                    return true;
                }

                if (vm.person.UserStatusReason === enums.PersonStatusReason.ImprovedLatency) {
                    return false;
                }
            }

            var status = getStatus();
            switch (status) {
                case enums.PersonStatusNames.Alerting:
                case enums.PersonStatusNames.InCall:
                case enums.PersonStatusNames.Ringing:
                case enums.PersonStatusNames.Reconnect:
                case enums.PersonStatusNames.AfterCallWork:
                    return true;
                case enums.PersonStatusNames.Quarantine:
                    return true;
            }
            return false;
        }

        function chkStatusName(status, statusName) {
            var userIsOnlyMonitor = false;
            var isInterpreter = false;
            if (vm.roles) {
                if (vm.roles.length === 1 && vm.roles[0] === 'Monitor') {
                    userIsOnlyMonitor = true;
                }
                if (vm.roles.indexOf('Interpreter') >= 0 && vm.roles.indexOf('Operator') < 0) {
                    isInterpreter = true;
                }
            }

            var result = getResultByStatus(status, statusName, isInterpreter, userIsOnlyMonitor);
            return result;
        }

        function getResultByStatus(status, statusName, isInterpreter, userIsOnlyMonitor) {
            var result = false;
            switch (statusName) {
                case enums.PersonStatusNames.Alerting:
                case enums.PersonStatusNames.InCall:
                case enums.PersonStatusNames.AvailablePhone:
                case enums.PersonStatusNames.Ringing:
                case enums.PersonStatusNames.Reconnect:
                case enums.PersonStatusNames.AfterCallWork:
                case enums.PersonStatusNames.Quarantine:
                    result = true;
                    break;
                case enums.PersonStatusNames.Unavailable:
                    result = (status !== enums.PersonStatusNames.Unavailable); // To hide Unavailable status If interpreter select the Away or Available status
                    break;
                case enums.PersonStatusNames.NotAvailable:    // Hide from interpreters and monitors but not opererators
                    result = isInterpreter || userIsOnlyMonitor;
                    break;
                case enums.PersonStatusNames.Away:
                    result = userIsOnlyMonitor;
                    break;
                case enums.PersonStatusNames.Offline:
                    result = (status !== enums.PersonStatusNames.Offline);
                    break;
            }
            return result;
        }

        // When an interpreter's / operator's status is a non-system status, hide the system statuses
        function statusOptionHidden(statusName) {

            // SuperUsers have no restrictions
            if (vm.roles.indexOf('SuperUser') >= 0) {
                return false;
            }

            if (!vm.person) {
                return false;
            }

            var status = getStatus();

            if ((status === enums.PersonStatusNames.Available) || (status === enums.PersonStatusNames.Away) || (status === enums.PersonStatusNames.Unavailable) ||
                (status === enums.PersonStatusNames.NotAvailable) || (status === enums.PersonStatusNames.Offline) || (status === enums.PersonStatusNames.Monitoring)) {
                return chkStatusName(status, statusName);
            }

            return false;
        }

        function setTempPhoneNumber() {
            if (vm.TempPhoneNumber) {
                vm.person.TempPhoneNumber = vm.TempPhoneNumber;
            }
        }

        function phoneErrorMessageChanged(data, event) {
            if (data !== undefined && event.message !== undefined) {
                if (event.setUserStatus) {
                    if (vm.person.Status !== enums.PersonStatusNames.Unavailable) {
                        vm.invalidPhoneOriginalStatus = vm.person.Status;
                        vm.person.Status = enums.PersonStatusNames.Unavailable;
                        vm.statusChanged(enums.PersonStatusReason.InvalidPhoneNumber);
                    }
                }
            }
            else if (vm.invalidPhoneOriginalStatus) {
                vm.person.Status = vm.invalidPhoneOriginalStatus;
                vm.invalidPhoneOriginalStatus = undefined;
                vm.statusChanged();
            }
        }

        function logClientJavaScriptVersion(personId) {
            var fileName = utilities.getClientAppJavaScriptFileName();
            if (fileName && fileName.length > 0) {
                accountservice.logMessage('Message: JavaScript application, UserId: ' + personId + ', FileName: ' + fileName, vm.logLevel.Info);
            }
        }

        // Should we show the contact method selector?
        // this flag will hide/show contact methods directive
        function contactMethodSelectShown(contactMethods) {
            switch (contactMethods.length) {
                case 0:
                    vm.showContactMethods = false;
                    break;
                case 1:
                    vm.showContactMethods = (+contactMethods[0] === +enums.ContactMethod.WebRTC);
                    break;
                default:
                    vm.showContactMethods = true;
            }
        }

        function notifyTestButtonDirective(status) {
            usermessageservice.notify('callStatus', { StatusName: status });
        }
        function setStatusIntoCookie(statusName) {
            $cookies.put('currentStatus', statusName);
            usermessageservice.notify('notify', { eventName: 'currentStatus', statusName: statusName });
        }

        function resetDialpad() {
            usermessageservice.notify('resetDialpad');
        }

    }
})();

(function (angular) {
    'use strict';

    angular
        .module('vox-leonis.console')
        .directive('voxConsoleReminder', voxConsoleReminder);

    /* @ngInject */
    function voxConsoleReminder() {
        var directive = {
            bindToController: true,
            controller: ConsoleReminderController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'interpreterDetails': '=',
                'operatorDetails': '=',
                'customerDetails': '='
            },
            templateUrl: 'app/console/vox-console-reminder.html'
        };
        return directive;
    }

    ConsoleReminderController.$inject = ['$scope', '$cookies', 'enums', 'constants', 'accountservice', 'appsettingsservice', 'preferences', 'usermessageservice'];

    /* @ngInject */
    function ConsoleReminderController($scope, $cookies, enums, constants, accountservice, appsettingsservice, preferences, usermessageservice) {

        var vm = this;

        vm.reminder = undefined;
        vm.greeting = undefined;
        vm.closing = undefined;
        vm.customReminderText = undefined;
        vm.customerGreetingText = undefined;
        vm.customerReminder = undefined;
        vm.customerGreeting = undefined;
        vm.language = undefined;
        vm.customerdata = undefined;
        vm.interpreterdata = undefined;
        vm.interpreterPin = vm.interpreterDetails !== undefined ? vm.interpreterDetails.Pin : undefined;
        vm.interpreterName = vm.interpreterDetails !== undefined ? vm.interpreterDetails.FirstName : undefined;
        vm.callId = undefined;
        var userId = vm.interpreterDetails !== undefined ? vm.interpreterDetails.Id : vm.operatorDetails.Id;
        usermessageservice.subscribe($scope, 'notify', function (event, data) {
            if (data.eventName === 'customerDetails') {
                vm.customerDetails = data;
                vm.customerdata = data.customerdata;
                getGreetingReminderText();
            }
        });

        //To get The Preference Value
        var getDefaultShowReminderText = '|';
        if (vm.interpreterDetails !== undefined) {
            appsettingsservice.getAppSetting(preferences.DefaultShowReminderText, getDefaultShowReminderText).then(function (data) {
                getDefaultShowReminderText = data;
                getGreetingReminderText();
            });
        }
        else {
            appsettingsservice.getAppSetting(preferences.DefaultShowOperatorReminderText, getDefaultShowReminderText).then(function (data) {
                getDefaultShowReminderText = data;
                getGreetingReminderText();
            });
        }

        usermessageservice.subscribe($scope, 'notify', function (event, data) {
            if (data.eventName === 'refreshCustomerDetails') {
                accountservice.logMessage('Message: vox-console-reminder| Message:Enter, CallId:' + data.callId + 'OldCallId:' + vm.customerDetails.callId, enums.LogLevel.Debug);
                if (vm.customerDetails.callId !== data.callId) {
                    vm.customerDetails = data;
                    if (vm.customerDetails.customerdata) {
                        getGreetingReminderText();
                    }
                }
            }
        });

        function getGreetingReminderText() {

            setValues();

            accountservice.logMessage('Message: vox-console-reminder| Message:Enter, CallId:' + vm.callId + 'UserId: ' + userId, enums.LogLevel.Debug);

            getReminderTextDatabase();
            getGreetingText();
            getClosingText();

            if (vm.interpreterDetails !== undefined && !vm.customerGreeting && !vm.customerReminder) {
                vm.customerReminder = 'Please use the following greeting and closing below';
                vm.customerGreeting = 'Hello, this is ' + vm.interpreterName + '; I am your Lionbridge ' + vm.language + ' interpreter. I am ready for your instructions.';
            }
            var displayedGreeting = (vm.customerGreeting === null || vm.customerGreeting === undefined) ? 'false' : 'true';
            var displayedReminder = (vm.customerReminder === null || vm.customerReminder === undefined) ? 'false' : 'true';

            accountservice.logMessage('Message: vox-console-reminder| Message:Exit, CallId: ' + vm.callId + ' userId: ' +
                userId + ' DisplayedGreeting? ' + displayedGreeting + ' DisplayedReminder? ' + displayedReminder, enums.LogLevel.Debug);
        }

        function getReminderTextDatabase() {
            if (vm.reminder === null) {
                var value = getDefaultShowReminderText.split('|');
                vm.reminder = value[0];
                vm.customerReminder = vm.reminder.replace('Reminder:', '');
            }
            else {
                var reminderHasData = true;
                if (vm.reminder && vm.reminder.match('Reminder:')) {
                    vm.customerReminder = vm.reminder.replace('Reminder:', '');
                }
                else {
                    vm.customerReminder = vm.reminder;
                }
                accountservice.logMessage('Message: vox-console-reminder| Message:Exit, CallId:' + vm.callId + ' reminderHasData: ' +
                    reminderHasData + ' reminder: ' + vm.reminder, enums.LogLevel.Debug);
            }
        }

        function getGreetingText() {
            var usedDefaultGreeting = false;
            if (!vm.greeting) {
                vm.greeting = getDefaultShowReminderText.split('|')[1];
                usedDefaultGreeting = true;
            }
            vm.greeting = vm.greeting.replace('Greeting:', '');
            if (vm.interpreterName) {
                vm.greeting = vm.greeting.replace('[First Name]', vm.interpreterName);
            }
            if (vm.language) {
                vm.greeting = vm.greeting.replace('[language]', vm.language);
            }
            if (vm.interpreterPin) {
                vm.greeting = vm.greeting.replace('[PIN]', vm.interpreterPin);
            }

            vm.customerGreeting = vm.greeting;

            accountservice.logMessage('Message: vox-console-reminder| Message:Exit, CallId:' + vm.callId + ' usedDefaultGreeting: ' +
                usedDefaultGreeting + ' Greeting: ' + vm.greeting + ' UserId: ' + userId, enums.LogLevel.Debug);
        }

        function getClosingText() {
            if (vm.closing === null) {
                if (vm.interpreterDetails !== undefined) {
                    vm.closing = '<div class="font-italic mb-1">Is there anything else I can assist you with?</div><div><span><strong>If No</strong>' +
                        '</span><i class="fas fa-long-arrow-alt-right"></i><span class="font-italic">Thank you for calling Lionbridge for your language needs.</span></div>';
                }
                else {
                    vm.closing = '<span class="font-italic">Standard Closing in the event of a no-show:  Unfortunately, we do not have an interpreter available at this time.' +
                        ' Thank you, good bye.</span><br />' +
                        '<span class="font-italic"><strong>No Show Closing with Option to Schedule a Call</strong>: Would you like to schedule an appointment for a future date time?' +
                        ' If so, what is your PIN, contact information and preference for the new date / time.We will add this request to our system and provide a final status update' +
                        ' as soon as possible.Thank you, good bye.</span><br /><span class="font-italic"><strong>No Show for No Cleared Interpreters</strong>:' +
                        ' Unfortunately, we do not have any cleared resources available for this language.' +
                        ' Our recruitment efforts are ongoing and we apologize for the inconvenience. Thank you, good bye.</span><br />';
                }
            }
        }

        function setValues() {
            vm.language = vm.customerDetails.languageName;
            vm.callId = vm.customerDetails.callId;
            vm.reminder = vm.interpreterDetails !== undefined ? vm.customerDetails.customerdata.InterpreterReminder : vm.customerDetails.customerdata.OperatorReminder;
            vm.greeting = vm.interpreterDetails !== undefined ? vm.customerDetails.customerdata.InterpreterGreeting : vm.customerDetails.customerdata.OperatorGreeting;
            vm.closing = vm.interpreterDetails !== undefined ? null : vm.customerDetails.customerdata.OperatorClosing;
            accountservice.logMessage('Message: vox-console-reminder| Message:Set Values for reminder and greeting , CallId:' + vm.callId + 'Reminder : ' +
                vm.reminder + ' Greeting : ' + vm.greeting + ' UserId: ' + userId, enums.LogLevel.Debug);

        }
    }
})(angular);

(function () {
    'use strict';

    angular
        .module('vox-leonis.console')
        .directive('voxConsoleInstructionMessage', voxConsoleInstructionMessage);

    function voxConsoleInstructionMessage() {
        var directive = {
            bindToController: true,
            controller: ConsoleInstructionMessageController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'userId': '=',
            },
            templateUrl: 'app/console/vox-console-instruction-message.html'
        };
        return directive;
    }

    ConsoleInstructionMessageController.$inject = ['$scope', '$timeout', 'enums', 'accountservice', 'usermessageservice', 'interpretersignalreceiver', 'operatorsignalreceiver'];

    /* @ngInject */
    function ConsoleInstructionMessageController($scope, $timeout, enums, accountservice, usermessageservice, interpretersignalreceiver, operatorsignalreceiver) {

        var vm = this;
        vm.userMessage = false;
        //To get The Preference Value
        setupSubscriptions();
        listeners();

        function setupSubscriptions() {
            usermessageservice.subscribe($scope, 'notify', function (event, data) {
                switch (data.eventName) {
                    //reconnect instruction for interpreters
                    case 'reconnectWarning':
                        $timeout(showMessage(data.message, 'reconnectWarning'));
                        break;

                    case 'ReconnectInitialized':
                        $timeout(showMessage(data.message, 'ReconnectInitialized'));
                        break;

                    case 'interpreterDropAbruptly':
                        $timeout(showMessage(data.message, 'interpreterDropAbruptly'));
                        break;

                    case 'TwilioErrors':
                        $timeout(showMessage(data.message, 'TwilioErrors'));
                        break;
                }
            });

            usermessageservice.subscribe($scope, enums.Events.ShowInstructionMessage, function (event, data) {
                vm.userMessage = data.message;
            });
        }

        function listeners() {
            $scope.$on(interpretersignalreceiver.interpreterPostServerMessageEvent, PostServerMessage);
            $scope.$on(operatorsignalreceiver.operatorPostServerMessageEvent, PostServerMessage);

        }

        function showMessage(showInstructionalMessage, eventName) {
            if (showInstructionalMessage) {
                switch (eventName) {
                    case 'reconnectWarning':
                        vm.userMessage = 'Click on the Reconnect button to avoid any abrupt disruption between you and the customer.';
                        break;
                    case 'ReconnectInitialized':
                        vm.userMessage = 'Please hang up your phone to re-establish the connection with the Customer.';
                        break;
                    case 'interpreterDropAbruptly':
                        vm.userMessage = 'The customer is connecting with you because the previous interpreter disconnected. Please continue interpretating for this customer.';
                        $timeout(hideInstructionMessage, 15000);
                        break;
                    case 'TwilioErrors':
                        vm.userMessage = 'You are experiencing a poor network condition and your audio quality will be degraded.';
                        break;
                    case 'WebRTCReconnecting':
                        vm.userMessage = 'Call connectivity lost! Trying to reconnect you automatically';
                        break;
                    case 'WebRTCReconnected':
                        vm.userMessage = 'The call has regained connectivity.';
                        break;
                    default:
                        vm.userMessage = false;
                        break;
                }
            }
            else {
                vm.userMessage = false;
            }
        }

        function PostServerMessage(event, data) {
            $scope.$apply(function () {
                accountservice.logMessage('Message: vox-console-instruction-message.PostServerMessage, UserId: ' + vm.userId + ', Message: ' + data.message, enums.LogLevel.Debug);
                //temp bug fix for 1041120
                if (data.reason !== 40 && data.reason !== 41) {
                    vm.userMessage = data.message;
                }
                $timeout(hideInstructionMessage, 15000);
            });
        }

        // hide user instruction from UI
        function hideInstructionMessage() {
            vm.userMessage = false;
        }
    }
})(angular);

(function (angular) {
    'use strict';

    angular
        .module('vox-leonis.console')
        .directive('voxConsoleCallControlPanel', voxConsoleCallControlPanel);

    /* @ngInject */
    function voxConsoleCallControlPanel() {
        var directive = {
            bindToController: true,
            controller: ConsoleCallControlPanelController,
            controllerAs: 'vm',
            restrict: 'E',
            scope: { 'person': '=' },
            templateUrl: 'app/console/vox-console-call-control-panel.html'
        };
        return directive;
    }

    ConsoleCallControlPanelController.$inject = ['$timeout', 'enums', 'twiliowebrtcservice', 'usermessageservice', '$scope', 'constants', '$cookies', 'userservice', 'callEvents',
        'interpreterservice', 'accountservice', 'appsettingsservice', 'preferences', 'operatorservice', 'utilities', 'interpretersignalreceiver'];
    /* @ngInject */
    function ConsoleCallControlPanelController($timeout, enums, twiliowebrtcservice, usermessageservice, $scope, constants, $cookies, userservice, callEvents, interpreterservice,
        accountservice, appsettingsservice, preferences, operatorservice, utilities, interpretersignalreceiver) {
        var vm = this;

        vm.hangUp = hangUp;
        vm.selectedContactMethod = undefined;
        vm.callId = $cookies.get(constants.callId);
        vm.currentRole = $cookies.get(constants.userRole);
        vm.personCurrentStatus = $cookies.get('currentStatus');
        vm.IsInterpreterDispositionMenu = 'true';
        vm.disconnectWebRtcActiveConnection = 'false';
        vm.isHangUpDisabled = true;
        vm.isApplicableforDisposition = false;
        vm.refreshRetainsCall = false;
        vm.showNoTalkPopup = false;
        vm.showing = false;
        appsettingsservice.getAppSetting(preferences.RefreshRetainsCall, vm.refreshRetainsCall).then(function (data) {
            vm.refreshRetainsCall = (data === 'true');
        });

        setupSubscriptions();
        setuplisteners();
        isInCall();
        if (vm.currentRole !== undefined) {
            if (vm.currentRole === constants.Interpreter || vm.currentRole === constants.Operator) {
                appsettingsservice.getAppSetting(preferences.IsInterpreterDispositionMenu, vm.dispositionMenuPrefFlag).then(function (data) {
                    vm.dispositionMenuPrefFlag = (data === 'true');
                    if (vm.dispositionMenuPrefFlag) {
                        vm.isApplicableforDisposition = true;
                    }
                });
            }

            appsettingsservice.getAppSetting(preferences.DisconnectWebRtcActiveConnection, vm.disconnectWebRtcActiveConnection).then(function (data) {
                vm.disconnectWebRtcActiveConnection = data;
            });
        }

        function enableHangupButton() {
            vm.isHangUpDisabled = false;
            vm.callId = $cookies.get(constants.callId);
            utilities.logButtonShowEvent(callEvents.HangupButtonVisible, vm.callId);
        }

        function setupSubscriptions() {
            usermessageservice.subscribe($scope, 'notify', function (event, data) {
                switch (data.eventName) {

                    //subscribe 'contactMethod' event
                    case 'contactMethod':
                        vm.selectedContactMethod = data.message.id;
                        break;
                    //subscribe 'disableHangupButton' event
                    case 'disableHangupButton':
                        vm.personCurrentStatus = $cookies.get('currentStatus');
                        if (data.message === true) {
                            if (vm.personCurrentStatus === enums.PersonStatusNames.AfterCallWork) {
                                vm.isHangUpDisabled = true;
                            }
                        }
                        else {
                            vm.isHangUpDisabled = false;
                        }
                        break;
                    //subscribe 'hangUp' event
                    case 'hangUp':
                        hangUp();
                        break;
                }
            });
            usermessageservice.subscribe($scope, 'notalksubmitted', function (event, data) {
                vm.showNoTalkPopup = false;
                vm.showing = false;
            });
        }
        function setuplisteners() {
            $scope.$on(interpretersignalreceiver.interpreterNoTalkActivityEvent, NoTalkActivity);
        }
        function NoTalkActivity(event, data) {
            $scope.$apply(function () {
                if (data) {
                    if (!vm.showing && !vm.showNoTalkPopup && data.message === 'Show NoTalk Events') {
                        vm.showing = true;
                        vm.showNoTalkPopup = true;
                        vm.callId = $cookies.get(constants.callId);
                        userservice.addCallEvent(callEvents.ShowedNoTalkDisposition, vm.callId);
                        setTimeout(function () { vm.showing = false; }, 2000);
                    }
                    else if (vm.showNoTalkPopup && data.message === 'Clear No Talk') {
                        vm.showNoTalkPopup = false;
                    }
                }
            });
        }
        function hangUp() {
            accountservice.logMessage('vox-console-call-control-panel.hangUp| Enter CallId: ' + vm.callId + ', CurrentRole: ' +
                vm.currentRole + ' DispositionPreference: ' + vm.dispositionMenuPrefFlag + 'ApplicableForDisposition: ' + vm.isApplicableforDisposition, enums.LogLevel.Debug);
            if (vm.selectedContactMethod === enums.ContactMethod.WebRTC) {
                usermessageservice.notify('resetDialpad');
                if (vm.refreshRetainsCall) {
                    console.log('clearing device');
                    twiliowebrtcservice.clearDevice(false);
                }
            }
            if (vm.currentRole === constants.Interpreter && vm.dispositionMenuPrefFlag) {
                interpreterservice.setStatus(enums.PersonStatusNames.AfterCallWork, '0').then(function (data) {
                    if (data === true) {
                        vm.isHangUpDisabled = true;
                        dissconnectCallAndAddEvent();
                        vm.isApplicableforDisposition = true;
                        vm.person.Status = enums.PersonStatusNames.AfterCallWork;
                        accountservice.logMessage('vox-console-call-control-panel.hangUp|CallId: ' + vm.callId + ', CurrentRole: ' +
                            vm.currentRole, enums.LogLevel.Debug);
                    }
                });
            }
            else if (vm.currentRole === constants.Operator && vm.dispositionMenuPrefFlag) {
                operatorservice.setStatus(enums.PersonStatusNames.AfterCallWork, '0').then(function (data) {
                    if (data === true) {
                        vm.isHangUpDisabled = true;
                        dissconnectCallAndAddEvent();
                        vm.isApplicableforDisposition = true;
                        vm.person.Status = enums.PersonStatusNames.AfterCallWork;
                        accountservice.logMessage('vox-console-call-control-panel.hangUp|CallId: ' + vm.callId + ', CurrentRole: ' +
                            vm.currentRole, enums.LogLevel.Debug);
                    }
                });
            }
            else {
                dissconnectCallAndAddEvent();
            }
        }

        function isInCall() {
            vm.personCurrentStatus = $cookies.get('currentStatus');

            if (vm.personCurrentStatus === enums.PersonStatusNames.InCall) {
                $timeout(enableHangupButton, 1500);
            }

            else if (vm.personCurrentStatus === enums.PersonStatusNames.AfterCallWork) {
                vm.isHangUpDisabled = true;
            }
        }

        function dissconnectCallAndAddEvent() {
            vm.callId = $cookies.get(constants.callId);
            if (vm.person.ContactMethod === enums.ContactMethod.WebRTC) {
                accountservice.logMessage('vox-console-call-control-panel.Hangup| Message: WebRTC Hangup Called, CallId: ' + vm.callId + ', UserId: ' + vm.person.Id, enums.LogLevel.Debug);
                userservice.addCallEvent(callEvents.WebRTCHangup, vm.callId);
                if (vm.disconnectWebRtcActiveConnection === 'true') {
                    twiliowebrtcservice.disconnect();
                }
                else {
                    twiliowebrtcservice.hangUp();
                }
            }
            else {
                if (vm.callId) {
                    userservice.addCallEvent(callEvents.PhoneHangup, vm.callId);
                    userservice.disconnectCall(vm.callId);
                    accountservice.logMessage('vox-console-call-control-panel.Hangup| Message: Phone Hangup Called, CallId: ' + vm.callId + ', UserId: ' + vm.person.Id, enums.LogLevel.Debug);

                }
            }
        }
    }
})(angular);

(function () {
    'use strict';

    angular
        .module('vox-leonis.console')
        .directive('voxConsoleAlert', voxConsoleAlert);

    function voxConsoleAlert() {
        var directive = {
            bindToController: true,
            controller: ConsoleAlertController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'operator': '=',
                'interpreter': '=',
                'monitor': '=',
                'person': '=',
            },
            templateUrl: 'app/console/vox-console-alert.html'
        };
        return directive;
    }

    ConsoleAlertController.$inject = ['$scope', '$timeout', '$cookies', 'enums', 'accountservice', 'userservice', 'usermessageservice',
        'interpretersignalreceiver', 'operatorsignalreceiver', 'appsettingsservice', 'preferences', 'callEvents', 'constants'];
    /* @ngInject */
    function ConsoleAlertController($scope, $timeout, $cookies, enums, accountservice, userservice, usermessageservice,
        interpretersignalreceiver, operatorsignalreceiver, appsettingsservice, preferences, callEvents, constants) {
        var vm = this;
        setupVars();
        setupUser();
        activate();
        
        function activate() {
            listeners();
            setupSubscriptions();
        }

        function setupVars() {
            vm.alert = undefined;
            vm.tryGettingAlert = undefined;
            vm.reCreateTokens = false;

            appsettingsservice.getAppSetting(preferences.ReCreateTokens, vm.reCreateTokens).then(function (data) {
                vm.reCreateTokens = (data === 'true');
            });
        }
        function setupUser() {
            if (vm.operator !== undefined) {
                vm.tryGettingAlert = vm.person === undefined;
                vm.person = vm.operator;
                if (vm.tryGettingAlert) {
                    getCurrentAlert();
                }
            }

            if (vm.interpreter !== undefined && vm.operator === undefined) {
                vm.tryGettingAlert = vm.person === undefined;
                vm.person = vm.interpreter;
                if (vm.tryGettingAlert) {
                    getCurrentAlert();
                }
            }
            if (vm.monitor !== undefined && vm.operator === undefined && vm.interpreter === undefined) {
                vm.person = vm.monitor;
            }
           
        }

        function setupSubscriptions() {
            usermessageservice.subscribe($scope, 'notify', function (event, data) {
                switch (data.eventName) {

                    //displays message after accepting the call
                    case 'Accept':
                        setupAlertActionMessage('Accept','alert alert-warning', 'Get ready to answer your phone...');
                        //When we know that an alert is successfully accepted and is a webRTC call, Regenerate the token

                        break;

                    //displays message when a alert is already accepted by some other person
                    case 'AlreadyAccept':
                        setupAlertActionMessage('AlreadyAccept', 'alert alert-info', 'We\'ve assigned the call to another person.');
                        break;

                    //displays message after rejecting the alert
                    case 'Reject':
                        setupAlertActionMessage('Reject', 'alert alert-danger', 'You rejected the call.');
                        break;

                    case 'contactMethod':
                        vm.person.ContactMethod = data.message.id;
                        break;
                }
            });
        }

        function listeners() {
            $scope.$on(interpretersignalreceiver.alertStartEvent, alertStart);
            $scope.$on(interpretersignalreceiver.alertStopEvent, alertStop);
            $scope.$on(operatorsignalreceiver.alertStartEvent, alertStart);
            $scope.$on(operatorsignalreceiver.alertStopEvent, alertStop);
        }

        function hideAlertActionMessage() {
            vm.alertActionMessage = false;
        }

        function setupAlertActionMessage(action, alertType, alertActionMessage) {

            //change the action message if the call accepted is a webRTCCall,
            if (action === 'Accept' && +vm.person.ContactMethod === enums.ContactMethod.WebRTC)
            {
                alertActionMessage = 'You\'ve accepted a browser call.';
            }
            vm.alertType = alertType;
            vm.alertActionMessage = alertActionMessage;
            $timeout(hideAlertActionMessage, 5000);
        }

        function getCurrentAlert() {
            var status = vm.person.Status;
            if (status === enums.PersonStatusNames.Alerting) {
                userservice.getCurrentAlert().then(function (data) {
                    if (data !== '' && data.Id && data.ResourceRequestId) {
                        vm.alert = { ResourceAlertId: data.Id, CallId: data.CallId, ResourceRequestId: data.ResourceRequestId };
                    }
                });
            }
        }

        function alertStart(event, data) {
            $scope.$apply(function () {
                if (vm.person.Status !== enums.PersonStatusNames.Ringing || vm.person.Status !== enums.PersonStatusNames.InCall) {
                    accountservice.logMessage('Message: vox-console-status.alertStart, UserId: ' + vm.person.Id + ', ResourceAlertId: ' + data.ResourceAlertId +
                        ', ResourceRequestId: ' + data.ResourceRequestId + ', CallId: ' + data.CallId + ', IsTestCall: ' + data.IsTestCall + ',IsScheduleCall: ' +
                        data.IsScheduleCall, enums.LogLevel.Debug);
                    vm.alert = data;
                    vm.alertActionMessage = false;
                }
                else {
                    var currentCallId = $cookies.get(constants.callId);
                    accountservice.logMessage('Message: vox-console-status.alertStart, Interpreter is on another call. UserId: ' + vm.person.Id + ', ResourceAlertId: ' + data.ResourceAlertId +
                        ', ResourceRequestId: ' + data.ResourceRequestId + ', CallId: ' + data.CallId + ', CurrentOngoing CallId: ' + currentCallId + ', IsTestCall: ' +
                        data.IsTestCall + ',IsScheduleCall: ' + data.IsScheduleCall, enums.LogLevel.Debug);
                    userservice.addCallEvent(callEvents.InterpreterOnAnotherCall, data.CallId, currentCallId);
                }
            });
        }

        function alertStop(event) {
            $scope.$apply(function () {
                vm.alert = undefined;
            });
        }
    }
})(angular);

(function () {
    'use strict';

    angular
        .module('vox-leonis.console')
        .directive('voxCallEvents', voxCallEvents);

    /* @ngInject */
    function voxCallEvents() {
        var directive = {
            bindToController: true,
            controller: CallEventsController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'callEvents': '=',
                'callConnectedTime': '='
            },
            templateUrl: 'app/console/vox-call-events.html'
        };
        return directive;
    }

    CallEventsController.$inject = ['session'];
    /* @ngInject */
    function CallEventsController(session) {
        var vm = this;
        vm.getLocalDate = getLocalDate;
        vm.getAdditionalInfo = getAdditionalInfo;
        vm.callConnectedLocaleString = (new Date(vm.callConnectedTime)).toLocaleString();
        vm.roles = session.roles;

        function getLocalDate(callEvent) {
            var localDate = new Date(callEvent.EventTime);
            return localDate.toLocaleString();
        }

        function getAdditionalInfo(callEvent) {
            var additionalInfo = '';
            if (callEvent.StatusEvent === 'LanguageSelected') {
                additionalInfo = callEvent.LanguageName;
            } else {
                additionalInfo = getUserFullName(callEvent.UserFirstName, callEvent.UserLastName);
            }
            return additionalInfo;
        }

        function getUserFullName(firstName, lastName) {
            var name = '';
            if (firstName !== null) {
                name = firstName;
            }
            if (lastName !== null) {
                if (name === '') {
                    name = lastName;
                } else {
                    name = name + ' ' + lastName;
                }
            }
            return name;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.console')
        .directive('voxCallDuration', voxCallDuration);

    /* @ngInject */
    function voxCallDuration() {
        var directive = {
            bindToController: true,
            controller: CallDurationController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'callParticipants': '=',
                'interpreterId': '=',
                'operatorId': '=',
                'callId': '=',
                'betterVoiceCallId': '='
            },
            templateUrl: 'app/console/vox-call-duration.html'
        };
        return directive;
    }

    CallDurationController.$inject = ['appsettingsservice', 'utilities', 'usermessageservice', 'accountservice', 'enums'];
    /* @ngInject */
    function CallDurationController(appsettingsservice, utilities, usermessageservice, accountservice, enums) {
        var vm = this;
        vm.startTime = '';

        var reconnectWarningThreshold = getReconnectWarningThreshold();
        var autoReconnectThreshold = getAutoReconnectThreshold();

        vm.thresholds = [reconnectWarningThreshold, autoReconnectThreshold];

        // find the call participant of the supplied type
        if (vm.callParticipants) {
            for (var i = vm.callParticipants.length - 1; i >= 0; i--) {
                var callParticipant = vm.callParticipants[i];
                accountservice.logMessage('vox-call-duration|Message: Participants details., CallId: ' +
                    vm.callId + ', ParticipantId: ' + callParticipant.ParticipantId + ', StartTime: ' + callParticipant.StartTime +
                    ', ParticipantCallId: ' + callParticipant.CallId, enums.LogLevel.Debug);

                if (vm.interpreterId && (callParticipant.InterpreterId === vm.interpreterId)) {
                    vm.startTime = callParticipant.StartTime;
                    if (!vm.betterVoiceCallId) {
                        vm.thresholds = null;
                        accountservice.logMessage('vox-call-duration|Message: Reconnect and AutoReconnect is disabled., CallId: ' +
                            vm.callId + ', InterpreterId: ' + vm.interpreterId, enums.LogLevel.Debug);
                    }
                    else {
                        //TODO: Get this value only once
                        appsettingsservice.getAppSetting('Portal_ReconnectWarningMessageMinutes', vm.reconnectWarningMinutes).then(function (data) {
                            reconnectWarningThreshold.limitInSeconds = utilities.convertMinutesToSeconds(data);
                        });

                        //TODO: Get this value only once
                        appsettingsservice.getAppSetting('Portal_AutoReconnectMinutes', vm.autoReconnectMinutes).then(function (data) {
                            autoReconnectThreshold.limitInSeconds = utilities.convertMinutesToSeconds(data);
                        });

                        //TODO: What if there are more than one interpreter in the participants list?
                        //TODO: Is it safe to stop looping once we've found a match?

                        accountservice.logMessage('vox-call-duration|Message: Reconnect and AutoReconnect duration have been' +
                            'initialized to ' + reconnectWarningThreshold.limitInSeconds + ' and ' +
                            autoReconnectThreshold.limitInSeconds + ' seconds respectively., ' +
                            'CallId: ' + vm.callId + ', InterpreterId: ' + vm.interpreterId + ', BetterVoiceCallId: ' + vm.betterVoiceCallId, enums.LogLevel.Debug);
                    }
                    break;
                }
                else if (vm.operatorId && (callParticipant.OperatorId === vm.operatorId)) {
                    vm.startTime = callParticipant.StartTime;
                    vm.thresholds = null;
                    break;
                }
            }
        }

        function getReconnectWarningThreshold() {
            return {
                limitInSeconds: utilities.convertMinutesToSeconds(1380),
                description: 'Showing Reconnect Button and Warning Message',
                raise: function () {
                    usermessageservice.notify('notify', { message: true, eventName: 'reconnectWarning' });
                    vm.showWarning = true;
                }
            };
        }

        function getAutoReconnectThreshold() {
            return {
                limitInSeconds: utilities.convertMinutesToSeconds(1380),
                description: 'Auto-Reconnecting Interpreter',
                raise: function () {
                    usermessageservice.notify('notify', { eventName: 'AutoReconnect' });
                }
            };
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('vox-leonis.console')
        .run(appRun);

    appRun.$inject = ['routerHelper'];
    /* @ngInject */
    function appRun(routerHelper)
    {
        routerHelper.configureStates(getStates());
    }

    function getStates()
    {
        return [
            {
                state: 'console',
                config: {
                    url: '/console',
                    templateUrl: 'app/console/console.html',
                    controller: 'ConsoleController',
                    controllerAs: 'vm',
                    title: 'Console',
                    resolve: {
                        getRoles: getRoles
                    }
                }
            }
        ];
    }

    getRoles.$inject = ['$state', '$cookies', 'accountservice', 'session', 'constants'];
    /* @ngInject */
    function getRoles($state, $cookies, accountservice, session, constants) {
        var currentRole = $cookies.get(constants.userRole);
        if (currentRole === undefined) {
            $state.go('login');
            return;
        }
        else if (session.roles === undefined) {
            return accountservice.getRoles().then(function (data) {
                session.roles = data.Roles;
                return session.roles;
            }).catch(function (e) {
                if (e.status === 401) {
                    $state.go('login');
                }

                session.roles = undefined;
                return session.roles;
            });
        }
        else {
            return session.roles;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.console')
        .controller('ConsoleController', ConsoleController);

    ConsoleController.$inject = ['$scope', '$q', '$state', '$interval', '$cookies', 'logger', 'enums',
        'session', 'signalservice', 'appsettingsservice', 'utilities', 'usermessageservice', 'preferences', 'constants'];
    /* @ngInject */
    function ConsoleController($scope, $q, $state, $interval, $cookies, logger, enums,
        session, signalservice, appsettingsservice, utilities, usermessageservice, preferences, constants) {
        var vm = this;

        vm.identity = undefined;
        vm.interpreter = undefined;
        vm.operator = undefined;
        vm.monitor = undefined;
        vm.roles = session.roles;
        vm.callType = 'Operator';
        vm.beepSound = undefined;
        vm.logLevel = enums.LogLevel;
        vm.person = undefined;
        vm.maximised = true;
        vm.user = undefined;
        var keepAliveInterval;
        vm.showWebRtcDialpad = 'false';

        activate();

        function activate() {
            var currentRole = $cookies.get(constants.userRole);
            if (currentRole === undefined) {
                $state.go('login');
                return;
            }
            signalservice.connect();
            vm.user = vm.operator || vm.interpreter || vm.monitor;
            vm.beepSound = new Audio('assets/audio/Silence.mp3');
            vm.beepSound.autoplay = true;

            var setKeepAliveIntervalSeconds = 40;
            appsettingsservice.getAppSetting('Portal_SetKeepAliveIntervalSeconds', setKeepAliveIntervalSeconds).then(function (data) {
                setKeepAliveIntervalSeconds = data;
            }).finally(function () {
                keepAliveInterval = utilities.startKeepAliveInterval(vm.roles, setKeepAliveIntervalSeconds);
            });

            appsettingsservice.getAppSetting(preferences.ShowWebRtcDialpad, 'false').then(function (data) {
                vm.showWebRtcDialpad = data;
            });

            appsettingsservice.getAppSetting(preferences.IsShowAppVersion, vm.showAppVersionFlag).then(function (data) {
                vm.showAppVersionFlag = (data === 'true');
                if (vm.showAppVersionFlag) {
                    getApplicationVersion();
                }
            });

            var promises = [];
            return $q.all(promises).then(function () {
                logger.info('Activated Console View');
            }).catch(function (e) {
                if (e.status === 401) {
                    $state.go('login');
                }
            });
        }
        usermessageservice.subscribe($scope, 'person', function (event, data) {
            vm.person = data.data;
        });
       
        usermessageservice.subscribe($scope, 'notify', function (event, data) {
            switch (data.eventName) {

                //subscribe 'contactMethod' event
                case 'contactMethod':
                    vm.person.ContactMethod = data.message.id;
                    break;
            }
        });

        usermessageservice.subscribe($scope, 'dialpadMaximize', function (event, data) {
            if (data.message) {
                vm.maximised = true;
            }
            else {
                vm.maximised = false;
            }

        });
        $scope.$on('$destroy', function () {
            if (keepAliveInterval) {
                $interval.cancel(keepAliveInterval);
            }
        });
        function getApplicationVersion() {
            appsettingsservice.getAppVersion().then(function (data) {
                vm.version = data;
                vm.version = 'v' + data;
            });
        }
    }
})();


(function ()
{
    'use strict';

    angular
        .module('vox-leonis.interpreter', [
            'vox-leonis.core'
        ]);
})();


(function () {
    'use strict';

    angular
        .module('vox-leonis.interpreter')
        .directive('voxInterpreter', voxInterpreter);

    /* @ngInject */
    function voxInterpreter() {
        var directive = {
            bindToController: true,
            controller: InterpreterController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'interpreter': '=',
                'callType': '='
            },
            templateUrl: 'app/interpreter/vox-interpreter.html'
        };
        return directive;
    }

    InterpreterController.$inject = ['$scope', '$q', '$state', 'logger', '$uibModal', '$uibModalStack', 'enums',
        'interpreterservice', 'interpretersignalreceiver', 'utilities', 'accountservice', '$cookies', 'constants', 'usermessageservice', 'callEvents'];
    /* @ngInject */
    function InterpreterController($scope, $q, $state, logger, $uibModal, $uibModalStack, enums,
        interpreterservice, interpretersignalreceiver, utilities, accountservice, $cookies, constants, usermessageservice, callEvents) {
        var vm = this;

        vm.currentCall = undefined;
        vm.currentCustomer = undefined;
        vm.currentLanguageName = undefined;
        vm.callCenterPhoneNumber = undefined;
        vm.showCallDetails = undefined;
        vm.logLevel = enums.LogLevel;

        activate();

        function activate() {
            listeners();

            var promises = [getInterpreter()];
            return $q.all(promises).then(function () {
                getCurrentCall();
                logger.info('Activated Interpreter View');
            }).catch(function (e) {
                if (e.status === 401) {
                    $state.go('login');
                }
            });
        }

        function listeners() {
            $scope.$on(interpretersignalreceiver.alertStartEvent, alertStart);
            $scope.$on(interpretersignalreceiver.alertStopEvent, alertStop);
            $scope.$on(interpretersignalreceiver.callConnectedEvent, callConnected);
            $scope.$on(interpretersignalreceiver.testCallConnectedEvent, testCallConnected);
            $scope.$on(interpretersignalreceiver.callEndedEvent, callEnded);
            $scope.$on(interpretersignalreceiver.missedCallEvent, missedCall);
            $scope.$on(interpretersignalreceiver.refreshDataEvent, refreshData);
            $scope.$on(interpretersignalreceiver.youHaveACallEvent, youHaveACall);
        }

        function showCallDetails() {
            if (!vm.currentCall) {
                vm.showCallDetails = false;
                vm.callType = 'Operator';
            }
            else {
                for (var i = 0; i < vm.currentCall.Participants.length; i++) {
                    if (vm.currentCall.Participants[i].InterpreterId === vm.interpreter.Id) {
                        vm.showCallDetails = true;
                        vm.callType = 'Interpreter';
                        break;
                    }
                }
            }
        }

        function getInterpreter() {
            return interpreterservice.get().then(function (data) {
                if (data !== '') {
                    vm.interpreter = data;
                }
                else {
                    accountservice.logMessage('vox-interpreter.directive.getInterpreter Action Failed.', vm.logLevel.Warn);
                }
                return vm.interpreter;
            });
        }

        function getCurrentCall() {
            var status = vm.interpreter ? vm.interpreter.Status : '';
            if (status === enums.PersonStatusNames.InCall) {
                interpreterservice.getCurrentCall().then(function (data) {
                    if (data !== '') {
                        vm.currentCall = data.Call;
                        vm.currentCustomer = data.Customer;
                        vm.currentLanguageName = data.LanguageName;
                        vm.callCenterPhoneNumber = data.CallCenterPhoneNumber;
                        vm.currentMetaData = data.Metadata;
                        vm.currentSipCallData = data.SipCallData;

                        usermessageservice.notify('notify', { eventName: 'interpreterDetails', interpreterdata: vm.interpreter });

                        // show metadata details
                        usermessageservice.notify('notify', { eventName: 'metadataDetails', callId: vm.currentCall.CallId, metadata: vm.currentMetaData });

                        if (data.SipCallData) {
                            usermessageservice.notify('notify', { eventName: 'sipCallDataDetails', callId: vm.currentCall.CallId, sipCallData: vm.currentSipCallData });
                        }

                        // show Customer details
                        usermessageservice.notify('notify', { eventName: 'customerDetails', callId: vm.currentCall.CallId, customerdata: vm.currentCustomer, languageName: vm.currentLanguageName });

                        showCallDetails();
                    }
                    else {
                        accountservice.logMessage('vox-interpreter.directive.getCurrentCall Action Failed.', vm.logLevel.Warn);
                    }
                });
            }
        }

        // Event Listeners

        function alertStart(event, data) {
            $scope.$apply(function () {
                vm.alert = data;
            });
        }

        function alertStop(event, desiredStatus) {
            $scope.$apply(function () {
                vm.alert = undefined;
            });
        }

        function refreshData(event, data) {
            $scope.$apply(function () {
                switch (data.property) {
                    case 'RefreshData':
                        accountservice.logMessage('vox-interpreter.directive.refreshData Action Enter.', vm.logLevel.Info);
                        getInterpreter();
                }
            });
        }

        function callConnected(event, data) {
            $scope.$apply(function () {

                $cookies.put(constants.callId, data.call.CallId);
                vm.currentCall = data.call;
                vm.currentCustomer = data.customer;
                vm.currentLanguageName = data.languageName;
                vm.callCenterPhoneNumber = data.callCenterPhoneNumber;
                vm.currentMetaData = data.metadata;
                vm.currentSipCallData = data.SipCallData;

                usermessageservice.notify('notify', { eventName: 'interpreterDetails', interpreterdata: vm.interpreter });
                // show Customer details
                usermessageservice.notify('notify', { eventName: 'customerDetails', callId: vm.currentCall.CallId, customerdata: vm.currentCustomer, languageName: vm.currentLanguageName });

                // show metadata details
                usermessageservice.notify('notify', { eventName: 'metadataDetails', callId: vm.currentCall.CallId, metadata: vm.currentMetaData });

                if (data.SipCallData) {
                    usermessageservice.notify('notify', { eventName: 'sipCallDataDetails', callId: vm.currentCall.CallId, sipCallData: vm.currentSipCallData });
                }
                $cookies.put(constants.referenceId, data.call.ReferenceId);
                $cookies.put(constants.userRole, constants.Interpreter);
                $cookies.put(constants.userId, vm.interpreter.Id);
                $cookies.put(constants.profileName, data.customer.ProfileName);

                if (data.interpreterDropAbruptly) {
                    usermessageservice.notify('notify', { message: true, eventName: 'interpreterDropAbruptly' });
                }
            });
            showCallDetails();
        }

        function testCallConnected(event, data) {
            $scope.$apply(function () {
                $cookies.put(constants.callId, data.callId);
            });
        }

        function callEnded(event, data) {
            $scope.$apply(function () {
                vm.currentCall = undefined;
                vm.currentCustomer = undefined;
                vm.currentLanguageName = undefined;
                vm.currentMetaData = undefined;
                vm.callCenterPhoneNumber = undefined;

                // show metadata details
                usermessageservice.notify('notify', { eventName: 'metadataDetails', callId: undefined, metadata: undefined });
                usermessageservice.notify('notify', { eventName: 'sipCallDataDetails', callId: undefined, sipCallData: undefined });
                $cookies.put(callEvents.HangupButtonVisible, undefined);
            });
            showCallDetails();
        }

        function missedCall(event, data) {
            $scope.$apply(function () {
                utilities.setRootScopeTitle('vox-interpreter.directive.missedCall You missed a call');
                vm.currentCall = undefined;
                vm.currentCustomer = undefined;
                vm.currentLanguageName = undefined;
                vm.callCenterPhoneNumber = undefined;
            });
            showCallDetails();
        }

        function youHaveACall(event, data) {
            // close any existing modals before opening a new one
            $uibModalStack.dismissAll('');
            utilities.setRootScopeTitle('You have a call');
            vm.modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                bindToController: true,
                templateUrl: 'app/widgets/modal-call.html',
                controller: 'ModalCallController',
                controllerAs: 'vm',
                resolve: {
                    data: function () {
                        return data;
                    }
                }
            });
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('vox-leonis.interpreter')
        .directive('voxInterpreterConference', voxInterpreterConference);

    function voxInterpreterConference() {
        var directive = {
            bindToController: true,
            controller: InterpreterConferenceController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'currentCall': '=',
                'currentCustomer': '=',
                'currentLanguageName': '=',
                'callCenterPhoneNumber': '=',
                'interpreter': '=',
                'currentMetaData': '='
            },
            templateUrl: 'app/interpreter/vox-interpreter-conference.html'
        };

        return directive;
    }

    InterpreterConferenceController.$inject = ['$scope', 'interpreterservice', '$timeout', 'usermessageservice', 'userservice', 'callEvents', 'enums', 'appsettingsservice', 'preferences'];
    /* @ngInject */
    function InterpreterConferenceController($scope, interpreterservice, $timeout, usermessageservice, userservice, callEvents, enums, appsettingsservice, preferences) {
        var vm = this;
        vm.phoneNumberError = false;

        vm.reconnectButton = false; //Hide or show Reconnect button
        vm.reconnectButtonDisabled = false;

        vm.reconnectInterpreter = reconnectInterpreter;

        vm.isC2C = vm.currentCall && vm.currentCall.IVRApplicationId === enums.IVRApplication.ClickToCall;
        vm.isHostedIVR = vm.currentCall && vm.currentCall.IVRApplicationId === enums.IVRApplication.HostedIVR;
        vm.showCallCenterNumber = vm.isC2C || vm.isHostedIVR;

        usermessageservice.subscribe($scope, 'notify', function (event, data) {
            if (data.eventName === 'AutoReconnect' && vm.interpreter.Status === enums.PersonStatusNames.InCall)
            {
                reconnectInterpreter(true);
            }
        });

        usermessageservice.subscribe($scope, 'notify', function (event, data) {
            if (data.eventName === 'reconnectWarning' && vm.interpreter.Status === enums.PersonStatusNames.InCall)
            {
                $timeout(showReconnectButton(data.message));
            }
        });

        var refreshReminder = false;
        appsettingsservice.getAppSetting(preferences.RefreshReminder, refreshReminder).then(function (data) {
            refreshReminder = (data === 'true');
            if (refreshReminder) {
                usermessageservice.notify('notify', { eventName: 'refreshCustomerDetails', callId: vm.currentCall.CallId, customerdata: vm.currentCustomer, languageName: vm.currentLanguageName });
            }
        });

        function reconnectInterpreter(isAutoReconnect) {
            interpreterservice.setStatusAtomic(enums.PersonStatusNames.InCall, enums.PersonStatusNames.Reconnect, 'Reconnect', new Date()).then(function (data) {
                if (data === true)
                {
                    if (!isAutoReconnect) {
                        userservice.addCallEvent(callEvents.ReconnectButtonClicked, vm.currentCall.CallId);
                    }

                    vm.reconnectButtonDisabled = true;
                    interpreterservice.reconnectCall(vm.currentCall.CallId);
                    usermessageservice.notify('notify', { eventName: 'Accept' });
                    usermessageservice.notify('notify', { message: true, eventName: 'ReconnectInitialized' });
                }
            });
        }

        function showReconnectButton(showHideReconnect) {
            if (showHideReconnect && vm.currentCall)
            {
                userservice.addCallEvent(callEvents.ReconnectWarningButtonVisible, vm.currentCall.CallId);
            }
            vm.reconnectButton = showHideReconnect;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.interpreter')
        .factory('interpretersignalreceiver', interpretersignalreceiver);

    interpretersignalreceiver.$inject = ['$rootScope', '$window', 'accountservice', 'enums', 'Hub', 'interpreterservice', 'logger', 'signalreceiversmonitorservice',
        '$cookies', 'appsettingsservice', 'preferences'];
    /* @ngInject */
    function interpretersignalreceiver($rootScope, $window, accountservice, enums, Hub, interpreterservice, logger, signalreceiversmonitorservice,
        $cookies, appsettingsservice, preferences) {

        var service = {
            key: 'vox.interpreter',
            alertStartEvent: 'vox.interpreter.alertStartEvent',
            alertStopEvent: 'vox.interpreter.alertStopEvent',
            callConnectedEvent: 'vox.interpreter.callConnected',
            testCallConnectedEvent: 'vox.interpreter.testCallConnected',
            callEndedEvent: 'vox.interpreter.callEnded',
            youHaveACallEvent: 'vox.interpreter.youHaveACall',
            thirdPartyStatusEvent: 'vox.interpreter.thirdPartyStatus',
            callCenterStatusEvent: 'vox.interpreter.callCenterStatus',
            logOutUserEvent: 'vox.interpreter.logOutUser',
            missedCallEvent: 'vox.interpreter.missedCall',
            redirectToLoginEvent: 'vox.interpreter.redirectToLoginEvent',
            refreshDataEvent: 'vox.interpreter.refreshData',
            interpreterPostServerMessageEvent: 'vox.interpreter.postServerMessage',
            interpreterNoTalkActivityEvent: 'vox.interpreter.noTalkActivity',
            disconnect: disconnect,
            connect: connect,
            checkConnection: checkConnection,
            getIsConnected: getIsConnected,
            getBrowserInfo: getBrowserInfo,
            GetDeviceInfo: GetDeviceInfo,
            identifyUserDevice: identifyUserDevice
        };

        //declaring the hub connection
        var hub = new Hub('interpreterHub', {

            useSharedConnection: true,

            //client side methods
            listeners: {
                'alertStart': alertStart,
                'alertStop': alertStop,
                'callConnected': callConnected,
                'testCallConnected': testCallConnected,
                'callEnded': callEnded,
                'interpreterStatus': interpreterStatus,
                'missedCall': missedCall,
                'redirectToLogin': redirectToLogin,
                'refreshData': refreshData,
                'thirdPartyStatus': thirdPartyStatus,
                'callCenterStatus': callCenterStatus,
                'logOutUser': logOutUser,
                'youHaveACall': youHaveACall,
                'refreshBrowser': refreshBrowser,
                'interpreterPostServerMessage': interpreterPostServerMessage,
                'interpreterNoTalkActivity': interpreterNoTalkActivity,
                'GetDeviceInfo': GetDeviceInfo
            },

            //server side methods
            methods: ['checkConnection', 'pingComplete'],

            //query params sent on initial connection
            queryParams: {
                //'token': 'exampletoken'
            },

            //handle connection error
            errorHandler: function (error) {
                logger.info(error);
            },

            autoConnect: false,

            logging: true,

            transport: ['webSockets', 'serverSentEvents', 'longPolling'],

            // This method is called whenever the SignalR state changes
            stateChanged: function (state) {
                // When SignalR reconnects we refersh client side data
                //2. reconnecting  1.  connected
                if (state.oldState === 2 && state.newState === 1) {
                    interpreterservice.get().then(function (interpreter) {
                        if (interpreter !== '') {
                            accountservice.logMessage('interpretersignalreceiver.stateChanged Reconnected|UserId: ' + interpreter.Id, enums.LogLevel.Trace);
                        } else {
                            accountservice.logMessage('interpretersignalreceiver.stateChanged getInterpreter Action Failed', enums.LogLevel.Warn);
                        }
                    });
                    interpreterRefreshAll();
                }

                if (state.newState === 4) {
                    signalreceiversmonitorservice.unTrack(service.key);
                }

                logger.log('Interpreter: SignalR state changed from ' + state.oldState + ' to ' + state.newState);
                $rootScope.$broadcast(enums.Events.SignalRStateChanged, state.newState);
            }
        });

        var showAlert = false;

        activate();

        function activate() {
            appsettingsservice.getAppSetting(preferences.ShowScheduledCallAlert, showAlert).then(function (result) {
                showAlert = (result === 'true');
            });
        }

        return service;

        ////////////////

        function alertStart(interpreterId, data) {
            var timeStarted = new Date().toISOString();

            $rootScope.$broadcast(service.alertStartEvent, data);
            if (data.DesiredStatus && data.DesiredStatus !== null) {
                $rootScope.$broadcast(service.interpreterStatusEvent, { statusName: data.DesiredStatus });
            }
            var str = 'This is your ' + data.CaseId + ' Scheduled Call. Please answer promptly.';

            if (showAlert && data.IsScheduleCall) {
                interpreterPostServerMessage(interpreterId, str);
            }

            var message = 'interpretersignalreceiver.alertStart|UserId: ' + interpreterId + ', ResourceAlertId: ' + data.ResourceAlertId +
                ', ResourceRequestId: ' + data.ResourceRequestId + ', CallId: ' + data.CallId + ', DesiredStatus: ' + data.DesiredStatus + ', Received: ' + timeStarted;
            accountservice.logMessage(message, enums.LogLevel.Trace);
        }

        function alertStop(interpreterId, desiredStatus) {
            $rootScope.$broadcast(service.alertStopEvent);

            if (desiredStatus && desiredStatus !== null) {
                $rootScope.$broadcast(service.interpreterStatusEvent, { statusName: desiredStatus });
            }

            accountservice.logMessage('interpretersignalreceiver.alertStop|UserId: ' + interpreterId + ', DesiredStatus: ' + desiredStatus, enums.LogLevel.Trace);
        }

        function callConnected(call, customer, languageName, interpreterDropAbruptly, callCenterPhoneNumber, metadata, sipcalldata) {
            $rootScope.$broadcast(service.callConnectedEvent, {
                call: call, customer: customer, languageName: languageName, interpreterDropAbruptly: interpreterDropAbruptly,
                callCenterPhoneNumber: callCenterPhoneNumber, metadata: metadata, SipCallData: sipcalldata
            });
            accountservice.logMessage('interpretersignalreceiver.callConnected|CallId: ' + call.CallId, enums.LogLevel.Trace);
        }

        function testCallConnected(callId) {
            $rootScope.$broadcast(service.testCallConnectedEvent, { callId: callId });
            accountservice.logMessage('interpretersignalreceiver.testCallConnected|CallId: ' + callId, enums.LogLevel.Trace);
        }

        function callEnded(interpreterId) {
            $rootScope.$broadcast(service.callEndedEvent);
            accountservice.logMessage('interpretersignalreceiver.callEnded|UserId: ' + interpreterId, enums.LogLevel.Trace);
        }

        function interpreterStatus(statusName, interpreterId, reason, time) {
            var timeStarted = new Date().toISOString();
            $rootScope.$broadcast(service.interpreterStatusEvent, { statusName: statusName, reason: reason, time: time });
            var message = 'interpretersignalreceiver.interpreterStatus|UserId: ' + interpreterId + ', Status: ' + statusName + ', Reason: ' + reason + ', Time: ' + time + ', Received: ' + timeStarted;
            accountservice.logMessage(message, enums.LogLevel.Trace);
        }

        function interpreterPostServerMessage(interpreterId, message) {
            var timeStarted = new Date().toISOString();
            $rootScope.$broadcast(service.interpreterPostServerMessageEvent, { message: message });
            var logMessage = 'interpretersignalreceiver.postServerMessage|UserId: ' + interpreterId + ', Message: ' + message + ', Received: ' + timeStarted;
            accountservice.logMessage(logMessage, enums.LogLevel.Trace);
        }

        function interpreterNoTalkActivity(interpreterId, message) {
            var timeStarted = new Date().toISOString();
            $rootScope.$broadcast(service.interpreterNoTalkActivityEvent, { interpreterId: interpreterId, message: message });
            var logMessage = 'interpretersignalreceiver.interpreterNoTalkActivity|UserId: ' + interpreterId + ', Message: ' + message + ', Received: ' + timeStarted;
            accountservice.logMessage(logMessage, enums.LogLevel.Debug);
        }

        function missedCall(callSid, interpreterId) {
            $rootScope.$broadcast(service.missedCallEvent, { callSid: callSid });
            accountservice.logMessage('interpretersignalreceiver.missedCall|UserId: ' + interpreterId + ', CallSid: ' + callSid, enums.LogLevel.Warn);
        }

        function redirectToLogin(interpreterId) {
            $rootScope.$broadcast(service.redirectToLoginEvent);
            accountservice.logMessage('interpretersignalreceiver.redirectToLogin|UserId: ' + interpreterId, enums.LogLevel.Debug);
        }

        function refreshData(property) {
            $rootScope.$broadcast(service.refreshDataEvent, { property: property });
        }

        function thirdPartyStatus(participantId, statusName, interpreterId) {
            $rootScope.$broadcast(service.thirdPartyStatusEvent, { participantId: participantId, statusName: statusName });
            accountservice.logMessage('interpretersignalreceiver.thirdPartyStatus|UserId: ' + interpreterId + ', ParticipantId: ' + participantId + ', Status: ' + statusName, enums.LogLevel.Trace);
        }

        function callCenterStatus(participantId, statusName, userId) {
            $rootScope.$broadcast(service.callCenterStatusEvent, { participantId: participantId, statusName: statusName });
            accountservice.logMessage('interpretersignalreceiver.callCenterStatus|UserId: ' + userId + ', ParticipantId: ' + participantId + ', Status: ' + statusName, enums.LogLevel.Trace);

        }

        function logOutUser(interpreterId) {
            $rootScope.$broadcast(service.logOutUserEvent);
            accountservice.logMessage('interpretersignalreceiver.logOutUser|UserId: ' + interpreterId, enums.LogLevel.Debug);
        }

        function youHaveACall(data) {
            $rootScope.$broadcast(service.youHaveACallEvent, data);
            accountservice.logMessage('interpretersignalreceiver.youHaveACall|UserId: ' + data.InterpreterId + ', CallId: ' + data.CallId, enums.LogLevel.Trace);
        }

        function interpreterRefreshAll() {
            refreshData('RefreshData');
        }

        function refreshBrowser() {
            $window.location.reload(true);
        }

        // Disconnect SignalR
        function disconnect() {
            var result = hub.disconnect();
            signalreceiversmonitorservice.logSignalRTimeout(result, hub, 'interpretersignalreceiver.disconnect');
            $cookies.put('currentUserid', undefined);
            return result;
        }

        // Connect SignalR
        function connect() {
            var result = hub.connect();
            signalreceiversmonitorservice.logSignalRTimeout(result, hub, 'interpretersignalreceiver.connect');
            return result;
        }

        function checkConnection() {
            var result = hub.checkConnection();
            signalreceiversmonitorservice.logSignalRTimeout(result, hub, 'interpretersignalreceiver.checkConnection');
            return result;
        }

        function getIsConnected() {
            return hub.connection.state === 1;
        }

        function getBrowserInfo() {
            var userAgent = navigator.userAgent, tem,
                matchArray = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if (/trident/i.test(matchArray[1])) {
                tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
                return 'IE ' + (tem[1] || '');
            }
            if (matchArray[1] === 'Chrome') {
                tem = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
                if (tem != null) {
                    return tem.slice(1).join(' ').replace('OPR', 'Opera');
                }
            }
            matchArray = matchArray[2] ? [matchArray[1], matchArray[2]] : [navigator.appName, navigator.appVersion, '-?'];
            if ((tem = userAgent.match(/version\/(\d+)/i)) != null) {
                matchArray.splice(1, 1, tem[1]);
            }
            return matchArray.join(',');
        }

        function GetDeviceInfo(userId, deviceList, showAlert, alertMessage) {
            var deviceInfo = navigator.userAgent;
            var device;
            var os;
            var isMobile = false;
            $cookies.put('currentUserid', userId);

            if (deviceInfo.includes('Windows NT 6.1')) {
                os = 'Windows NT 6.1';
                device = 'Windows 7';
            }
            else if (deviceInfo.includes('iPad')) {
                os = 'iOS';
                device = 'iPad';
                isMobile = true;
            }
            else if (deviceInfo.includes('iPhone')) {
                os = 'iOS';
                device = 'iPhone';
                isMobile = true;
            }
            else if (deviceInfo.includes('Android')) {
                os = 'Android';
                device = 'Android';
                isMobile = true;
            }
            else if (deviceInfo.includes('Windows NT 6.2')) {
                os = 'Windows NT 6.2';
                device = 'Windows 8';
            }
            else if (deviceInfo.includes('Windows NT 6.3')) {
                os = 'Windows NT 6.3';
                device = 'Windows 8.1';
            }
            else if (deviceInfo.includes('Windows NT 5.1') || deviceInfo.includes('Windows NT 5.2')) {
                os = 'Windows NT 5.2';
                device = 'Windows XP';
            }
            else if (deviceInfo.includes('Linux') && deviceInfo.includes('KFAPWI')) {
                os = 'Linux';
                device = 'Kindle Fire';
                isMobile = true;
            }
            else if (deviceInfo.includes('Windows NT 6.0')) {
                os = 'Windows NT 6.0';
                device = 'Windows Vista';
            }
            else if (deviceInfo.includes('Windows NT 10')) {
                os = 'Windows NT 10';
                device = 'Windows 10';
            }
            else {
                device = deviceInfo;
                os = navigator.userAgentData.platform;
                isMobile = navigator.userAgentData.mobile;
            }

            identifyUserDevice(device, os, isMobile, deviceList, showAlert, alertMessage);
        }

        function identifyUserDevice(device, os, isMobile, deviceList, showAlert, alertMessage) {

            var userId = $cookies.get('currentUserid');
            var str = alertMessage + '. Current Device:' + device;
            var deviceArray = deviceList.split(',');
            if (showAlert) {
                for (var i = 0; i < deviceArray.length; i++) {
                    if (deviceArray[i] === device || deviceArray[i] === os) {
                        interpreterPostServerMessage(userId, str);
                        accountservice.logMessage('interpretersignalreceiver.identifyUserDevice|UserId: ' + userId + ', device: ' + device + ', OS:' + os, enums.LogLevel.Debug);
                    }
                    else if (isMobile) {
                        accountservice.logMessage('interpretersignalreceiver.identifyUserDevice|UserId: ' + userId + ', device: ' + device + ', OS:' + os, enums.LogLevel.Debug);
                    }
                }
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('vox-leonis.core')
        .value('session', {
            roles: undefined
        });
})();

/*jslint bitwise: true */
/*jshint esversion: 6 */

(function () {
    'use strict';

    angular
        .module('vox-leonis.core')
        .factory('utilities', utilities);

    utilities.$inject = ['$rootScope', '$filter', 'interpreterservice', 'operatorservice', '$interval', '$injector', '$cookies', 'enums'];
    /* @ngInject */
    function utilities($rootScope, $filter, interpreterservice, operatorservice, $interval, $injector, $cookies, enums) {
        var service = {
            buildInterpreters: buildInterpreters,
            buildLanguagesList: buildLanguagesList,
            buildPoolsList: buildPoolsList,
            buildLanguages: buildLanguages,
            getInterpreterLoginLogoutButtonState: getInterpreterLoginLogoutButtonState,
            buildLoggedInInterpreters: buildLoggedInInterpreters,
            buildLoggedInInterpreter: buildLoggedInInterpreter,
            setRootScopeTitle: setRootScopeTitle,
            startKeepAliveInterval: startKeepAliveInterval,
            getLocalDate: getLocalDate,
            stringFormat: stringFormat,
            convertMinutesToSeconds: convertMinutesToSeconds,
            convertSecondsToMilliseconds: convertSecondsToMilliseconds,
            convertSecondsToDisplayString: convertSecondsToDisplayString,
            logButtonShowEvent: logButtonShowEvent,
            getClientAppJavaScriptFileName: getClientAppJavaScriptFileName,
            createGuid: createGuid,
            isTrue: isTrue
        };

        return service;

        // set keep alive and then continue to set it on an interval
        function startKeepAliveInterval(roles, setKeepAliveIntervalSeconds) {
            if (setKeepAliveIntervalSeconds <= 0 || setKeepAliveIntervalSeconds === 2147483 || !roles || (roles.indexOf('Interpreter') < 0 && roles.indexOf('Operator') < 0)) {
                return null;
            }

            setKeepAlive(roles);

            return $interval(function () {
                setKeepAlive(roles);
            }, setKeepAliveIntervalSeconds * 1000);

            function setKeepAlive(userRoles) {
                if (userRoles.indexOf('Interpreter') >= 0) {
                    interpreterservice.setKeepAlive();
                } else {
                    operatorservice.setKeepAlive();
                }
            }
        }

        //Set browser tab title
        function setRootScopeTitle(title) {
            $rootScope.title = title;
        }

        function buildInterpreters(interpreters, languages) {
            if (interpreters) {
                return interpreters.map(function (interpreter) {
                    return {
                        Id: interpreter.Id, FirstName: interpreter.FirstName, LastName: interpreter.LastName, Status: interpreter.Status,
                        LanguagePayrates: interpreter.LanguagePayrates, PhoneNumber: interpreter.TempPhoneNumber || interpreter.PhoneNumber,
                        LastLogin: interpreter.LastLogin, LastLoginDisplay: $filter('date')(interpreter.LastLogin, 'medium'),
                        TimeZone: interpreter.TimeZone, GroupName: interpreter.GroupName, Pools: buildPoolsList(interpreter.Pools), Languages: buildLanguagesList(interpreter.LanguagePayrates),
                        IsLanguageService: getInterpreterLoginLogoutButtonState(interpreter)
                    };
                });
            }
            return [];
        }

        /* When connectMe, Language select and connect interpreter button display on UI this method triggers*/
        function logButtonShowEvent(eventName, callId) {
            var addEventFlag;

            switch (eventName) {
                case $injector.get('callEvents').LSButtonVisible:
                    addEventFlag = $cookies.get(eventName);
                    break;
                case $injector.get('callEvents').ConnectInterpreterButtonVisible:
                    addEventFlag = $cookies.get(eventName);
                    break;
                case $injector.get('callEvents').ConnectMeButtonVisible:
                    addEventFlag = $cookies.get(eventName);
                    break;
                case $injector.get('callEvents').HangupButtonVisible:
                    addEventFlag = $cookies.get(eventName);
                    break;
                case $injector.get('callEvents').ConnectButtonVisible:
                    addEventFlag = $cookies.get(eventName);
                    break;
            }

            // If addEventFlag is undefined or addEventFlag is false then add an event in to database
            if ((addEventFlag === undefined || !addEventFlag) && callId !== undefined) {
                $injector.get('userservice').addCallEvent(eventName, callId);
                $cookies.put(eventName, true);
            }

            return true;
        }

        //Convert dictionary to array and sort language alphabatically and set default value to the drop down.
        function buildLanguages(languages) {
            var arr = [];
            for (var key in languages) {
                if (languages.hasOwnProperty(key)) {
                    arr.push({
                        key: key, value: languages[key]
                    });
                }
            }
            return arr.sort(function (a, b) {
                return (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0);
            });
        }

        // creates a dynamic string of languages so that sorting works on the console.
        function buildLanguagesList(languagePayrates) {
            var languages = '';
            for (var i = 0; i < languagePayrates.length; i++) {
                languages += (i > 0 ? ', ' : '') + languagePayrates[i].Language;
            }
            return languages;
        }

        // creates a dynamic string of pools so that sorting works on the console.
        function buildPoolsList(pools) {
            var poolList = '';
            for (var i = 0; i < pools.length; i++) {
                poolList += (i > 0 ? ', ' : '') + pools[i].Name;
            }
            return poolList;
        }

        function canLoginLogoutLSUsers(interpreter) {
            return interpreter.IsLSAllOther === false && interpreter.IsLanguageService === true;
        }

        // returns string that defines state of interpreter button:
        // 'Login' = only Login button will be displayed
        // 'Logout' - only Logout button will be displayed
        // '' - none of buttons will be displayed.
        function getInterpreterLoginLogoutButtonState(interpreter) {
            return canLoginLogoutLSUsers(interpreter) ? ((interpreter.Status === enums.PersonStatusNames.Unavailable ||
                interpreter.Status === enums.PersonStatusNames.Offline) ? 'Login' : 'Logout') : '';
        }

        function buildLoggedInInterpreters(loggedInInterpreters) {
            if (loggedInInterpreters) {
                return loggedInInterpreters.map(function (interpreter) {
                    return {
                        Id: interpreter.Id, Name: interpreter.Name, FirstName: interpreter.FirstName, LastName: interpreter.LastName, Status: interpreter.Status,
                        PhoneNumber: interpreter.TempPhoneNumber || interpreter.PhoneNumber, LanguagePayrates: interpreter.LanguagePayrates,
                        TimeZone: interpreter.TimeZone, WorkGroup: interpreter.WorkGroup, LastLogin: interpreter.LastLogin, LastCallEnded: interpreter.LastCallEnded,
                        Pools: buildPoolsList(interpreter.Pools), Languages: buildLanguagesList(interpreter.LanguagePayrates), GroupName: interpreter.GroupName,
                        IsLanguageService: getInterpreterLoginLogoutButtonState(interpreter)
                    };
                });
            }
            return [];
        }

        function buildLoggedInInterpreter(interpreter) {
            if (!interpreter) {
                return null;
            }

            return {
                Id: interpreter.Id, Name: interpreter.Name, FirstName: interpreter.FirstName, LastName: interpreter.LastName, Status: interpreter.Status,
                PhoneNumber: interpreter.TempPhoneNumber || interpreter.PhoneNumber, LanguagePayrates: interpreter.LanguagePayrates,
                TimeZone: interpreter.TimeZone, WorkGroup: interpreter.WorkGroup, LastLogin: interpreter.LastLogin, LastCallEnded: interpreter.LastCallEnded,
                Pools: buildPoolsList(interpreter.Pools), Languages: buildLanguagesList(interpreter.LanguagePayrates), GroupName: interpreter.GroupName,
                IsLanguageService: getInterpreterLoginLogoutButtonState(interpreter)
            };
        }

        function getLocalDate(time) {
            var localDate = new Date(time).toLocaleString();
            return localDate.toLocaleString();
        }

        function stringFormat() {
            var s = arguments[0];
            for (var i = 0; i < arguments.length - 1; i++) {
                var reg = new RegExp('\\{' + i + '\\}', 'gm');
                s = s.replace(reg, arguments[i + 1]);
            }
            return s;
        }

        function convertMinutesToSeconds(minutes) {
            return minutes * 60;
        }

        function convertSecondsToMilliseconds(seconds) {
            return seconds * 1000;
        }

        function convertSecondsToDisplayString(seconds, hideDays) {
            // 86400 seconds in a day
            var days = Math.floor(seconds / 86400);
            seconds %= 86400;
            var hours = Math.floor(seconds / 3600);
            seconds %= 3600;
            var minutes = Math.floor(seconds / 60);
            seconds = Math.floor(seconds % 60);

            hideDays = hideDays === null ? days === 0 : hideDays;

            return (hideDays ? '' : days + ':') + padZeros(hours) + ':' + padZeros(minutes) + ':' + padZeros(seconds);
        }

        // ensure number has 2 digits
        function padZeros(number) {
            if (number === 0) {
                return '00';
            }
            else if (number < 10) {
                return '0' + number;
            }
            return number;
        }

        function getClientAppJavaScriptFileName() {
            var scripts = document.getElementsByTagName('script');
            if (scripts) {
                for (var i = 0; i < scripts.length; i++) {
                    var src = scripts[i].getAttribute('src');
                    if (src.startsWith('scripts/app-')) {
                        return src.substring(8);
                    }
                }
            }
        }

        // Generates RFC4122 random ("version 4") GUID. https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
        function createGuid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }

        function isTrue(value) {
            //if null or undefined or false
            if (!value) {
                return false;
            }
            //if value is true (boolean)
            if (typeof value === 'boolean') {
                return value;
            }
            if (typeof value === 'string') {
                return value.toLowerCase() === 'true';
            }
            else {
                return false;
            }
        }
    }
})();

(function () {
    'use strict';

    /* jshint -W121 */
    if (!String.prototype.startsWith) {
        String.prototype.startsWith = function (search, pos) {
            return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
        };
    }

})();

(function () {
    'use strict';

    angular.module('vox-leonis.core').config(['$provide', function ($provide) {
        $provide.factory('appHttpExceptionInterceptor', ['$q', 'internetConnectionChecker',
            function ($q, internetConnectionChecker) {
                return {
                    response: handleResponse,
                    responseError: handleResponseError
                };

                // on first successfull request we set that internet connection is working
                function handleResponse(response) {
                    internetConnectionChecker.setInternetConnectionState(true);
                    return $q.resolve(response);
                }

                //If request have failed we are checking if internet connection is up
                function handleResponseError(response) {
                    //internet connection is not checked if it's already verified and it's not working
                    //also we are skipping this check if interceptor have caught internetconnection request
                    if (!internetConnectionChecker.getInternetConnectionState() || internetConnectionChecker.isInternetConnectionResponse(response)) {
                        return $q.reject(response);
                    }

                    return internetConnectionChecker
                                .checkConnection()
                                .finally(function () {
                                    return $q.reject(response);
                                });
                }
            }]);
    }]);

    angular.module('vox-leonis.core').config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push('appHttpExceptionInterceptor');
    }]);
})();

/* global toastr:false, moment:false, twilio:true */
(function () {
    'use strict';

    angular
        .module('vox-leonis.core')
        .constant('toastr', toastr)
        .constant('moment', moment)
        .constant('twilio', window.Twilio)
        .constant('enums', {
            PersonStatus: [
                { id: 0, name: 'Unavailable' },
                { id: 1, name: 'Available' },
                { id: 2, name: 'Ringing' },
                { id: 3, name: 'Alerting' },
                { id: 4, name: 'InCall' },
                { id: 5, name: 'Offline' },
                { id: 6, name: 'AvailablePhone' },
                { id: 7, name: 'Away' },
                { id: 8, name: 'NotAvailable' },
                { id: 9, name: 'Reconnect' },
                { id: 10, name: 'AfterCallWork' },
                { id: 11, name: 'Quarantine' },
                { id: 12, name: 'Monitoring' }
            ],

            //Note: When adding a value to this enum, make sure you also update the associated enum in the Enums.cs file
            PersonStatusReason: {
                None: 0,
                UnableToSendAlerts: 1,
                UnableToCall: 2,
                CallNotAccepted: 3,
                CallRejected: 4,
                CallNotAnswered: 5,
                InvalidPhoneNumber: 6,
                UnableToUpdateTheCall: 7,
                ExceededReconnectAttempts: 8,
                ExceededMissedAlerts: 9,
                PhoneBusy: 10,
                MissedAlert: 11,
                Reconnect: 12,
                Login: 13,
                Logout: 14,
                CustomerInitiatedReconnect: 15,
                UnableToCallVOIPOffline: 16,
                DropThresholdExceeded: 17,
                LoginViaApi: 18,
                LogoutViaApi: 19,
                ExceededUnableToSendAlerts: 20,
                LostConnectivity: 21,
                PoorLatency: 40,
                ImprovedLatency: 41
            },
            PersonStatusMessage: {
                0: '',
                1: 'we\'re unable to send you alerts',
                2: 'we\'re unable to call you',
                3: 'you didn\'t accept the call',
                4: 'you rejected an alert',
                5: 'no one answered the phone when we called',
                6: 'your phone number is invalid or not callable',
                7: '',
                8: 'you didn\'t answer the phone during the reconnect process',
                9: 'you missed too many consecutive alerts',
                10: 'your phone was busy when we called',
                11: 'you missed an alert',
                15: 'the customer wishes to reconnect with you.',
                16: 'we\'re unable to call VOIP phone of offline user',
                17: 'abrupt drops limitation is reached',
                18: '',
                19: '',
                20: '',
                21: 'we lost connectivity with your browser',
                22: 'we detected an answering machine',
                40: 'you are experiencing poor connectivity due to a degraded network performance',
                41: 'your network performance has improved'
            },
            LogLevel:
                { Fatal: 0, Error: 1, Warn: 2, Info: 3, Debug: 4, Trace: 5 },
            Events:
            {
                ShowInstructionMessage: 'ShowInstructionMessage',
                SignalRStateChanged: 'SignalRStateChanged',
                InternetConnectionStateChanged: 'InternetConnectionStateChanged',
                ContactMethodChanged: 'ContactMethodChanged',
                WebRtcConnectionQualityChanged: 'WebRtcConnectionQualityChanged',
                SetTempPhoneNumber: 'SetTempPhoneNumber',
                PhoneErrorMessageChanged: 'PhoneErrorMessageChanged'
            },
            CallStatusNames: {
                LanguageSelected: 'LanguageSelected'
            },
            PersonStatusNames: {
                Unavailable: 'Unavailable',
                Available: 'Available',
                Ringing: 'Ringing',
                Alerting: 'Alerting',
                InCall: 'InCall',
                Offline: 'Offline',
                AvailablePhone: 'AvailablePhone',
                Away: 'Away',
                NotAvailable: 'NotAvailable',
                Reconnect: 'Reconnect',
                AfterCallWork: 'AfterCallWork',
                Quarantine: 'Quarantine',
                Monitoring: 'Monitoring'
            },
            WebRtcStatus: {
                Ready: 'ready',
                Offline: 'offline',
                Busy: 'busy',
                Registered: 'registered',
                Unregistered: 'unregistered'
            },
            DeviceStatus: {
                Incoming: 'incoming',
                Unregistered: 'unregistered',
                Registered: 'registered',
                Registering: 'registering',
                Destroyed: 'destroyed',
                TokenWillExpire: 'tokenWillExpire'
            },
            ContactMethod: {
                Phone: 1,
                WebRTC: 2
            },
            ContactMethodDesc: {
                ReceiveViaPhone: 'Receive call via phone',
                ReceiveViaComputer: 'Receive call via computer'
            },
            IVRApplication: {
                OPI: 1,
                ClickToCall: 2,
                HostedIVR: 3,
                EscalateToVoice: 4
            }
        })
        .constant('stringResources', {
            personStatusMessageFormat: 'Your status was changed to {0} because {1}. {2}',
            ThirdPartyEventMessages:
            {
                ThirdPartyFailed: 'The call could not be connected',
                ThirdPartyCanceled: 'The call was canceled while attempting to connect',
                ThirdPartyBusy: 'The call failed because the line was busy',
                ThirdPartyNoAnswer: 'The call failed because no one answered',
                AnsweringMachineDetected: 'The call failed because we detected an answering machine'
            },
            callCenterEventMessages: {
                CallCenterBusy: 'The call to call center failed because the line was busy',
                CallCenterNoAnswer: 'The call to call center failed because no one answered',
                CallCenterCanceled: 'The call to call center was canceled while attempting to connect',
                CallCenterFailed: 'The call to call center could not be connected'
            }
        })
        .constant('constants', {
            referenceCache: 'referenceCache',
            referenceId: 'referenceId',
            callId: 'callId',
            customerName: 'customerName',
            userRole: 'userRole',
            Operator: 'Operator',
            Interpreter: 'Interpreter',
            monitor: 'Monitor',
            dataCache: 'dataCache',
            operatorGetLoggedInInterpreters: 'operatorGetLoggedInInterpreters',
            adminGetLoggedInInterpreters: 'adminGetLoggedInInterpreters',
            operatorGetAllOperators: 'operatorGetAllOperators',
            phoneNumberInfo: 'phoneNumberInfo',
            lastRefreshTime: 'lastRefreshTime',
            userId: 'userId',
            Languages: 'languages',
            profileName: 'profileName'
        })
        .constant('preferences', {
            DataCacheExpirationTimeMilliseconds: 'Portal_DataCacheExpirationTimeMilliseconds',
            DispositionMaxAllowedChars: 'Portal_DispositionMaxAllowedChars',
            DisableTokenGenerationLocalHost: 'Portal_DisableTokenGenerationLocalHost',
            RecentCallsRefreshIntervalSeconds: 'Portal_RecentCallsRefreshIntervalSeconds',
            ReCreateTokens: 'Portal_ReCreateTokens',
            GetLoggedInInterpretersDelayMilliseconds: 'Portal_GetLoggedInInterpretersDelayMilliseconds',
            GetOperatorDelayMilliseconds: 'Portal_GetOperatorDelayMilliseconds',
            GetCallDispositionTimeoutMilliseconds: 'Portal_CallDispositionTimeout',
            GetCallDispositionMenuTimeOutSeconds: 'Portal_CallDispositionMenuTimeout',
            GetCallDispositionFlag: 'IVR_EnableCallDisposition', // This preference is also used in the IVR project
            SendCustomUITelemetry: 'Portal_SendCustomUITelemetry',
            UIRequestMinDuration: 'Portal_UIRequestMinDuration',
            LatencyMeasuringInterval: 'Portal_LatencyMeasuringInterval',
            IsInterpreterDispositionMenu: 'IVR_IsInterpreterDispositionMenu', // This preference is also used in the IVR project
            IsShowDefaultReminder: 'Portal_InterpreterCustomReminderText',
            DefaultShowReminderText: 'Portal_InterpreterCustomReminderText_Default',
            IsShowDefaultOperatorReminder: 'Portal_OperatorCustomReminderText',
            DefaultShowOperatorReminderText: 'Portal_OperatorCustomReminderText_Default',
            ShowNetworkQualityIndicator: 'Portal_ShowNetworkQualityIndicator',
            TestButtonDisabled: 'Portal_TestButtonDisabled',
            ShowWebRtcDialpad: 'Portal_ShowWebRtcDialpad',
            DisconnectWebRtcActiveConnection: 'Portal_DisconnectWebRtcActiveConnection',
            EnableStateMachine: 'Portal_EnableStateMachine',
            StateMachineStatusForAlerting: 'Portal_StateMachineStatusForAlerting',
            StateMachineStatusForInCall: 'Portal_StateMachineStatusForInCall',
            StateMachineStatusForRinging: 'Portal_StateMachineStatusForRinging',
            IsCustomerMonitorRefresh: 'Portal_IsCustomerMonitorRefresh',
            IsShowAppVersion: 'Portal_ShowAppVersionAfterLogin',
            TwilioErrorLimitToLog: 'Portal_TwilioErrorLimitToLog',
            ShowNonIVRLanguagesDropdown:  'Portal_ShowNonIVRLanguagesDropdown',
            FilterOverflowVendorsBasedOnLanguage: 'Portal_FilterOverflowVendorsBasedOnLanguage',
            ValidateMetadata: 'Portal_ValidateMetadata',
            ValidateSipdata: 'Portal_ValidateSipdata',
            EnableTwilioClientDebugging: 'Portal_EnableTwilioClientDebugging',
            CreateTokenOnError: 'Portal_CreateTokenOnError',
            RefreshReminder: 'Portal_RefreshReminder',
            preFlight: 'Portal_PreFlight',
            DisableStatusChange: 'Portal_DisableStatusChange',
            TokenRefreshMilliseconds: 'Portal_WebRTCTokenRefreshMilliseconds',
            ShowWebRTCReconnectionStatus: 'Portal_ShowWebRTCReconnectionStatus',
            WebRTCTokenAgeMinutes: 'IVR_TwilioWebRTC_TokenValidityInMinutes',
            WebRTCEdgeLocations: 'Portal_WebRTCEdgeLocations',
            CodecPreferences: 'Portal_CodecPreferences',
            LogTwilioErrorsOnConsole: 'Portal_LogTwilioErrorsOnConsole',
            TwilioSDKVersion: 'Portal_TwilioSDKVersion',
            RegisterDeviceWhenOffline: 'Portal_RegisterDeviceWhenOffline',
            RefreshRetainsCall: 'Portal_RefreshRetainsCall',
            ShowAdditionalStuckCalls: 'Portal_ShowAdditionalStuckCalls',
            NoTalkActionMessage1: 'Portal_NoTalkActionMessage_1',
            NoTalkActionMessage2: 'Portal_NoTalkActionMessage_2',
            PremiumRatePhoneNumberPrefix: 'IVR_PremiumRatePhoneNumberPrefix',
            ShowScheduledCallAlert: 'Portal_ScheduledCall_Alert',
            IvrNewVoicePortalUsedByInterpreter: 'IVR_NewVoicePortal_UsedByInterpreter',
            IvrNewVoicePortalUsedByOperator: 'IVR_NewVoicePortal_UsedByOperator',
            IvrNewVoicePortalUsedByOperatorByDefault: 'IVR_NewVoicePortal_UsedByOperatorByDefault',
            PortalSwitchingPortalsDelay: 'Portal_SwitchingPortalsDelay'
        })
        .constant('callEvents', {
            LSButtonVisible: 'LSButtonVisible',
            ConnectButtonVisible: 'ConnectButtonVisible',
            ConnectMeButtonVisible: 'ConnectMeButtonVisible',
            ConnectInterpreterButtonVisible: 'ConnectInterpreterButtonVisible',
            LSButtonClicked: 'LSButtonClicked',
            ConnectButtonClicked: 'ConnectButtonClicked',
            ConnectMeButtonClicked: 'ConnectMeButtonClicked',
            ConnectInterpreterButtonClicked: 'ConnectInterpreterButtonClicked',
            LSClickedFailed: 'LSClickedFailed',
            ConnectClickFailedNoInterpreters: 'ConnectClickFailedNoInterpreters',
            ConnectMeClickedFailed: 'ConnectMeClickedFailed',
            ConnectInterpreterClickedFailed: 'ConnectInterpreterClickedFailed',
            AlertButtonVisible: 'AlertButtonVisible',
            AlertSoundPlaying: 'AlertSoundPlaying',
            ReconnectWarningButtonVisible: 'ReconnectWarningButtonVisible',
            ReconnectButtonClicked: 'ReconnectButtonClicked',
            MetadataAnswerChanged: 'MetadataAnswerChanged',
            SipCallHeaderChanged: 'SipCallHeaderChanged',
            UserHangup: 'UserHangup',
            PhoneHangup: 'PhoneHangup',
            WebRTCHangup: 'WebRTCHangup',
            DispositionMenuCallWasSuccessfull: 'DispositionMenuCallWasSuccessfull',
            DispositionMenuWrongLanguageSelected: 'DispositionMenuWrongLanguageSelected',
            DispositionMenuAudioLossAndOrCantHear: 'DispositionMenuAudioLossAndOrCantHear',
            DispositionMenuNoCustomerAndOrOnlyLEP: 'DispositionMenuNoCustomerAndOrOnlyLEP',
            DispositionMenuInaudibleNonEnglishSpeaker: 'DispositionMenuInaudibleNonEnglishSpeaker',
            DispositionMenuCustomerDropCallQuality: 'DispositionMenuCustomerDropCallQuality',
            DispositionMenuCustomerDropAbruptly: 'DispositionMenuCustomerDropAbruptly',
            DispositionMenuCustomerDropWhileConferencing: 'DispositionMenuCustomerDropWhileConferencing',
            DispositionMenuInterpreterNolongerNeeded: 'DispositionMenuInterpreterNolongerNeeded',
            DispositionMenuOther: 'DispositionMenuOther',
            DispositionMenuCouldNotHearCustomerAndOrLEP: 'DispositionMenuCouldNotHearCustomerAndOrLEP',
            DispositionMenuPoorAudioQuality: 'DispositionMenuPoorAudioQuality',
            DispositionMenuCallDropped: 'DispositionMenuCallDropped',
            DispositionMenuTechnicalProblem: 'DispositionMenuTechnicalProblem',
            DispositionMenuCustomerDidNotReturnFromHold: 'DispositionMenuCustomerDidNotReturnFromHold',
            DispositionMenuCustomerHangupOrTransferContd: 'DispositionMenuCustomerHangupOrTransferContd',
            NoDispositionOptionSelected: 'NoDispositionOptionSelected',
            ShowedNoTalkDisposition: 'ShowedNoTalkDisposition',
            NoInterpreter: 'NoInterpreter',
            CancelledCall: 'CancelledCall',
            LowMosWebRTCError: 'LowMosWebRTCError',
            HighRttWebRTCError: 'HighRttWebRTCError',
            HighJitterWebRTCError: 'HighJitterWebRTCError',
            HighPacketLossWebRTCError: 'HighPacketLossWebRTCError',
            AudioDeviceChanged: 'AudioDeviceChanged',
            WebRTCErrorCleared: 'WebRTCErrorCleared',
            ConnectToMale: 'ConnectToMale',
            ConnectToFemale: 'ConnectToFemale',
            InterpreterOnAnotherCall: 'InterpreterOnAnotherCall',
            HangupButtonVisible: 'HangupButtonVisible',
            CustomerPutCallOnHold: 'CustomerPutCallOnHold',
            LEPPutCallOnHoldOrDelayedCall: 'LEPPutCallOnHoldOrDelayedCall',
            CustomerOrLEPNotJoinedCall: 'CustomerOrLEPNotJoinedCall',
            ActiveInterpretationGoingOn: 'ActiveInterpretationGoingOn',
            AudioOrTechnicalIssue: 'AudioOrTechnicalIssue',
            HighPacketsLossFractionWebRTCError: 'HighPacketsLossFractionWebRTCError',
            QualityMonitorOnCall: 'QualityMonitorOnCall'
        });
})();

(function () {
    'use strict';

    var core = angular.module('vox-leonis.core');

    core.config(toastrConfig);

    toastrConfig.$inject = ['toastr'];
    /* @ngInject */
    function toastrConfig(toastr) {
        toastr.options.timeOut = 4000;
        toastr.options.positionClass = 'toast-bottom-right';
    }

    var config = {
        appErrorPrefix: '[portal Error] ',
        appTitle: 'Lionbridge Voice Portal'
    };

    core.value('config', config);

    core.config(configure);

    configure.$inject = ['$logProvider', '$httpProvider', 'routerHelperProvider', 'exceptionHandlerProvider', 'applicationInsightsServiceProvider'];
    /* @ngInject */
    function configure($logProvider, $httpProvider, routerHelperProvider, exceptionHandlerProvider, applicationInsightsServiceProvider) {
        if ($logProvider.debugEnabled)
        {
            $logProvider.debugEnabled(true);
        }
        exceptionHandlerProvider.configure(config.appErrorPrefix);
        routerHelperProvider.configure({ docTitle: config.appTitle + ' ' });

        $httpProvider.interceptors.push('httpInterceptor');

        //turn on all default telemetry
        var options = {
            // applicationName: used as a 'friendly name' prefix to url paths
            // ex: myAmazingapp/mainView
            applicationName: 'vox-leonis',
            // autoPageViewTracking: enables the sending a event to Application Insights when
            // ever the $locationChangeSuccess event is fired on the rootScope
            autoPageViewTracking: true,
            // autoStateChangeTracking: enables the sending a event to Application Insights when
            // ever the $stateChangeSuccess event is fired on the rootScope. To enable 'autoPageViewTracking' option should be set too.
            autoStateChangeTracking: true,
            // autoLogTracking: enables the interception of calls to the $log service and have the trace
            // data sent to Application Insights.
            autoLogTracking: true,
            // autoExceptionTracking: enables calls to the $exceptionHandler service, usually unhandled exceptions, to have the error and stack data sent to Application Insights.
            autoExceptionTracking: true,
            // sessionInactivityTimeout: The time (in milliseconds) that a user session can be inactive, before a new session will be created (on the next api call). Default is 30mins.
            sessionInactivityTimeout: 1800000,
            // developerMode: Makes the service not post anything to AI but print it to the console instead
            developerMode: false
        };

        var appInsightsInstrumentationKey /* @setApplicationInsightsKey */;

        applicationInsightsServiceProvider.configure(appInsightsInstrumentationKey, options);

        var enableCorsCorrelationFlag = false;

        // sepcify the domains that you want to allow to communicate with dc.services.visualstudio.com/v2/track
        // blank with allow all domains

        var correlationHeaderExcludedDomains = '';

        /*jshint immed: false */
        var appInsights = (function (config) {
            function i(config) { t[config] = function () { var i = arguments; t.queue.push(function () { t[config].apply(t, i); }); }; }
            var t = { config: config }, u = document, e = window, o = 'script', s = 'AuthenticatedUserContext';
            var h = 'start', c = 'stop', l = 'Track', a = l + 'Event', v = l + 'Page', y = u.createElement(o), r, f;
            y.src = config.url || 'https://az416426.vo.msecnd.net/scripts/a/ai.0.js';
            u.getElementsByTagName(o)[0].parentNode.appendChild(y);
            try { t.cookie = u.cookie; } catch (p) { } for (t.queue = [], t.version = '1.0',
                r = ['Event', 'Exception', 'Metric', 'PageView', 'Trace', 'Dependency']; r.length;) { i('track' + r.pop()); }
            return i('set' + s), i('clear' + s), i(h + a), i(c + a), i(h + v), i(c + v), i('flush'),
                config.disableExceptionTracking || (r = 'onerror', i('_' + r), f = e[r],
                    e[r] = function (config, i, u, e, o) { var s = f && f(config, i, u, e, o); return (s !== true) && t['_' + r](config, i, u, e, o), s; }), t;
        }({
            instrumentationKey: appInsightsInstrumentationKey,
            enableCorsCorrelation: enableCorsCorrelationFlag,
            correlationHeaderExcludedDomains: [correlationHeaderExcludedDomains]
        }));

        window.appInsights = appInsights;
        appInsights.trackPageView();
    }
})();

(function ()
{
    'use strict';

    angular
        .module('vox-leonis.admin', [
            'vox-leonis.core'
        ]);
})();


(function () {
    'use strict';

    angular
        .module('vox-leonis.admin')
        .directive('voxAdmin', voxAdmin);

    /* @ngInject */
    function voxAdmin() {
        var directive = {
            bindToController: true,
            controller: AdminLayoutController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'roles': '=',
            },
            templateUrl: 'app/admin/vox-admin.html'
        };
        return directive;
    }

    AdminLayoutController.$inject = ['$scope', '$q', '$state', 'logger', 'operatorservice', 'operatorsignalreceiver',
        'utilities', 'constants', 'reducecallfrequencyservice', 'appsettingsservice', 'preferences', 'userservice'];
    /* @ngInject */
    function AdminLayoutController($scope, $q, $state, logger,
        operatorservice, operatorsignalreceiver, utilities, constants, reducecallfrequencyservice, appsettingsservice, preferences) {
        var vm = this;
        vm.loggedInInterpreters = undefined;

        var getLoggedInInterpretersDelay = 1000;

        operatorservice.get().then(function (data) {
            if (data !== '') {
                var userId = data.Id;
                appsettingsservice.getAppSetting(preferences.GetLoggedInInterpretersDelayMilliseconds, getLoggedInInterpretersDelay, userId).then(function (data) {
                    getLoggedInInterpretersDelay = data;
                });
            }
        });

        activate();

        function activate() {
            listeners();

            getLoggedInInterpretersCall();
        }

        function listeners() {
            $scope.$on(operatorsignalreceiver.refreshDataEvent, refreshData);
        }

        // Data retrieval
        function getLoggedInInterpreters() {
            return operatorservice.getLoggedInInterpreters().then(function (loggedInInterpreters) {
                return loggedInInterpreters;
            });
        }

        function getLoggedInInterpretersCall() {
            reducecallfrequencyservice.call(constants.operatorGetLoggedInInterpreters, function () {
                getLoggedInInterpreters().then(function (loggedInInterpreters) {
                    vm.loggedInInterpreters = utilities.buildLoggedInInterpreters(loggedInInterpreters);
                }).catch(function (e) {
                    if (e.status === 401) {
                        $state.go('login');
                    }
                });
            }, getLoggedInInterpretersDelay);
        }

        function refreshData(event, data) {
            $scope.$apply(function () {
                switch (data.property) {
                    case 'InterpreterStatus':
                        getLoggedInInterpretersCall();
                        break;
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.admin')
        .directive('voxAdminCallsTable', voxAdminCallsTable);

    /* @ngInject */
    function voxAdminCallsTable() {
        var directive = {
            bindToController: true,
            controller: AdminCallsTableController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                'monitor': '=',
                'roles': '='
            },
            templateUrl: 'app/admin/vox-admin-calls-table.html'
        };
        return directive;
    }

    AdminCallsTableController.$inject = ['$scope', '$cookies', '$rootScope', '$filter', '$interval', 'adminservice', 'session', 'operatorsignalreceiver',
        'exception', 'monitorservice', 'monitorsignalreceiver', 'appsettingsservice', 'operatorservice', 'preferences', '$window', 'userservice', 'accountservice', 'enums', 'constants'];
    /* @ngInject */
    function AdminCallsTableController($scope, $cookies, $rootScope, $filter, $interval, adminservice, session, operatorsignalreceiver,
        exception, monitorservice, monitorsignalreceiver, appsettingsservice, operatorservice, preferences, $window, userservice, accountservice, enums, constants) {
        var vm = this;

        var userSpecRefreshRecentCallsInterval = null;
        vm.calls = [];
        vm.callsUpdating = false;
        vm.requestingToListen = null;
        vm.recentHours = 'No Interpreter:-1,Active:0,Calls with No Talk Activity:-3,1:1,2:2,3:3,6:6';
        vm.recentCallsRefreshIntervalSeconds = 15;
        vm.selectedHour = { id: '-1', name: 'Waiting for Interpreter' };
        vm.filterChange = filterChange;
        vm.monitorCall = monitorCall;
        vm.hasMonitoring = hasMonitoring;
        vm.hoursChanged = hoursChanged;
        vm.endConference = endConference;
        vm.customerMonitor = true;
        vm.isCustomerMonitorRefresh = false;
        vm.showTerminateButton = getTerminameButtonAdditionalCondition;
        vm.additionalStuckCallCondition = true;
        activate();

        function activate() {
            listeners();

            appsettingsservice.getAppSetting(preferences.isCustomerMonitorRefresh, vm.isCustomerMonitorRefresh).then(function (data) {
                vm.isCustomerMonitorRefresh = data !== undefined && data !== '';
            });

            appsettingsservice.getAppSetting(preferences.ShowAdditionalStuckCalls, vm.additionalStuckCallCondition).then(function (data) {
                vm.additionalStuckCallCondition = (data === 'true');
            });

            appsettingsservice.getAppSetting('Portal_RecentCallsTableHours', vm.recentHours).then(function (data) {
                vm.recentHours = recentCallCriteriaList(data);
            }).finally(function () {
                hoursChanged();
            });

            userservice.getUserSetting('Portal_CustomerMonitor', '').then(function (data) {
                vm.customerMonitor = data !== undefined && data !== '';
                if (vm.customerMonitor && vm.isCustomerMonitorRefresh) {
                    userservice.getUserSetting(preferences.RecentCallsRefreshIntervalSeconds, vm.recentCallsRefreshIntervalSeconds).then(function (data) {
                        vm.recentCallsRefreshIntervalSeconds = data;
                        setTimerToRefreshRecentCalls();
                    });
                }
            });

            if (session.roles.indexOf('Operator') >= 0) {
                operatorservice.get().then(function (data) {
                    if (data !== '') {
                        var userId = data.Id;
                        appsettingsservice.getAppSetting(preferences.RecentCallsRefreshIntervalSeconds, vm.recentCallsRefreshIntervalSeconds, userId).then(function (data) {
                            vm.recentCallsRefreshIntervalSeconds = data;
                            setTimerToRefreshRecentCalls();
                        });
                    }
                });
            }
        }

        $scope.$on('$destroy', function () {
            $interval.cancel(userSpecRefreshRecentCallsInterval);
        });

        function listeners() {
            $scope.$on(operatorsignalreceiver.refreshDataEvent, refreshRecentCalls);
            $scope.$on(monitorsignalreceiver.refreshDataEvent, refreshRecentCallsForMonitor);
        }

        function hoursChanged() {
            getCalls(true).then(function (calls) {
                updateCalls(calls);
            });
        }
        
        function getTerminameButtonAdditionalCondition(callStatus) {
            var defaultCondition = (+vm.selectedHour.id === -2 || +vm.selectedHour.id === -3 || +vm.selectedHour.id === -4);
            var additionalCondition = false;
            if (vm.additionalStuckCallCondition) {
                switch (callStatus) {
                    case 'CustomerConnected':
                    case 'LanguageSelected':
                    case 'InterpreterAlerting':
                    case 'OperatorAlerting':
                    case 'OperatorDisconnected':
                    case 'InterpreterDisconnected':
                    case 'InterpreterRinging':
                    case 'OperatorRinging':
                        additionalCondition = true;
                        break;
                    default:
                        additionalCondition = false;
                        break;
                }
            }
            return defaultCondition || additionalCondition;
        }

        function recentCallCriteriaList(list) {
            return list.split(',').map(function (attribute) {
                var dividedAttribute = attribute.split(':');
                var hours = dividedAttribute[0];
                return {
                    id: dividedAttribute[1],
                    name: dividedAttribute[1] > 0 ? 'Completed within ' + hours + ' hour' + (+hours === 1 ? '' : 's') : dividedAttribute[0]
                };
            });
        }

        // get the call data
        function getCalls(forceGet) {
            vm.callsUpdating = true;

            return adminservice.getCalls(vm.selectedHour.id, forceGet)
                .then(getCallsComplete, getCallsFailed);

            function getCallsComplete(response) {
                vm.callsUpdating = false;
                return response;
            }

            function getCallsFailed(e) {
                vm.callsUpdating = false;
                return exception.catcher('getCalls')(e);
            }
        }

        // refresh the data every 10 seconds
        function refreshRecentCalls(event, data) {
            $scope.$apply(function () {
                if (data.property === 'RecentCalls') {
                    getCalls(false).then(function (calls) {
                        updateCalls(calls);
                    });
                }
            });
        }

        function refreshRecentCallsForMonitor(event, data) {
            if (!session.roles || session.roles.indexOf('Operator') >= 0 || session.roles.indexOf('Admin') >= 0 || session.roles.indexOf('SuperUser') >= 0) {
                // this user is a monitor and an operator and so received 2 refresh recent calls events. only need to refresh once, exit here
                return;
            }
            refreshRecentCalls(event, data);
        }

        function updateCalls(calls) {
            if (calls && calls !== 'NoUpdate') {
                for (var i = 0; i < calls.length; i++) {
                    var call = calls[i];
                    // calculate the display value here so that users can search on this value
                    call.CallConnectedDisplay = $filter('date')(call.CallConnected, 'medium');
                    call.CallConnectedDisplay = call.CallConnectedDisplay.replace(new Date().getFullYear(), '');
                }
                vm.calls = calls;
            }
        }

        function filterChange() {
            $rootScope.$broadcast('renderScrollableTable');
        }

        function monitorCall(callId) {
            vm.requestingToListen = callId;
            $cookies.put(constants.userRole, constants.monitor);
            monitorservice.listen(callId)
                .finally(function () {
                    vm.requestingToListen = null;
                });
        }

        function hasMonitoring(monitoringRestricted) {
            var hasAccess = false;
            hasAccess = vm.monitor && (!monitoringRestricted || vm.roles.indexOf('SuperUser') >= 0);
            return hasAccess;
        }

        function setTimerToRefreshRecentCalls() {
            userSpecRefreshRecentCallsInterval = $interval(function () {
                //CustomerMonitor: refresh list of active calls.
                if (vm.customerMonitor && vm.isCustomerMonitorRefresh) {
                    getCalls(false).then(function (calls) {
                        updateCalls(calls);
                    });
                }
                //actively refresh only when "Show Calls - with No Interpreter" or "Abnormally Long" is selected in the Recent Calls table
                else if (+vm.selectedHour.id === -1 || +vm.selectedHour.id === -2) {
                    getCalls(false).then(function (calls) {
                        updateCalls(calls);
                    });
                }
            }, (vm.recentCallsRefreshIntervalSeconds * 1000));
        }

        function endConference(callId, referenceId) {
            var terminateCall = true;
            terminateCall = $window.confirm('Call with reference Id ' + referenceId + '. If you continue, call will be terminated. Are you sure you want to terminate the call?');

            if (terminateCall) {
                userservice.endConference(callId).then(function (data) {
                    if (!data) {
                        accountservice.logMessage('vox-admin-calls-table.endConference Action Failed, CallId: ' + callId + ',', enums.LogLevel.Warn);
                    }
                    else {
                        hoursChanged();
                    }
                });
            }
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.admin')
        .run(appRun);

    appRun.$inject = ['routerHelper'];
    /* @ngInject */
    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'admin',
                config: {
                    url: '/admin',
                    templateUrl: 'app/admin/admin.html',
                    controller: 'AdminController',
                    controllerAs: 'vm',
                    title: 'Admin',
                    resolve: {
                        getRoles: getRoles
                    }
                }
            }
        ];
    }

    getRoles.$inject = ['$state', '$cookies', 'accountservice', 'session', 'constants'];
    /* @ngInject */
    function getRoles($state, $cookies, accountservice, session, constants) {
        var currentRole = $cookies.get(constants.userRole);
        if (currentRole === undefined) {
            $state.go('login');
            return;
        }
        else if (session.roles === undefined) {
            return accountservice.getRoles().then(function (data) {
                session.roles = data.Roles;
                return session.roles;
            }).catch(function (e) {
                if (e.status === 401) {
                    $state.go('login');
                }

                session.roles = undefined;
                return session.roles;
            });
        }
        else {
            return session.roles;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vox-leonis.admin')
        .controller('AdminController', AdminController);

    AdminController.$inject = ['$scope', '$q', '$state', '$cookies', 'session', 'signalservice', '$interval', 'utilities', 'appsettingsservice', 'constants'];
    /* @ngInject */
    function AdminController($scope, $q, $state, $cookies, session, signalservice, $interval, utilities, appsettingsservice, constants) {
        var vm = this;

        vm.identity = undefined;
        vm.interpreter = undefined;
        vm.roles = session.roles;
        var keepAliveInterval;

        activate();

        function activate() {
            var currentRole = $cookies.get(constants.userRole);
            if (currentRole === undefined) {
                $state.go('login');
                return;
            }

            signalservice.connect();

            var setKeepAliveIntervalSeconds = 40;
            appsettingsservice.getAppSetting('Portal_SetKeepAliveIntervalSeconds', setKeepAliveIntervalSeconds).then(function (data) {
                setKeepAliveIntervalSeconds = data;
            }).finally(function () {
                keepAliveInterval = utilities.startKeepAliveInterval(vm.roles, setKeepAliveIntervalSeconds);
            });

            var promises = [];
            return $q.all(promises).then(function () {
            }).catch(function (e) {
                if (e.status === 401) {
                    $state.go('console');
                }
            });
        }

        $scope.$on('$destroy', function () {
            if (keepAliveInterval) {
                $interval.cancel(keepAliveInterval);
            }
        });
    }
})();


(function ()
{
    'use strict';

    angular.module('vox-leonis', [
        'vox-leonis.admin',
        'vox-leonis.core',
        'vox-leonis.login',
        'vox-leonis.operator',
        'vox-leonis.monitor',
        'vox-leonis.interpreter',
        'vox-leonis.layout',
        'vox-leonis.widgets',
        'vox-leonis.console'
    ]);

})();

angular.module("vox-leonis").run(["$templateCache", function($templateCache) {$templateCache.put("app/admin/admin.html","<vox-top-nav user-name=\"vm.operator.Name || vm.interpreter.Name\"></vox-top-nav><div class=\"container-fluid vox-main\"><vox-admin roles=\"vm.roles\" ng-if=\"vm.roles.indexOf(\'Admin\') >= 0 || vm.roles.indexOf(\'SuperUser\') >= 0\"></vox-admin></div>");
$templateCache.put("app/admin/vox-admin-calls-table.html","<div class=\"panel panel-default panel-vox animated fadeIn\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"col-md-9\"><div class=\"admin-calls-title\"><span><strong><i class=\"fa fa-phone fa-lg fa-fw\"></i> Recent Calls <span class=\"badge\">{{vm.displayedCollection.length}}{{vm.displayedCollection.length != vm.calls.length ? \'/\'+ vm.calls.length : \'\' }}</span></strong></span> <i ng-show=\"vm.callsUpdating\" class=\"fa fa-refresh fa-spin fa-lg\"></i></div></div><div class=\"col-md-3\" ng-hide=\"vm.customerMonitor\"><div class=\"form-group\"><div class=\"input-group\"><div class=\"input-group-addon\"><strong>Show Calls</strong></div><select class=\"form-control recent-calls-select\" ng-model=\"vm.selectedHour\" ng-change=\"vm.hoursChanged()\" ng-options=\"recentHour.name for recentHour in vm.recentHours | orderBy:id track by recentHour.id\"></select></div></div></div></div></div><table st-table=\"vm.displayedCollection\" st-safe-src=\"vm.calls\" class=\"table smart-table freeze-header\"><thead><tr><th st-sort=\"CustomerOrganization\">Customer</th><th st-sort=\"CustomerProfile\">Site</th><th st-sort=\"InterpreterName\">Interpreter</th><th st-sort=\"Status\">Status</th><th st-sort=\"LanguageName\">Language</th><th st-sort=\"Duration\">Duration</th><th st-sort=\"ReferenceId\">Reference #</th><th st-sort=\"CallConnected\">Date/Time</th><th ng-if=\"vm.hasMonitoring(call.MonitoringRestricted) || +vm.selectedHour.id === -2\"></th><th ng-if=\"vm.roles.indexOf(\'SuperUser\') >= 0\"></th><th><button class=\"btn fa fa-filter fa-lg pull-right\" ng-click=\"showFilter = !showFilter\" st-reset=\"\"></button></th></tr><tr ng-show=\"showFilter\"><th><input st-search=\"CustomerOrganization\" placeholder=\"Customer\" class=\"input-sm form-control\" type=\"search\"></th><th><input st-search=\"CustomerProfile\" placeholder=\"Site\" class=\"input-sm form-control\" type=\"search\"></th><th><input st-search=\"InterpreterName\" placeholder=\"Interpreter\" class=\"input-sm form-control\" type=\"search\"></th><th><input st-search=\"Status\" placeholder=\"Status\" class=\"input-sm form-control\" type=\"search\"></th><th><input st-search=\"LanguageName\" placeholder=\"Language\" class=\"input-sm form-control\" type=\"search\"></th><th></th><th><input st-search=\"ReferenceId\" placeholder=\"Reference #\" class=\"input-sm form-control\" type=\"search\"></th><th><input st-search=\"CallConnectedDisplay\" placeholder=\"Date/Time\" class=\"input-sm form-control\" type=\"search\"></th><th ng-if=\"vm.hasMonitoring(call.MonitoringRestricted) || +vm.selectedHour.id === -2\"></th><th ng-if=\"vm.roles.indexOf(\'SuperUser\') >= 0\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"call in vm.displayedCollection\" ng-class=\"{success: call.CallId === vm.monitor.CurrentCallId}\"><td>{{call.CustomerOrganization}}</td><td>{{call.CustomerProfile}}</td><td>{{call.InterpreterName}}</td><td>{{call.Status}}</td><td>{{call.LanguageName}}</td><td ng-if=\"call.CallEnded\">{{call.CallConnected | elapsedTime : call.CallEnded}}</td><td ng-if=\"!call.CallEnded\"><vox-countup start-date-time=\"call.CallConnected\" hide-days=\"true\"></vox-countup></td><td>{{call.ReferenceId}}</td><td>{{call.CallConnectedDisplay}}</td><td ng-if=\"vm.hasMonitoring(call.MonitoringRestricted)\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.monitorCall(call.CallId)\" ng-if=\"call.Status !== \'Completed\'\" ng-disabled=\"vm.monitor.Status !== \'Monitoring\'\" title=\"{{vm.monitor.Status === \'Monitoring\' ? \'Receive a call on your phone to monitor this call\' : \'Your status must be Monitoring to monitor this call\'}}\" ladda=\"vm.requestingToListen === call.CallId\">Listen</button></td><td><div ng-if=\"vm.roles.indexOf(\'SuperUser\') >= 0 && vm.showTerminateButton(call.Status)\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.endConference(call.CallId, call.ReferenceId)\" ng-if=\"call.Status !== \'Completed\'\" title=\"End Conference\">Terminate call</button></div></td><td></td></tr></tbody></table></div>");
$templateCache.put("app/admin/vox-admin.html","<div><div class=\"row\"><div class=\"col-md-12\"><vox-admin-calls-table roles=\"vm.roles\"></vox-admin-calls-table></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"logged-in-interpreter-title\"><span><strong>Logged In Interpreters <span class=\"badge\">{{vm.loggedInInterpreterCount}}{{vm.loggedInInterpreterCount != vm.loggedInInterpreters.length ? \'/\'+ vm.loggedInInterpreters.length : \'\' }}</span></strong></span></div><vox-loggedin-interpreters-table logged-in-interpreters=\"vm.loggedInInterpreters\" logged-in-interpreter-count=\"vm.loggedInInterpreterCount\"></vox-loggedin-interpreters-table></div></div></div>");
$templateCache.put("app/console/console.html","<style type=\"text/css\">\r\n    .box {\r\n        width: 150px;\r\n        height: 150px;\r\n        opacity: 0.9;\r\n        position: absolute;\r\n        top: 30px;\r\n        left: 30px;\r\n    }\r\n</style><vox-top-nav user=\"vm.operator || vm.interpreter || vm.monitor\" version=\"vm.version\"></vox-top-nav><div class=\"container-fluid vox-main\"><div class=\"row\"><div class=\"col-md-8\" ng-if=\"vm.interpreter || vm.operator || vm.monitor\"><div class=\"row col-md-12\"><vox-console-status operator=\"vm.operator\" interpreter=\"vm.interpreter\" monitor=\"vm.monitor\"></vox-console-status></div><div class=\"row col-md-12\"><vox-meta-data user-id=\"vm.interpreter.Id || vm.operator.Id\"></vox-meta-data></div><div class=\"row col-md-12\"><vox-sip-data user-id=\"vm.interpreter.Id || vm.operator.Id\"></vox-sip-data></div></div><div class=\"col-md-4\"><div class=\"col-md-12\" ng-if=\"vm.person.Status == \'InCall\' || vm.person.Status == \'AfterCallWork\'\"><vox-console-call-control-panel person=\"vm.person\"></vox-console-call-control-panel></div><div class=\"col-md-12\"><vox-interpreter call-type=\"vm.callType\" interpreter=\"vm.interpreter\" ng-if=\"vm.roles.indexOf(\'Interpreter\') >= 0\"></vox-interpreter></div></div></div><vox-operator operator=\"vm.operator\" call-type=\"vm.callType\" roles=\"vm.roles\" ng-if=\"vm.roles.indexOf(\'Operator\') >= 0 || vm.roles.indexOf(\'SuperUser\') >= 0\"></vox-operator><vox-monitor monitor=\"vm.monitor\" ng-if=\"vm.roles.indexOf(\'Monitor\') >= 0\"></vox-monitor><div ng-if=\"vm.roles.indexOf(\'Operator\') >= 0 || vm.roles.indexOf(\'SuperUser\') >= 0 || vm.roles.indexOf(\'Monitor\') >= 0\"><vox-admin-calls-table monitor=\"vm.monitor\" roles=\"vm.roles\"></vox-admin-calls-table></div></div><div class=\"dialpad-minimized-container clearfix\" ng-show=\"vm.showWebRtcDialpad == \'true\' &&vm.person.ContactMethod === 2 && vm.person.Status === \'InCall\' && !vm.maximised\"><vox-console-webrtc-dialpad-min></vox-console-webrtc-dialpad-min></div><div ng-show=\"vm.showWebRtcDialpad == \'true\' && vm.person.ContactMethod === 2 && vm.person.Status === \'InCall\' && vm.maximised\" class=\"shape\" ng-draggable=\"dragOptions\"><vox-console-webrtc-dialpad></vox-console-webrtc-dialpad></div>");
$templateCache.put("app/console/vox-call-duration.html","<span ng-class=\"{\'instruction-text Duration-Bold\': vm.showWarning}\"><vox-countup start-date-time=\"vm.startTime\" hide-days=\"true\" thresholds=\"vm.thresholds\" call-id=\"vm.callId\" interpreter-id=\"vm.interpreterId\"></vox-countup></span>");
$templateCache.put("app/console/vox-call-events.html","<table class=\"table\"><thead><tr><th ng-show=\"(vm.roles.indexOf(\'Operator\') >= 0 || vm.roles.indexOf(\'Admin\') >= 0)\">Timestamp</th><th>Call Event</th><th>Info</th></tr></thead><tbody><tr><td ng-show=\"(vm.roles.indexOf(\'Operator\') >= 0 || vm.roles.indexOf(\'Admin\') >= 0)\">{{vm.callConnectedLocaleString}}</td><td>Call Created</td><td></td></tr><tr ng-repeat=\"callEvent in vm.callEvents | orderBy:\'EventTime\'\" ng-show=\"callEvent.StatusEvent !== \'MonitorConnected\' && callEvent.StatusEvent !== \'MonitorDisconnected\'\"><td ng-show=\"(vm.roles.indexOf(\'Operator\') >= 0 || vm.roles.indexOf(\'Admin\') >= 0)\">{{vm.getLocalDate(callEvent)}}</td><td>{{callEvent.StatusEvent | camelcaseSpace}}</td><td>{{vm.getAdditionalInfo(callEvent)}}</td></tr></tbody></table>");
$templateCache.put("app/console/vox-console-alert.html","<div><div><vox-alert ng-if=\"vm.alert\" alert=\"vm.alert\" contact-method=\"vm.person.ContactMethod\" re-create-tokens=\"vm.reCreateTokens\"></vox-alert></div><div ng-class=\"vm.alertType\" ng-if=\"vm.alertActionMessage\"><span>{{vm.alertActionMessage}}</span></div></div>");
$templateCache.put("app/console/vox-console-call-control-panel.html","<div class=\"panel panel-default panel-vox animated fadeIn\"><div class=\"panel-heading\"><span class=\"fa-stack fa-lg\"><i class=\"fa fa-square-o fa-stack-2x\"></i> <i class=\"fa fa-headphones fa-stack-1x\"></i></span> <strong>{{vm.selectedContactMethod == 2 ? \'Computer call\' : \'Telephonic Call\' }}</strong></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-6\"><h5><strong>{{vm.person.Status == \'AfterCallWork\' ? \'Call Ended\' : \'Incoming call\'}}</strong></h5></div><div class=\"col-sm-6\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.hangUp()\" ng-disabled=\"vm.isHangUpDisabled\">Hang Up</button></div></div><div ng-if=\"vm.currentRole == \'Interpreter\' || vm.currentRole == \'Operator\'\"><div class=\"col-sm-12\" ng-if=\"(vm.person.Status == \'AfterCallWork\' && vm.isApplicableforDisposition)\"><vox-disposition-menu person=\"vm.person\"></vox-disposition-menu></div></div><div ng-if=\"vm.currentRole == \'Interpreter\'\"><div class=\"col-sm-12\" ng-if=\"(vm.person.Status == \'InCall\' && vm.showNoTalkPopup)\"><vox-notalk-action-menu person=\"vm.person\"></vox-notalk-action-menu></div></div></div></div></div>");
$templateCache.put("app/console/vox-console-instruction-message.html","<div class=\"alert alert-instruction\" role=\"alert\" ng-show=\"vm.userMessage\"><strong class=\"instruction-message\">{{ vm.userMessage }}</strong></div>");
$templateCache.put("app/console/vox-console-reminder.html","<div class=\"greeting-container animate\"><div class=\"mb-2\"><strong>REMINDER:</strong> <span class=\"ml-2\">{{vm.customerReminder}}</span></div><div><strong>Greeting:</strong></div><div class=\"font-italic mb-2\">{{vm.customerGreeting}}</div><hr class=\"mb-2\" style=\"height: 1px; color: #DCDCDC; margin: 0\"><div><strong>Closing:</strong></div><div ng-bind-html=\"vm.closing\"></div></div>");
$templateCache.put("app/console/vox-console-status.html","<div class=\"panel panel-default panel-vox panel-status animated fadeIn\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"col-md-5 panel-heading-title-container\"><strong>Status - {{::vm.person.Name}}</strong></div><div class=\"col-md-7\"><vox-console-instruction-message user-id=\"vm.person.Id\"></vox-console-instruction-message></div></div></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-5\"><vox-user-information operator-pools=\"vm.operator.Pools\" interpreter-language-payrates=\"vm.interpreter.LanguagePayrates\" is-customer-monitor=\"vm.isCustomerMonitor\"></vox-user-information></div><div class=\"col-sm-7\"><div class=\"form-group\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"fa fa-flag fa-lg fa-fw\" ng-class=\"{\'blinking alertColor\': vm.person.Status === \'Unavailable\'}\"></i></div><select class=\"form-control\" ng-model=\"vm.person.Status\" ng-change=\"vm.statusChanged()\" ng-disabled=\"vm.statusDisabled()\" style=\"height: 35px;\"><option ng-repeat=\"status in vm.statuses | orderBy:\'id\'\" value=\"{{status.name}}\" ng-if=\"!vm.statusOptionHidden(status.name)\">{{status.name}}</option></select><div class=\"input-group-addon\" style=\"padding: 0px 0px; margin-left: -1px;\"><vox-test-call-button person=\"vm.person\"></vox-test-call-button></div></div></div><div class=\"form-group\"><vox-console-contact-methods person=\"vm.person\" ng-if=\"vm.showContactMethods\"></vox-console-contact-methods></div><div class=\"form-group\" ng-if=\"+vm.person.ContactMethod === vm.enums.ContactMethod.Phone\"><vox-phone-number phone-number=\"vm.person.TempPhoneNumber\" default-number=\"vm.person.PhoneNumber\" phone-error-message=\"vm.phoneErrorMessage\" user-country-name=\"vm.person.Country\" person-status=\"vm.person.Status\" allow-blank-numbers=\"false\" allow-mobile-numbers=\"false\" set-user-status=\"true\" user-id=\"vm.person.Id\" third-party=\"false\"></vox-phone-number><div class=\"vox-interpreter-phone-number-error\"><span>{{vm.phoneErrorMessage}}</span></div></div></div></div><div class=\"row col-sm-7 col-sm-offset-5\"><vox-console-alert person=\"vm.person\" operator=\"vm.operator\" interpreter=\"vm.interpreter\" monitor=\"vm.monitor\"></vox-console-alert></div><div class=\"row col-sm-7 col-sm-offset-5\" ng-if=\"((vm.showDefaultReminderText === \'true\' && vm.interpreterDetails) || (vm.showDefaultOpertorReminderText === \'true\' && vm.operatorDetails)) && vm.customerDetails\"><vox-console-reminder interpreter-details=\"vm.interpreterDetails\" operator-details=\"vm.operatorDetails\" customer-details=\"vm.customerDetails\"></vox-console-reminder></div></div></div>");
$templateCache.put("app/console/vox-user-information.html","<div><p class=\"form-control-static\" ng-if=\"vm.operatorPools\"><strong>Operator Pools</strong> <span ng-repeat=\"pool in ::vm.operatorPools\">{{::pool.Name}}{{$last ? \'\' : \', \'}}</span></p><div ng-hide=\"!vm.interpreterLanguagePayrates || vm.isCustomerMonitor\"><p class=\"form-control-static\"><strong><u>Interpreter Languages</u></strong></p><p class=\"form-control-static\" ng-repeat=\"languagePayrate in ::vm.interpreterLanguagePayrates\"><i class=\"fa fa-language fa-lg fa-fw\"></i>{{::languagePayrate.Language}}</p></div></div>");
$templateCache.put("app/interpreter/vox-interpreter-conference.html","<div class=\"panel panel-default panel-vox animated fadeIn\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"panel-heading-title col-md-6\"><span class=\"fa-stack fa-lg\"><i class=\"fa fa-square-o fa-stack-2x\"></i> <i class=\"fa fa-headphones fa-stack-1x\"></i></span> <strong>Your Conference Details</strong></div><div class=\"panel-heading-actions col-md-6\" ng-if=\"vm.reconnectButton\"><button type=\"button\" class=\"btn btn-priority ng-binding ladda-button\" ng-click=\"vm.reconnectInterpreter(false)\" ng-disabled=\"vm.reconnectButtonDisabled\" data-style=\"expand-right\"><i class=\"fa fa-phone-square fa-lg fa-fw\"></i> Reconnect</button></div></div></div><div class=\"panel-body\"><div class=\"table-responsive\"><table class=\"table\"><tbody><tr ng-show=\"vm.isC2C\"><td><strong>Call Type:</strong></td><td>ClickToCall</td></tr><tr ng-show=\"vm.isHostedIVR\"><td><strong>Call Type:</strong></td><td>Hosted IVR</td></tr><tr><td><strong>Customer Name:</strong></td><td>{{vm.currentCustomer.OrganizationName}}</td></tr><tr><td><strong>Site Name:</strong></td><td>{{vm.currentCustomer.ProfileName}}</td></tr><tr ng-show=\"(vm.roles.indexOf(\'Operator\') >= 0 || vm.roles.indexOf(\'Admin\') >= 0)\"><td><strong>Phone Number:</strong></td><td>{{vm.currentCall.FromPhoneNumber}}</td></tr><tr><td><strong>Language:</strong></td><td>{{vm.currentLanguageName}}</td></tr><tr><td><strong>Reference ID:</strong></td><td>{{vm.currentCall.ReferenceId}}</td></tr><tr ng-show=\"vm.showCallCenterNumber\"><td><strong>Call Center Number:</strong></td><td>{{vm.callCenterPhoneNumber}}</td></tr><tr><td><strong>Call Duration:</strong></td><td><vox-call-duration call-participants=\"vm.currentCall.Participants\" interpreter-id=\"vm.interpreter.Id\" call-id=\"vm.currentCall.CallId\" better-voice-call-id=\"vm.currentCall.BetterVoiceCallId\"></vox-call-duration></td></tr></tbody></table></div><div class=\"row\"><div class=\"col-sm-12 form-control-static\" ng-show=\"vm.roles.indexOf(\'Operator\') >= 0\"><vox-call-events call-events=\"vm.currentCall.Events\" call-connected-time=\"vm.currentCall.CallConnected\"></vox-call-events></div></div><div class=\"col-sm-12 form-control-static\"><vox-participants ng-if=\"vm.currentCall\" current-call=\"vm.currentCall\" interpreter=\"vm.interpreter\" customer=\"vm.currentCustomer\"></vox-participants></div></div></div>");
$templateCache.put("app/interpreter/vox-interpreter.html","<div class=\"vox-interpreter\"><vox-interpreter-conference ng-if=\"vm.showCallDetails\" current-call=\"vm.currentCall\" current-customer=\"vm.currentCustomer\" current-language-name=\"vm.currentLanguageName\" interpreter=\"vm.interpreter\" call-center-phone-number=\"vm.callCenterPhoneNumber\" current-meta-data=\"vm.currentMetaData\"></vox-interpreter-conference></div>");
$templateCache.put("app/layout/vox-top-nav.html","<nav class=\"navbar navbar-fixed-top navbar-inverse animated fadeInDown\" role=\"navigation\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a ng-href=\"/\" class=\"navbar-brand\"><span class=\"brand-title\">Lionbridge Voice Portal</span>&nbsp;<span class=\"h6\">{{vm.version}}</span></a> <span ng-if=\"vm.hasAccessToNewInterpreterVoicePortal && vm.hasRequiredStatusToSwitchNewVoicePortal\"><a href=\"#\" ng-click=\"vm.switchToInterpreterVoicePortal()\" class=\"navbar-text align-text-bottom\"><span class=\"\">Switch to New Voice Portal</span></a></span> <button class=\"navbar-toggle\" ng-init=\"vm.navCollapsed = true\" ng-click=\"vm.navCollapsed = !vm.navCollapsed\"><span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse\" uib-collapse=\"vm.navCollapsed\"><ul class=\"nav navbar-nav navbar-right\"><li><vox-signal-r-status></vox-signal-r-status></li><li ng-if=\"vm.roles.indexOf(\'Admin\') >= 0 || vm.roles.indexOf(\'SuperUser\') >= 0\"><a ng-href=\"admin\"><i class=\"fa fa-gears fa-fw\"></i> Admin</a></li><li><a ng-href=\"\" ng-click=\"vm.reload()\" title=\"Refresh the page\"><i class=\"fa fa-refresh fa-fw refresh-icon\"></i></a></li><li><a ng-href=\"\" ng-click=\"vm.feedback()\" title=\"Give feedback\"><i class=\"fa fa-commenting-o fa-lg fa-fw\"></i></a></li><li class=\"dropdown\" uib-dropdown=\"\"><a href=\"\" class=\"dropdown-toggle\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\" uib-dropdown-toggle=\"\" id=\"vox-user-dropdown\"><i class=\"fa fa-user\"></i> {{vm.user.Name}} <span class=\"caret\"></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" aria-labelledby=\"vox-user-dropdown\"><li><a href=\"\" ng-click=\"vm.signOut()\"><i class=\"fa fa-sign-out fa-fw\"></i> Sign Out</a></li></ul></li></ul></div></div></nav>");
$templateCache.put("app/login/login.html","<div class=\"top-content login animated\" ng-class=\"{fadeInDown: vm.activated}\"><div class=\"inner-bg\"><div class=\"container\"><div class=\"row\"><div class=\"col-sm-8 col-sm-offset-2 text\" ng-if=\"(vm.voicePortalLoginMode != \'AzureEnabled\')\"><h1><strong>Lionbridge Voice</strong> Portal</h1><div class=\"description\"><p></p></div></div></div><div class=\"row\"><div class=\"col-sm-6 col-sm-offset-3 form-box\"><div ng-if=\"vm.oldLoginVisible\"><div class=\"form-top\"><div class=\"form-top-left\"><h3>Login to our site</h3><p>Enter your username and password to log on:</p></div><div class=\"form-top-right\"><i class=\"fa fa-lock\"></i></div></div><div class=\"form-bottom well\"><form name=\"login\" role=\"form\" class=\"login-form\" novalidate=\"\"><div ng-show=\"vm.loginError !== undefined\"><div class=\"alert alert-danger\">Invalid Username or Password. Try again.</div></div><div class=\"form-group\"><label class=\"sr-only\" for=\"form-username\">Username</label> <input type=\"text\" name=\"form-username\" placeholder=\"Username...\" class=\"form-username form-control\" ng-focus=\"vm.loginError = undefined\" ng-model=\"vm.username\" required=\"\"></div><div class=\"form-group\"><label class=\"sr-only\" for=\"form-password\">Password</label> <input type=\"password\" name=\"form-password\" placeholder=\"Password...\" class=\"form-password form-control\" ng-focus=\"vm.loginError = undefined\" ng-model=\"vm.password\" required=\"\"></div><button type=\"submit\" class=\"btn\" ladda=\"vm.loginWaiting\" ng-disabled=\"login.$invalid\" ng-click=\"vm.login()\">Sign in!</button></form></div></div><div class=\"form-bottom well\" ng-if=\"vm.voicePortalLoginMode === \'Dual\'\"><div class=\"form-group\"><div><p>Lionbridge has completed migration to the \"New Login\" mechanism. You are now required to use your new credentials (email and password) to log into the Voice Portal.</p><p>Please contact <a href=\"mailto: GEOFLUENT.SUPPORT@lionbridge.com\">GEOFLUENT.SUPPORT@lionbridge.com</a> with questions.</p><p>If you have issues using your new credentials, click \"Old Login\" and then scroll down. This feature will be deactivated by May 19th, 2021.</p><span style=\"text-align: left;display: inline-block;width: 50%;\"><a style=\"display: inline-block;color: #f68306;text-decoration: none;\" href=\"https://interpretation.lionbridge.com/Help/Index\" target=\"_blank\">Learn More</a></span><a style=\"text-align: right;display: inline-block;width: 50%;text-decoration: none;color: #f68306;\" href=\"javascript:void(0);\" ng-click=\"vm.setOldLoginVisible();\">Old Login</a></div></div><button style=\"width:100%\" type=\"submit\" class=\"btn\" ladda=\"vm.loginWaiting\" ng-click=\"vm.redirectToADB2C()\">New Login</button></div><div ng-if=\"vm.voicePortalLoginMode === \'AzureDisabled\'\"><div class=\"form-top\"><div class=\"form-top-left\"><h3>Login to our site</h3><p>Enter your username and password to log on:</p></div><div class=\"form-top-right\"><i class=\"fa fa-lock\"></i></div></div><div class=\"form-bottom well\"><form name=\"login\" role=\"form\" class=\"login-form\" novalidate=\"\"><div ng-show=\"vm.loginError !== undefined\"><div class=\"alert alert-danger\">Invalid Username or Password. Try again.</div></div><div class=\"form-group\"><label class=\"sr-only\" for=\"form-username\">Username</label> <input type=\"text\" name=\"form-username\" placeholder=\"Username...\" class=\"form-username form-control\" ng-focus=\"vm.loginError = undefined\" ng-model=\"vm.username\" required=\"\"></div><div class=\"form-group\"><label class=\"sr-only\" for=\"form-password\">Password</label> <input type=\"password\" name=\"form-password\" placeholder=\"Password...\" class=\"form-password form-control\" ng-focus=\"vm.loginError = undefined\" ng-model=\"vm.password\" required=\"\"></div><button type=\"submit\" class=\"btn\" ladda=\"vm.loginWaiting\" ng-disabled=\"login.$invalid\" ng-click=\"vm.login()\">Sign in!</button></form></div></div></div></div></div></div><div class=\"footer version-footer\">{{vm.version}}</div></div>");
$templateCache.put("app/operator/vox-interpreters-table.html","<div class=\"panel panel-default panel-vox fadeIn\"><table st-table=\"vm.displayedCollection\" st-safe-src=\"vm.interpreters\" class=\"table smart-table freeze-header\"><thead><tr><th st-sort=\"FirstName\">First Name</th><th st-sort=\"LastName\">Last Name</th><th st-sort=\"Status\">Status</th><th st-sort=\"Languages\">Languages</th><th st-sort=\"PhoneNumber\">Phone #</th><th st-sort=\"Pools\">Pools</th><th st-sort=\"LastLogin\">Last Login</th><th st-sort=\"TimeZone\">Time Zone</th><th st-sort=\"GroupName\">Group Name</th><th ng-if=\"vm.roles.indexOf(\'Operator\') >= 0 || vm.roles.indexOf(\'SuperUser\') >= 0\" st-sort=\"IsLanguageService\">Action</th><th><button class=\"btn fa fa-filter fa-lg pull-right\" ng-click=\"showFilter = !showFilter\" st-reset=\"\"></button></th></tr><tr ng-show=\"showFilter\"><th><input st-search=\"FirstName\" placeholder=\"First Name\" class=\"input-sm form-control\" type=\"search\"></th><th><input st-search=\"LastName\" placeholder=\"Last Name\" class=\"input-sm form-control\" type=\"search\"></th><th><input st-search=\"Status\" placeholder=\"Status\" class=\"input-sm form-control\" type=\"search\"></th><th><input st-search=\"Languages\" placeholder=\"Languages\" class=\"input-sm form-control\" type=\"search\"></th><th><input st-search=\"PhoneNumber\" placeholder=\"Phone #\" class=\"input-sm form-control\" type=\"search\"></th><th><input st-search=\"Pools\" placeholder=\"Pools\" class=\"input-sm form-control\" type=\"search\"></th><th><input st-search=\"LastLoginDisplay\" placeholder=\"Last Login\" class=\"input-sm form-control\" type=\"search\"></th><th><input st-search=\"TimeZone\" placeholder=\"Time Zone\" class=\"input-sm form-control\" type=\"search\"></th><th><input st-search=\"GroupName\" placeholder=\"Group Name\" class=\"input-sm form-control\" type=\"search\"></th><th ng-if=\"vm.roles.indexOf(\'Operator\') >= 0 || vm.roles.indexOf(\'SuperUser\') >= 0\"><input st-search=\"IsLanguageService\" placeholder=\"Action\" class=\"input-sm form-control\" type=\"search\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"interpreter in vm.displayedCollection\"><td>{{interpreter.FirstName}}</td><td>{{interpreter.LastName}}</td><td>{{interpreter.Status}}</td><td>{{interpreter.Languages}}</td><td>{{interpreter.PhoneNumber}}</td><td>{{interpreter.Pools}}</td><td>{{interpreter.LastLoginDisplay}}</td><td>{{interpreter.TimeZone}}</td><td>{{interpreter.GroupName}}</td><td ng-if=\"vm.roles.indexOf(\'Operator\') >= 0 || vm.roles.indexOf(\'SuperUser\') >= 0\"><a class=\"btn\" ng-click=\"vm.interpreterLoginStatusChange(interpreter.Id, interpreter.IsLanguageService)\"><i class=\"fa fa-sign-out\" aria-hidden=\"true\" ng-show=\"interpreter.IsLanguageService == \'Logout\'\">{{interpreter.IsLanguageService}}</i> <i class=\"fa fa-sign-in\" aria-hidden=\"true\" ng-show=\"interpreter.IsLanguageService == \'Login\'\">{{interpreter.IsLanguageService}}</i></a></td><td></td></tr></tbody></table></div>");
$templateCache.put("app/operator/vox-loggedin-interpreters-table.html","<div class=\"panel panel-default panel-vox fadeIn\"><table st-table=\"vm.displayedCollection\" st-safe-src=\"vm.loggedInInterpreters\" class=\"table smart-table freeze-header\"><thead><tr><th st-sort=\"Name\">Name</th><th st-sort=\"Languages\">Languages</th><th st-sort=\"PhoneNumber\">Phone Number</th><th st-sort=\"Pools\">Pools</th><th>Waiting Duration</th><th st-sort=\"TimeZone\">Time Zone</th><th st-sort=\"GroupName\">Group Name</th><th ng-if=\"vm.roles.indexOf(\'Operator\') >= 0 || vm.roles.indexOf(\'SuperUser\') >= 0\" st-sort=\"IsLanguageService\">Action</th><th><button class=\"btn fa fa-filter fa-lg pull-right\" ng-click=\"showFilter = !showFilter\" st-reset=\"\"></button></th></tr><tr ng-show=\"showFilter\"><th><input st-search=\"Name\" placeholder=\"Name\" class=\"input-sm form-control\" type=\"search\"></th><th><input st-search=\"Languages\" placeholder=\"Languages\" class=\"input-sm form-control\" type=\"search\"></th><th><input st-search=\"PhoneNumber\" placeholder=\"PhoneNumber\" class=\"input-sm form-control\" type=\"search\"></th><th><input st-search=\"Pools\" placeholder=\"Pools\" class=\"input-sm form-control\" type=\"search\"></th><th></th><th><input st-search=\"TimeZone\" placeholder=\"TimeZone\" class=\"input-sm form-control\" type=\"search\"></th><th><input st-search=\"GroupName\" placeholder=\"GroupName\" class=\"input-sm form-control\" type=\"search\"></th><th ng-if=\"vm.roles.indexOf(\'Operator\') >= 0 || vm.roles.indexOf(\'SuperUser\') >= 0\"><input st-search=\"IsLanguageService\" placeholder=\"Action\" class=\"input-sm form-control\" type=\"search\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"interpreter in vm.displayedCollection\"><td>{{interpreter.Name}}</td><td>{{interpreter.Languages}}</td><td>{{interpreter.PhoneNumber}}</td><td>{{interpreter.Pools}}</td><td><vox-countup start-date-time=\"interpreter.LastLogin\" alternate-date-time=\"interpreter.LastCallEnded\"></vox-countup></td><td>{{interpreter.TimeZone}}</td><td>{{interpreter.GroupName}}</td><td ng-if=\"vm.roles.indexOf(\'Operator\') >= 0 || vm.roles.indexOf(\'SuperUser\') >= 0\"><a class=\"btn\" ng-click=\"vm.interpreterLoginStatusChange(interpreter.Id, interpreter.IsLanguageService)\"><i class=\"fa fa-sign-out\" aria-hidden=\"true\" ng-show=\"interpreter.IsLanguageService == \'Logout\'\">{{interpreter.IsLanguageService}}</i> <i class=\"fa fa-sign-in\" aria-hidden=\"true\" ng-show=\"interpreter.IsLanguageService == \'Login\'\">{{interpreter.IsLanguageService}}</i></a></td><th></th></tr></tbody></table></div>");
$templateCache.put("app/operator/vox-operator.html","<div class=\"vox-operator\"><div class=\"row\" ng-if=\"vm.showCallDetails\"><div class=\"col-md-6\" ng-if=\"!vm.currentCase.RelayLanguageId\"><div class=\"panel panel-default panel-vox\" ng-if=\"vm.showCallDetails\"><div class=\"panel-heading\" ng-if=\"vm.showCallDetails\"><h4>Call From: {{vm.currentCustomer.Name}} - {{vm.currentCustomer.ProfileName}} ({{vm.currentCall.FromPhoneNumber}})</h4><br><p>Reference Id: {{vm.currentCall.ReferenceId}}</p><p>Call Duration:<vox-call-duration call-participants=\"vm.currentCall.Participants\" operator-id=\"vm.operator.Id\"></vox-call-duration></p></div><div class=\"panel-body\"><vox-reconnect-interpreter call-id=\"vm.currentCall.CallId\" call-events=\"vm.currentCall.Events\" interpreters=\"vm.interpreters\" call-participants=\"vm.currentCall.Participants\" language-id=\"vm.currentCall.LanguageId\"></vox-reconnect-interpreter><table class=\"table\" ng-show=\"vm.logButtonShowEvent(\'ConnectButtonVisible\')\"><tr ng-repeat=\"language in vm.currentLanguages\"><td><div class=\"language-container\"><p class=\"form-control-static\">{{language.Name}}</p></div><div class=\"vox-connect-interpreter\"><vox-connect-interpreter call-id=\"vm.currentCall.CallId\" language-id=\"language.Id\" language-service=\"vm.currentCustomer.LanguageService\" customer-id=\"vm.currentCall.CustomerId\" call-participants=\"vm.currentCall.Participants\" call-language=\"vm.currentCallLanguage\" interpreter-pool-id=\"vm.currentCustomer.InterpreterPoolId\" secondary-interpreter-pool-id=\"vm.currentCustomer.SecondaryInterpreterPoolId\" third-interpreter-pool-id=\"vm.currentCustomer.ThirdInterpreterPoolId\" fourth-interpreter-pool-id=\"vm.currentCustomer.FourthInterpreterPoolId\" disable-all-language-select=\"vm.disableAllLanguageSelect\" case=\"vm.currentCase\" filter-overflow=\"vm.filterOverflowVendorsBasedOnLanguage\"></vox-connect-interpreter></div></td></tr><tr><td><div class=\"language-container\">Select Language:<select class=\"form-control\" data-ng-model=\"vm.selectedLanguage\" data-ng-options=\"language.key as language.value for language in vm.languageList | orderBy:\'value\'\" style=\"width:auto;display:inline-block\"></select></div><div class=\"vox-connect-interpreter\"><vox-connect-interpreter call-id=\"vm.currentCall.CallId\" language-id=\"vm.selectedLanguage\" language-service=\"vm.currentCustomer.LanguageService\" customer-id=\"vm.currentCall.CustomerId\" call-participants=\"vm.currentCall.Participants\" call-language=\"vm.currentCallLanguage\" current-languages=\"vm.currentLanguages\" interpreter-pool-id=\"vm.currentCustomer.InterpreterPoolId\" secondary-interpreter-pool-id=\"vm.currentCustomer.SecondaryInterpreterPoolId\" third-interpreter-pool-id=\"vm.currentCustomer.ThirdInterpreterPoolId\" fourth-interpreter-pool-id=\"vm.currentCustomer.FourthInterpreterPoolId\" disable-all-language-select=\"vm.disableAllLanguageSelect\" case=\"vm.currentCase\" disable-if-not-selected=\"!vm.selectedLanguage || vm.selectedLanguage.length == 0\" filter-overflow=\"false\"></vox-connect-interpreter></div></td></tr></table></div></div></div><div class=\"col-md-6\"><vox-case ng-if=\"vm.currentCase\" current-call=\"vm.currentCall\" current-case=\"vm.currentCase\" interpreters=\"vm.interpreters\" operator=\"vm.operator\" customer=\"vm.currentCustomer\" language-service=\"vm.currentCustomer.LanguageService\"></vox-case><div class=\"panel panel-default panel-vox\"><div class=\"panel-heading\"><strong>Call Events</strong></div><div class=\"panel-body\"><vox-call-events call-events=\"vm.currentCall.Events\" call-connected-time=\"vm.currentCall.CallConnected\"></vox-call-events></div></div><div class=\"panel panel-default panel-vox\" ng-show=\"vm.showThirdParty\"><vox-participants ng-if=\"vm.currentCall\" current-call=\"vm.currentCall\" operator=\"vm.operator\" customer=\"vm.currentCustomer\"></vox-participants></div></div></div><div class=\"row\" ng-if=\"vm.callType === \'Operator\'\"><div class=\"col-md-12\"><ul class=\"nav nav-tabs\"><li ng-click=\"vm.changeActiveTable(\'loggedInInterpreters\')\" ng-class=\"{\'active\': vm.activeTable === \'loggedInInterpreters\'}\"><a>Logged In Interpreters <span class=\"badge\">{{vm.loggedInInterpreterCount}}{{vm.loggedInInterpreterCount != vm.loggedInInterpreters.length ? \'/\'+ vm.loggedInInterpreters.length : \'\' }}</span></a></li><li ng-click=\"vm.changeActiveTable(\'allInterpreters\')\" ng-class=\"{\'active\': vm.activeTable === \'allInterpreters\'}\"><a>All Interpreters <span class=\"badge\">{{vm.interpreterCount}}{{vm.interpreterCount != vm.interpreters.length ? \'/\'+ vm.interpreters.length : \'\' }}</span></a></li><li ng-click=\"vm.changeActiveTable(\'allOperators\')\" ng-class=\"{\'active\': vm.activeTable === \'allOperators\'}\"><a>All Operators <span class=\"badge\">{{vm.operatorCount}}{{vm.operatorCount != vm.operators.length ? \'/\'+ vm.operators.length : \'\' }}</span></a></li></ul><div class=\"tab-content\"><vox-loggedin-interpreters-table class=\"tab-pane\" ng-class=\"{\'active\': vm.activeTable === \'loggedInInterpreters\'}\" logged-in-interpreters=\"vm.loggedInInterpreters\" logged-in-interpreter-count=\"vm.loggedInInterpreterCount\"></vox-loggedin-interpreters-table><vox-interpreters-table class=\"tab-pane\" ng-class=\"{\'active\': vm.activeTable === \'allInterpreters\'}\" interpreters=\"vm.interpreters\" interpreter-count=\"vm.interpreterCount\"></vox-interpreters-table><vox-operators-table class=\"tab-pane\" ng-class=\"{\'active\': vm.activeTable === \'allOperators\'}\" operators=\"vm.operators\" operator-count=\"vm.operatorCount\"></vox-operators-table></div></div></div></div>");
$templateCache.put("app/operator/vox-operators-table.html","<div class=\"panel panel-default panel-vox fadeIn\"><table st-table=\"vm.displayedCollection\" st-safe-src=\"vm.operators\" class=\"table smart-table freeze-header\"><thead><tr><th st-sort=\"FirstName\">First Name</th><th st-sort=\"LastName\">Last Name</th><th st-sort=\"Status\">Status</th><th st-sort=\"PhoneNumber\">Phone #</th><th st-sort=\"Pools\">Pools</th><th><button class=\"btn fa fa-filter fa-lg pull-right\" ng-click=\"showFilter = !showFilter\" st-reset=\"\"></button></th></tr><tr ng-show=\"showFilter\"><th><input st-search=\"FirstName\" placeholder=\"First Name\" class=\"input-sm form-control\" type=\"search\"></th><th><input st-search=\"LastName\" placeholder=\"Last Name\" class=\"input-sm form-control\" type=\"search\"></th><th><input st-search=\"Status\" placeholder=\"Status\" class=\"input-sm form-control\" type=\"search\"></th><th><input st-search=\"PhoneNumber\" placeholder=\"Phone #\" class=\"input-sm form-control\" type=\"search\"></th><th><input st-search=\"Pools\" placeholder=\"Pools\" class=\"input-sm form-control\" type=\"search\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"operator in vm.displayedCollection\"><td>{{operator.FirstName}}</td><td>{{operator.LastName}}</td><td>{{operator.Status}}</td><td>{{operator.PhoneNumber}}</td><td>{{operator.Pools}}</td><td></td></tr></tbody></table></div>");
$templateCache.put("app/operator/vox-reconnect-interpreter.html","<div ng-show=\"vm.callId && vm.interpreterId\" style=\"font-size: 15px;\"><span class=\"label label-default\">{{vm.disconnectMessage}}</span><div style=\"float:right;\"><span class=\"btn btn-danger\" ng-show=\"vm.isInterpreterUnavailable\">Interpreter is not available.</span> <button class=\"btn btn-default\" ng-click=\"vm.callInterpreter()\" ng-disabled=\"vm.callInterpreterDisabled\" title=\"Put the customer on hold and call the interpreter\" ladda=\"vm.connectingInterpreter\" data-style=\"expand-right\" data-spinner-color=\"#000000\"><i class=\"fa fa-phone fa-lg fa-fw\"></i> Call Interpreter</button> <button class=\"btn btn-default\" ng-click=\"vm.connectInterpreter()\" ng-disabled=\"vm.isReconnectInterpreterDisabled\" title=\"Reconnect the interpreter with the customer\"><i class=\"fa fa-phone-square fa-lg fa-fw\"></i> Reconnect Interpreter</button></div></div>");
$templateCache.put("app/operator/vox-reconnect-specific-interpreter.html","<div ng-show=\"vm.callId && vm.interpreterId\" style=\"font-size: 15px;\"><div><button class=\"btn btn-default\" ng-click=\"vm.callInterpreter()\" ng-disabled=\"vm.callDisabled\" ng-attr-title=\"{{vm.callTitle}}\" ladda=\"vm.callingInterpreter\" data-style=\"expand-right\" data-spinner-color=\"#000000\"><i class=\"fa fa-phone fa-lg fa-fw\"></i> Call {{vm.interpreterName}}</button> <span class=\"btn btn-danger\" ng-show=\"vm.interpreterUnavailable\">{{vm.interpreterName}} is not available.</span> <button class=\"btn btn-default\" ng-click=\"vm.connectInterpreter()\" ng-disabled=\"vm.connectDisabled\" ng-attr-title=\"{{vm.connectTitle}}\" ladda=\"vm.connectingInterpreter\" data-style=\"expand-right\" data-spinner-color=\"#000000\"><i class=\"fa fa-phone-square fa-lg fa-fw\"></i> Connect {{vm.interpreterName}}</button> <span class=\"btn btn-danger\" ng-show=\"vm.cantConnectInterpreter\">Can\'t connect {{vm.interpreterName}}.</span></div></div>");
$templateCache.put("app/operator/vox-scheduled-relay-interpretation.html","<div class=\"panel panel-default panel-vox\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"panel-heading-title col-md-5\"><span class=\"fa-stack fa-lg\"><i class=\"fa fa-square-o fa-stack-2x\"></i> <i class=\"fa fa-clock-o fa-stack-1x\"></i></span> <strong>Scheduled Relay Interpretation Call</strong></div><div class=\"panel-heading-actions col-md-7\"><button class=\"btn btn-priority ladda-button\" ng-if=\"!vm.isRareLanguageInterpreterConnected\" type=\"button\" ng-disabled=\"vm.areControlsDisabled()\" ladda=\"vm.connectingRareLanguageInterpreter\" data-style=\"expand-right\" data-spinner-color=\"#000000\" title=\"Put the customer on hold and call the interpreter\" ng-click=\"vm.connectRareLanguageInterpreter()\"><span class=\"ladda-label\">Connect Rare Language Interpreter</span></button><div class=\"btn-group\" ng-if=\"vm.isRareLanguageInterpreterConnected && !vm.isRelayInterpreterConnected && vm.relayInterpreterConnectFailed && vm.logButtonShowEvent(\'LSButtonVisible\')\" data-style=\"expand-right\" uib-dropdown=\"\"><button id=\"split-button\" type=\"button\" class=\"btn btn-default\" ng-disabled=\"vm.areControlsDisabled()\" ng-click=\"vm.callLanguageService(vm.LanguageSelect)\">{{vm.LanguageSelect.Name}}</button> <button type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span></button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"split-button\"><li role=\"menuitem\" ng-click=\"vm.changeLanguageServiceSelection({ GroupId: 0, Name: \'Language Service\' })\"><a href=\"#\">Language Service</a></li><li role=\"menuitem\" ng-repeat=\"languageService in vm.languageService | unique: \'Name\'\" ng-click=\"vm.changeLanguageServiceSelection(languageService)\"><a href=\"#\">{{languageService.Name}}</a></li></ul></div><button class=\"btn btn-priority ladda-button\" ng-if=\"vm.isRareLanguageInterpreterConnected && !vm.isRelayInterpreterConnected && !vm.languageServiceIsTimeouted\" type=\"button\" ng-disabled=\"vm.areControlsDisabled() || vm.isConnectRelayInterpreterButtonDisabled()\" ladda=\"vm.connectingRelayInterpreter\" data-style=\"expand-right\" title=\"Call the interpreter\" ng-click=\"vm.connectRelayInterpreter()\"><span class=\"ladda-label\">Connect Relay Interpreter</span></button> <button class=\"btn btn-priority ladda-button\" ng-if=\"vm.isRareLanguageInterpreterConnected && vm.isRelayInterpreterConnected && !vm.arePartiesConnected\" type=\"button\" ng-disabled=\"vm.areControlsDisabled()\" ladda=\"vm.connectingParties\" data-style=\"expand-right\" title=\"Connect all 3 parties\" ng-click=\"vm.conferenceAllParties()\"><span class=\"ladda-label\">Conference All Parties</span></button></div></div></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-2\">COI Number</div><div class=\"col-md-3\">{{vm.caseDisplay.Id}}</div></div><div class=\"row\"><div class=\"col-md-2\">Scheduled Start</div><div class=\"col-md-4\">{{vm.caseDisplay.ScheduledStartTime | date:\'medium\'}}</div></div><div class=\"row row-call-id\"><div class=\"col-md-2\">Call Id</div><div class=\"col-md-4\">{{vm.currentCall.CallId | limitTo : 8}}</div></div><div class=\"row row-call-duration\"><div class=\"col-md-2\">Call Duration:</div><div class=\"col-md-4\"><vox-call-duration call-participants=\"vm.currentCall.Participants\" operator-id=\"vm.operator.Id\"></vox-call-duration></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive over-flow-auto-false\"><table class=\"table\"><thead><th>Name</th><th>Role</th><th>Language</th><th>Number</th><th>Status</th><th></th></thead><tbody><tr><td>{{ vm.operator.Name }}</td><td>Operator</td><td></td><td>{{ vm.operator.TempPhoneNumber || vm.operator.PhoneNumber }}</td><td>Connected</td></tr><tr></tr><tr><td>{{ vm.customer.Name }}</td><td>Customer</td><td>{{ vm.caseDisplay.LanguageName }}</td><td>{{ vm.customer.PhoneNumber }}</td><td>{{ vm.isCustomerOnHold ? \'OnHold\' : \'Connected\' }}</td><td><div><button class=\"btn btn-default ladda-button\" ng-click=\"vm.switchParticipant(!vm.isCustomerOnHold, true, true)\" ng-disabled=\"vm.areControlsDisabled()\">{{ vm.isCustomerOnHold ? \'unmute\' : \'mute\' }}</button></div></td></tr><tr><td>{{ vm.caseDisplay.InterpreterName }}</td><td>Interpreter</td><td>{{ vm.caseDisplay.LanguageName }}/{{ vm.caseDisplay.RelayLanguageName }}</td><td>{{ vm.getRareInterpreterPhone() }}</td><td>{{ vm.isRareLanguageInterpreterConnected ? (vm.isRareLanguageInterpreterOnHold ? \'OnHold\' : \'Connected\' ) : \'Not Connected\' }}</td><td><div ng-if=\"vm.isRareLanguageInterpreterConnected\"><button class=\"btn btn-default ladda-button\" ng-click=\"vm.switchParticipant(true, !vm.isRareLanguageInterpreterOnHold, true)\" ng-disabled=\"vm.areControlsDisabled()\">{{ vm.isRareLanguageInterpreterOnHold ? \'unmute\' : \'mute\' }}</button></div></td></tr><tr><td>Relay Interpreter</td><td>Relay Interpreter</td><td>{{ vm.caseDisplay.RelayLanguageName }}/English</td><td>{{ vm.relayInterpreterPhoneNumber }}</td><td>{{ vm.isRelayInterpreterConnected ? (vm.isRelayInterpreterOnHold ? \'OnHold\' : \'Connected\' ) : \'Not Connected\' }}</td><td><div ng-if=\"vm.isRelayInterpreterConnected\"><button class=\"btn btn-default ladda-button\" ng-click=\"vm.switchParticipant(true, true, !vm.isRelayInterpreterOnHold)\" ng-disabled=\"vm.areControlsDisabled()\">{{ vm.isRelayInterpreterOnHold ? \'unmute\' : \'mute\' }}</button></div></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/widgets/modal-call.html","<div class=\"modal-header\"><h3 class=\"modal-title\" ng-if=\"vm.interpreterid\">Incoming Interpretation Call</h3><h3 class=\"modal-title\" ng-if=\"vm.operatorid\">Incoming Operator Call</h3></div><div class=\"modal-body\"><div ng-if=\"!vm.callRejectedMessage\"><p>Customer: <span>{{vm.organizationName}}</span></p><p ng-show=\"(vm.roles.indexOf(\'Operator\') >= 0 || vm.roles.indexOf(\'Admin\') >= 0)\">From: <span>{{vm.from}}</span></p><p ng-if=\"vm.language\">Language: <span>{{vm.language}}</span></p><p ng-show=\"(vm.roles.indexOf(\'Operator\') >= 0 || vm.roles.indexOf(\'Admin\') >= 0) && vm.scheduledCase\">Scheduled Interpretation Call</p></div><p>{{vm.callRejectedMessage}}</p></div><div class=\"modal-footer\"><vox-countdown seconds=\"vm.responseTimeout\" started=\"vm.timerStarted\" class=\"pull-left\"></vox-countdown><div ng-if=\"!vm.callRejectedMessage\"><button type=\"button\" class=\"btn btn-default\" ladda=\"vm.waitingForResponse\" ng-click=\"vm.reject(\'Reject\')\">Reject</button> <button type=\"button\" class=\"btn btn-primary\" ladda=\"vm.waitingForResponse\" id=\"accept\" ng-click=\"vm.accept()\">Accept</button></div><button ng-if=\"vm.callRejectedMessage\" type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.close()\">Close</button></div>");
$templateCache.put("app/widgets/modal-feedback.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Submit Feedback</h3></div><form name=\"feedbackForm\" data-toggle=\"validator\" role=\"form\" ng-submit=\"vm.submitFeedback()\"><div class=\"modal-body form-group\"><p><select class=\"form-control\" ng-model=\"vm.feedbackType\" required=\"\" ng-options=\"item.name for item in vm.feedbackTypes | orderBy:\'id\' track by item.id\"><option value=\"\" hidden=\"\" disabled=\"\">Please select an issue type...</option></select></p><p><textarea placeholder=\"Please enter a description\" class=\"form-control\" ng-model=\"vm.feedbackDescription\" required=\"\"></textarea></p></div><div class=\"modal-footer form-group\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"feedbackForm.$invalid || vm.submitting\">Submit</button> <button type=\"button\" class=\"btn\" ng-click=\"vm.cancel()\">Cancel</button></div></form>");
$templateCache.put("app/widgets/modal-new-call-operators-portal.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Voice Portal Redirection</h3></div><div class=\"modal-body form-group\" style=\"text-align: center\"><p><span>Please use the most recent version of the Call Operators Voice Portal website. <a ng-href=\"{{vm.callOperatorsVoicePortalFrontEndUrl}}\"><strong>Click here</strong></a> to open or you will be automatically redirected in a few seconds.</span></p><p><span>If you want to enter the legacy version of the Voice Portal website <a href=\"#\" ng-click=\"vm.stayInOldVoicePortal()\"><strong>click here</strong></a></span></p></div>");
$templateCache.put("app/widgets/modal-new-interpreter-portal.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Voice Portal Redirection</h3></div><div class=\"modal-body form-group\" style=\"text-align: center\"><p><span>Please use the most recent version of the Voice Portal website. <a ng-href=\"{{vm.interpreterVoicePortalFrontEndUrl}}\"><strong>Click here</strong></a> to open or you will be automatically redirected in a few seconds.</span></p><p><span ng-if=\"vm.hasRequiredStatusToStayInOldVoicePortal\">If you want to enter the legacy version of the Voice Portal website <a href=\"#\" ng-click=\"vm.stayInOldVoicePortal()\"><strong>click here</strong></a></span></p></div>");
$templateCache.put("app/widgets/vox-alert.html","<div ng-class=\"vm.alertType\" role=\"alert\" key-capture=\"\"><div ng-if=\"!vm.alertMessage\"><button type=\"button\" class=\"btn btn-primary\" accesskey=\"a\" ng-click=\"vm.alertResponse(\'Accept\', false)\" ladda=\"vm.waitingForAcceptResponse\" ng-disabled=\"vm.waitingForRejectResponse\">Accept</button> <button type=\"button\" class=\"btn btn-default\" accesskey=\"r\" ng-click=\"vm.alertResponse(\'Reject\', false)\" ladda=\"vm.waitingForRejectResponse\" ng-disabled=\"vm.waitingForAcceptResponse\">Reject</button></div></div>");
$templateCache.put("app/widgets/vox-case.html","<div ng-if=\"!vm.currentCase.RelayLanguageId\" class=\"panel panel-default panel-vox\"><div class=\"panel-heading\"><span class=\"fa-stack fa-lg\"><i class=\"fa fa-square-o fa-stack-2x\"></i> <i class=\"fa fa-clock-o fa-stack-1x\"></i></span> <strong>Scheduled Interpretation Call</strong></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-2\">COI Number</div><div class=\"col-md-3\">{{vm.caseDisplay.Id}}</div></div><div class=\"row\"><div class=\"col-md-2\">Scheduled Start</div><div class=\"col-md-4\">{{vm.caseDisplay.ScheduledStartTime | date:\'medium\'}}</div></div><div class=\"row\"><div class=\"col-md-2\">Language</div><div class=\"col-md-3\">{{vm.caseDisplay.LanguageName}}</div></div><div class=\"row\"><div class=\"col-md-2\">Interpreter</div><div class=\"col-md-3\">{{vm.caseDisplay.InterpreterName}}</div></div></div><div class=\"panel-footer\"><div class=\"row\"><div class=\"col-md-12\"><vox-reconnect-specific-interpreter call-id=\"vm.currentCall.CallId\" call-participants=\"vm.currentCall.Participants\" interpreter-name=\"vm.caseDisplay.InterpreterName\" interpreter-id=\"vm.currentCase.InterpreterId\"></vox-reconnect-specific-interpreter></div></div></div></div><div ng-if=\"vm.currentCase.RelayLanguageId\"><vox-scheduled-relay-interpretation current-call=\"vm.currentCall\" current-case=\"vm.currentCase\" case-display=\"vm.caseDisplay\" operator=\"vm.operator\" customer=\"vm.customer\" interpreters=\"vm.interpreters\" language-service=\"vm.customer.LanguageService\"></vox-scheduled-relay-interpretation></div>");
$templateCache.put("app/widgets/vox-connect-interpreter.html","<div><div class=\"row\"><div class=\"col-md-12\"><div style=\"float:right;\"><button type=\"button\" class=\"btn btn-default\" ng-show=\"vm.inCall && vm.logButtonShowEvent(\'ConnectMeButtonVisible\')\" ng-click=\"vm.connectMe()\" ladda=\"vm.connectingMe\" data-style=\"expand-right\" data-spinner-color=\"#000000\"><i class=\"fa fa-arrow-left fa-lg fa-fw\"></i> Connect Me</button> <button type=\"button\" class=\"btn btn-default\" ng-show=\"vm.inCall && !vm.connectInterpreterDisabled && vm.logButtonShowEvent(\'ConnectInterpreterButtonVisible\')\" ng-click=\"vm.connectInterpreter()\" ladda=\"vm.connectingInterpreter\" data-style=\"expand-right\" data-spinner-color=\"#000000\"><i class=\"fa fa-user-plus fa-lg fa-fw\"></i> Connect Interpreter</button><div class=\"btn-group\" ng-if=\"vm.showLanguageSelectForScheduled && vm.showLanguageSelect && vm.logButtonShowEvent(\'LSButtonVisible\')\" data-style=\"expand-right\" uib-dropdown=\"\" style=\"padding-right:3px\"><button id=\"split-button\" type=\"button\" class=\"btn btn-default\" ng-click=\"vm.callLanguageSelect(vm.LanguageSelect)\" ng-disabled=\"vm.disableLanguageSelect\" ladda=\"vm.callingLanguageSelect\" data-style=\"expand-right\" data-spinner-color=\"#000000\"><i class=\"fa fa-users fa-lg fa-fw\"></i> {{vm.LanguageSelect.Name}}</button> <button type=\"button\" class=\"btn btn-default\" ng-disabled=\"vm.disableLanguageSelect || vm.disableIfNotSelected\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span></button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"split-button\" ng-disabled=\"vm.disableLanguageSelect\"><li role=\"menuitem\" ng-click=\"vm.changeLanguageServiceSelection({ GroupId: 0, Name: \'Language Service\' })\"><a href=\"#\">Language Service</a></li><li role=\"menuitem\" ng-repeat=\"languageService in vm.languageServiceList | unique: \'Name\' | orderBy: \'Name\'\" ng-click=\"vm.changeLanguageServiceSelection(languageService)\"><a href=\"#\">{{languageService.Name}}</a></li></ul></div><div class=\"btn-group\" ng-disabled=\"vm.showNoInterpsFoundError || vm.inCall || vm.findingInterpreter || vm.disableAllConnect || vm.disableIfNotSelected\" data-style=\"expand-right\" uib-dropdown=\"\" style=\"padding-right:3px\"><button id=\"split-button\" type=\"button\" class=\"btn btn-default\" ng-disabled=\"vm.showNoInterpsFoundError || vm.inCall || vm.findingInterpreter || vm.disableAllConnect || vm.disableIfNotSelected\" ng-click=\"vm.findInterpreter(vm.genderSelect)\" data-style=\"expand-right\" data-spinner-color=\"#000000\"><i class=\"fa fa-phone-square fa-lg fa-fw\"></i> {{vm.genderSelect.Name}}</button> <button type=\"button\" class=\"btn btn-default\" ng-disabled=\"vm.showNoInterpsFoundError || vm.inCall || vm.findingInterpreter || vm.disableAllConnect || vm.disableIfNotSelected\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span></button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"split-button\"><li role=\"menuitem\" ng-repeat=\"gender in vm.genderOptions\" ng-click=\"vm.changeGenderInterpreterSelection(gender)\"><a href=\"#\">{{gender.Name}}</a></li></ul></div><button type=\"button\" class=\"btn btn-default\" ng-hide=\"vm.interpreterStatisticsShown\" ng-click=\"vm.showInterpreterStatistics()\" ng-disabled=\"vm.disableIfNotSelected\"><i class=\"fa fa-chevron-down fa-fw\"></i></button> <button type=\"button\" class=\"btn btn-default\" ng-show=\"vm.interpreterStatisticsShown\" ng-click=\"vm.loadStatistics()\" ng-disabled=\"vm.statisticsLoading || vm.disableIfNotSelected\"><i class=\"fa fa-refresh fa-fw\"></i></button><div ng-show=\"!vm.hasInterpreters && vm.showNoInterpsFoundError\" class=\"alert alert-danger vox-no-interpreter\" role=\"alert\" style=\"margin-right:3px\"><button type=\"button\" class=\"close\" ng-click=\"vm.close()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> <strong>No interpreters available!</strong></div><div ng-show=\"vm.showErrorMessage\" class=\"alert alert-danger vox-no-interpreter\" role=\"alert\" style=\"margin-right:3px\"><button type=\"button\" class=\"close\" ng-click=\"vm.close()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> <strong>{{vm.errorMessage}}</strong></div></div></div></div><div class=\"row\" ng-if=\"vm.interpreterStatisticsShown\"><div class=\"col-md-12\"><div class=\"interpreters-statistic-container\"><div ng-if=\"vm.statistics && !vm.statisticsLoading\"><ul class=\"nav nav-pills interpreters-statistic\"><li class=\"status-statistic\"><span>Available Portal:</span><span class=\"status-statistic-value\">{{ vm.statistics.AvailablePortal }}</span></li><li class=\"status-statistic\"><span>Available Phone:</span><span class=\"status-statistic-value\">{{ vm.statistics.AvailablePhone }}</span></li><li class=\"status-statistic\"><span>Offline:</span><span class=\"status-statistic-value\">{{ vm.statistics.Offline }}</span></li><li class=\"status-statistic\"><span>In Call:</span><span class=\"status-statistic-value\">{{ vm.statistics.InCall }}</span></li><li class=\"status-statistic\"><span>Connecting:</span><span class=\"status-statistic-value\">{{ vm.statistics.Connecting }}</span></li><li class=\"status-statistic\"><span>Away:</span><span class=\"status-statistic-value\">{{ vm.statistics.Away }}</span></li><li class=\"status-statistic\"><span>Unavailable:</span><span class=\"status-statistic-value\">{{ vm.statistics.Unavailable }}</span></li><li class=\"status-statistic\"><span>Off-hours:</span><span class=\"status-statistic-value\">{{ vm.statistics.OffHours }}</span></li><li class=\"status-statistic\"><span>Total:</span><span class=\"status-statistic-value\">{{ vm.statistics.Total }}</span></li></ul></div><div ng-if=\"vm.statisticsLoading\" class=\"loader-container\"><i class=\"fa fa-refresh fa-fw fa-spin\"></i></div></div></div></div></div>");
$templateCache.put("app/widgets/vox-console-contact-methods.html","<div><div class=\"form-group\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"fa fa-lg fa-fw\" ng-class=\"vm.selectedContactMethod.faClass\"></i></div><select class=\"form-control\" ng-model=\"vm.selectedContactMethod\" ng-change=\"vm.contactMethodChanged()\" ng-options=\"contactMethod.name for contactMethod in vm.contactMethods | orderBy:id track by contactMethod.id\" ng-disabled=\"vm.contactMethodSelectDisabled()\"></select><div class=\"input-group-addon\" ng-show=\"vm.person.ContactMethod == vm.enums.ContactMethod.WebRTC\"><vox-web-rtc-connection-quality></vox-web-rtc-connection-quality></div></div></div></div>");
$templateCache.put("app/widgets/vox-console-webrtc-dialpad-min.html","<div><div class=\"dialpad-minimized-left\"><span class=\"m-active-phone-icon\"><i class=\"fas fa-phone-volume\"></i></span> <span class=\"\">{{vm.enteredDigits}}</span></div><div class=\"dialpad-minimized-right\"><button class=\"btn btn-default m-end-call-btn mr-1\" type=\"button\" ng-click=\"vm.muted = !vm.muted; vm.muteUnmute(vm.muted);\" title=\"Toggle Mute\"><span class=\"m-mute-icon\" ng-class=\"{ \'active\': vm.muted }\"><i class=\"fas fa-microphone-slash\"></i></span></button> <button class=\"btn btn-default m-end-call-btn mr-2\" type=\"button\" title=\"End Call\" ng-click=\"vm.hangUp()\"><span class=\"m-end-call-icon\"><i class=\"fas fa-phone fa-flip-horizontal\"></i></span> <span class=\"m-end-call-letters\">End Call</span></button> <span class=\"m-expand-icon\" title=\"Maximize\" ng-click=\"vm.maximize()\"><i class=\"fas fa-expand\"></i></span></div></div>");
$templateCache.put("app/widgets/vox-console-webrtc-dialpad.html","<div><div class=\"dialpad-outer-container\"><div class=\"dialpad-container-options\"></div><div class=\"dialpad-container\"><div class=\"\"><input class=\"form-control form-control-lg input-digits\" type=\"tel\" ng-model=\"vm.enteredDigits\"></div><div class=\"digit-row\"><button class=\"btn btn-default digit-button\" type=\"button\" ng-click=\"vm.sendDigit(\'1\')\"><div class=\"digit-char\">1</div><div>&nbsp;</div></button> <button class=\"btn btn-default digit-button\" type=\"button\" ng-click=\"vm.sendDigit(\'2\')\"><div class=\"digit-char\">2</div><div class=\"digit-letters\">ABC</div></button> <button class=\"btn btn-default digit-button\" type=\"button\" ng-click=\"vm.sendDigit(\'3\')\"><div class=\"digit-char\">3</div><div class=\"digit-letters\">DEF</div></button></div><div class=\"digit-row\"><button class=\"btn btn-default digit-button\" type=\"button\" ng-click=\"vm.sendDigit(\'4\')\"><div class=\"digit-char\">4</div><div class=\"digit-letters\">GHI</div></button> <button class=\"btn btn-default digit-button\" type=\"button\" ng-click=\"vm.sendDigit(\'5\')\"><div class=\"digit-char\">5</div><div class=\"digit-letters\">JKL</div></button> <button class=\"btn btn-default digit-button\" type=\"button\" ng-click=\"vm.sendDigit(\'6\')\"><div class=\"digit-char\">6</div><div class=\"digit-letters\">MNO</div></button></div><div class=\"digit-row\"><button class=\"btn btn-default digit-button\" type=\"button\" ng-click=\"vm.sendDigit(\'7\')\"><div class=\"digit-char\">7</div><div class=\"digit-letters\">PQRS</div></button> <button class=\"btn btn-default digit-button\" type=\"button\" ng-click=\"vm.sendDigit(\'8\')\"><div class=\"digit-char\">8</div><div class=\"digit-letters\">TUV</div></button> <button class=\"btn btn-default digit-button\" type=\"button\" ng-click=\"vm.sendDigit(\'9\')\"><div class=\"digit-char\">9</div><div class=\"digit-letters\">WXYZ</div></button></div><div class=\"digit-row\"><button class=\"btn btn-default digit-button\" type=\"button\" ng-click=\"vm.sendDigit(\'*\')\"><div class=\"digit-char-asterisk\"><i class=\"fas fa-asterisk\"></i></div></button> <button class=\"btn btn-default digit-button\" type=\"button\" ng-click=\"vm.sendDigit(\'0\')\"><div class=\"digit-char\">0</div></button> <button class=\"btn btn-default digit-button\" type=\"button\" ng-click=\"vm.sendDigit(\'#\')\"><div class=\"digit-char\">#</div></button></div><div class=\"other-buttons-row\"><button class=\"btn btn-default dialpad-button\" type=\"button\" ng-click=\"vm.muted = !vm.muted; vm.muteUnmute(vm.muted);\"><div class=\"dialpad-button-icon icon-mute\" ng-class=\"{ \'active\': vm.muted }\"><i class=\"fas fa-microphone-slash\"></i></div><div class=\"dialpad-button-letters\" ng-class=\"{ \'active\': vm.muted }\">Mute</div></button> <button class=\"btn btn-default dialpad-button\" type=\"button\" ng-click=\"vm.hangUp()\"><div class=\"dialpad-button-icon icon-end-call\"><i class=\"fas fa-phone fa-flip-horizontal\"></i></div><div class=\"dialpad-button-letters\">End Call</div></button> <button class=\"btn btn-default dialpad-button\" type=\"button\" ng-click=\"vm.minimize()\"><div class=\"dialpad-button-icon\"><i class=\"fas fa-compress\"></i></div><div class=\"dialpad-button-letters\">Minimize</div></button></div></div></div></div>");
$templateCache.put("app/widgets/vox-countdown.html","<progress-arc class=\"vox-countdown\" size=\"20\" stroke-width=\"5\" complete=\"vm.progress\"></progress-arc>");
$templateCache.put("app/widgets/vox-countup.html","<span>{{vm.timeDisplay}}</span>");
$templateCache.put("app/widgets/vox-disposition-menu.html","<div class=\"panel-body customPadding\"><hr class=\"customHeading\"><div class=\"disp-message\"><span class=\"palette-color-primary-lighter\"><i class=\"fa fa-exclamation-triangle\"></i></span> Select an after-call disposition.</div><div class=\"form-group row\"><div class=\"col-sm-12\"><div><label><strong>Dispositions</strong></label></div><div class=\"\" style=\"height: auto\"><div class=\"form-check\" ng-repeat=\"item in vm.dispositionOptions\"><input class=\"form-check-input\" type=\"radio\" name=\"{{item.value}}\" ng-value=\"{{item.key}}\" ng-model=\"vm.dispositionSelected\" style=\"float:left;\"> <label class=\"form-check-label wordwrap\" for=\"{{item.key}}\">{{item.value}}</label></div></div></div></div><div class=\"form-group row\"><div class=\"col-sm-12\"><div><label><strong>Comments</strong></label></div><textarea class=\"form-control\" id=\"comment\" row=\"2\" ng-focus=\"vm.stopTimer()\" ng-blur=\"vm.startTimer()\" ng-model=\"vm.comment\" maxlength=\"{{vm.maxLength}}\"></textarea></div></div><div class=\"form-group row\"><div class=\"col-sm-12\"><div class=\"clearfix\"><div class=\"float-left\"><div class=\"lds-body-lg\">Automatically dismissed in <strong>{{vm.countDown}}</strong> seconds...</div></div><div class=\"float-right\"><button class=\"btn btn-primary\" ng-disabled=\"!vm.dispositionSelected\" ng-click=\"vm.submitDisposition()\">Submit</button></div></div></div></div></div>");
$templateCache.put("app/widgets/vox-meta-data.html","<div class=\"panel panel-default panel-vox\" ng-show=\"vm.showMetadata()\"><div class=\"panel panel-default panel-vox\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"panel-heading-title col-md-6\"><strong>Caller Supplied Information</strong></div><div ng-if=\"vm.showUpdateMessage && form.$valid\" class=\"message update\">Data updated. Please save changes.</div><div ng-if=\"vm.showSaveMessage\" class=\"message save\">Data saved.</div></div></div><div class=\"panel-body\"><div><form name=\"form\" class=\"form-horizontal\"><div class=\"form-group\" ng-repeat=\"metadatum in vm.metadata track by $index\"><label class=\"col-sm-2 control-label\" style=\"text-align: left;\">{{metadatum.Label}}</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"metadatum.AnswerText\" id=\"metadata{{$index}}\" ng-change=\"vm.metadataChanged($index)\" ng-disabled=\"!vm.editMetadataItem(metadatum)\" ng-pattern=\"vm.handlePattern($index)\" name=\"metadata{{$index}}\" required=\"\"><div ng-if=\"!form[\'metadata\' + ($index)].$valid\" class=\"messageError message update\">Invalid Data.</div><div class=\"buttons-right-row\"><button type=\"button\" class=\"btn btn-default\" ng-disabled=\"!vm.editMetadataItem(metadatum)\" ng-click=\"vm.reset($index)\">Reset</button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!form[\'metadata\' + ($index)].$valid || !vm.editMetadataItem(metadatum)\" ng-click=\"vm.save($index)\">Save</button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/widgets/vox-notalk-action-menu.html","<div class=\"panel-body customPadding\" ng-if=\"!vm.submitted\"><hr class=\"customHeading\"><div class=\"disp-message\"><span class=\"palette-color-primary-lighter\"><i class=\"fa fa-exclamation-triangle\"></i></span> Select an action.</div><div>{{vm.message}}</div><div class=\"form-group row\"><div class=\"col-sm-12\"><div><label><strong>Reason for No-Talk Activity</strong></label></div><div class=\"\" style=\"height: auto\"><div class=\"form-check\" ng-repeat=\"item in vm.notalkOptions\"><input class=\"form-check-input\" type=\"radio\" name=\"{{item.value}}\" ng-value=\"{{item.key}}\" ng-model=\"vm.notalkActionSelected\" ng-change=\"vm.displaymessage()\" style=\"float:left;\"> <label class=\"form-check-label wordwrap\" for=\"{{item.key}}\">{{item.value}}</label></div></div></div></div><div class=\"form-group row\"><div class=\"col-sm-12\"><div class=\"clearfix\"><div class=\"float-right\"><button class=\"btn btn-primary\" ng-click=\"vm.submitNotalkAction()\">Submit</button></div></div></div></div></div>");
$templateCache.put("app/widgets/vox-participants.html","<div><hr><div class=\"panel-heading\"><span class=\"fa-stack fa-lg\"><i class=\"fa fa-square-o fa-stack-2x\"></i> <i class=\"fa fa-group fa-stack-1x\"></i></span> <strong>Participants</strong></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"table-responsive over-flow-auto-false\"><table class=\"table\"><tbody><tr><td><strong>Name</strong></td><td><strong>Status</strong></td><td></td></tr></tbody><tr ng-repeat=\"participant in vm.participants\" ng-if=\"participant.PhoneNumber\"><td title=\"{{participant.PhoneNumber}}\">{{participant.Name || participant.PhoneNumber}}</td><td>{{participant.Status}}</td><td><i class=\"fa fa-times pull-right\" ng-hide=\"participant.InterpreterId || participant.OperatorId || participant.CustomerId\" ng-click=\"vm.removeParticipant(participant)\" style=\"cursor:pointer;\"></i></td></tr></table></div></div></div><div class=\"row\"><hr class=\"short-hr\"><div class=\"col-sm-12\"><div class=\"form-group\"><div class=\"input-group\"><vox-phone-number phone-number=\"vm.newParticipantPhoneNumber\" phone-error-message=\"vm.phoneErrorMessage\" validating=\"vm.phoneIsValidating\" allow-blank-numbers=\"true\" allow-mobile-numbers=\"true\" set-user-status=\"false\" third-party=\"true\"></vox-phone-number><div class=\"input-group-addon\"><button class=\"fa fa-user-plus\" ng-click=\"vm.addParticipant()\" ng-disabled=\"vm.isDisabled()\" style=\"cursor:pointer;\"></button></div></div><div class=\"vox-interpreter-phone-number-error\"><span>{{vm.phoneErrorMessage}}</span></div></div></div></div><div class=\"row\" ng-show=\"vm.thirdPartyMessage\"><div class=\"col-sm-12\"><div class=\"alert alert-instruction\" role=\"alert\"><strong class=\"instruction-message\">{{ vm.thirdPartyMessage }}</strong></div></div></div><div class=\"row\" ng-show=\"vm.callCenterMessage\"><div class=\"col-sm-12\"><div class=\"alert alert-instruction\" role=\"alert\"><strong class=\"instruction-message\">{{ vm.callCenterMessage }}</strong></div></div></div></div>");
$templateCache.put("app/widgets/vox-phone-number.html","<div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"fa fa-phone fa-lg fa-fw\"></i></div><select class=\"form-control vox-phone-country\" ng-disabled=\"vm.countryDisabled()\" ng-model=\"vm.country\" ng-change=\"vm.phoneChanged(\'vox-phone-number_select_ng-change_event\')\"><option value=\"\"></option><option data-countrycode=\"US\" value=\"1\">USA (+1)</option><option data-countrycode=\"DZ\" value=\"213\">Algeria (+213)</option><option data-countrycode=\"AD\" value=\"376\">Andorra (+376)</option><option data-countrycode=\"AO\" value=\"244\">Angola (+244)</option><option data-countrycode=\"AI\" value=\"1264\">Anguilla (+1264)</option><option data-countrycode=\"AG\" value=\"1268\">Antigua &amp; Barbuda (+1268)</option><option data-countrycode=\"AR\" value=\"54\">Argentina (+54)</option><option data-countrycode=\"AM\" value=\"374\">Armenia (+374)</option><option data-countrycode=\"AW\" value=\"297\">Aruba (+297)</option><option data-countrycode=\"AU\" value=\"61\">Australia (+61)</option><option data-countrycode=\"AT\" value=\"43\">Austria (+43)</option><option data-countrycode=\"AZ\" value=\"994\">Azerbaijan (+994)</option><option data-countrycode=\"BS\" value=\"1242\">Bahamas (+1242)</option><option data-countrycode=\"BH\" value=\"973\">Bahrain (+973)</option><option data-countrycode=\"BD\" value=\"880\">Bangladesh (+880)</option><option data-countrycode=\"BB\" value=\"1246\">Barbados (+1246)</option><option data-countrycode=\"BY\" value=\"375\">Belarus (+375)</option><option data-countrycode=\"BE\" value=\"32\">Belgium (+32)</option><option data-countrycode=\"BZ\" value=\"501\">Belize (+501)</option><option data-countrycode=\"BJ\" value=\"229\">Benin (+229)</option><option data-countrycode=\"BM\" value=\"1441\">Bermuda (+1441)</option><option data-countrycode=\"BT\" value=\"975\">Bhutan (+975)</option><option data-countrycode=\"BO\" value=\"591\">Bolivia (+591)</option><option data-countrycode=\"BA\" value=\"387\">Bosnia Herzegovina (+387)</option><option data-countrycode=\"BW\" value=\"267\">Botswana (+267)</option><option data-countrycode=\"BR\" value=\"55\">Brazil (+55)</option><option data-countrycode=\"BN\" value=\"673\">Brunei (+673)</option><option data-countrycode=\"BG\" value=\"359\">Bulgaria (+359)</option><option data-countrycode=\"BF\" value=\"226\">Burkina Faso (+226)</option><option data-countrycode=\"BI\" value=\"257\">Burundi (+257)</option><option data-countrycode=\"KH\" value=\"855\">Cambodia (+855)</option><option data-countrycode=\"CM\" value=\"237\">Cameroon (+237)</option><option data-countrycode=\"CV\" value=\"238\">Cape Verde Islands (+238)</option><option data-countrycode=\"KY\" value=\"1345\">Cayman Islands (+1345)</option><option data-countrycode=\"CF\" value=\"236\">Central African Republic (+236)</option><option data-countrycode=\"CL\" value=\"56\">Chile (+56)</option><option data-countrycode=\"CN\" value=\"86\">China (+86)</option><option data-countrycode=\"CO\" value=\"57\">Colombia (+57)</option><option data-countrycode=\"KM\" value=\"269\">Comoros (+269)</option><option data-countrycode=\"CG\" value=\"242\">Congo (+242)</option><option data-countrycode=\"CK\" value=\"682\">Cook Islands (+682)</option><option data-countrycode=\"CR\" value=\"506\">Costa Rica (+506)</option><option data-countrycode=\"HR\" value=\"385\">Croatia (+385)</option><option data-countrycode=\"CU\" value=\"53\">Cuba (+53)</option><option data-countrycode=\"CY\" value=\"90392\">Cyprus North (+90392)</option><option data-countrycode=\"CY\" value=\"357\">Cyprus South (+357)</option><option data-countrycode=\"CZ\" value=\"42\">Czech Republic (+42)</option><option data-countrycode=\"DK\" value=\"45\">Denmark (+45)</option><option data-countrycode=\"DJ\" value=\"253\">Djibouti (+253)</option><option data-countrycode=\"DO\" value=\"1809\">Dominican Republic (+1809)</option><option data-countrycode=\"EC\" value=\"593\">Ecuador (+593)</option><option data-countrycode=\"EG\" value=\"20\">Egypt (+20)</option><option data-countrycode=\"SV\" value=\"503\">El Salvador (+503)</option><option data-countrycode=\"GQ\" value=\"240\">Equatorial Guinea (+240)</option><option data-countrycode=\"ER\" value=\"291\">Eritrea (+291)</option><option data-countrycode=\"EE\" value=\"372\">Estonia (+372)</option><option data-countrycode=\"ET\" value=\"251\">Ethiopia (+251)</option><option data-countrycode=\"FK\" value=\"500\">Falkland Islands (+500)</option><option data-countrycode=\"FO\" value=\"298\">Faroe Islands (+298)</option><option data-countrycode=\"FJ\" value=\"679\">Fiji (+679)</option><option data-countrycode=\"FI\" value=\"358\">Finland (+358)</option><option data-countrycode=\"FR\" value=\"33\">France (+33)</option><option data-countrycode=\"GF\" value=\"594\">French Guiana (+594)</option><option data-countrycode=\"PF\" value=\"689\">French Polynesia (+689)</option><option data-countrycode=\"GA\" value=\"241\">Gabon (+241)</option><option data-countrycode=\"GM\" value=\"220\">Gambia (+220)</option><option data-countrycode=\"GE\" value=\"7880\">Georgia (+7880)</option><option data-countrycode=\"DE\" value=\"49\">Germany (+49)</option><option data-countrycode=\"GH\" value=\"233\">Ghana (+233)</option><option data-countrycode=\"GI\" value=\"350\">Gibraltar (+350)</option><option data-countrycode=\"GR\" value=\"30\">Greece (+30)</option><option data-countrycode=\"GL\" value=\"299\">Greenland (+299)</option><option data-countrycode=\"GD\" value=\"1473\">Grenada (+1473)</option><option data-countrycode=\"GP\" value=\"590\">Guadeloupe (+590)</option><option data-countrycode=\"GU\" value=\"671\">Guam (+671)</option><option data-countrycode=\"GT\" value=\"502\">Guatemala (+502)</option><option data-countrycode=\"GN\" value=\"224\">Guinea (+224)</option><option data-countrycode=\"GW\" value=\"245\">Guinea - Bissau (+245)</option><option data-countrycode=\"GY\" value=\"592\">Guyana (+592)</option><option data-countrycode=\"HT\" value=\"509\">Haiti (+509)</option><option data-countrycode=\"HN\" value=\"504\">Honduras (+504)</option><option data-countrycode=\"HK\" value=\"852\">Hong Kong (+852)</option><option data-countrycode=\"HU\" value=\"36\">Hungary (+36)</option><option data-countrycode=\"IS\" value=\"354\">Iceland (+354)</option><option data-countrycode=\"IN\" value=\"91\">India (+91)</option><option data-countrycode=\"ID\" value=\"62\">Indonesia (+62)</option><option data-countrycode=\"IR\" value=\"98\">Iran (+98)</option><option data-countrycode=\"IQ\" value=\"964\">Iraq (+964)</option><option data-countrycode=\"IE\" value=\"353\">Ireland (+353)</option><option data-countrycode=\"IL\" value=\"972\">Israel (+972)</option><option data-countrycode=\"IT\" value=\"39\">Italy (+39)</option><option data-countrycode=\"JM\" value=\"1876\">Jamaica (+1876)</option><option data-countrycode=\"JP\" value=\"81\">Japan (+81)</option><option data-countrycode=\"JO\" value=\"962\">Jordan (+962)</option><option data-countrycode=\"KZ\" value=\"7\">Kazakhstan (+7)</option><option data-countrycode=\"KE\" value=\"254\">Kenya (+254)</option><option data-countrycode=\"KI\" value=\"686\">Kiribati (+686)</option><option data-countrycode=\"KP\" value=\"850\">Korea North (+850)</option><option data-countrycode=\"KR\" value=\"82\">Korea South (+82)</option><option data-countrycode=\"KW\" value=\"965\">Kuwait (+965)</option><option data-countrycode=\"KG\" value=\"996\">Kyrgyzstan (+996)</option><option data-countrycode=\"LA\" value=\"856\">Laos (+856)</option><option data-countrycode=\"LV\" value=\"371\">Latvia (+371)</option><option data-countrycode=\"LB\" value=\"961\">Lebanon (+961)</option><option data-countrycode=\"LS\" value=\"266\">Lesotho (+266)</option><option data-countrycode=\"LR\" value=\"231\">Liberia (+231)</option><option data-countrycode=\"LY\" value=\"218\">Libya (+218)</option><option data-countrycode=\"LI\" value=\"417\">Liechtenstein (+417)</option><option data-countrycode=\"LT\" value=\"370\">Lithuania (+370)</option><option data-countrycode=\"LU\" value=\"352\">Luxembourg (+352)</option><option data-countrycode=\"MO\" value=\"853\">Macao (+853)</option><option data-countrycode=\"MK\" value=\"389\">Macedonia (+389)</option><option data-countrycode=\"MG\" value=\"261\">Madagascar (+261)</option><option data-countrycode=\"MW\" value=\"265\">Malawi (+265)</option><option data-countrycode=\"MY\" value=\"60\">Malaysia (+60)</option><option data-countrycode=\"MV\" value=\"960\">Maldives (+960)</option><option data-countrycode=\"ML\" value=\"223\">Mali (+223)</option><option data-countrycode=\"MT\" value=\"356\">Malta (+356)</option><option data-countrycode=\"MH\" value=\"692\">Marshall Islands (+692)</option><option data-countrycode=\"MQ\" value=\"596\">Martinique (+596)</option><option data-countrycode=\"MR\" value=\"222\">Mauritania (+222)</option><option data-countrycode=\"MX\" value=\"52\">Mexico (+52)</option><option data-countrycode=\"FM\" value=\"691\">Micronesia (+691)</option><option data-countrycode=\"MD\" value=\"373\">Moldova (+373)</option><option data-countrycode=\"MC\" value=\"377\">Monaco (+377)</option><option data-countrycode=\"MN\" value=\"976\">Mongolia (+976)</option><option data-countrycode=\"MS\" value=\"1664\">Montserrat (+1664)</option><option data-countrycode=\"MA\" value=\"212\">Morocco (+212)</option><option data-countrycode=\"MZ\" value=\"258\">Mozambique (+258)</option><option data-countrycode=\"MN\" value=\"95\">Myanmar (+95)</option><option data-countrycode=\"NA\" value=\"264\">Namibia (+264)</option><option data-countrycode=\"NR\" value=\"674\">Nauru (+674)</option><option data-countrycode=\"NP\" value=\"977\">Nepal (+977)</option><option data-countrycode=\"NL\" value=\"31\">Netherlands (+31)</option><option data-countrycode=\"NC\" value=\"687\">New Caledonia (+687)</option><option data-countrycode=\"NZ\" value=\"64\">New Zealand (+64)</option><option data-countrycode=\"NI\" value=\"505\">Nicaragua (+505)</option><option data-countrycode=\"NE\" value=\"227\">Niger (+227)</option><option data-countrycode=\"NG\" value=\"234\">Nigeria (+234)</option><option data-countrycode=\"NU\" value=\"683\">Niue (+683)</option><option data-countrycode=\"NF\" value=\"672\">Norfolk Islands (+672)</option><option data-countrycode=\"NP\" value=\"670\">Northern Marianas (+670)</option><option data-countrycode=\"NO\" value=\"47\">Norway (+47)</option><option data-countrycode=\"OM\" value=\"968\">Oman (+968)</option><option data-countrycode=\"PW\" value=\"680\">Palau (+680)</option><option data-countrycode=\"PA\" value=\"507\">Panama (+507)</option><option data-countrycode=\"PG\" value=\"675\">Papua New Guinea (+675)</option><option data-countrycode=\"PY\" value=\"595\">Paraguay (+595)</option><option data-countrycode=\"PE\" value=\"51\">Peru (+51)</option><option data-countrycode=\"PH\" value=\"63\">Philippines (+63)</option><option data-countrycode=\"PL\" value=\"48\">Poland (+48)</option><option data-countrycode=\"PT\" value=\"351\">Portugal (+351)</option><option data-countrycode=\"QA\" value=\"974\">Qatar (+974)</option><option data-countrycode=\"RE\" value=\"262\">Reunion (+262)</option><option data-countrycode=\"RO\" value=\"40\">Romania (+40)</option><option data-countrycode=\"RU\" value=\"7\">Russia (+7)</option><option data-countrycode=\"RW\" value=\"250\">Rwanda (+250)</option><option data-countrycode=\"SM\" value=\"378\">San Marino (+378)</option><option data-countrycode=\"ST\" value=\"239\">Sao Tome &amp; Principe (+239)</option><option data-countrycode=\"SA\" value=\"966\">Saudi Arabia (+966)</option><option data-countrycode=\"SN\" value=\"221\">Senegal (+221)</option><option data-countrycode=\"CS\" value=\"381\">Serbia (+381)</option><option data-countrycode=\"SC\" value=\"248\">Seychelles (+248)</option><option data-countrycode=\"SL\" value=\"232\">Sierra Leone (+232)</option><option data-countrycode=\"SG\" value=\"65\">Singapore (+65)</option><option data-countrycode=\"SK\" value=\"421\">Slovak Republic (+421)</option><option data-countrycode=\"SI\" value=\"386\">Slovenia (+386)</option><option data-countrycode=\"SB\" value=\"677\">Solomon Islands (+677)</option><option data-countrycode=\"SO\" value=\"252\">Somalia (+252)</option><option data-countrycode=\"ZA\" value=\"27\">South Africa (+27)</option><option data-countrycode=\"ES\" value=\"34\">Spain (+34)</option><option data-countrycode=\"LK\" value=\"94\">Sri Lanka (+94)</option><option data-countrycode=\"SH\" value=\"290\">St. Helena (+290)</option><option data-countrycode=\"KN\" value=\"1869\">St. Kitts (+1869)</option><option data-countrycode=\"SC\" value=\"1758\">St. Lucia (+1758)</option><option data-countrycode=\"SD\" value=\"249\">Sudan (+249)</option><option data-countrycode=\"SR\" value=\"597\">Suriname (+597)</option><option data-countrycode=\"SZ\" value=\"268\">Swaziland (+268)</option><option data-countrycode=\"SE\" value=\"46\">Sweden (+46)</option><option data-countrycode=\"CH\" value=\"41\">Switzerland (+41)</option><option data-countrycode=\"SI\" value=\"963\">Syria (+963)</option><option data-countrycode=\"TW\" value=\"886\">Taiwan (+886)</option><option data-countrycode=\"TH\" value=\"66\">Thailand (+66)</option><option data-countrycode=\"TG\" value=\"228\">Togo (+228)</option><option data-countrycode=\"TO\" value=\"676\">Tonga (+676)</option><option data-countrycode=\"TT\" value=\"1868\">Trinidad &amp; Tobago (+1868)</option><option data-countrycode=\"TN\" value=\"216\">Tunisia (+216)</option><option data-countrycode=\"TR\" value=\"90\">Turkey (+90)</option><option data-countrycode=\"TM\" value=\"993\">Turkmenistan (+993)</option><option data-countrycode=\"TC\" value=\"1649\">Turks &amp; Caicos Islands (+1649)</option><option data-countrycode=\"TV\" value=\"688\">Tuvalu (+688)</option><option data-countrycode=\"UG\" value=\"256\">Uganda (+256)</option><option data-countrycode=\"GB\" value=\"44\">UK (+44)</option><option data-countrycode=\"UA\" value=\"380\">Ukraine (+380)</option><option data-countrycode=\"AE\" value=\"971\">United Arab Emirates (+971)</option><option data-countrycode=\"UY\" value=\"598\">Uruguay (+598)</option><option data-countrycode=\"VU\" value=\"678\">Vanuatu (+678)</option><option data-countrycode=\"VA\" value=\"379\">Vatican City (+379)</option><option data-countrycode=\"VE\" value=\"58\">Venezuela (+58)</option><option data-countrycode=\"VN\" value=\"84\">Vietnam (+84)</option><option data-countrycode=\"VG\" value=\"1284\">Virgin Islands - British (+1284)</option><option data-countrycode=\"VI\" value=\"1340\">Virgin Islands - US (+1340)</option><option data-countrycode=\"WF\" value=\"681\">Wallis &amp; Futuna (+681)</option><option data-countrycode=\"YE\" value=\"969\">Yemen (North)(+969)</option><option data-countrycode=\"YE\" value=\"967\">Yemen (South)(+967)</option><option data-countrycode=\"ZM\" value=\"260\">Zambia (+260)</option><option data-countrycode=\"ZW\" value=\"263\">Zimbabwe (+263)</option></select><input class=\"form-control vox-phone-number\" type=\"tel\" ng-model=\"vm.number\" ng-style=\"vm.color\" ng-change=\"vm.phoneChanged(\'vox-phone-number_input_ng-change_event\')\" ng-model-options=\"{ debounce: vm.validationTimeoutDuration }\" ng-disabled=\"vm.personStatus == \'InCall\' || vm.personStatus == \'Reconnect\'\"><div ng-show=\"vm.validating\"><i class=\"fa fa-refresh fa-spin vox-phone-number-spinner\"></i></div><div class=\"input-group-addon\" ng-if=\"vm.isTemporaryPhonenumber\" ng-click=\"vm.resetClicked()\" title=\"Reset\"><i class=\"fa fa-undo\"></i></div></div>");
$templateCache.put("app/widgets/vox-signal-r-status.html","<a href=\"\" ng-show=\"vm.showWarning===true;\"><i ng-class=\"vm.statusClass\" ng-attr-title=\"{{vm.statusTitle}}\"></i></a>");
$templateCache.put("app/widgets/vox-sip-data.html","<div class=\"panel panel-default panel-vox\" ng-show=\"vm.showSipdata()\"><div class=\"panel panel-default panel-vox\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"panel-heading-title col-md-6\"><strong>Caller Supplied Headers</strong></div><div ng-if=\"vm.showUpdateMessage && form.$valid\" class=\"message update\">Data updated. Please save changes.</div><div ng-if=\"vm.showSaveMessage\" class=\"message save\">Data saved.</div></div></div><div class=\"panel-body\"><div><form name=\"form\" class=\"form-horizontal\"><div class=\"form-group\" ng-repeat=\"sipdatum in vm.sipdata track by $index\"><label class=\"col-sm-2 control-label\" style=\"text-align: left;\">{{sipdatum.HeaderText}}</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"sipdatum.ValueText\" id=\"sipdata{{$index}}\" ng-change=\"vm.sipdataChanged($index)\" ng-disabled=\"!vm.editSipdataItem(sipdatum)\" ng-pattern=\"vm.handlePattern($index)\" name=\"sipdata{{$index}}\"></div><div ng-if=\"!form[\'sipdata\' + ($index)].$valid\" class=\"messageError message update\">Invalid Data.</div><div class=\"buttons-right-row\"><button type=\"button\" class=\"btn btn-default\" ng-disabled=\"!vm.editSipdataItem(sipdatum)\" ng-click=\"vm.reset($index)\">Reset</button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!form[\'sipdata\' + ($index)].$valid || !vm.editSipdataItem(sipdatum)\" ng-click=\"vm.save($index)\">Save</button></div></div></form></div></div></div></div>");
$templateCache.put("app/widgets/vox-test-call-button.html","<div><button type=\"button\" ng-class=\"{true : \'btn btn-default\' , false : \'btn btn-primary\'}[!vm.enableTestButton || vm.forceButtonToDisable]\" ladda=\"vm.waiting\" style=\"border-top-left-radius: 0; border-bottom-left-radius: 0; border-radius: .25rem;\" title=\"Test Connection\" ng-click=\"vm.test(); vm.forceButtonToDisable=true\" ng-disabled=\"(!vm.enableTestButton || vm.forceButtonToDisable)\"><span style=\"font-size: 12px\">TEST</span></button></div>");
$templateCache.put("app/widgets/vox-web-rtc-connection-quality.html","<a href=\"\" ng-show=\"vm.errorLevel > -1;\"><i ng-class=\"vm.statusClass\" ng-attr-title=\"{{vm.statusTitle}}\"></i></a>");}]);